import React, { useState, useEffect, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import "../../styles/gmr.scss";
import "../../styles/steps.scss";
import BrokerWelcomeSkipImage from "../../assets/broker-welcome-skip-help.png";
import BCMessage from "../ui/BCMessage";
import { createMockBuilder, deleteMockGuarantor, exportMockGMRQuote, getMockApplicationInfo, getMockApplicationInfolist, getMockApplicationMetadata, getMockBorrowerEntity, getMockBrokerGuarantors, getMockGuarantor, getMockGuarantorExists, pullMockCreditScore, sendMockApplicationStartEmail, upsertMockGuarantor, upsertMockBorrowerEntity, calculateMockGmrFromApplication, sendMockLoanApplication, getMockGMRSummary, getMockApplicationCopy, getMockDisclosures, addMockBorrowerGuarantors, isMockProjectNameExists, getMockGuarantors, resendMockGuarantorInvite, acceptMockGuarantorInvitation, patchMockBorrowerApplicationProjectSection, deleteMockGuarantorALSchedule, patchMockBorrowerApplicationProperties, patchMockBorrowerApplicationCostsPaids, deleteMockBorrowerApplicationCostsPaids, deleteMockBorrowerApplicationPropertiesAndUnits, deleteMockBorrowerApplicationUnits, patchMockBorrowerApplicationPlans, deleteMockBorrowerApplicationPlans, submitMockBorrowerApplication, getMockBrokerBuilder, createMockDeal, patchMockBorrowerApplicationEntities, getMockBorrowerApplicationEntities, getMockSimilarBrokerageNameList, createMockNewBroker, getMockBrokerEmailExists, getMockAllBrokers, getMockGuarantorGuarantors, downloadMockPropertyUnitExcel, importMockPropertyUnitExcel, getMockBorrowerApplicationGuarantorSigned, notifyMockLoanOfficer, createMockBorrowerApplicationGuarantors, declineMockGuarantorInvitation } from "../../api/mock/MockBrokerApi";
import { acceptGuarantorInvitation, addBorrowerGuarantors, calculateGmrFromApplication, createBuilder, createDeal, deleteBorrowerApplicationCostsPaids, deleteBorrowerApplicationPlans, deleteBorrowerApplicationPropertiesAndUnits, deleteBorrowerApplicationUnits, deleteGuarantor, deleteGuarantorALSchedule, exportGMRQuote, getApplicationCopy, getBorrowerApplicationInfo, getApplicationInfoList, getApplicationMetadata, getBorrowerEntity, getBrokerBuilder, getBrokerGuarantors, getDisclosure, getGMRSummary, getGuarantor, getGuarantorExists, getGuarantors, isProjectNameExists, patchBorrowerApplicationCostsPaids, patchBorrowerApplicationPlans, patchBorrowerApplicationProjectSection, patchBorrowerApplicationProperties, pullCreditScore, resendGuarantorInvite, sendApplicationStartEmail, sendLoanApplication, submitBorrowerApplication, upsertBorrowerEntity, upsertGuarantor, patchBorrowerApplicationEntities, getBorrowerApplicationEntities, getSimilarBrokerageNameList, createNewBroker, getBrokerEmailExists, getAllBrokers, getGuarantorGuarantors,downloadPropertyUnitExcel, importPropertyUnitExcel, getBorrowerApplicationGuarantorSigned, notifyLoanOfficer, createBorrowerApplicationGuarantors, declineGuarantorInvitation } from "../../api/BrokerApi";
import { Breadcrumb, Button, Card, Dropdown, Form, Grid, Header, Icon, Loader, Table, Step, Image } from "semantic-ui-react";
import { combineAddresses, converToSSNString, convertToDollar, convertToOrganizationString, convertToPercentString, convertToMinFraction, convertToYesNo, createErrorResponse, createFile, getDropdownOptions, guid, handleAddressValue, handleErrorResponse, handleFormChange, handleGetValueFromId, handleInputType, hasDuplicates, hasDuplicatesArray, isApplicationBorrower, isApplicationGuarantor, isValidGuarantorAccessLevel, isValidPermission, isWhiteLabeled, operationOfNumberArray, parseAddressLine1, parseAddressLine2, removeFromArrayByValues, setBackgroundColor, setColor, validateEmails, validateObj, uniqueArray, validateNestedObj, deepCopy, convertToDateString} from "../../Helpers";
import BCSteps from "../ui/BCSteps";
import BCFormInput from "../ui/BCFormInput";
import BCValidationMessage from "../ui/BCValidationMessage";
import { css } from "@emotion/css";
import BCAccordion from "../ui/BCAccordion";
import BCButton from "../ui/BCButton";
import { GlobalConstants, ErrorMessages, Personas, FileType, Environments } from "../constants/GlobalConstants";
import BCTable from "../ui/BCTable";
import BCModal from "../ui/BCModal";
import BCEmptyState from "../ui/BCEmptyState";
import { IApplicationScreenStatus } from "../interfaces/BorrowerApplication";
import { checkHoliday, checkWeekend, clearMixedValueBulkEdit, getBulkEditFieldValue, handleBulkEditFieldChange, handleBulkEditModalClose, convertArrayToOxfordString, handleApiPromise } from "../../helpers/GlobalHelper";
import { BPAssociatedBrokerQuestion, BPBrokerEmailQuestion, BPBrokerFeeRateQuestion, BPSelectLoanOfficerQuestion, BPBorrowerEntitySelection, BPBorrowerEntityAdditionalInformation} from "./BPApplicationQuestions";
import { IBrokerage, IBrokerageInfo, INewBroker } from "../interfaces/GetMyRate";
import { getIsWhiteLabeled, whoAmI } from "../../helpers/PermissionHelper";
import BPNewBrokerModals from "./BPNewBrokerModals";
import BCUploadBox from "../ui/BCUploadBox";
import { FeatureFlags, getFeatureFlags } from "../constants/LocalServerConstants";
import { BPConstructionScheduleTable, BPPropertyUnitsTable } from "./BPApplicationTables";
import { BPQuestionLabels } from "./BPQuestionLabels";
import BCConfirmationModal from "../ui/BCConfirmationModal";
import { handleAssociatedBorrowers, handleAssociatedOrganizationContactId, handlePurchaseOrRefinanceOptions, handleRefinanceOptions } from "../../helpers/MasterPortalHelper";
import BPAddGuarantorForm from "./BPAddGuarantorForm";
import { ConfigDefaults } from "../constants/BrokerConstants";

interface IBorrowerApplicationScreenStatus {
  Projects: string | undefined;
  Property: string | undefined;
  Budget: string | undefined;
  Entity: string | undefined;
  Guarantor: string | undefined;
  Summary: string | undefined;
}

const emptyPropertyInformationBulkEdit = {
  address: null,
  city: null,
  county: null,
  state: null,
  zip: null,
  numberOfUnits: null,
  existingStructurePropertyTypeId: null,
  newStructurePropertyTypeId: null,
  parcelNumber: null,
  lotNumberStartingFrom: null as any,
  lotNumber: 1,
  zoning: null,
  workStageId: null,
  completedValue: null,
};

const BPBorrowerApplication = ({ 
  isGreaterThanMobile, 
  isGreaterThanTablet, 
  isSidebar, 
  isMessage, 
  setIsMessage, 
  setSuccessMessage,
  errorResponse, 
  setErrorResponse, 
  gmrEditData,
  setGmrEditData,
  isModalOpen,
  setIsModalOpen,
  proxyUser,
  permissions,
  organizationContactId,
  applicationId,
  copiedApplicationId,
  user,
  brokerColor
}) => {
  const unfocusRef = useRef<HTMLElement>(null);
  const applicationRef = useRef<HTMLElement>(null);
  const exportRef = useRef<HTMLElement>(null);
  const unitRef = useRef() as any;
  const [isFirstLoad, setIsFirstLoad] = useState(true as boolean);
  const [primeGuarantorModal, setPrimeGuarantorModal] = useState(false as boolean);
  const [isLoading, setIsLoading] = useState(true as boolean);
  const [isModalSubmitted, setIsModalSubmitted] = useState(false as boolean);
  const [applicationMetadata, setApplicationMetadata] = useState({} as any);
  const [applicationCalculationObject, setApplicationCalculationObject] = useState({} as any); 
  const [invalidProps, setInvalidProps] = useState([] as string[]);
  const [warningIds, setWarningIds] = useState([] as string[]); 
  const [startAppObject, setStartAppObject] = useState({} as any);
  const [initialStartAppObject, setInitialStartAppObject] = useState({} as any);
  const [startAppObjectFromGmr, setStartAppObjectFromGmr] = useState({} as any); 
  const [isPatchedFromGmr, setIsPatchedFromGmr] = useState(false); 
  const [currentProgress, setCurrentProgress] = useState(0 as number);
  const [excludedStepIds, setExcludedStepIds] = useState([] as string[]);
  const [metadataExcludedIds, setMetadataExcludedIds] = useState([] as string[]);
  const BrokerWelcomeStepId = "58b68d2c-7e20-4cad-aa2d-5ceea0536f5d";
  const [currentStepId, setCurrentStepId] = useState(BrokerWelcomeStepId as string);
  const [applicationScreenStatus, setApplicationScreenStatus] = useState({
    Projects: undefined,
    Property: undefined,
    Budget: undefined,
    Entity: undefined,
    Guarantor: undefined,
    Summary: undefined
  } as IBorrowerApplicationScreenStatus);

  const backgroundColorStyle = getIsWhiteLabeled() ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0;
  const wlColorStyle = getIsWhiteLabeled() ? setColor(brokerColor ? brokerColor : "#000000") : void 0;
  const wlBrokerHex = getIsWhiteLabeled() ? brokerColor : void 0;
  const brokerLabelBorderOverrideCSS = css`
    border-bottom: 3px solid ${brokerColor ? brokerColor : "black"}!important;
  `;
  const brokerLabelBorderStyle = (getIsWhiteLabeled() && brokerColor) ? brokerLabelBorderOverrideCSS : "form-input-border";
  const [isScreenFormChanged, setIsScreenFormChanged] = useState(false as boolean); 
  const [checkedProperties, setCheckedProperties] = useState([] as string[]);
  const [checkedUnits, setCheckedUnits] = useState([] as string[]);
  const [checkedPropertySchedules, setCheckedPropertySchedules] = useState([] as string[]);
  const [copiedFromAbove, setCopiedFromAbove] = useState([] as number[]);
  const [generalContractors, setGeneralContractors] = useState([] as any[]);
  const [newAssetAndLiability, setNewAssetAndLiability] = useState({} as any);
  const [newReoSchedule, setNewReoSchedule] = useState({ isMortgageFree: true } as any);
  const [isSocialSecurityEdit, setIsSocialSecurityEdit] = useState(false as boolean);
  const [newBuilder, setNewBuilder] = useState({} as any);
  const [newBorrowerEntity, setNewBorrowerEntity] = useState({} as any);
  const [newGuarantor, setNewGuarantor] = useState({ isMailingSameAsPhysical: true, isUSCitizen: true } as any);
  const [modalType, setModalType] = useState(undefined as any);
  const [alType, setAlType] = useState ("" as string);
  const [isGuarantorAssetEdit, setIsGuarantorAssetEdit] = useState(false as boolean);
  const [entityAssetsAndLiabilities, setEntityAssetAndLiabilities] = useState([] as any[]);
  const [entityReoSchedules, setEntityReoSchedules] = useState([] as any[]);
  const [guarantorAssetsAndLiabilities, setGuarantorAssetAndLiabilities] = useState([] as any[]);
  const [guarantorReoSchedules, setGuarantorReoSchedules] = useState([] as any[]);
  const [guarantorSearch, setGuarantorSearch] = useState("" as string);
  const [isBrokerGuarantorSelected, setIsBrokerGuarantorSelected] = useState(true as boolean);
  const [metaGuarantors, setMetaGuarantors] = useState([] as any[]);
  const [selectedBrokerGuarantors, setSelectedBrokerGuarantors] = useState([] as any[]);
  const [brokerGuarantors, setBrokerGuarantors] = useState([] as any[]);
  const [brokerApiGuarantors, setBrokerApiGuarantors] = useState([] as any[]);
  const [associatedGuarantors, setAssociatedGuarantors] = useState([] as any[]);
  const [propertyUploadModalFile, setPropertyUploadModalFile] = useState(undefined as any);
  const [isPropertyUploadModalOpen, setIsPropertyUploadModalOpen] = useState(false as boolean);
  const [propertyUploadModalMessage, setPropertyUploadModalMessage] = useState("" as string);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false as boolean);
  const [isCreditModalOpen, setIsCreditModalOpen] = useState(false as boolean);
  const [isCreditScoreSkipped, setIsCreditScoreSkipped] = useState(false as boolean);
  const [isCreditScorePulled, setIsCreditScorePulled] = useState(false as boolean);
  const [creditModalStage, setCreditModalStage] = useState("" as string);
  const [paymentModalStage, setPaymentModalStage] = useState("" as string);
  const [isSkipModalOpen, setIsSkipModalOpen] = useState(false as boolean);
  const [skipModalId, setSkipModalId] = useState("" as string);
  const [incompleteApplicationText, setIncompleteApplicationText] = useState("" as string);
  const [isRefinanceSelected, setIsRefinanceSelected] = useState(false as boolean);
  const realEstateOwnedText = "Real Estate Owned includes all properties currently owned and the remaining principal balance owed on each, including residential and commercial structures and undeveloped land. This does NOT include the specific properties for which this loan application is being submitted, if already owned. Properties being rented or leased should be listed as liabilities.";
  const applicationChoice = "";
  const [isApplicationNew, setIsApplicationNew] = useState(true as boolean);
  const isApplicationNewRef = useRef<boolean>(true);
  isApplicationNewRef.current = isApplicationNew;
  const [entityAdditionalCollateral, setEntityAdditionalCollateral] = useState([] as any[]);
  const [guarantorAdditionalCollateral, setGuarantorAdditionalCollateral] = useState([] as any[]);
  const [guarantorAdditionalCollateralFull, setGuarantorAdditionalCollateralFull] = useState([] as any[]);
  const [isBrokerGuarantorInvited, setIsBrokerGuarantorInvited] = useState(false as boolean);
  const [isLoanOfficerMessage, setIsLoanOfficerMessage] = useState(true as boolean);
  const [isLoanOfficerWarning, setIsLoanOfficerWarning] = useState(true as boolean);
  const [brokerGuarantorInvitedName, setBrokerGuarantorInvitedName] = useState("" as string);
  const [isAdditionalCollateralWarning, setIsAdditionalCollateralWarning] = useState(false as boolean);
  const [additionalCollateralWarning, setAdditionalCollateralWarning] = useState(undefined as any);
  const [isSSNReveal, setIsSSNReveal] = useState(false as boolean); 
  const [isDOBReveal, setIsDOBReveal] = useState(false as boolean);
  const [isBrokerGuarantorsLoading, setIsBrokerGuarantorsLoading] = useState(true as boolean);
  const [selectedBrokerEmail, setSelectedBrokerEmail] = useState("" as string);
  const [brokerSearch, setBrokerSearch] = useState("" as string);
  const [isBrokerSearchFocus, setIsBrokerSearchFocus] = useState(false as boolean);
  const [isPropertyBulkEditAddressOpen, setIsPropertyBulkEditAddressOpen] = useState(false as boolean);
  const [isPropertyBulkEditLotOpen, setIsPropertyBulkEditLotOpen] = useState(false as boolean);
  const [newBroker, setNewBroker] = useState({} as INewBroker);
  const [isBrokerModalOpen, setIsBrokerModalOpen] = useState(false as boolean);
  const [isModalLoading, setIsModalLoading] = useState(true as boolean);
  const [isModalMessage, setIsModalMessage] = useState(false as boolean);
  const [similarBrokerageList, setSimilarBrokerageList] = useState([] as IBrokerage[]);
  const [newBrokerageId, setNewBrokerageId] = useState("" as string);
  const [isNewBrokerage, setIsNewBrokerage] = useState(false as boolean);
  const [brokerageInfo, setBrokerageInfo] = useState({} as IBrokerageInfo | any);
  const [isBrokerageNameModalOpen, setIsBrokerageNameModalOpen] = useState(false as boolean);
  const [isBrokerageInfoModalOpen, setIsBrokerageInfoModalOpen] = useState(false as boolean);
  const [isNewBrokerCreated, setIsNewBrokerCreated] = useState(false as boolean);
  const [brokerSearchDropdown, setBrokerSearchDropdown] = useState([] as any[]);
  const [prefilledFromGmr, setPrefilledFromGmr] = useState({} as any);
  const [associatedBorrowers, setAssociatedBorrowers] = useState([] as any[]);
  const [isPropertyUnitMixUploaded, setIsPropertyUnitMixUploaded] = useState(false as boolean);
  const [isPropertyUnitUploadedMessage, setIsPropertyUnitUploadedMessage] = useState(false as boolean);
  const [isLoadingPropertyUnitExcel, setIsLoadingPropertyUnitExcel] = useState(false as boolean);
  const [excelProperties, setExcelProperties] = useState([] as any[]);
  const [isNumberOfUnitWarningModalOpen, setIsNumberOfUnitWarningModalOpen] = useState(false as boolean);
  const [propertyUnitExcelDate, setPropertyUnitExcelDate] = useState(undefined as any);
  const [isPropertyBulkEditModalOpen, setIsPropertyBulkEditModalOpen] = useState(false);
  const [isUnitBulkEditModalOpen, setIsUnitBulkEditModalOpen] = useState(false);
  const [propertyInformationBulkEdit, setPropertyInformationBulkEdit] = useState(emptyPropertyInformationBulkEdit);
  const [isEnteredNext, setIsEnteredNext] = useState(false as boolean);
  const UserFeatureFlags = getFeatureFlags(user);
  let minMandatoryBrokerFee = ConfigDefaults.MIN_MANDATORY_BROKER_FEE;
  if (applicationMetadata && applicationMetadata.configs) {
    minMandatoryBrokerFee = applicationMetadata.configs.minMandatoryBrokerFee;
  }
  
  const propertyUnitDescriptionText = "To enable mass editing, select all rows you would like to edit by clicking the checkboxes on the left side of the table. Then click the Edit button.";
  const authorizationText = "By clicking below, I authorize Construction Loan Services II, LLC and its affiliates and/or assigns to obtain a Background Check and / or Consumer Credit Report on me. This authorization is valid for purposes of verifying information given pursuant to any lawful purpose covered under the Fair Credit Reporting Act (FCRA).";
  const ApplicationChoices = {
    Start: {
      icon: "pencil alternate",
      text: "Start Application",
      description: "Complete a loan application on behalf of my client.",
      type: "start"
    },
    Send: {
      icon: "envelope",
      text: "Send Application",
      description: "Send a loan application for my client to complete.",
      type: "send"
    }
  };

  const yesNoBooleanRadios = [{ name: "Yes", value: true }, { name: "No", value: false }];
  const propertyUploadOptionRadios = [{ name: "Upload", value: GlobalConstants.UploadOptions.UPLOAD }, { name: "Fill it out", value: GlobalConstants.UploadOptions.FILL_OUT }];
  const [exportURL, setExportURL]  = useState(undefined as any);
  const [exportLoading, setExportLoading] = useState(false as any);
  const [greatestTotalToComplete, setGreatestTotalToComplete] = useState(0 as number);
  const unitPlanConfig = {
    name: undefined,
    numberOfBedroom: undefined,
    numberOfBathroom: undefined,
    numberOfCarGarage: undefined,
    squareFootage: undefined,
    currentValue: undefined,
    completedValue: undefined
  };
  const [unitPlan, setUnitPlan] = useState(unitPlanConfig as any);
  const [brokerScreenStatus, setBrokerScreenStatus] = useState("" as string);
  const ApplicationWarnings = {
    Reinput: {
      id: "9e3ada24-ccbd-496c-9ca8-59cef4fd525f",
      message: "Due to changing this value, you may need to re-input your information in future steps."
    },
    OriginationFee: {
      id: "3a382d43-f78e-438c-a0ef-73e97f2ab17f",
      message: "Our policy is to only roll up to 2% into the origination fee. Any fee above that will show as an external broker fee."
    }
  };
  const GmrSummaryDimensions = isGreaterThanTablet ? 4 : isGreaterThanMobile ? 3 : 2;
  const GmrSummaryTable = [
    {
      name: "Loan Commitment",
      value: "loanCommitment",
      format: "dollar"
    },
    {
      name: "Interest Rate",
      value: "interestRate",
      format: "percent"
    },
    {
      name: "Origination Fee",
      value: "originationFeeRate",
      format: "percent"
    },
    {
      name: "Term",
      value: "requestedLoanTermInMonths"
    },
    {
      name: "Estimated Cash Down",
      value: "requiredCashDown",
      format: "dollar"
    },
    {
      name: "Refinance Payoff",
      value: "refinancePayoff",
      format: "dollar"
    },
    {
      name: "LTV",
      value: "ltv",
      format: "percent"
    },
    {
      name: "LTC",
      value: "ltc",
      format: "percent"
    },
    {
      name: "Budget",
      value: "budget",
      format: "dollar"
    },
    {
      name: "Finished Value",
      value: "afterRepairValue",
      format: "dollar"
    }
  ];
  const brokerTableOverrideCSS = css`
    padding: 10px 10px;
    font-family: $fontFamily;
    background-color: ${brokerColor ? brokerColor : "black"} !important;;
    color: $white;
  `;
  const defaultProjectOverviewPatchProps = ["name", "loanProgramId", "zip", "cityName", "stateName", "countyName"];
  const isViewOnly = isValidGuarantorAccessLevel(permissions, "GuarantorWhiteLabeledApplication", "read", startAppObject.guarantors ? startAppObject.guarantors : [], organizationContactId, GlobalConstants.AccessLevelIds.VIEW_ONLY);
  const isLimited = isValidGuarantorAccessLevel(permissions, "GuarantorWhiteLabeledApplication", "read", startAppObject.guarantors ? startAppObject.guarantors : [], organizationContactId, GlobalConstants.AccessLevelIds.LIMITED) || startAppObject.submittedOn;
  const isNonGuarantorDisabled = isViewOnly || isLimited;
  const initialPersona = whoAmI(user, proxyUser);
  const [persona, setPersona] = useState(initialPersona);
  const isAdminBrmNwlOrLo = [
    Personas.SYSTEM_ADMIN,
    Personas.SALES_ADMIN,
    Personas.BROKER_ADMIN,
    Personas.LOAN_OFFICER,
    Personas.BRM,
    Personas.NWL_GUARANTOR
  ].indexOf(persona) > -1;

  const isAllBorrowersPersona = [
    Personas.SYSTEM_ADMIN,
    Personas.SALES_ADMIN,
    Personas.LOAN_OFFICER,
    Personas.BRM
  ].indexOf(persona) > -1; 
  
  const isSubmitButtonPersona = [
    Personas.SYSTEM_ADMIN,
    Personas.SALES_ADMIN,
    Personas.BROKER_ADMIN,
    Personas.LOAN_OFFICER,
    Personas.BRM,
    Personas.BROKER,
    Personas.NWL_GUARANTOR,
    Personas.WL_GUARANTOR
  ].indexOf(persona) > -1;

  const isSubmitPersona = [
    Personas.BROKER_ADMIN,
    Personas.BROKER,
  ].indexOf(persona) > -1;

  const isAdminPersona = [
    Personas.SYSTEM_ADMIN,
    Personas.SALES_ADMIN,
    Personas.BROKER_ADMIN
  ].indexOf(persona) > -1;

  const isGuarantorPersona = [
    Personas.WL_GUARANTOR,
    Personas.NWL_GUARANTOR
  ].indexOf(persona) > -1;

  const isNotifyLoanOfficerPersona = [
    Personas.BROKER,
    Personas.NWL_GUARANTOR,
    Personas.WL_GUARANTOR,
  ].indexOf(persona) > -1;

  const [newBrokerageName, setNewBrokerageName] = useState((persona === Personas.BROKER_ADMIN && user?.organization?.name)? user?.organization?.name : "" as string);
  const isPermitTimingInMonthsNeeded = [GlobalConstants.PermitStatusIds.ISSUED, GlobalConstants.PermitStatusIds.NOT_APPLICABLE].indexOf(startAppObject.permitStatusId) === -1;
  const allowMultiplePropertiesLoanType = [GlobalConstants.LoanProgramIds.ALL_IN_ONE, GlobalConstants.LoanProgramIds.NEW_CONSTRUCTION, GlobalConstants.LoanProgramIds.BRIDGE_TO_BUILD].indexOf(startAppObject.loanProgramId) > -1;
  const singleUnitLoanType = [GlobalConstants.LoanProgramIds.DEVELOPMENT, GlobalConstants.LoanProgramIds.BRIDGE].indexOf(startAppObject.loanProgramId) > -1;
  const singleUnitPropertyTypeArray = [GlobalConstants.PropertyTypeIds.SINGLE_FAMILY, GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND, GlobalConstants.PropertyTypeIds.LAND_UNDEVELOPED];
  const allStartAppUnits = startAppObject.properties ? startAppObject.properties.reduce((acc, property) => Array.isArray(property.units) ? [...acc, ...property.units] : acc, []) : null;
  const isAdditionalDetailsRegardingPermitStatusOtherOptions = [GlobalConstants.PermitStatusIds.PENDING, GlobalConstants.PermitStatusIds.FINAL_ENGINEERING, GlobalConstants.PermitStatusIds.EXPIRED, GlobalConstants.PermitStatusIds.NO_APPLICATION, GlobalConstants.PermitStatusIds.OTHER, GlobalConstants.PermitStatusIds.SUBMITTED, GlobalConstants.PermitStatusIds.PRELIM_ENGINEERING].indexOf(startAppObject.permitStatusId) > -1;
  const BrokerApplicationEmptyState = ({ ...props}) => {
    return (
      <div className="application-empty-state">
        <div className="application-empty-container">
          <Icon name={props.iconName} style={wlColorStyle} size="huge" />
          <div className="application-empty-text">{props.label}</div>
          {props.action && props.buttonLabel && <Button 
            className="bp-button primary-under-table-button" 
            style={backgroundColorStyle} 
            icon 
            onClick={props.action}
            disabled={props.disabled}
          >
            <div className="gmr-button-container">
              {props.plus && <Icon name="add" size="large"/>}
              <div className={props.plus ? "gmr-button-icon-text" : "gmr-button-text"}>{props.buttonLabel}</div>
            </div>
          </Button>}
        </div>
      </div>
    );
  };

  const WhiteLabeledApplicationWelcome = () => {
    if (proxyUser && proxyUser.id) {
      user = proxyUser;
      user.name = `${proxyUser.firstName} ${proxyUser.lastName}`;
    }

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <BCFormInput labelClass="primary-title-label" label={`Welcome${(user && user.name) ? ` ${user.name}` : ""}!`} />
            You have been invited to complete the Loan Appliction{startAppObject.name ? ` for ${startAppObject.name}` : ""}.
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}>
            <BCFormInput label="Loan Application Overview" />
          </Grid.Column>
          <Grid.Column width={16}>
            <Step.Group vertical fluid className="bc-steps">
              <Step 
                className="bc-step-vertical" 
                active={handleStepIsActive(ProjectSteps.WhiteLabeledWelcome, PropertySteps.NumberOfProperties)} 
                completed={applicationScreenStatus.Projects === ProjectSteps.PermitStatus.id}
                disabled={handleStepIsDisabled(applicationScreenStatus.Projects, ProjectSteps.ProjectOverview)}
              >
                <div className={handleStepIsDisabled(applicationScreenStatus.Projects, ProjectSteps.ProjectOverview) ? "bc-step-numeric-disabled" : 
                  applicationScreenStatus.Projects === ProjectSteps.PermitStatus.id ? "bc-step-numeric-completed" : "bc-step-numeric"}
                  style={applicationScreenStatus.Projects === ProjectSteps.PermitStatus.id ? backgroundColorStyle : void 0}>1</div>
                <Step.Content className="bc-step-vertical-content">
                  <Step.Title className="bc-step-vertical-title">Tell us about the Project</Step.Title>
                  <Step.Description>Give us the overview of the Project details, such as location, Loan Program and background of the property and ownership.</Step.Description>
                </Step.Content>
              </Step>
              <Step 
                className="bc-step-vertical" 
                active={handleStepIsActive(PropertySteps.NumberOfProperties, BudgetSteps.RequestedBudget)} 
                completed={applicationScreenStatus.Property === PropertySteps.LoanTerm.id} 
                disabled={handleStepIsDisabled(applicationScreenStatus.Property, PropertySteps.NumberOfProperties)}
              >
                <div className={handleStepIsDisabled(applicationScreenStatus.Property, PropertySteps.NumberOfProperties) ? "bc-step-numeric-disabled" : 
                  applicationScreenStatus.Property === PropertySteps.LoanTerm.id ? "bc-step-numeric-completed" : "bc-step-numeric"} 
                  style={applicationScreenStatus.Property === PropertySteps.LoanTerm.id ? backgroundColorStyle : void 0}>2</div>
                <Step.Content className="bc-step-vertical-content">
                  <Step.Title className="bc-step-vertical-title">Tell us about the Property</Step.Title>
                  <Step.Description>This section captures property addresses, unit details, and plans.</Step.Description>
                </Step.Content>
              </Step>
              <Step 
                className="bc-step-vertical" 
                active={handleStepIsActive(BudgetSteps.RequestedBudget, EntitySteps.ExistingBorrower)} 
                completed={applicationScreenStatus.Budget === BudgetSteps.ProjectDetails.id} 
                disabled={handleStepIsDisabled(applicationScreenStatus.Budget, BudgetSteps.RequestedBudget)}
              >
                <div className={handleStepIsDisabled(applicationScreenStatus.Budget, BudgetSteps.RequestedBudget) ? "bc-step-numeric-disabled" : 
                  applicationScreenStatus.Budget === BudgetSteps.ProjectDetails.id ? "bc-step-numeric-completed" : "bc-step-numeric"}
                  style={applicationScreenStatus.Budget === BudgetSteps.ProjectDetails.id ? backgroundColorStyle : void 0}>3</div>
                <Step.Content className="bc-step-vertical-content">
                  <Step.Title className="bc-step-vertical-title">Tell us about the Budget</Step.Title>
                  <Step.Description>Provide details on costs paid to date, interest payments, payoff strategy and the builder details (if applicable).</Step.Description>
                </Step.Content>
              </Step>
              <Step 
                className="bc-step-vertical" 
                active={handleStepIsActive(EntitySteps.ExistingBorrower, GuarantorSteps.DoubleFilterGuarantor)} 
                completed={applicationScreenStatus.Entity === EntitySteps.RealEstateOwned.id} 
                disabled={handleStepIsDisabled(applicationScreenStatus.Entity, EntitySteps.ExistingBorrower)}
              >
                <div className={handleStepIsDisabled(applicationScreenStatus.Entity, EntitySteps.ExistingBorrower) ? "bc-step-numeric-disabled" : 
                  applicationScreenStatus.Entity === EntitySteps.RealEstateOwned.id ? "bc-step-numeric-completed" : "bc-step-numeric"}
                  style={applicationScreenStatus.Entity === EntitySteps.RealEstateOwned.id ? backgroundColorStyle : void 0}>4</div>
                <Step.Content className="bc-step-vertical-content">
                  <Step.Title className="bc-step-vertical-title">Tell us about the Borrowing Entity</Step.Title>
                  <Step.Description>Provide contact details, financial information and background on the Borrowing Entity.</Step.Description>
                </Step.Content>
              </Step>
              <Step 
                className="bc-step-vertical" 
                active={handleStepIsActive(GuarantorSteps.DoubleFilterGuarantor, SummarySteps.AdditionalCollateral)} 
                completed={newGuarantor.isDisclosureCompleted ? true : false} 
                disabled={handleStepIsDisabled(applicationScreenStatus.Guarantor, GuarantorSteps.DoubleFilterGuarantor)}
              >
                <div className={handleStepIsDisabled(applicationScreenStatus.Guarantor, GuarantorSteps.DoubleFilterGuarantor) ? "bc-step-numeric-disabled" : 
                  newGuarantor.isDisclosureCompleted ? "bc-step-numeric-completed" : "bc-step-numeric"}
                  style={newGuarantor.isDisclosureCompleted ? backgroundColorStyle : void 0}>5</div>
                <Step.Content className="bc-step-vertical-content">
                  <Step.Title className="bc-step-title">Tell us about yourself</Step.Title>
                  <Step.Description>Provide contact details, financial information and background as a Guarantor, or provide alternative contact details for additional Guarantors.</Step.Description>
                </Step.Content>
              </Step>
            </Step.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  const BrokerApplicationWelcome = () => {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <BCFormInput label="Application Tips" />
          </Grid.Column>
          <Grid.Column width={16}>  
            <Step.Group vertical fluid className="bc-steps">
              <Step className="bc-step-vertical" completed={true}>
                  <div className={"bc-step-numeric-completed"}>1</div>
                  <Step.Content className="bc-step-vertical-content">
                    <Step.Title className="bc-step-vertical-title">How to invite a Guarantor</Step.Title>
                    <Step.Description>
                      <div className="broker-welcome-padding">Click the button below to quickly invite your primary Guarantor, or click Next at the bottom to complete the application yourself.</div>
                      <Button className="bp-button" 
                        onClick={() => setPrimeGuarantorModal(true)}
                      >
                        <div className="gmr-button-container">
                          <div className="gmr-button-text">Invite Guarantor</div>
                        </div>
                      </Button>
                    </Step.Description>
                  </Step.Content>
                </Step>
                <Step className="bc-step-vertical" completed={true}>
                <div className={"bc-step-numeric-completed"}>{FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? "2" : "1"}</div>
                <Step.Content className="bc-step-vertical-content">
                  <Step.Title className="bc-step-vertical-title">How to skip around in the application</Step.Title>
                  <Step.Description>
                    <div className="broker-welcome-padding">Once you have completed the next two pages of the Projects Tab, you can click on any of the application tabs.</div>
                    <Image className="broker-welcome-skip-image" src={BrokerWelcomeSkipImage} />
                  </Step.Description>
                </Step.Content>
              </Step>
              {FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && <Step className="bc-step-vertical" completed={true}>
                <div className={"bc-step-numeric-completed"}>3</div>
                <Step.Content className="bc-step-vertical-content">
                  <Step.Title className="bc-step-vertical-title">Property Unit Redesign</Step.Title>
                  <Step.Description>The Property section has been revamped. You can now edit multiple properties in bulk, OR download a spreadsheet to complete offline and upload when you're ready.</Step.Description>
                </Step.Content>
              </Step>}
              {!FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && <Step className="bc-step-vertical" completed={true}>
                <div className={"bc-step-numeric-completed"}>3</div>
                <Step.Content className="bc-step-vertical-content">
                  <Step.Title className="bc-step-vertical-title">New Submission Process</Step.Title>
                  <Step.Description>Guarantors used to be able to submit the application to your Loan Officer, but now they will submit to you for review. You may send it to your Loan Officer when you are ready.</Step.Description>
                </Step.Content>
              </Step>}
            </Step.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  const AddGuarantorHelper = () => {
    const projectSecondRequiredIds = [
      ProjectSteps.ProjectStructure.id,
      ProjectSteps.DurationOwned.id,
      ProjectSteps.SubordinatedDebt.id,
      ProjectSteps.CumulativeProjectExperience.id,
      ProjectSteps.ProjectDevelopment.id,
      ProjectSteps.PermitStatus.id
    ];
    
    const projectFirstRequiredIds = projectSecondRequiredIds.concat([ProjectSteps.ProjectOverview.id]);
    return (
      <React.Fragment>
        <div>You can invite Guarantors as soon as the minimum information to get an application.</div>
        <div className="broker-welcome-list-item">{(applicationScreenStatus.Projects && projectFirstRequiredIds.indexOf(applicationScreenStatus.Projects) > -1) ? <Icon name="check square outline" color="green" /> : <Icon name="square outline" color="black" />}Project Name, Loan Program type, and your Broker Fee (Projects)</div>
        <div className="broker-welcome-list-item">{(applicationScreenStatus.Projects && projectSecondRequiredIds.indexOf(applicationScreenStatus.Projects) > -1) ? <Icon name="check square outline" color="green" /> : <Icon name="square outline" color="black" />}What is being built (Projects)</div>
        <div className="broker-welcome-list-item">{applicationScreenStatus.Entity ? <Icon name="check square outline" color="green" /> : <Icon name="square outline" color="black" />}Borrower Name, Type, and Business Address (Entity)</div>
        <div className="broker-welcome-list-item">{(selectedBrokerGuarantors && selectedBrokerGuarantors.length > 0) ? <Icon name="check square outline" color="green" /> : <Icon name="square outline" color="black" />}Guarantor Name and Email Address (Guarantor)</div>
      </React.Fragment>
    );
  };

  const GuarantorSocialSecurity = () => {
    return (
      <React.Fragment>
        {isSSNReveal ? <BCFormInput
          labelClass="gmr-background-label"
          actionText="Hide"
          actionLabel="Social Security Number"
          labelAction={() => setIsSSNReveal(!isSSNReveal)}
          actionLabelClass="sub-action-label"
          type="input"
          placeholder="123-45-6789"
          obj={newGuarantor}
          value={newGuarantor.socialSecurityNumber}
          field="socialSecurityNumber"
          fieldType="socialSecurity"
          inputType="text"
          handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.MASKED)}
          required
        /> : <BCFormInput
          labelClass="gmr-background-label"
          actionText="Reveal"
          actionLabel="Social Security Number"
          labelAction={() => setIsSSNReveal(!isSSNReveal)}
          actionLabelClass="sub-action-label"
          type="input"
          placeholder="123-45-6789"
          obj={newGuarantor}
          value={converToSSNString(newGuarantor.socialSecurityNumber)}
          field="socialSecurityNumber"
          inputType="text"
          required
          disabled
        />}
      </React.Fragment>
    );
  };

  const GuarantorDateOfBirth = () => {
    return (
      <React.Fragment>
        {isDOBReveal ? <BCFormInput 
          labelClass="gmr-background-label"
          type="calendar"
          actionText="Hide"
          actionLabel="Date Of Birth"
          labelAction={() => setIsDOBReveal(!isDOBReveal)}
          obj={newGuarantor}
          field="dateOfBirth"
          handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
        /> : <BCFormInput
          labelClass="gmr-background-label"
          actionText="Reveal"
          actionLabel="Date Of Birth"
          labelAction={() => setIsDOBReveal(!isDOBReveal)}
          actionLabelClass="sub-action-label"
          type="input"
          obj={newGuarantor}
          value="Hidden"
          field="dateOfBirth"
          inputType="text"
          disabled
        />}
      </React.Fragment>
    );
  };

  const GuarantorDisclosure = () => {
    return (
      <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
          <BCFormInput labelClass="primary-title-label" label={`Guarantor Disclosure${(newGuarantor.firstName && newGuarantor.lastName) ? ` for ${newGuarantor.firstName} ${newGuarantor.lastName}` : ""}`} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <React.Fragment>
            <Grid.Column width={16}>
              {newGuarantor && newGuarantor.isDisclosureCompleted === true ? <BrokerApplicationEmptyState 
                iconName="pencil"
                label="Looks Like you have completed your Disclosures, please go click next to view your summary!"
              /> : <BrokerApplicationEmptyState 
                iconName="pencil"
                label="Click the button to review and electronically sign your disclosures."
                action={() => handleDisclosure(startAppObject.id)}
                buttonLabel="Sign My Disclosures"
                disabled={process.env.REACT_APP_ENV !== Environments.LOCAL && process.env.REACT_APP_ENV !== Environments.DEVELOPMENT && proxyUser && proxyUser.id}
              />}
            </Grid.Column>
          </React.Fragment>
        </Grid.Row>
      </React.Fragment>
    );
  };

  const handleCustomFormChange = (field, value, formObj) => {
    if (field === ProjectQuestions.LoanProgram.field) {
      if (value === GlobalConstants.LoanProgramIds.ALL_IN_ONE) {
        setExcludedStepIds(AllInOneExcludeIds);
      }
      else if (value === GlobalConstants.LoanProgramIds.BRIDGE) {
        setExcludedStepIds(FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? [...BridgeExcludeIds, PropertySteps.Plans.id] : BridgeExcludeIds);
      }
      else if (value === GlobalConstants.LoanProgramIds.DEVELOPMENT) {
        setExcludedStepIds(FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? [...DevelopmentExcludeIds, PropertySteps.Plans.id] : DevelopmentExcludeIds);
      }
      else if (value === GlobalConstants.LoanProgramIds.FIX_AND_FLIP) {
        setExcludedStepIds(FixAndFlipExcludeIds);
      }
      else if (value === GlobalConstants.LoanProgramIds.NEW_CONSTRUCTION) {
        setExcludedStepIds(NewConstructionExcludeIds);
      }
      else if (value === GlobalConstants.LoanProgramIds.BRIDGE_TO_BUILD) {
        setExcludedStepIds(BridgeToBuildExcludeIds);
      }

      return startAppObject;
    }

    if (field === ProjectQuestions.LoanProgram.field && [GlobalConstants.LoanProgramIds.BRIDGE, GlobalConstants.LoanProgramIds.DEVELOPMENT].indexOf(formObj[field]) > -1
      && [GlobalConstants.LoanProgramIds.BRIDGE, GlobalConstants.LoanProgramIds.DEVELOPMENT].indexOf(value) === -1) {
      const addWarningIds = warningIds.concat([ApplicationWarnings.Reinput.id]);
      setWarningIds([]);
      setTimeout(() => { 
        setWarningIds([...addWarningIds]);
      }, 50);
    }
    else if (field === "wlbrokerFeeRate" && (Number(value) + minMandatoryBrokerFee > 2) &&
      !warningIds.includes(ApplicationWarnings.OriginationFee.id)) {
      const addWarningIds = warningIds.concat([ApplicationWarnings.OriginationFee.id]);
      setWarningIds([]);
      setTimeout(() => { 
        setWarningIds([...addWarningIds]);
      }, 50);
    }
    else if (field === ProjectQuestions.DurationOwned.field) {
      if (value === GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE) {
        startAppObject.durationOwnedId = null;
        startAppObject.amountOwed = null;
        startAppObject.cashOutAmountRequested = null;
        startAppObject.estimatePropertyValue = null;
      }

      if (value === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL) {
        startAppObject.cashOutAmountRequested = null;
      }

      if (value === GlobalConstants.PurchaseOrRefinanceOptionIds.OWN) {
        startAppObject.amountOwed = null;
      }

      setStartAppObject({...startAppObject});
    }
    else if (field === ProjectQuestions.SubordinatedDebt.field && value === false) {
      startAppObject.subordinatedDebtAmount = null;
      setStartAppObject({...startAppObject});
    }
    else if (field === PropertyQuestions.NumberOfProperties.field) {
      startAppObject.hasPropertiesChanged = true;
      setStartAppObject({...startAppObject});
    }
    else if (field === "isExistingBorrower" && value === false) {
      startAppObject.borrowerEntity = undefined;
      startAppObject.borrowerOrganizationId = undefined;
      setNewBorrowerEntity({});
      setStartAppObject({...startAppObject});
    }
    else if (field === "isAdditionalGuarantors" && value === false) {
      if (startAppObject.invitedGuarantors && startAppObject.invitedGuarantors.length > 0) {
        startAppObject.invitedGuarantors.forEach(async (invitedGuarantor) => {
          const guarantorDeleteObj = {
            borrowerApplicationId: startAppObject.id,
            organizationContactId: invitedGuarantor.id
          };

          await handleDeleteGuarantorAsync(guarantorDeleteObj);
        });
      }
      
      startAppObject.invitedGuarantors = undefined;
      setStartAppObject({...startAppObject});
    }
  };

  const handleApplicationFormChange = (value, field, obj = startAppObject, setObj = setStartAppObject, type = "string", handleCustomFormChange = undefined as any, charLimit = undefined as number | undefined) => {
    handleFormChange(value, field, obj, setObj, type, handleCustomFormChange, charLimit);
    setIsScreenFormChanged(true);
  };

  const handlePurchaseRefinanceOptionFormChange = (value, field, handleCustomFormChange) => {
    if (value === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL) {
      setIsRefinanceSelected(true);
    }
    else {
      setIsRefinanceSelected(false);
    }

    handleFormChange(value, field, startAppObject, setStartAppObject, GlobalConstants.InputTypes.STRING, handleCustomFormChange);
    setIsScreenFormChanged(true);
  };

  const handleRefinanceSummaryText = (purchaseRefinanceOptionLookupId) => {
    if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
      if (startAppObject.refinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_INTERNAL) {
        return `Refinance; Internal (${BPQuestionLabels.RefinanceInternalDescription})`;
      }
      else if (startAppObject.refinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL) {
        return `Refinance; External (${BPQuestionLabels.RefinanceExternalDescription})`;
      }
      else if (startAppObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL) {
        return "N/A";
      }
    }

    return handleGetValueFromId(applicationMetadata.purchaseRefinance, purchaseRefinanceOptionLookupId);
  };

  const handleAssociatedBrokerChange = (value, field) => {
    if (!value) {
      setBrokerSearch("");
      startAppObject.brokerOrganizationContactId = null;
      delete startAppObject.brokerFeeRate;
      delete startAppObject.wlbrokerFeeRate;
    }

    user[field] = value;
    startAppObject[field] = value;
    setStartAppObject({...startAppObject});
    setIsScreenFormChanged(true);
  };

  const handleAddBroker = () => {
    if (brokerSearch !== "") {
      handleNewBrokerModal();
    }
  };
  
  const handleNewBrokerModal = async () => {
    const notValidEmails = validateEmails(startAppObject, ["brokerSearchEmail"]);
    if (notValidEmails.length === 0) {
      setInvalidProps([]);
      setIsLoading(true);
      const existedBrokerEmail = await handleGetBrokerEmailExistsAsync(brokerSearch);
      if (existedBrokerEmail) {
        setSelectedBrokerEmail(existedBrokerEmail);
        setIsBrokerSearchFocus(false);
      }
      else {
        newBroker.brokerEmail = brokerSearch;
        if (!newBroker.id) {
          newBroker.id = guid();
        }

        setNewBroker({...newBroker});
        setIsBrokerModalOpen(true);
      }

      setIsLoading(false);
    }
    else {
      invalidProps.push("custom-broker-invalid-email");
      setInvalidProps([...invalidProps]);
    }
  };

  const handleBrokerSearchChange = async (value, field, charLimit = undefined as number | undefined) => {
    if (value && selectedBrokerEmail && value !== selectedBrokerEmail) {
      setSelectedBrokerEmail("");
      delete startAppObject.brokerOrganizationContactId;
      setStartAppObject({...startAppObject});
    }

    handleFormChange(value, field, startAppObject, setStartAppObject);
    const brokerSearchValue = handleInputType("string", value, undefined, undefined, charLimit);
    setInvalidProps([]);
    setBrokerSearch(brokerSearchValue);
    if (brokerSearchValue !== "" && applicationMetadata.associatedBrokers && applicationMetadata.associatedBrokers.length > 0) {
      const filteredBrokers = applicationMetadata.associatedBrokers.filter(x => ((x.firstName && ((x.firstName).toLowerCase().includes(brokerSearchValue.toLowerCase()))) || 
        (x.lastName && (x.lastName).toLowerCase().includes(brokerSearchValue.toLowerCase())) ||
        (x.email && (x.email).toLowerCase().includes(brokerSearchValue.toLowerCase()))));
        setBrokerSearchDropdown(filteredBrokers);
    }
    else if (brokerSearchValue === "" && applicationMetadata.associatedBrokers && applicationMetadata.associatedBrokers.length > 0) {
      setBrokerSearchDropdown(applicationMetadata.associatedBrokers);
    }
    else {
      setBrokerSearchDropdown([]);
    }
  };

  const handleDoubleFilterBrokerSuggestions = () => {
    const results = [] as any[];
    let resultLimit = 6;
    let associatedBrokers = applicationMetadata.associatedBrokers;
    if (brokerSearch && brokerSearch !== "") {
      associatedBrokers = brokerSearchDropdown;
    }

    if (associatedBrokers && associatedBrokers.length > 0) {
      associatedBrokers.forEach(broker => {
        if (resultLimit > 0 && broker.email !== brokerSearch) {
          const brokerObj = {
            id: broker.id,
            email: broker.email,
            firstName: broker.firstName,
            lastName: broker.lastName,
            status: broker.status
          };

          results.push({
            key: broker.id,
            title: `${broker.firstName} ${broker.lastName}`,
            description: broker.email,
            value: brokerObj,
            firstName: broker.firstName,
            lastName: broker.lastName,
            status: broker.status
          });

          resultLimit--;
        }
      });
    }

    return results;
  };

  const handleBrokerSelect = async (result) => {
    if (result && result !== "") {
      setInvalidProps([]);
      if (result.value && result.value.id && result.value.email) {
        setSelectedBrokerEmail(result.value.email);
        setStartAppObject({...startAppObject, brokerOrganizationContactId: result.value.id, brokerSearchEmail: result.value.email });
      }

      setBrokerSearch(result.value.email);
      setIsBrokerSearchFocus(false);
    }
  };

  const handleBrokerSearchKeyDown = async (e) => {
    if (FeatureFlags.IS_BETA) {
      if (e.keyCode === 13 && currentStepId === ProjectSteps.ProjectOverview.id && isBrokerSearchFocus) {
        await handleNewBrokerModal();
      }
      else if (e.keyCode === 27) {
        handleBrokerSearchClear();
      }
    }
  };

  const handleBrokerSearchClear = () => {
    setIsBrokerSearchFocus(true);
    setBrokerSearch("");
  };

  const handleSelectBrokerage = (value, field) => {
    handleFormChange(value, field, brokerageInfo, setBrokerageInfo, GlobalConstants.InputTypes.STRING, handleCustomFormChange);
    const selectedBrokerage = similarBrokerageList.find(x => x.id === value);
    const brokerageKey = (name: keyof IBrokerage) : string => name;
    if (selectedBrokerage) {
      Object.entries(selectedBrokerage).forEach(([key, value]) => {
        if (key === brokerageKey("name")) {
          brokerageInfo.organizationName = value;
        } 
        else if (key === brokerageKey("id")) {
          brokerageInfo.organizationId = value;
        }
        else {
          brokerageInfo[key] = value;
        }
      });

      setBrokerageInfo({...brokerageInfo});
      setIsNewBrokerage(false);
    }
    else {
      setBrokerageInfo({ organizationName: newBrokerageName, organizationId: newBrokerageId });
      setIsNewBrokerage(true);
    }
  };

  const handleOpenBrokerageListModal = async () => {
    setInvalidProps([]);
    let notValidProps = [] as string[];
    notValidProps = validateObj(newBroker, ["firstName", "lastName", "phone", "brokerEmail"]);
    if (!newBrokerageName) {
      notValidProps.push("organizationName");
    }

    if (notValidProps.length === 0) {
      newBroker.id = guid();
      setIsModalLoading(true);
      const isSearchBrokerageNameSuccess = await handleGetBrokerageNameListAsync(newBrokerageName);
      if (isSearchBrokerageNameSuccess) {
        setNewBrokerageId(guid());
        setNewBrokerageName(newBrokerageName);
        setIsModalLoading(false);
        setIsBrokerageNameModalOpen(true);
        setIsBrokerModalOpen(false);
      }

      setIsModalLoading(false);
    }
    else {
      setTimeout(() => { 
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleGetBrokerageNameListAsync = async (name) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockSimilarBrokerageNameList() : await getSimilarBrokerageNameList(encodeURI(name), proxyUser.id) as any;
      if (response && response.ok) {
        setIsMessage(false);
        const companyList = await response.json();
        setSimilarBrokerageList([...companyList]);
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleOpenBrokerageInfoModal = async () => {
    setInvalidProps([]);
    if(brokerageInfo.organizationId) {
      setIsBrokerageInfoModalOpen(true);
      setIsBrokerageNameModalOpen(false);
      setBrokerageInfo({...brokerageInfo, isMailingSameAsPhysical: true });
    }
    else {
      setTimeout(() => { 
        setInvalidProps(["organizationId"]);
      }, 50);
    }
  };

  const handleBrokerModalSubmit = async () => {
    setInvalidProps([]);
    let notValidProps = [] as string[];
    if (isNewBrokerage) {
       notValidProps = validateObj(brokerageInfo, ["entitySubTypeId", "physicalStreet", "physicalZipCode", "physicalCityName", "physicalStateName"]);
       if (!brokerageInfo.isMailingSameAsPhysical) {
        notValidProps = validateObj(brokerageInfo, ["entitySubTypeId", "physicalStreet", "physicalZipCode", "physicalCityName", "physicalStateName", "mailingStreet", "mailingCityName", "mailingStateName", "mailingZipCode"]);
       }
    }

    if (notValidProps.length === 0) {
      if (brokerageInfo.isMailingSameAsPhysical) {
        brokerageInfo.mailingStreet = combineAddresses(brokerageInfo.physicalStreet, brokerageInfo.physicalAddressLine2);
        brokerageInfo.mailingZipCode = brokerageInfo.physicalZipCode;
        brokerageInfo.mailingCityName = brokerageInfo.physicalCityName;
        brokerageInfo.mailingStateName = brokerageInfo.physicalStateName;
        brokerageInfo.mailingCountyName = brokerageInfo.physicalCountyName || "";
      }
      else {
        brokerageInfo.mailingStreet = combineAddresses(brokerageInfo.mailingStreet, brokerageInfo.mailingAddressLine2);
      }

      const completedBrokerObj = {...newBroker, ...brokerageInfo};
      completedBrokerObj.physicalStreet = combineAddresses(brokerageInfo.physicalStreet, brokerageInfo.physicalAddressLine2);
      delete completedBrokerObj.isMailingSameAsPhysical;
      delete completedBrokerObj.physicalAddressLine2;
      delete completedBrokerObj.mailingAddressLine2;
      const isApiSuccess = await handleCreateNewBrokerAsync(completedBrokerObj);
      if (isApiSuccess) {
        setIsBrokerageInfoModalOpen(false);
        setIsNewBrokerCreated(true);
        setStartAppObject({...startAppObject, brokerOrganizationContactId: newBroker.id});
      }

      setIsModalLoading(false);
    }
    else {
      setTimeout(() => { 
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleCreateNewBrokerAsync = async (newBroker) => {
    setIsModalLoading(true);
    try {
      const response = FeatureFlags.IS_MOCK ? await createMockNewBroker() : await createNewBroker(newBroker, proxyUser.id);
      if (response && response.ok) {
        setIsModalMessage(false);
        if (isAdminBrmNwlOrLo) {
          const allBrokers = await getAllBrokersAsync();
          applicationMetadata.associatedBrokers = allBrokers;
          setApplicationMetadata(applicationMetadata);
        }
        
        return true;
      }
      else {
        await handleErrorResponse(response, setIsModalMessage, setErrorResponse);
        setIsModalMessage(true);
      }
    }
    catch (error) {
      setIsModalMessage(false);
    }

    setIsModalLoading(false);
    return false;
  };

  const handleUserIsLoanOfficer = (gmrMetadata, user) => {
    if (gmrMetadata.loanOfficers && user.organizationContactId) {
      gmrMetadata.loanOfficers.forEach(loanOfficer => {
        if (loanOfficer.id === user.organizationContactId) {
          setStartAppObject({...startAppObject, loanOfficerOrganizationContactId: user.organizationContactId });
          return user.organizationContactId;
        }
      });
    }

    return false;
  };

  const handleDefaultOneProperty = () => {
    const prefillPropertyValue = (field) => {
      if (startAppObject.properties && startAppObject.properties[0] && startAppObject.properties[0][field]){
        return startAppObject.properties[0][field];
      }

      return startAppObject[field];
    };

    if (!startAppObject.properties || startAppObject.properties.length < 1) {
      startAppObject.numberOfProperties = 1;
      startAppObject.properties = [{
        id: guid(),
        numberOfUnits: 1,
        city : prefillPropertyValue("city"),
        state : prefillPropertyValue("state"),
        county : prefillPropertyValue("county"),
        zip : prefillPropertyValue("zip"),
        newStructurePropertyTypeId : prefillPropertyValue(ProjectQuestions.NewStructure.field),
        existingStructurePropertyTypeId : prefillPropertyValue(ProjectQuestions.ExistingStructure.field),
        zoning : prefillPropertyValue(ProjectQuestions.Zoning.field),
        workStageId : UserFeatureFlags.IS_RETAIL_PHASE_2 ? prefillPropertyValue("workStageId") : prefillPropertyValue(ProjectQuestions.PercentComplete.field)
      }];

      startAppObject.hasPropertiesChanged = true;
    }
  };
  
  const handleProjectLevelPropertyInfoChange = (value, field, obj = startAppObject, setObj = setStartAppObject) => {
    const formattedValue = handleInputType(GlobalConstants.InputTypes.STRING, value, undefined, undefined, 50);
    if (obj.properties) {
      const newProperties = obj.properties.map(property => { 
        property[field] = formattedValue;
        return property;
      });
      obj.hasPropertiesChanged = true;
      setObj({...obj, properties: newProperties});
    }

    if (obj.borrowerApplicationProperties) {
      const newBAProperties = obj.borrowerApplicationProperties.map(property => { 
        property[field] = formattedValue;
        return property;
      });
      obj.hasPropertiesChanged = true;
      setObj({...obj, borrowerApplicationProperties: newBAProperties});
    }

    handleApplicationFormChange(formattedValue, field, startAppObject, setStartAppObject, GlobalConstants.InputTypes.STRING, undefined, 50);
  };

  const handlePaidCostsFormChange = async (value, field, obj = startAppObject, setObj = setStartAppObject, type = "string", handleCustomFormChange = undefined as any, charLimit = undefined as number | undefined) => {
    let isApiSuccess = true;
    if (value) {
      if (!obj.gmrCostPaids) {
        obj.gmrCostPaids = [{ id: guid() }];
      }
    }
    else if (!value && initialStartAppObject.gmrCostPaids && initialStartAppObject.gmrCostPaids.length > 0) {
      const initialCostsPaidsIds = Array.from(initialStartAppObject.gmrCostPaids as any[], x => x.id);
      isApiSuccess = await handleDeleteCostsPaidsAsync(initialCostsPaidsIds);
      if (isApiSuccess) {
        obj.gmrCostPaids = undefined;
      }
    }

    if (isApiSuccess) {
      handleFormChange(value, field, obj, setObj, type, handleCustomFormChange, charLimit);
      setIsScreenFormChanged(true);
    }
  };

  const handlePropertyUploadOption = (value, field) => {
    setInvalidProps([]);
    handleApplicationFormChange(value, field, undefined, undefined, undefined, handleCustomFormChange(field, value, startAppObject));
    if (value === true) {
      if (!startAppObject.numberOfProperties) {
        setInvalidProps([...invalidProps, "numberOfProperties"]);
      }
    }
  };

  const handleUploadPropertyUnitExcel = async (file) => {
    setInvalidProps(invalidProps.filter(x => x !== "invalid-excel-upload"));  
    if (file && (file.type.includes(FileType.EXCEL_BASIC) || file.type.includes(FileType.EXCEL_XLSX))) {
      setIsMessage(false);
      setIsLoadingPropertyUnitExcel(true);
      const excelPropertyInfo = await importPropertyUnitExcelAsync(file);
      if (excelPropertyInfo) {
        const excelProperties = [] as any[];
        let greatestLoanTermSum = 0;
        excelPropertyInfo.forEach(property => {
          const loanTermSum = operationOfNumberArray("sum", [property.monthOfFirstDraw, property.buildTimeInMonths, property.timeFrameToSellOrRefinanceInMonths, -1]);
          if (loanTermSum && loanTermSum > greatestLoanTermSum) {
            greatestLoanTermSum = loanTermSum;
          }

          const formattedUnits = property.borrowerApplicationPropertyUnits;
          formattedUnits.forEach((unit) => {unit.completedValue = unit.afterRepairValue; return unit;});
          excelProperties.push({
            ...property,
            address: property.street,
            city: property.city && property.city.name,
            state: property.state && property.state.name,
            county: property.county && property.county.name,
            units: formattedUnits
          });
        });

        setGreatestTotalToComplete(greatestLoanTermSum);
        startAppObject.properties = excelProperties;
        setExcelProperties(excelProperties);
        setStartAppObject(startAppObject);
      }
    }
    else {
      setInvalidProps([...invalidProps, "invalid-excel-upload"]);
    }
  };

  const handlePlanFormChange = (value, field, unitIndex, type, charLimit = undefined as number | undefined) => {
    startAppObject.hasPlansChanged = true;
    startAppObject.unitPlans[unitIndex][field] = handleInputType(type, value, startAppObject, field, charLimit);
    setStartAppObject({...startAppObject});
  };

  const handleCopyFromAboveProperty = (index) => {
    if (startAppObject.properties[index-1] && startAppObject.properties[index] && startAppObject.properties[index-1].numberOfUnits !== startAppObject.properties[index].numberOfUnits) {
      copiedFromAbove.push(index);
      setCopiedFromAbove([...copiedFromAbove]);
    }

    Object.assign(startAppObject.properties[index], startAppObject.properties[index - 1], { 
      id: startAppObject.properties[index].id,
      address: startAppObject.properties[index].address
    });

    const copiedUnits = [] as any[];
    if (startAppObject.properties[index - 1] && startAppObject.properties[index - 1].units) {
      startAppObject.properties[index - 1].units.forEach(unit => {
        const copiedUnit = {
          id: guid(),
          propertyIndex: index,
          unitIndex: unit.unitIndex
        };

        copiedUnits.push(copiedUnit);
      });
    }

    startAppObject.properties[index].units = copiedUnits;
    setStartAppObject({...startAppObject});
  };

  const handleCopyToAllProperty = (startIndex, endIndex) => {
    for (let index = startIndex; index <= endIndex; index++) {
      if (startAppObject.properties && startAppObject.properties[index-1] && startAppObject.properties[index] && startAppObject.properties[index-1].numberOfUnits !== startAppObject.properties[index].numberOfUnits) {
        copiedFromAbove.push(index);
        setCopiedFromAbove([...copiedFromAbove]);
      }
  
      Object.assign(startAppObject.properties[index], startAppObject.properties[index - 1], { 
        id: startAppObject.properties[index].id,
        address: startAppObject.properties[index].address
      });
  
      const copiedUnits = [] as any[];
      if (startAppObject.properties[index - 1] && startAppObject.properties[index - 1].units) {
        startAppObject.properties[index - 1].units.forEach(unit => {
          const copiedUnit = {
            id: guid(),
            propertyIndex: index,
            unitIndex: unit.unitIndex
          };
  
          copiedUnits.push(copiedUnit);
        });
      }
  
      startAppObject.properties[index].units = copiedUnits;
    }
    
    setStartAppObject({...startAppObject});
  };

  const handleFormatNewStructureDropdownOptions = (propertyTypes) => {
    if (allowMultiplePropertiesLoanType && startAppObject.newStructurePropertyTypeId !== GlobalConstants.PropertyTypeIds.APARTMENT) {
      return getDropdownOptions(propertyTypes, ["id"], "name").filter(option => option.value !== GlobalConstants.PropertyTypeIds.APARTMENT);
    }

    return getDropdownOptions(propertyTypes, ["id"], "name");
  };

  const handlePropertyTableData = () => {
    const propertyTable = [] as any;
    if (startAppObject.properties) {
      startAppObject.properties.forEach(property => {
        propertyTable.push({
          "id": property.id,
          "Address (or unique identifier)": <React.Fragment>
            <BCFormInput 
              type={GlobalConstants.FormInputTypes.INPUT}
              inputKey={`property-${property.id}`}
              placeholder="123 Main Street"
              obj={property}
              field="address"
              value={property.address}
              handleFormChange={(value) => handlePropertiesFormChange(value, "address", property)}
              required
              autoFocus
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop={`custom-properties-address-${property.id}`} />
          </React.Fragment>,
          "Zip": <React.Fragment>
            <BCFormInput
              inputKey={`property-${property.id}`}
              type={GlobalConstants.FormInputTypes.PLACES}
              placeDetailsObject={property}
              setPlaceDetailsObject={(placeDetailObject) => handlePropertiesZipChange(property, placeDetailObject)}
              placeholder="98052"
              defaultValue={handleAddressValue({
                zip: property.zip
              })}
              autofillOverrides={["zip"]}
              placeFields={["city", "state", "county", "zip"]}
              fieldType={GlobalConstants.InputTypes.ZIP}
              searchScopeOptions={GlobalConstants.ZipSearchScopeOptions}
              required
              disabled={isNonGuarantorDisabled}
            />
            {invalidProps.includes(`custom-properties-state-${property.id}`) ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop={`custom-properties-state-${property.id}`}
              propText="This state for this zip is invalid." 
            /> : <BCValidationMessage 
              invalidProps={invalidProps} 
              prop={`custom-properties-zip-${property.id}`}
              propText="This zip is invalid." 
            />}
          </React.Fragment>,
          "No. of Units": <React.Fragment>
            <BCFormInput 
              inputKey={`property-${property.id}`}
              type={GlobalConstants.FormInputTypes.INPUT}
              placeholder="2"
              field="numberOfUnits"
              value={(singleUnitLoanType || [...singleUnitPropertyTypeArray].indexOf(property.newStructurePropertyTypeId)) > -1 ? 1 : property.numberOfUnits}
              handleFormChange={(value, field) => handlePropertyNumberOfUnitChange(value, field, property)}
              required
              disabled={singleUnitLoanType
                || isNonGuarantorDisabled 
                || (startAppObject.newStructurePropertyTypeId && [...singleUnitPropertyTypeArray].indexOf(startAppObject.newStructurePropertyTypeId) > -1)
                || [...singleUnitPropertyTypeArray].indexOf(property.newStructurePropertyTypeId) > -1}
            />
            <BCValidationMessage invalidProps={invalidProps} prop={`custom-properties-numberOfUnits-${property.id}`} />
          </React.Fragment>,
          "Existing Structure": <React.Fragment>
            <BCFormInput 
              inputKey={`property-${property.id}`}
              type={GlobalConstants.FormInputTypes.DROPDOWN}
              placeholder="Please Select"
              field="existingStructurePropertyTypeId"
              dropdownOptions={getDropdownOptions(applicationMetadata.propertyTypes, ["id"], "name")}
              value={property.existingStructurePropertyTypeId ? property.existingStructurePropertyTypeId : startAppObject.existingStructurePropertyTypeId ? startAppObject.existingStructurePropertyTypeId : ""}
              handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property)}
              required
              disabled={!allowMultiplePropertiesLoanType || isNonGuarantorDisabled }
            />
            <BCValidationMessage invalidProps={invalidProps} prop={`custom-properties-existingStructurePropertyTypeId-${property.id}`} />
          </React.Fragment>,
          "New Structure": <React.Fragment>
              <BCFormInput 
                labelClass="gmr-background-label"
                inputKey={`property-${property.id}`}
                type={GlobalConstants.FormInputTypes.DROPDOWN}
                placeholder="Please Select"
                field="newStructurePropertyTypeId"
                dropdownOptions={handleFormatNewStructureDropdownOptions(applicationMetadata.propertyTypes)}
                value={property.newStructurePropertyTypeId ? property.newStructurePropertyTypeId : startAppObject.newStructurePropertyTypeId ? startAppObject.newStructurePropertyTypeId : ""}
                handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property)}
                required
                disabled={!allowMultiplePropertiesLoanType || startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.APARTMENT || isNonGuarantorDisabled }
              />
              <BCValidationMessage invalidProps={invalidProps} prop={`custom-properties-newStructurePropertyTypeId-${property.id}`} />
          </React.Fragment>,
          "Finished Value (ARV)": <React.Fragment>
            <BCFormInput
              type={GlobalConstants.FormInputTypes.INPUT}
              inputKey={`unit-completedValue-${property.id}`}
              placeholder="100000"
              field="completedValue"
              fieldType="dollar"
              inputType="number"
              obj={property}
              value={(property.units && property.units[0]) ? property.units[0].completedValue : property.completedValue}
              handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property, GlobalConstants.InputTypes.DOLLAR)}
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop={`custom-properties-completedValue-${property.id}`} />
          </React.Fragment>,
          "Stabilized Value (ARV)": <React.Fragment>
            <BCFormInput
              type={GlobalConstants.FormInputTypes.INPUT}
              inputKey={`unit-completedValue-${property.id}`}
              placeholder="100000"
              field="completedValue"
              fieldType="dollar"
              inputType="number"
              obj={property}
              value={(property.units && property.units[0]) ? property.units[0].completedValue : property.completedValue}
              handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property, GlobalConstants.InputTypes.DOLLAR)}
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop={`custom-properties-completedValue-${property.id}`} />
          </React.Fragment>,
          "Current Parcel No.": <React.Fragment>
            <BCFormInput 
              inputKey={`property-${property.id}`}
              type={GlobalConstants.FormInputTypes.INPUT}
              placeholder="1"
              field="parcelNumber"
              value={property.parcelNumber}
              handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property)}
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop={`custom-properties-parcelNumber-${property.id}`} />
          </React.Fragment>,
          "Lot No.": <React.Fragment>
            <BCFormInput 
              inputKey={`property-${property.id}`}
              type={GlobalConstants.FormInputTypes.INPUT}
              placeholder="1"
              field="lotNumber"
              value={property.lotNumber}
              handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property)}
              disabled={isNonGuarantorDisabled}
            />
          </React.Fragment>,
          "Zoning": <React.Fragment>
            <BCFormInput
              inputKey={`property-${property.id}`}
              type={GlobalConstants.FormInputTypes.INPUT}
              field="zoning"
              value={property.zoning}
              handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property)}
              disabled={isNonGuarantorDisabled}
            />
          </React.Fragment>,
          "% of Work Complete": <React.Fragment>
            <BCFormInput 
              inputKey={`property-${property.id}`}
              type={GlobalConstants.FormInputTypes.DROPDOWN}
              field="workStageId"
              value={property.workStageId}
              dropdownOptions={getDropdownOptions(applicationMetadata.workStages, ["id"], "name")}
              handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property)}
              disabled={isNonGuarantorDisabled}
            />
          </React.Fragment>,
        });
      });
    }

    if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE) {
      if (startAppObject.newStructurePropertyTypeId !== GlobalConstants.PropertyTypeIds.APARTMENT) {
        propertyTable.forEach(row => delete row[BPQuestionLabels.EstimatedSalesPrice]);
      }
      else {
        propertyTable.forEach(row => delete row["Finished Value (ARV)"]);
      }
    }
    else {
      propertyTable.forEach(row => delete row["Finished Value (ARV)"]);
      if (startAppObject.newStructurePropertyTypeId !== GlobalConstants.PropertyTypeIds.APARTMENT) {
        propertyTable.forEach(row => delete row["Stabilized Value (ARV)"]);
      }
    }

    return propertyTable;
  };

  const getAscendingLotEditFieldValue = (checkedIdItems: string[], bulkEditState: any, arr: {[key: string]: unknown}[]) => {
    if (checkedIdItems.length === 0 || !arr) {
      return "";
    }

    if (bulkEditState && (bulkEditState.lotNumberStartingFrom || bulkEditState.lotNumberStartingFrom === "")) {
      return bulkEditState.lotNumberStartingFrom;
    }

    const checkedItems = arr.filter((item) => checkedIdItems.indexOf(item.id as string) !== -1) as any[];
    const isAllCheckedEmpty = checkedItems.every(x => { return !x.lotNumber; });
    if (isAllCheckedEmpty) {
      return "";
    }
    
    let firstLotValue = "";
    let previousLotValue = null as number | null;
    let isMixed = false;
    checkedItems.forEach((checkedItem, i) => {
      if (i === 0) {
        if (isNaN(checkedItem.lotNumber)) {
          isMixed = true;
        }

        firstLotValue = checkedItem.lotNumber;
      }

      if ((i !== 0 && !previousLotValue) || (checkedItem.lotNumber !== firstLotValue && (previousLotValue && checkedItem.lotNumber !== previousLotValue.toString()))) {
        isMixed = true;
      }

      if (!isNaN(checkedItem.lotNumber)) {
        previousLotValue = parseInt(checkedItem.lotNumber);
        previousLotValue++;
      }
    });

    if (isMixed) {
      return GlobalConstants.BulkEditValue.MIXED;
    }

    return `Ascending starting from ${firstLotValue}` || "";
  };

  const getPropertyBulkEditFieldValue = getBulkEditFieldValue.bind(null, checkedProperties, propertyInformationBulkEdit, startAppObject.properties);

  const getARVPropertyBulkEditValue = getBulkEditFieldValue.bind(
    null,
    startAppObject.properties ? startAppObject.properties.reduce((acc, property) => [
      ...acc,
      ...(checkedProperties.indexOf(property.id) !== -1 && property.units ? property.units.map((unit) => unit.id) : [])
    ], []) : [],
    propertyInformationBulkEdit,
    allStartAppUnits,
    "completedValue"
  );

  const handleSelectPropertyAddressBulkEditField = (value, field) => {
    setIsPropertyBulkEditAddressOpen(false);
    handlePropertyBulkEditFieldChange(value, field);
  };

  const handlePropertyAddressBulkEditFieldSearchChange = (value, field) => {
    setIsPropertyBulkEditAddressOpen(true);
    handlePropertyBulkEditFieldChange(value, field);
  };

  const handleSelectPropertyLotBulkEditField = (value, field) => {
    setIsPropertyBulkEditLotOpen(false);
    handlePropertyBulkEditFieldChange(value, field);
  };

  const handlePropertyLotBulkEditFieldSearchChange = (value, field) => {
    if (value.includes("Ascending starting from ")) {
      const lotNumberStartingFromSplit = value.split("Ascending starting from ");
      if (lotNumberStartingFromSplit[1] && !isNaN(lotNumberStartingFromSplit[1])) {
        propertyInformationBulkEdit.lotNumber = lotNumberStartingFromSplit[1];
        setPropertyInformationBulkEdit({...propertyInformationBulkEdit});
      }
    }
    setIsPropertyBulkEditLotOpen(true);
    handlePropertyBulkEditFieldChange(value, field);
  };

  const handlePropertyBulkEditLotNumberChange = (value, field, type) => {
    if (!isNaN(value)) {
      propertyInformationBulkEdit.lotNumberStartingFrom = `Ascending starting from ${value}`;
      setPropertyInformationBulkEdit({...propertyInformationBulkEdit});
    }
    
    handlePropertyBulkEditFieldChange(value, field, type);
  };

  const handlePropertyBulkEditFieldChange = handleBulkEditFieldChange.bind(null, setPropertyInformationBulkEdit);

  const handlePropertyBulkEditModalExit = () => {
    setIsPropertyBulkEditAddressOpen(false);
    setIsPropertyBulkEditLotOpen(false);
    handlePropertyBulkEditModalClose();
  };

  const handlePropertyBulkEditModalClose = handleBulkEditModalClose.bind(
    null,
    setIsPropertyBulkEditModalOpen,
    setPropertyInformationBulkEdit,
    emptyPropertyInformationBulkEdit
  );

  const handleApplyPropertyInformationBulkEdit = (): void => {
    const {
      address,
      lotNumber,
      completedValue,
      lotNumberStartingFrom,
      ...remainPropertyInformationBulkEdit
    } = propertyInformationBulkEdit;
    let addressCount = 1;
    let lotNumberCount = +lotNumber;

    setStartAppObject((prevStartAppObject) => ({
      ...prevStartAppObject,
      hasPropertiesChanged: true,
      properties: prevStartAppObject.properties.map((prevStartAppProperty) => {
        if (checkedProperties.indexOf(prevStartAppProperty.id) !== -1) {
          if (address === "Assign unique identifiers") {
            prevStartAppProperty.address = `Property ${addressCount}`;
            addressCount++;
          } 
          else if ((address || address === "") && address !== GlobalConstants.BulkEditValue.MIXED) {
            prevStartAppProperty.address = address;
          }
          if (lotNumberStartingFrom && lotNumberStartingFrom.startsWith("Ascending starting from") && !isNaN(lotNumberCount)) {
            prevStartAppProperty.lotNumber = lotNumberCount;
            lotNumberCount++;
          }
          else if ((lotNumberStartingFrom || lotNumberStartingFrom === "" || !lotNumberStartingFrom) && lotNumberStartingFrom !== GlobalConstants.BulkEditValue.MIXED) {
            prevStartAppProperty.lotNumber = lotNumberStartingFrom;
          }
          if (completedValue) {
            if (Array.isArray(prevStartAppProperty.units) && prevStartAppProperty.units.length > 0) {
              prevStartAppProperty.units = prevStartAppProperty.units.map((unit) => ({...unit, completedValue}));
            }
            else {
              prevStartAppProperty.units = [{id: guid(), completedValue, unitNumber: 1}];
            }
          }
          for (const key in remainPropertyInformationBulkEdit) {
            if ((remainPropertyInformationBulkEdit[key] || remainPropertyInformationBulkEdit[key] === "") && remainPropertyInformationBulkEdit[key] !== GlobalConstants.BulkEditValue.MIXED) {
              prevStartAppProperty[key] = remainPropertyInformationBulkEdit[key];
            }
          }
        }

        return prevStartAppProperty;
      })
    }));

    handlePropertyBulkEditModalExit();
    setCheckedProperties([]);
  };

  const handleOpenPropertyInformationBulkEdit = () => {
    const lotNumberStartingFrom = getAscendingLotEditFieldValue(checkedProperties, undefined, startAppObject.properties);
    if (lotNumberStartingFrom.includes("Ascending starting from ")) {
      const splitAscending = lotNumberStartingFrom.split("Ascending starting from ");
      if (!isNaN(splitAscending[1])) {
        propertyInformationBulkEdit.lotNumber = splitAscending[1];
        propertyInformationBulkEdit.lotNumberStartingFrom = lotNumberStartingFrom;
        setPropertyInformationBulkEdit({...propertyInformationBulkEdit});
      }
    }

    setIsPropertyBulkEditModalOpen(true);

  };

  const handlePropertiesFormChange = (value, field, property, type = "string") => {
    startAppObject.hasPropertiesChanged = true;
    property[field] = handleInputType(type, value, undefined, undefined, 50);
    if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && field === "completedValue") {
      if (property.units && property.units.length > 0) {
        property.units.forEach(unit => unit.completedValue = handleInputType(type, value, undefined, undefined, 50));
      }
      else {
        property.units = [{id: guid(), completedValue: handleInputType(type, value, undefined, undefined, 50), unitNumber: 1}];
      }
    }
    else if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && field === "newStructurePropertyTypeId") {
      if ([...singleUnitPropertyTypeArray].indexOf(property.newStructurePropertyTypeId) > -1) {
        property.numberOfUnits = 1;
      }
    }

    setStartAppObject({...startAppObject});
  };

  const handlePropertyNumberOfUnitChange = (value, field, property) => {
    if (property[field] && property[field] > 1 && property[field] > value) {
      setIsNumberOfUnitWarningModalOpen(true);
    }

    handlePropertiesFormChange(value, field, property, GlobalConstants.InputTypes.INT);
  };

  const handleUndoPropertyNumberOfUnitChange = () => {
    const initialProperty = excelProperties.length ? excelProperties : (initialStartAppObject.properties && initialStartAppObject.properties.length) ? initialStartAppObject.properties : null;
    if (initialProperty) {
      const propertyNumberOfUnitsMap = initialProperty.reduce((map, obj) => {
        map[obj.id] = obj.numberOfUnits;
        return map;
      }, {});

      startAppObject.properties.forEach(property => {
        property.numberOfUnits = propertyNumberOfUnitsMap[property.id];
      });
    }

    setStartAppObject({...startAppObject});
    setIsNumberOfUnitWarningModalOpen(false);
  };

  const handlePropertiesZipChange = (property, placeDetailObject) => {
    startAppObject.hasPropertiesChanged = true;
    property = placeDetailObject;
    setStartAppObject({...startAppObject});
  };
  
  const handleArrayFormChange = (value, field, array, index, type = "string", charLimit = undefined as number | undefined) => {
    startAppObject[array][index][field] = handleInputType(type, value, undefined, undefined, charLimit);
    setStartAppObject({...startAppObject});
  };

  const handleCostPaidsArrayFormChange = (value, field, index, type = "string", charLimit = undefined as number | undefined) => {
    startAppObject.hasCostPaidsChanged = true;
    startAppObject.gmrCostPaids[index][field] = handleInputType(type, value, undefined, undefined, charLimit);
    setStartAppObject({...startAppObject});
  };

  const handlePlanTableData = () => {
    const planTable = [] as any;
    if (!startAppObject.unitPlans || startAppObject.unitPlans.length === 0) {
      startAppObject.unitPlans = [{ id: guid() }];
    }

    startAppObject.unitPlans.forEach((unitPlan, i) => {
      planTable.push({
        "Name": <React.Fragment>
          <BCFormInput 
            labelClass="gmr-background-label"
            inputKey={`property-${i}`}
            type="input"
            placeholder="Default"
            obj={unitPlan}
            field="name"
            inputType={GlobalConstants.InputTypes.STRING}
            handleFormChange={(value, field) => handlePlanFormChange(value, field, i, GlobalConstants.InputTypes.STRING, 255)}
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop={`custom-name-${i}`} />
        </React.Fragment>,
        "Number of Bedrooms": <React.Fragment>
            <BCFormInput 
              labelClass="gmr-background-label"
              inputKey={`property-${i}`}
              type="input"
              placeholder="1"
              obj={unitPlan}
              field="numberOfBedroom"
              inputType={GlobalConstants.InputTypes.INT}
              handleFormChange={(value, field) => handlePlanFormChange(value, field, i, GlobalConstants.InputTypes.INT, 255)}
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop={`custom-numberOfBedroom-${i}`} />
          </React.Fragment>,
        "Number Of Bathrooms": <React.Fragment>
          <BCFormInput 
            labelClass="gmr-background-label"
            type="input"
            inputKey={`property-${i}`}
            placeholder="1"
            obj={unitPlan}
            field="numberOfBathroom"
            inputType={GlobalConstants.InputTypes.FLOAT}
            handleFormChange={(value, field) => handlePlanFormChange(value, field, i, GlobalConstants.InputTypes.FLOAT, 255)}
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop={`custom-numberOfBathroom-${i}`} />
        </React.Fragment>,
        "Number of Garage Bays": <React.Fragment>
          <BCFormInput 
            labelClass="gmr-background-label"
            type="input"
            inputKey={`property-${i}`}
            placeholder="1"
            obj={unitPlan}
            field="numberOfCarGarage"
            inputType={GlobalConstants.InputTypes.INT}
            handleFormChange={(value, field) => handlePlanFormChange(value, field, i, GlobalConstants.InputTypes.INT, 255)}
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop={`custom-numberOfCarGarage-${i}`} />
        </React.Fragment>,
        "Square Footage": <React.Fragment>
          <BCFormInput 
            labelClass="gmr-background-label"
            type="input"
            inputKey="property"
            placeholder="2000"
            obj={unitPlan}
            field="squareFootage"
            inputType={GlobalConstants.InputTypes.INT}
            handleFormChange={(value, field) => handlePlanFormChange(value, field, i, GlobalConstants.InputTypes.INT, 255)}
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop={`custom-squareFootage-${i}`} />
        </React.Fragment>
      });
    });

    return planTable;
  };

  const handleInvitedGuarantorDelete = async (invitedGuarantor) => {
    const foundMetaGuarnatorIndex = metaGuarantors.findIndex(x => x.id === invitedGuarantor.id);
    if (foundMetaGuarnatorIndex !== -1) {
      const guarantorDeleteObj = {
        borrowerApplicationId: startAppObject.id,
        organizationContactId: invitedGuarantor.id
      };

      const isGuarantorDelete = await handleDeleteGuarantorAsync(guarantorDeleteObj);
      if (isGuarantorDelete) {
        metaGuarantors.splice(foundMetaGuarnatorIndex, 1);
        setMetaGuarantors([...metaGuarantors]);
      }
    }
  }; 

  const handleRemoveInvitedGuarantors = async (array, index) => {
    handleInvitedGuarantorDelete(startAppObject[array][index]);
    startAppObject[array].splice(index, 1);
    setStartAppObject({...startAppObject});
  };

  const handleDeleteCostsPaid = async (index) => {
    if (startAppObject.gmrCostPaids && startAppObject.gmrCostPaids.length > 0 && startAppObject.gmrCostPaids[index]) {
      let foundInitialCostPaid = undefined;
      let isApiSuccess = true;
      if (initialStartAppObject.gmrCostPaids && initialStartAppObject.gmrCostPaids.length > 0) {
        foundInitialCostPaid = initialStartAppObject.gmrCostPaids.find(x => x.id === startAppObject.gmrCostPaids[index].id);
      }

      if (foundInitialCostPaid) {
        isApiSuccess = await handleDeleteCostsPaidsAsync([startAppObject.gmrCostPaids[index].id]);
      }
      
      if (isApiSuccess) {
        if (startAppObject.gmrCostPaids.length === 1) {
          startAppObject.paidCosts = false;
          startAppObject.gmrCostPaids = [{ id: guid() }];
        }
        else {
          startAppObject.gmrCostPaids.splice(index, 1);
        }
        
        setStartAppObject({...startAppObject});
      }
    }
  };

  const handleDeletePlan = async (index) => {
    if (startAppObject.unitPlans && startAppObject.unitPlans[index]) {
      let foundInitialUnitPlan = undefined;
      let isApiSuccess = true;
      initialStartAppObject.unitPlans = initialStartAppObject.unitPlans && initialStartAppObject.unitPlans[0] && initialStartAppObject.unitPlans[0].name ? initialStartAppObject.unitPlans : [];
      if (initialStartAppObject.unitPlans && initialStartAppObject.unitPlans.length > 0) {
        foundInitialUnitPlan = initialStartAppObject.unitPlans.find(x => x.id === startAppObject.unitPlans[index].id);
      }

      if (foundInitialUnitPlan) {
        isApiSuccess = await handleDeletePlanAsync([startAppObject.unitPlans[index].id]);
      }
      
      if (isApiSuccess) {
        startAppObject.hasPropertiesChanged = true;
        startAppObject.unitPlans.splice(index, 1);
        setStartAppObject({...startAppObject});
      }
    }
  };

  const handleModal = (type, isNew = false, alType = "", isPrev = false) => {
    if (type === "guarantor additional" && isPrev) {
      setModalType(type);
      setIsModalOpen(true);
    }
    else if (type === "guarantor additional") {
      setInvalidProps([]);
      let notValidProps = [] as string[];
      let validatingProps = ["firstName", "lastName", "email"];
      if (newGuarantor.isMailingSameAsPhysical === false) {
        validatingProps = validatingProps.concat(["mailingAddress", "mailingZip", "mailingCity", "mailingCounty", "mailingState"]);
      }
      notValidProps = validateObj(newGuarantor, validatingProps);
      
      if (metaGuarantors && metaGuarantors.length > 0) {
        const foundMetaGuarantor = metaGuarantors.find(x => x.email === newGuarantor.email);
        if (foundMetaGuarantor) {
          notValidProps.push("custom-guarantor-email");
        }
      }

      const notValidEmails = validateEmails(newGuarantor, ["email"]);
      if (notValidEmails && notValidEmails.length > 0 && notValidProps && !notValidProps.includes("email")) {
        notValidProps.push("custom-guarantor-invalid-email");
      }

      if (notValidProps.length === 0) {
        setModalType(type);
        setIsModalOpen(true);
      }
      else {
        setTimeout(() => { 
          setInvalidProps(notValidProps);
        }, 50);
      }
    }
    else {
      if (type === "new organization" && !isNew) {
        setNewBorrowerEntity({});
      }
      else if (alType !== "") {
        setAlType(alType);
      }

      setModalType(type);
      setIsModalOpen(true);
    }
  };

  const handleUnitFormChange = (value, field, unit, type) => {
    unit[field] = handleInputType(type, value, unit, field, 255);
    startAppObject.hasPropertiesChanged = true;
    setStartAppObject({...startAppObject});
  };

  const handleUnitChange = (value, field, propertyIndex, unitIndex, type = "string") => {
    startAppObject.properties[propertyIndex].units[unitIndex][field] = handleInputType(type, value);
    startAppObject.hasPropertiesChanged = true;
    setStartAppObject({...startAppObject});
  };

  const handleUnitTableData = () => {
    const unitTable = [] as any[];
    if (startAppObject.properties) {
      startAppObject.properties.forEach((property, i) => {
        for (let j=0; j<property.numberOfUnits; j++) {
          if (property.units && property.units[j]) {
            unitTable.push({
              "id": property.units[j].id,
              "Address": property.address,
              "Unit": <React.Fragment>
                <BCFormInput
                  type="input"
                  inputKey={`property-${j}`}
                  field="unitNumber"
                  value={property.units[j].unitNumber ? property.units[j].unitNumber : ""}
                  handleFormChange={(value, field) => handleUnitChange(value, field, i, j, "string")}
                  disabled={isNonGuarantorDisabled}
                />
                <BCValidationMessage invalidProps={invalidProps} prop={`custom-unit-duplicated-${property.units[j].id}`} propText="Duplicated unit number." />
              </React.Fragment>,
              "Plan": <Dropdown
                className="primary-dropdown"
                inputKey={`property-${j}`}
                value={property.units[j].plan ? property.units[j].plan : ""}
                placeholder={"Please Select"}
                fluid
                selection
                options={startAppObject.unitPlans ? getDropdownOptions(Array.from(startAppObject.unitPlans as any[], x => x.name)) : []}
                onChange={(e, { value }) => handleUnitChange(value, "plan", i, j)}
                disabled={isNonGuarantorDisabled}
              />,
              "Current Value (AIV)": <BCFormInput
                type="input"
                inputKey={`property-${j}`}
                placeholder="100000"
                field="currentValue"
                fieldType="dollar"
                inputType="number"
                value={property.units[j].currentValue ? property.units[j].currentValue : ""}
                handleFormChange={(value, field) => handleUnitChange(value, field, i, j, "dollar")}
                disabled={isNonGuarantorDisabled}
              />,
              "Completed Value (ARV)": <BCFormInput
                type="input"
                inputKey={`property-${j}`}
                placeholder="100000"
                field="completedValue"
                fieldType="dollar"
                inputType="number"
                value={property.units[j].completedValue ? property.units[j].completedValue : ""}
                handleFormChange={(value, field) => handleUnitChange(value, field, i, j, "dollar")}
                disabled={isNonGuarantorDisabled}
              />
            });
          }
        }
      });
    }

    return unitTable;
  };

  const handleAddCostPaid = () => {
    startAppObject.gmrCostPaids.push({ id: guid() });
    setStartAppObject({...startAppObject});
  };

  const handleAddToArray = (array, obj) => {
    if (array === "unitPlans") {
      if (!startAppObject.unitPlans) {
        startAppObject.unitPlans = [];
      }

      const emptyPlan = { id: guid() };
      startAppObject[array].push(emptyPlan);
      setUnitPlan({});
      setStartAppObject({...startAppObject});
    }
    else {
      if (array === "additionalCollateral") {
        obj.id = guid();
        if (startAppObject.zip) {
          obj.zip = startAppObject.zip;
        }
        if (startAppObject.city) {
          obj.city = startAppObject.city;
        }
        if (startAppObject.state) {
          obj.state = startAppObject.state;
        }
        if (startAppObject.county) {
          obj.county = startAppObject.county;
        }
      }
      else if (array === "invitedGuarantors") {
        if (!startAppObject.invitedGuarantors) {
          startAppObject.invitedGuarantors = [];
        }
      }

      startAppObject[array].push({...obj});
      setStartAppObject({...startAppObject});
    }
  };

  const handlePropertyCheckbox = (propertyId) => {
    if (checkedProperties.includes(propertyId)) {
      setCheckedProperties([...checkedProperties.filter(x => x !== propertyId)]);
    }
    else {
      setCheckedProperties([...checkedProperties, propertyId]);
    }
  };

  const handleCheckAllProperties = () => {
    const allProperties = [] as any[];
    startAppObject.properties.forEach(property => {
      allProperties.push(property.id);
    });

    if (allProperties.length === checkedProperties.length) {
      setCheckedProperties([]);
    }
    else {
      setCheckedProperties(allProperties);
    }
  };

  const handleUnitCheckbox = (unitId) => {
    if (checkedUnits.includes(unitId)) {
      setCheckedUnits([...checkedUnits.filter(x => x !== unitId)]);
    }
    else {
      setCheckedUnits([...checkedUnits, unitId]);
    }
  };

  const handleCheckAllUnits = () => {
    let allUnitId = [] as string[];
    startAppObject.properties.forEach(property => {
      if (property.units) {
        property.units.forEach(unit => {
          allUnitId = unit.id ? [...allUnitId, unit.id] : allUnitId;
        });
      }
    });

    if (allUnitId.length === checkedUnits.length) {
      setCheckedUnits([]);
    }
    else {
      setCheckedUnits(allUnitId);
    }
  };
  
  const handleCalculateGreatestLoanTerm = (properties) => {
    let greatestLoanTermSum = 0;
    properties.forEach(property => {
      const loanTermSum = operationOfNumberArray("sum", [property.monthOfFirstDraw, property.buildTimeInMonths, property.timeFrameToSellOrRefinanceInMonths, -1]);
      if (loanTermSum && loanTermSum > greatestLoanTermSum) {
        greatestLoanTermSum = loanTermSum;
      }
    });

    setGreatestTotalToComplete(greatestLoanTermSum);
  };

  const handlePropertyLoanTermChange = (value, field, property, type) => {
    property[field] = handleInputType(type, value, undefined, undefined, 50);
    if (startAppObject.properties && startAppObject.properties.length > 0) {
      handleCalculateGreatestLoanTerm(startAppObject.properties);
    }

    startAppObject.hasPropertiesChanged = true;
    setStartAppObject({...startAppObject});
  };

  const handleLoanTermTableData = () => {
    const loanTermTable = [] as any;
    if (startAppObject.properties) {
      startAppObject.properties.forEach((property) => {
        const loanTermSum = operationOfNumberArray("sum", [property.monthOfFirstDraw, property.buildTimeInMonths, property.timeFrameToSellOrRefinanceInMonths, -1]);
        loanTermTable.push({
          "Address": property.address ? property.address : "",
          "Months of First Draw": <BCFormInput
            type="input"
            inputKey={`monthsOfFirstDraw-${property.id}`}
            placeholder="1"
            obj={property}
            field="monthOfFirstDraw"
            inputType={GlobalConstants.InputTypes.INT}
            value={property.monthOfFirstDraw}
            handleFormChange={(value, field) => handlePropertyLoanTermChange(value, field, property, GlobalConstants.InputTypes.INT)}
            disabled={isNonGuarantorDisabled}
          />,
          "Months to Finish Construction": <BCFormInput
            type="input"
            inputKey={`monthsToFinishConstruction-${property.id}`}
            placeholder="1"
            obj={property}
            field="buildTimeInMonths"
            inputType={GlobalConstants.InputTypes.INT}
            value={property.buildTimeInMonths}
            handleFormChange={(value, field) => handlePropertyLoanTermChange(value, field, property, GlobalConstants.InputTypes.INT)}
            disabled={isNonGuarantorDisabled}
          />,
          "Months to Sell Or Refinance": <BCFormInput
            type="input"
            inputKey={`monthsToSellOrRefinance-${property.id}`}
            placeholder="1"
            obj={property}
            field="timeFrameToSellOrRefinanceInMonths"
            inputType={GlobalConstants.InputTypes.INT}
            value={property.timeFrameToSellOrRefinanceInMonths === 0 ? "0" : property.timeFrameToSellOrRefinanceInMonths}
            handleFormChange={(value, field) => handlePropertyLoanTermChange(value, field, property, GlobalConstants.InputTypes.INT)}
            disabled={isNonGuarantorDisabled}
          />,
          "Total to Complete": (property && (property.monthOfFirstDraw || property.buildTimeInMonths || property.timeFrameToSellOrRefinanceInMonths)) ? loanTermSum : ""
        });
      });
    }
    
    return loanTermTable;
  };

  const handleIsBorrowerFormChange = async (value, field) => {
    await handleGetBorrowerEntityAsync(applicationId, value);
    startAppObject.borrowerOrganizationId = handleInputType("string", value, startAppObject, field);
    setStartAppObject({...startAppObject});
  };

  const getFilteredAL = (array, alType) => {
    const filteredAL = [] as string[];
    if (array) {
      array.forEach((item) => {
        if (item && item.Class === alType) {
          filteredAL.push(item);
        }
      });
    }

    return filteredAL;
  };

  const addAL = (obj, setObj, alType) => {
    obj.isREOChanged = true;
    const newAssetAndLiabilityObj = {
      id: guid(),
      alOption: alType,
     };
    obj.assetsAndLiabilities.push(newAssetAndLiabilityObj);
    
    setObj({...obj});
  };

  const formatAssets = (editMode, obj, setObj, isGuarantor = false, handleAlType = undefined) => {
    const formattedAssets = [] as any[];
    if (!obj.assetsAndLiabilities) {
      obj.assetsAndLiabilities = [] as any[];
    }

    if (obj.assetsAndLiabilities) {
      const assets = obj.assetsAndLiabilities.filter(x => x.alOption === "Asset");
      if (assets.length === 0) {
        const newAssetAndLiabilityObj = {
          id: guid(),
          alOption: "Asset"
        };
  
        obj.assetsAndLiabilities.push(newAssetAndLiabilityObj);
      }
    }

    obj.assetsAndLiabilities.forEach((alschedule, i) => {
      if (alschedule.alOption === "Asset") {
        const alObj = {
          "Type": <BCFormInput 
                    labelClass="gmr-background-label"
                    inputKey={(handleAlType && handleAlType === "guarantor wizard") ? `guarantor-liability-${i}` : `entity-liability-${i}`}
                    type="dropdown"
                    placeholder="Please Select"
                    obj={newAssetAndLiability}
                    field="alType"
                    fluid={false}
                    value={alschedule.alType}
                    dropdownOptions={getDropdownOptions(applicationMetadata.assetTypes, ["id"], "name")}
                    handleFormChange={(value, field) => handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, "string")}
                    disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
                  />,
          "Institution": <BCFormInput
                          labelClass="gmr-background-label"
                          type="input"
                          inputKey={(handleAlType && handleAlType === "guarantor wizard") ? `guarantor-liability-${i}` : `entity-liability-${i}`}
                          placeholder="Construction Loan Services II"
                          value={alschedule.institutionName}
                          inputType="text"
                          disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
                          field="institutionName"
                          handleFormChange={(value, field) =>  handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, GlobalConstants.InputTypes.STRING, 50)}
                        />,
          "Current balance": <BCFormInput 
                              labelClass="gmr-background-label"
                              inputKey={(handleAlType && handleAlType === "guarantor wizard") ? `guarantor-liability-${i}` : `entity-liability-${i}`}
                              type="input"
                              placeholder="10000"
                              fieldType="dollar"
                              inputType="number"
                              value={alschedule.currentBalance}
                              field="currentBalance"
                              handleFormChange={(value, field) =>  handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, "string")}
                              disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
                            />,
          "isDeleteHide": alschedule.isDeleteHide
        };
  
        formattedAssets.push(alObj);
      }
    });
  
    return formattedAssets;
  };

  const filterDefaultLiabilities = (liabilityTypes, isDeleteHide) => {
    if (!liabilityTypes) {
      return [];
    }

    return isDeleteHide ? liabilityTypes : liabilityTypes.filter(x => x.isBuiltIn === true);
  };

  const formatLiabilities = (editMode, obj, setObj, isGuarantor = false, handleAlType = undefined) => {
    const formattedLiabilities = [] as any[];
    if (obj.assetsAndLiabilities) {
      const liabilities = obj.assetsAndLiabilities.filter(x => x.alOption === "Liability");
      if (liabilities.length === 0) {
        const newAssetAndLiabilityObj = {
          id: guid(),
          alOption: "Liability"
        };
  
        obj.assetsAndLiabilities.push(newAssetAndLiabilityObj);
      }
    }

    obj.assetsAndLiabilities.forEach((alschedule, i) => {
      if (alschedule.alOption === "Liability") {
        const alObj = {
          "Type": <BCFormInput 
                    labelClass="gmr-background-label"
                    inputKey={(handleAlType && handleAlType === "guarantor wizard") ? `guarantor-liability-${i}` : `entity-liability-${i}`}
                    type="dropdown"
                    placeholder="Please Select"
                    obj={newAssetAndLiability}
                    field="alType"
                    fluid={false}
                    value={alschedule.alType}
                    dropdownOptions={alType === "Asset" ? getDropdownOptions(applicationMetadata.assetTypes, ["id"], "name") : 
                      getDropdownOptions(filterDefaultLiabilities(applicationMetadata.liabilityTypes, alschedule.isDeleteHide), ["id"], "name")}
                    handleFormChange={(value, field) => handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, "string")}
                    disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
                  />,
          "Institution": <BCFormInput
                          labelClass="gmr-background-label"
                          type="input"
                          inputKey={(handleAlType && handleAlType === "guarantor wizard") ? `guarantor-liability-${i}` : `entity-liability-${i}`}
                          placeholder="Construction Loan Services II"
                          value={alschedule.institutionName}
                          inputType="text"
                          disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
                          field="institutionName"
                          handleFormChange={(value, field) =>  handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, GlobalConstants.InputTypes.STRING, 50)}
                        />,
          "Current balance": <BCFormInput 
                              labelClass="gmr-background-label"
                              type="input"
                              inputKey={(handleAlType && handleAlType === "guarantor wizard") ? `guarantor-liability-${i}` : `entity-liability-${i}`}
                              placeholder="10000"
                              fieldType="dollar"
                              inputType="number"
                              value={alschedule.currentBalance}
                              field="currentBalance"
                              handleFormChange={(value, field) =>  handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, "string")}
                              disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
                            />,
          "Liability": <BCFormInput 
                  labelClass="gmr-background-label"
                  type="input"
                  placeholder="10000"
                  fieldType="dollar"
                  inputType="number"
                  inputKey={(handleAlType && handleAlType === "guarantor wizard") ? `guarantor-liability-${i}` : `entity-liability-${i}`}
                  value={alschedule.monthlyLiability}
                  field="monthlyLiability"
                  handleFormChange={(value, field) =>  handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, "string")}
                  disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
                  />,
          "isDeleteHide": alschedule.isDeleteHide
        };

        formattedLiabilities.push(alObj);
      }
    });

    return formattedLiabilities;
   
  };

  const handleAlReoFormChange = (value, field, array, obj, setObj, index, type = "string", charLimit = undefined as number | undefined) => {
    obj.hasReoChanged = true;
    obj[array][index][field] = handleInputType(type, value, undefined, undefined, charLimit);
    setObj({...obj});
  };

  const handleReoAdditonalCollateralChange = (isDeleteHide, value, field, array, obj, setObj, index, type = "string", charLimit = undefined as number | undefined) => {
    if (!isDeleteHide) {
      obj.hasReoChanged = true;
      obj[array][index][field] = handleInputType(type, value, undefined, undefined, charLimit);
      setObj({...obj});
    }
  };

  const handleREODuplicateAddresses = (obj, setObj, index) => {
    if (handleIsDuplicateREOAddresses()) {
      obj.reoSchedules[index].street = undefined;
      obj.reoSchedules[index].county = undefined;
      obj.reoSchedules[index].city = undefined;
      obj.reoSchedules[index].state = undefined;
      obj.reoSchedules[index].zip = undefined;
      setObj({...obj});
    }
  };

  const handleIsDuplicateREOAddresses = () => {
    const borrowerEntityReoScheduleAddresses = [] as string[];
    const guarantorReoScheduleAddresses = [] as string[];
    if (newBorrowerEntity && newBorrowerEntity.reoSchedules && newBorrowerEntity.reoSchedules.length > 0) {
      newBorrowerEntity.reoSchedules.forEach(reoSchedule => {
        if (reoSchedule.street && reoSchedule.city && reoSchedule.state && reoSchedule.zip) {
          borrowerEntityReoScheduleAddresses.push(handleAddressValue({
            address: reoSchedule.street,
            city: reoSchedule.city,
            state: reoSchedule.state,
            zip: reoSchedule.zip
          }));
        }
      });
    }

    if (newGuarantor && newGuarantor.reoSchedules && newGuarantor.reoSchedules.length > 0) {
      newGuarantor.reoSchedules.forEach(reoSchedule => {
        if (reoSchedule.street && reoSchedule.city && reoSchedule.state && reoSchedule.zip) {
          guarantorReoScheduleAddresses.push(handleAddressValue({
            address: reoSchedule.street,
            city: reoSchedule.city,
            state: reoSchedule.state,
            zip: reoSchedule.zip
          }));
        }
      });
    }

    const allReoAddresses = borrowerEntityReoScheduleAddresses.concat(guarantorReoScheduleAddresses);
    const uniqueReoAddresses = uniqueArray(allReoAddresses);
    if (allReoAddresses.length !== uniqueReoAddresses.length) {
      return true;
    }
    
    return false;
  };

  const formatReos = (obj, setObj, isGuarantor = false, handleReotype = undefined) => {
    const formattedReos = [] as any[];
    if (!obj.reoSchedules) {
      obj.reoSchedules = [];
    }

    if (obj.reoSchedules) { 
      if (obj.reoSchedules.length === 0) {
        obj.reoSchedules.push({id: guid() });
      }
      
      obj.reoSchedules.forEach((reoSchedule, i) => {
        const guarantorAdditionalCollateralFullIds = Array.from(guarantorAdditionalCollateralFull, x => x.id);
        const entityAdditionalCollateralIds = Array.from(entityAdditionalCollateral, x => x.id);
        let isDeleteHide = false;
        if (guarantorAdditionalCollateralFullIds.concat(entityAdditionalCollateralIds).includes(reoSchedule.id) && reoSchedule.additionalCollateral) {
          isDeleteHide = true;
        }
        const reoObj = {
          "REO Type": <React.Fragment>
          <BCFormInput 
            labelClass="gmr-background-label"
            type="dropdown"
            inputKey={(handleReotype && handleReotype === "guarantor reo") ? `guarantor-${i}` :`reo-${i}`}
            placeholder="Please Select"
            obj={reoSchedule}
            field="reoType"
            fluid={false}
            value={reoSchedule.reoType}
            dropdownOptions={getDropdownOptions(applicationMetadata.reoTypes, ["id"], "name")}
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "reoSchedules", obj, setObj, i, "string")}
            disabled={isNonGuarantorDisabled && !isGuarantor}
          />
          <BCValidationMessage invalidProps={invalidProps} prop={`custom-reoSchedules-reoType-${reoSchedule.id}`} />
          </React.Fragment>,
          "Mortgage Status": <React.Fragment>
          <BCFormInput 
            labelClass="gmr-background-label"
            type="dropdown"
            inputKey={(handleReotype && handleReotype === "guarantor reo") ? `guarantor-${i}` :`reo-${i}`}
            placeholder="Please Select"
            obj={reoSchedule}
            field="reoStatus"
            fluid={false}
            value={reoSchedule.reoStatus}
            dropdownOptions={getDropdownOptions(applicationMetadata.reoStatuses, ["id"], "name")}
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "reoSchedules", obj, setObj, i, "string")}
            disabled={isNonGuarantorDisabled && !isGuarantor}
          />
          <BCValidationMessage invalidProps={invalidProps} prop={`custom-reoSchedules-reoStatus-${reoSchedule.id}`} />
        </React.Fragment>,
          "Institution": <React.Fragment>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey={(handleReotype && handleReotype === "guarantor reo") ? `guarantor-${i}` :`reo-${i}`}
              placeholder="Construction Loan Services II"
              obj={reoSchedule}
              value={reoSchedule.holder1}
              field="holder1"
              inputType="text"
              handleFormChange={(value, field) => handleAlReoFormChange(value, field, "reoSchedules", obj, setObj, i, GlobalConstants.InputTypes.STRING, 50)}
              disabled={isNonGuarantorDisabled && !isGuarantor}
            />
            <BCValidationMessage invalidProps={invalidProps} prop={`custom-reoSchedules-holder1-${reoSchedule.id}`} />
          </React.Fragment>,
          "Total Mortgage Amount": <React.Fragment>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey={(handleReotype && handleReotype === "guarantor reo") ? `guarantor-${i}` :`reo-${i}`}
              placeholder="1000"
              obj={reoSchedule}
              field="mortgageAmount1"
              value={reoSchedule.mortgageAmount1}
              fieldType="dollar"
              inputType="number"
              handleFormChange={(value, field) => handleAlReoFormChange(value, field, "reoSchedules", obj, setObj, i, GlobalConstants.InputTypes.DOLLAR)}
              disabled={isNonGuarantorDisabled && !isGuarantor}
            />
            <BCValidationMessage invalidProps={invalidProps} prop={`custom-reoSchedules-mortgageAmount1-${reoSchedule.id}`} />
          </React.Fragment>,
          "Address":  <React.Fragment>
            <BCFormInput
              labelClass="gmr-background-label"
              inputKey={(handleReotype && handleReotype === "guarantor reo") ? `guarantor-${i}` :`reo-${i}`}
              type={GlobalConstants.FormInputTypes.PLACES}
              placeDetailsObject={reoSchedule}
              setPlaceDetailsObject={setNewReoSchedule}
              placeholder="1234 Main Street, Seattle, WA 98052, USA"
              defaultValue={handleAddressValue({
                address: reoSchedule.street,
                city: reoSchedule.city,
                state: reoSchedule.state,
                zip: reoSchedule.zip
              })}
              placeFields={["address", "city", "state", "county", "zip"]}
              placeFieldsNameOverrides={[
                {
                  addressComponent: "address",
                  field: "street"
                },
              ]}
              disabled={isNonGuarantorDisabled && !isGuarantor}
              handleFormChange={(value, field) => handleAlReoFormChange(value, field, "reoSchedules", obj, setObj, i, "string")}
              handleCustomFormChange={() => handleREODuplicateAddresses(obj, setObj, i)}
              handleIsDuplicate={() => handleIsDuplicateREOAddresses()}
            />
            {invalidProps.includes(`custom-reoSchedules-city-${reoSchedule.id}`) ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop={`custom-reoSchedules-city-${reoSchedule.id}`}
              propText="This city is invalid." 
            /> : invalidProps.includes(`custom-reoSchedules-state-${reoSchedule.id}`) ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop={`custom-reoSchedules-state-${reoSchedule.id}`}
              propText="This state is invalid."
            /> : invalidProps.includes(`custom-reoSchedules-zip-${reoSchedule.id}`) ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop={`custom-reoSchedules-zip-${reoSchedule.id}`}
              propText="This zip code is invalid."
            /> : invalidProps.includes(`custom-reoSchedules-county-${reoSchedule.id}`) ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop={`custom-reoSchedules-county-${reoSchedule.id}`}
              propText="This county is invalid."
            /> : <BCValidationMessage 
              invalidProps={invalidProps} 
              prop={`custom-reoSchedules-street-${reoSchedule.id}`}
              propText={ErrorMessages.Address} />
            }
          </React.Fragment>,
          "Parcel No.": <React.Fragment>
           <BCFormInput 
              labelClass="gmr-background-label"
              inputKey={(handleReotype && handleReotype === "guarantor reo") ? `guarantor-${i}` :`reo-${i}`}
              type="input" 
              placeholder="1"
              obj={reoSchedule}
              field="parcelNumber"
              inputType="text"
              value={reoSchedule.parcelNumber}
              handleFormChange={(value, field) => handleAlReoFormChange(value, field, "reoSchedules", obj, setObj, i, "string")}
              disabled={isNonGuarantorDisabled && !isGuarantor}
            />
            <BCValidationMessage invalidProps={invalidProps} prop={`custom-reoSchedules-parcelNumber-${reoSchedule.id}`} />
          </React.Fragment>,
          "Market Value": <React.Fragment>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey={(handleReotype && handleReotype === "guarantor reo") ? `guarantor-${i}` :`reo-${i}`}
              placeholder="10000"
              obj={reoSchedule}
              field="marketValue"
              value={reoSchedule.marketValue}
              fieldType="dollar"
              inputType="number"
              handleFormChange={(value, field) => handleAlReoFormChange(value, field, "reoSchedules", obj, setObj, i, "string")}
              disabled={isNonGuarantorDisabled && !isGuarantor}
            />
            <BCValidationMessage invalidProps={invalidProps} prop={`custom-reoSchedules-marketValue-${reoSchedule.id}`} />
          </React.Fragment>,
          "Include as Additional Collateral?": <BCFormInput
            labelClass="gmr-background-label"
            type="checkbox"
            inputKey={(handleReotype && handleReotype === "guarantor reo") ? `guarantor-${i}` :`reo-${i}`}
            obj={reoSchedule}
            field="additionalCollateral"
            value={reoSchedule.additionalCollateral}
            handleFormChange={(value, field) => handleReoAdditonalCollateralChange(isDeleteHide, value, field, "reoSchedules", obj, setObj, i)}
            disabled={isNonGuarantorDisabled && !isGuarantor}
          />,
          isDeleteHide: isDeleteHide
        };

        formattedReos.push(reoObj);
      });
    }

    return formattedReos;
  };

  const handleGuarantorFormChange = async (value, field, array, setSelectedBrokerGuarantors, i, guarantor) => {
    handleFormChange(value, field, array, setSelectedBrokerGuarantors, "string", undefined, undefined, i);
    setIsLoading(true);
    if (guarantor.borrowerApplicationEntityId && guarantor.accessLevelId) {
      const guarantorAccessPatchObj = [{
        id: guarantor.borrowerApplicationEntityId,
        accessLevelId: guarantor.accessLevelId
      }];
  
      await patchGuarantorAccessLevelAsync(guarantorAccessPatchObj);
    }
    
    setIsLoading(false);
  };

  const formatGuarantors = (array) => {
    const formattedGuarantor = [] as any[];
      array && array.forEach((guarantor, i) => {
        const guarantorStatus = guarantor.statusLookupName ? guarantor.statusLookupName : guarantor.status ? guarantor.status : "";
        const guarantorObj = {
          "First Name": guarantor.firstName && guarantor.firstName,
          "Last Name": guarantor.lastName && guarantor.lastName,
          "Email": guarantor.email && guarantor.email,
          "Access Level": <React.Fragment>
            <BCFormInput 
              labelClass="gmr-background-label"
              type="dropdown"
              placeholder="Please Select"
              obj={guarantor}
              field="accessLevelId"
              fluid={false}
              value={guarantor.accessLevelId}
              dropdownOptions={getDropdownOptions(applicationMetadata.accessLevels, ["id"], "name")}
              handleFormChange={(value, field) => handleGuarantorFormChange(value, field, array, setSelectedBrokerGuarantors, i, guarantor)}
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage 
              invalidProps={invalidProps} 
              prop={`selectedBrokerGuarantors-accessLevelId-${i}`}
            />
          </React.Fragment>,
          "Status": guarantorStatus === "BrokerInitiated" || !guarantorStatus ? "Not Sent" : guarantorStatus !== "" ? guarantorStatus : "Pending",
          "": <React.Fragment>
            <div className="guarantor-interior-filter-buttons">
              {guarantorStatus !== "Completed" && guarantor.email !== user.email && <Button 
                className="table-button" 
                icon
                color="green"
                inverted
                onClick={() => handleBrokerGuarantorInvite(i)}
                disabled={!guarantor.accessLevelId}
              >
                <div className="gmr-button-container">
                  {isGreaterThanMobile && <div className="table-button-text">{formatButtonWords(guarantor)}</div>}
                </div>
              </Button>}
              {(selectedBrokerGuarantors && selectedBrokerGuarantors.length > 1) && <Button 
                className="table-button" 
                icon
                color="red"
                inverted
                onClick={() => handleBrokerGuarantorDelete(i)}
              >
                <div className="gmr-button-container">
                  <Icon name='trash' />
                  {isGreaterThanMobile && <div className="table-button-text">Delete</div>}
                </div>
              </Button>}
            </div>
          </React.Fragment>
        };
  
        formattedGuarantor.push(guarantorObj);
    });
  
    return formattedGuarantor;
  };

  const handleDeleteGuarantorAL = async (index, alType) => {
    if (newGuarantor.assetsAndLiabilities && newGuarantor.assetsAndLiabilities.length > 0) {
      const guarantorAlTypes = newGuarantor.assetsAndLiabilities.filter(x => x.alOption === alType);
      if (guarantorAlTypes[index]) {
        setIsLoading(true);
        const isApiSuccess = await handleDeleteAlScheduleAsync(guarantorAlTypes[index].id);
        if (isApiSuccess) {
          await handleGetGuarantorAsync(newGuarantor.id);
        }

        setIsLoading(false);
      }
    }
  };

  const handleDeleteBorrowerEntityAL = async (index, alType) => {
    if (newBorrowerEntity.assetsAndLiabilities && newBorrowerEntity.assetsAndLiabilities.length > 0) {
      const entityAlTypes = newBorrowerEntity.assetsAndLiabilities.filter(x => x.alOption === alType);
      if (entityAlTypes[index]) {
        setIsLoading(true);
        const isApiSuccess = await handleDeleteAlScheduleAsync(entityAlTypes[index].id);
        if (isApiSuccess) {
          await handleGetBorrowerEntityAsync(applicationId, newBorrowerEntity.id);
        }

        setIsLoading(false);
      }
    }
  };

  const handleTableRemove = (array, index = 0, type = "borrower entity", alType = undefined as string | undefined) => {
    if (array === "borrowerEntity") {
      startAppObject.borrowerEntity = undefined;
      setStartAppObject({...startAppObject});
    }
    else if (array === "entityAssetsAndLiabilities") {
      if (type === "borrower entity") {
        newBorrowerEntity.hasALChanged = true;
        if (newBorrowerEntity.assetsAndLiabilities && newBorrowerEntity.assetsAndLiabilities.length > 0) {
          if (alType) {
            const entityAlTypes = newBorrowerEntity.assetsAndLiabilities.filter(x => x.alOption === alType);
            if (entityAlTypes[index]) {
              const indexOfNewEntityAL = newBorrowerEntity.assetsAndLiabilities.findIndex(x => x.id === entityAlTypes[index].id);
              newBorrowerEntity.assetsAndLiabilities.splice(indexOfNewEntityAL, 1);
              setNewBorrowerEntity({...newBorrowerEntity});
              const indexOfEntityAL = entityAssetsAndLiabilities.findIndex(x => x.id === entityAlTypes[index].id);
              entityAssetsAndLiabilities.splice(indexOfEntityAL, 1);
              setEntityAssetAndLiabilities([...entityAssetsAndLiabilities]);
            }
          }
          else {
            const indexOfGuarantorAl = index;
            newBorrowerEntity.assetsAndLiabilities.splice(indexOfGuarantorAl, 1);
            setNewBorrowerEntity({...newBorrowerEntity});
            entityAssetsAndLiabilities.splice(index, 1);
            setEntityAssetAndLiabilities([...entityAssetsAndLiabilities]);
          }
        }
      }
    }
    else if (array === "guarantorAssetsAndLiabilities") {
      if (newGuarantor.assetsAndLiabilities && newGuarantor.assetsAndLiabilities.length > 0) {
        if (alType) {
          const guarantorAlTypes = newGuarantor.assetsAndLiabilities.filter(x => x.alOption === alType);
          if (guarantorAlTypes[index]) {
            const indexOfNewGuarantorAl = newGuarantor.assetsAndLiabilities.findIndex(x => x.id === guarantorAlTypes[index].id);
            newGuarantor.assetsAndLiabilities.splice(indexOfNewGuarantorAl, 1);
            setNewGuarantor({...newGuarantor});
            const indexOfGuarantorAl = guarantorAssetsAndLiabilities.findIndex(x => x.id === guarantorAlTypes[index].id);
            guarantorAssetsAndLiabilities.splice(indexOfGuarantorAl, 1);
            setGuarantorAssetAndLiabilities([...guarantorAssetsAndLiabilities]);
            handleDeleteAlScheduleAsync(guarantorAlTypes[index].id);
          }
        }
        else {
          const indexOfGuarantorAl = index;
          newGuarantor.assetsAndLiabilities.splice(indexOfGuarantorAl, 1);
          setNewGuarantor({...newGuarantor});
          guarantorAssetsAndLiabilities.splice(index, 1);
          setGuarantorAssetAndLiabilities([...guarantorAssetsAndLiabilities]);
        }
      }
    }
    else if (array === "entityReoSchedules") {
      newBorrowerEntity.hasReoChanged = true;
      if (newBorrowerEntity.reoSchedules && newBorrowerEntity.reoSchedules.length > 0) {
        const indexOfGuarantorReoSchedule = index; 
        newBorrowerEntity.reoSchedules.splice(indexOfGuarantorReoSchedule, 1);
        setNewBorrowerEntity({...newBorrowerEntity});
        entityReoSchedules.splice(index, 1);
        setEntityReoSchedules([...entityReoSchedules]);
      }
    }
    else if (array === "guarantorReoSchedules") {
      newGuarantor.hasReoChanged = true;
      if (newGuarantor.reoSchedules && newGuarantor.reoSchedules.length > 0) {
        const indexOfGuarantorReoSchedule = index;
        newGuarantor.reoSchedules.splice(indexOfGuarantorReoSchedule, 1);
        setNewGuarantor({...newGuarantor});
        guarantorReoSchedules.splice(index, 1);
        setGuarantorReoSchedules([...guarantorReoSchedules]);
      }
    }
    else if (array === "unitPlans") {
      if (startAppObject[array]) {
        startAppObject[array].splice(index, 1);
        setStartAppObject({...startAppObject});
      }
    }
    else {
      if (startAppObject[array]) {
        startAppObject[array].splice(index, 1);
        setStartAppObject({...startAppObject});
      }
    }
  };

  const handleGuarantorSearchClear = () => {
    setIsBrokerGuarantorSelected(true);
    setGuarantorSearch("");
  };

  const handleBrokerGuarantorModal = async () => {
    const newGuarantor = { id: guid(), email: guarantorSearch, isMailingSameAsPhysical: true, isUSCitizen: true };
    const notValidEmails = validateEmails(newGuarantor, ["email"]);
    if (notValidEmails.length === 0) {
      setInvalidProps([]);
      setIsLoading(true);
      const guarantorExists = await handleGetGuarantorExistsAsync(guarantorSearch);
      if (guarantorExists) {
        await handleEntities();
      }
      else {
        setNewGuarantor(newGuarantor);
        handleModal("new guarantor");
      }

      setIsLoading(false);
    }
    else {
      setTimeout(() => { 
        invalidProps.push("custom-broker-guarantor-email");
        setInvalidProps([...invalidProps]);
      }, 50);
    }

    handleGuarantorSearchClear();
  };

  const handleAddBrokerGuarantor = () => {
    if (guarantorSearch !== "") {
      handleBrokerGuarantorModal();
    }
  };

  const handleGuarantorSearchChange = async (value, field, charLimit = undefined as number | undefined) => {
    const guarantorSearchValue = handleInputType("string", value, undefined, undefined, charLimit);
    setInvalidProps([]);
    setGuarantorSearch(guarantorSearchValue);
    setIsBrokerGuarantorSelected(false);
    const secondFilterGuarantors = applicationMetadata.associatedGuarantors;
    if (guarantorSearchValue !== "" && secondFilterGuarantors && secondFilterGuarantors.length > 0) {
      const filteredGuarantors = secondFilterGuarantors.filter(x => ((x.firstName && ((x.firstName).toLowerCase().includes(guarantorSearchValue.toLowerCase()))) || 
        (x.lastName && (x.lastName).toLowerCase().includes(guarantorSearchValue.toLowerCase())) ||
        (x.email && (x.email).toLowerCase().includes(guarantorSearchValue.toLowerCase()))));
      setBrokerGuarantors(filteredGuarantors);
    }
    else if (guarantorSearchValue === "" && startAppObject.borrowerOrganizationId && isBrokerGuarantorsLoading) {
      setBrokerGuarantors(brokerApiGuarantors);
    }
    else {
      setBrokerGuarantors([]);
    }
  };

  const handleDoubleFilterGuarantorSuggestions = (guarantorSearch) => {
    const results = [] as any[];
    let resultLimit = 6;
    let filteredGuarantors = associatedGuarantors;
    if (guarantorSearch && guarantorSearch !== "") {
      filteredGuarantors = brokerGuarantors;
    }

    if (filteredGuarantors && filteredGuarantors.length > 0) {
      filteredGuarantors.forEach(brokerGuarantor => {
        const foundSelectedGuarantorIndex = selectedBrokerGuarantors.findIndex(x => x.email === brokerGuarantor.email);
        if (resultLimit > 0 && foundSelectedGuarantorIndex === -1) {
          const guarantorObj = {
            id: brokerGuarantor.id,
            email: brokerGuarantor.email,
            firstName: brokerGuarantor.firstName,
            lastName: brokerGuarantor.lastName,
            status: brokerGuarantor.status
          };

          results.push({
            key: brokerGuarantor.id,
            title: `${brokerGuarantor.firstName} ${brokerGuarantor.lastName}`,
            description: brokerGuarantor.email,
            value: guarantorObj,
            firstName: brokerGuarantor.firstName,
            lastName: brokerGuarantor.lastName,
            status: brokerGuarantor.status
          });

          resultLimit--;
        }
      });
    }

    return results;
  };

  const handleGuarantorSelect = async (result, accessLevelId = undefined, status = undefined) => {
    if (result && result !== "") {
      setInvalidProps([]);
      const foundSelectedGuarantorIndex = selectedBrokerGuarantors.findIndex(x => x.id === result.key);
      if (foundSelectedGuarantorIndex === -1 && result.value) {
        selectedBrokerGuarantors.push({
          id: result.value.id,
          firstName: result.value.firstName,
          lastName: result.value.lastName,
          email: result.value.email,
          accessLevelId: accessLevelId ? accessLevelId : result.value.accessLevelId,
          status: status ? status : result.value.status
        });

        setSelectedBrokerGuarantors([...selectedBrokerGuarantors]);
      }

      setGuarantorSearch("");
      setIsBrokerGuarantorSelected(true);
      setIsLoading(true);
      await handleEntities();
      setIsLoading(false);
    }
  };

  const handleGuarantorFocus = async () => {
    setIsBrokerGuarantorSelected(false);
    if (startAppObject.borrowerOrganizationId && isBrokerGuarantorsLoading) {
      setBrokerGuarantors(brokerApiGuarantors);
    }
  };

  const handleGuarantorSearchKeyDown = async (e) => {
    if (e.keyCode === 13 && currentStepId === GuarantorSteps.DoubleFilterGuarantor.id && !isBrokerGuarantorSelected && brokerGuarantors.length === 0) {
      await handleBrokerGuarantorModal();
    }
    else if (e.keyCode === 13 && currentStepId === GuarantorSteps.DoubleFilterGuarantor.id && !isBrokerGuarantorSelected) {
      handleGuarantorSearchClear();
    }
    else if (e.keyCode === 27) {
      handleGuarantorSearchClear();
    }
  };

  const handleBrokerGuarantorDelete = async (index) => {
    if (selectedBrokerGuarantors[index]) {
      const guarantorDeleteObj = {
        borrowerApplicationId: startAppObject.id,
        organizationContactId: selectedBrokerGuarantors[index].id
      };

      const isGuarantorDeleted = await handleDeleteGuarantorAsync(guarantorDeleteObj);
      if (isGuarantorDeleted) {
        selectedBrokerGuarantors.splice(index, 1);
        setSelectedBrokerGuarantors([...selectedBrokerGuarantors]);
      }
    }
  };

  const handleBrokerGuarantorInvite = async (index) => {
    setInvalidProps([]);
    if (newBorrowerEntity && newBorrowerEntity.name) {
      if (selectedBrokerGuarantors[index]) {
        const guarantorInviteObj = {
          borrowerApplicationId: startAppObject.id,
          borrowerApplicationName: startAppObject.name,
          firstName: selectedBrokerGuarantors[index].firstName,
          lastName: selectedBrokerGuarantors[index].lastName,
          email: selectedBrokerGuarantors[index].email,
          borrowerName: (newBorrowerEntity && newBorrowerEntity.name) ? newBorrowerEntity.name : ""
        };
  
        const isGuarantorInvited = await handleBrokerGuarantorInviteAsync(guarantorInviteObj);
        if (isGuarantorInvited) {
          if (["Accepted", "Completed"].indexOf(selectedBrokerGuarantors[index].status) === -1) {
            selectedBrokerGuarantors[index].status = "Pending";
            selectedBrokerGuarantors[index].statusLookupName = "Pending";
          }
          
          setSelectedBrokerGuarantors([...selectedBrokerGuarantors]);
          setIsBrokerGuarantorInvited(true);
          setBrokerGuarantorInvitedName(`${selectedBrokerGuarantors[index].firstName} ${selectedBrokerGuarantors[index].lastName}`);
          setTimeout(() => {
            setIsBrokerGuarantorInvited(false);
            setBrokerGuarantorInvitedName("");
          }, 3000);
        }
      }
    }
    else {
      setTimeout(() => { 
        setInvalidProps(["custom-invite-broker-guarantor"]);
      }, 50);
    }
  };

  const handleBorrowerGuarantorFormChange = (value, field) => {
    handleFormChange(value, field, startAppObject, setStartAppObject);
    if (!value) {
      startAppObject.isAdditionalGuarantors = false;
      if (startAppObject.invitedGuarantors && startAppObject.invitedGuarantors.length > 0) {
        startAppObject.invitedGuarantors.forEach(async (invitedGuarantor) => {
          const guarantorDeleteObj = {
            borrowerApplicationId: startAppObject.id,
            organizationContactId: invitedGuarantor.id
          };
          
          await handleDeleteGuarantorAsync(guarantorDeleteObj);
        });
      }

      startAppObject.invitedGuarantors = undefined;
      setStartAppObject({...startAppObject});
    }
  };

  const handlePaymentModal = (paymentModalStage) => {
    const paymentModal = [] as any;
    if (paymentModalStage === "warning") {
      paymentModal.content = <React.Fragment>
        <div className="payment-modal-title">
          <Icon name="warning sign" color="yellow" />
          Payment Warning
        </div>
        <div className="payment-modal-description">
          <span className="credit-score-modal-subtext">We understand you’d like to pay later. Once paid, it can take up to 10 days to receive 3rd party services. A delay in pre-paying could delay closing of the loan. We recommend paying as soon as possible.</span>
        </div>
      </React.Fragment>;
      paymentModal.actions = <React.Fragment>
        <Button className="payment-button" color="yellow" onClick={() => handleRouteToPayments()}>
          <div className="gmr-button-container">
            <div className="payment-button-text">Review</div>
          </div>
        </Button>
        <div className="payment-skip" onClick={() => setIsPaymentModalOpen(false)}>Pay Later</div>
      </React.Fragment>;
    }
    else {
      paymentModal.content = <React.Fragment>
        <div className="payment-modal-title">
          <Icon name="credit card outline" />
          Payment
        </div>
        <div className="payment-modal-description">
          <span className="credit-score-modal-subtext">Some fees associated with your loan will need to be paid prior to closing. You can review these and pay them now. Otherwise, if you'd like to make payments later, you will be able to access your invoice(s) via the payments tab on your loan, at your convenience.</span>
        </div>
      </React.Fragment>;
      paymentModal.actions = <React.Fragment>
        <Button className="bp-button payment-button" onClick={() => handleRouteToPayments()}>
          <div className="gmr-button-container">
            <div className="payment-button-text">Review</div>
          </div>
        </Button>
        <div className="payment-skip" onClick={() => setPaymentModalStage("warning")}>Pay Later</div>
      </React.Fragment>;
    }
    
    return paymentModal;
  };

  const handleCreditModalClose = () => {
    setIsCreditModalOpen(false);
  };

  const handleCreditModal = (creditModalStage) => {
    const brokerModal = [] as any;
    if (creditModalStage === "pulling") {
      brokerModal.content = <div className="credit-score-modal">
        <div className="credit-score-modal-title">Your credit is being pulled, please wait.</div>
        <Loader className="modal-loader" active inline="centered" size={"big"} />
      </div>; 
    }
    else if (creditModalStage === "pulled") {
      brokerModal.content = <div className="credit-score-modal">
        <div className="credit-score-modal-title">Success! We were able to retrieve your credit score.</div>
        <div className="credit-score-modal-credit-container">
          <span className="credit-score-modal-subtext">Your credit score is</span>
          <span className="credit-score-modal-credit">{newGuarantor.creditScore ? newGuarantor.creditScore : ""}</span>
        </div>
      </div>;
      brokerModal.actions = <Button 
          className="bp-button" 
          style={backgroundColorStyle}
          fluid 
          onClick={() => handleCreditModalClose()}
        >
        <div className="gmr-button-container">
          <div className="gmr-button-text">Close</div>
        </div>
      </Button>;
    }
    else if (creditModalStage === "pull failed") {
      brokerModal.content = <div className="credit-score-modal">
        <div className="credit-score-modal-title">We were unable to retrieve your credit score.</div>
        <div className="credit-score-modal-credit-failed-container">
          <div className="credit-score-modal-subtext">Common causes include incorrect entry of:</div>
          <div className="credit-score-modal-subtext-padding">1. Social Security Number (SSN)</div>
          <div className="credit-score-modal-subtext">2. Legal first and last name</div>
          <div className="credit-score-modal-subtext">3. Accurate physical address</div>
          <div className="credit-score-modal-subtext-padding">Please verify the information you entered and try again.</div>
        </div>
      </div>;
      brokerModal.actions = <Button 
          className="bp-button" 
          style={backgroundColorStyle}
          fluid 
          onClick={() => handleCreditModalClose()}
        >
        <div className="gmr-button-container">
          <div className="gmr-button-text">Close</div>
        </div>
      </Button>;
    }
    else if (creditModalStage === "skip credit") {
      brokerModal.content = <div className="credit-score-modal">
        <div className="credit-score-modal-title">Why you should reconsider</div>
        <div className="credit-score-modal-credit-container">
          <span className="credit-score-modal-subtext">Pull your Credit Score now to give your lending team the best opportunity to advocate on your behalf. If you wait to pull your credit score later some of the conditions of your loan may change, potentially delaying your closing process.</span>
        </div>
      </div>;
      brokerModal.actions = <React.Fragment>
        <Button className="bp-button primary-under-table-button-fit" style={backgroundColorStyle} icon onClick={() => handlePullCreditScore()}>
          <div className="gmr-button-container">
            <div className="gmr-button-text">Yes, Pull My Score to Expedite the Process</div>
          </div>
        </Button>
        <div className="application-credit-score-skip" onClick={() => handleSkipCreditScoreConfirm()}>No, Pull My Score Later</div>
      </React.Fragment>;
    }
    
    return brokerModal;
  };

  const handlePullCreditScore = async () => {
    setIsCreditModalOpen(true);
    setCreditModalStage("pulling");
    setIsCreditScoreSkipped(false);
    if (newGuarantor && newGuarantor.id) {
      const creditUser = {
        "BorrowerApplicationId": startAppObject.id,
        "OrganizationContactId": newGuarantor.id,
        "SocialSecurityNumber": newGuarantor.socialSecurityNumber,
        "FirstName": newGuarantor.firstName,
        "LastName": newGuarantor.lastName,
        "StreetAddressLine": newGuarantor.physicalAddress,
        "CityName": newGuarantor.physicalCity,
        "StateName": newGuarantor.physicalState,
        "ZipCode": newGuarantor.physicalZip
      };

      const isPullCreditScoreSuccess = await handlePullCreditScoreAsync(creditUser);
      let creditModalStage = "pull failed";
      if (isPullCreditScoreSuccess) {
        const isGetGuarantorSuccess = await handleGetGuarantorAsync(newGuarantor.id);
        if (isGetGuarantorSuccess) {
          creditModalStage = "pulled";
        } 
      }

      setCreditModalStage(creditModalStage);
    }
  };

  const handleSkipCreditScore = () => {
    setIsCreditModalOpen(true);
    setCreditModalStage("skip credit");
  };

  const handleSkipCreditScoreConfirm = () => {
    setIsCreditModalOpen(false);
    setIsCreditScoreSkipped(true);
  };

  const handleGuarantorAssetTableEdit = (index) => {
    let editGuarantorAssets = [] as any;
    if (newGuarantor && newGuarantor.assetsAndLiabilities) {
      editGuarantorAssets = newGuarantor.assetsAndLiabilities.filter(x => x.alOption === "Asset");
    }
    
    if (editGuarantorAssets && editGuarantorAssets[index]) {
      setIsGuarantorAssetEdit(true);
      setNewAssetAndLiability(editGuarantorAssets[index]);
      handleModal("guarantor al", false, "Asset");
    }
  };

  const handleGuarantorLiabilityTableEdit = (index) => {
    let editGuarantorLiabilities = [] as any;
    if (newGuarantor && newGuarantor.assetsAndLiabilities) {
      editGuarantorLiabilities = newGuarantor.assetsAndLiabilities.filter(x => x.alOption === "Liability");
    }

    if (editGuarantorLiabilities && editGuarantorLiabilities[index]) {
      setIsGuarantorAssetEdit(true);
      setNewAssetAndLiability(editGuarantorLiabilities[index]);
      handleModal("guarantor al", false, "Liability");
    }
  };

  const handleGuarantorREOTableEdit = (index) => {
    if (newGuarantor && newGuarantor.reoSchedules && newGuarantor.reoSchedules[index]) {
      setIsGuarantorAssetEdit(true);
      setNewReoSchedule(newGuarantor.reoSchedules[index]);
      handleModal("guarantor reo");
    }
  };

  const handleSkipModalSubmit = (skipModalType) => {
    if (skipModalType === "Close and Continue" || skipModalType === "Save and Continue") {
      handlePrev(skipModalId, skipModalType);
    }

    setIsSkipModalOpen(false);
  };

  const handleSkipModal = () => {
    const skipModal = [] as any;
    skipModal.header = <div>Save Changes</div>;
    skipModal.content = <div>It looks like you made some changes, but they aren't saved yet. What would you like to do?</div>;
    skipModal.actions = <Grid>
      <Grid.Row columns={3}>
        <Grid.Column>
          <Button icon fluid onClick={() => setIsSkipModalOpen(false)}>
            <div className="gmr-button-container">
              <div className="gmr-button-text">Go Back</div>
            </div>
          </Button>
        </Grid.Column>
        <Grid.Column>
          <Button icon fluid onClick={() => handleSkipModalSubmit("Close and Continue")}>
            <div className="gmr-button-container">
              <div className="gmr-button-text">Close and Continue</div>
            </div>
          </Button>
        </Grid.Column>
        <Grid.Column>
          <Button 
            className="bp-button" 
            style={backgroundColorStyle}
            fluid 
            onClick={() => handleSkipModalSubmit("Save and Continue")}
          >
            <div className="gmr-button-container">
              <div className="gmr-button-text">Save and Continue</div>
            </div>
          </Button>
        </Grid.Column>
      </Grid.Row>
    </Grid>;
    
    return skipModal;
  };

  const handleHorizontalDevelopmentValue = (developmentBeginsAfterClosingInMonths, timeFrameToDevelopInMonths) => {
    if (Number.isInteger(developmentBeginsAfterClosingInMonths) && Number.isInteger(timeFrameToDevelopInMonths)) {
      return timeFrameToDevelopInMonths + developmentBeginsAfterClosingInMonths - 1;
    }

    return 0;
  };

  const handleCalculateFullLoanTerm = (developmentBeginsAfterClosingInMonths, timeFrameToDevelopInMonths, greatestLoanTerm) => {
    if (developmentBeginsAfterClosingInMonths && timeFrameToDevelopInMonths && startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.ALL_IN_ONE) {
      return timeFrameToDevelopInMonths + developmentBeginsAfterClosingInMonths + greatestLoanTerm - 1;
    }

    return (greatestLoanTerm > 0) ? greatestLoanTerm : 0;
  };

  const formatAdditionalCollateral = () => {
    let additionalCollateral = [] as any[];
    additionalCollateral = additionalCollateral.concat(guarantorAdditionalCollateral);
    additionalCollateral = additionalCollateral.concat(entityAdditionalCollateral);
    const uniqueAddresses = [] as string[];
    const uniqueAdditionalCollateral = [] as any[];
    additionalCollateral.forEach(additionalCollateralItem => {
      if (!uniqueAddresses.includes(additionalCollateralItem.Address)) {
        uniqueAddresses.push(additionalCollateralItem.Address);
        uniqueAdditionalCollateral.push(additionalCollateralItem);
      }
    });

    return uniqueAdditionalCollateral;
  };

  const formatButtonWords = (guarantor) => {
    const guarantorStatus = guarantor.statusLookupName ? guarantor.statusLookupName : guarantor.status ? guarantor.status : "";
    if (["Completed", "Accepted", "Declined", "Pending"].indexOf(guarantorStatus) > -1) {
      return "Resend Invite";
    }
    else {
      return "Send Invite";
    }
  };

  const handleProjectOverviewPatchProps = () => {
    let patchProps = defaultProjectOverviewPatchProps;
    if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT) {
      patchProps = patchProps.concat([ProjectQuestions.NewStructure.field, ProjectQuestions.ExistingStructure.field]);
    }

    if (isAdminBrmNwlOrLo && startAppObject.isBrokerInvolved) {
      patchProps = patchProps.concat(["brokerOrganizationContactId"]);
    }
    
    if (!(isAdminBrmNwlOrLo && startAppObject.isBrokerInvolved === false)) {
      patchProps = patchProps.concat(ProjectQuestions.BrokerFeeRate.fields);
    }

    if (isAdminBrmNwlOrLo || persona === Personas.BROKER) {
      patchProps = patchProps.concat([ProjectQuestions.SelectLoanOfficer.field]);
    }

    if (persona === Personas.WL_GUARANTOR) {
      patchProps = patchProps.concat([ProjectQuestions.GuarantorBroker.field]);
    }

    if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
      patchProps = patchProps.concat([ProjectQuestions.RequestedClosingDate.field]);
    }

    return patchProps;
  };

  const handleSelfGuarantorChange = (value, field) => {
    const selfGuarantorExcludedStepIds = [GuarantorSteps.AdditionalInformation.id, GuarantorSteps.Assets.id, GuarantorSteps.Liabilities.id, GuarantorSteps.RealEstateOwned.id, GuarantorSteps.CreditScore.id, GuarantorSteps.Disclosure.id];
    if (value) {
      const removedExcludedStepIds = removeFromArrayByValues(excludedStepIds, selfGuarantorExcludedStepIds);
      setExcludedStepIds(removedExcludedStepIds);
    }
    else {
      setExcludedStepIds(excludedStepIds.concat(selfGuarantorExcludedStepIds)); 
    }

    handleApplicationFormChange(value, field);
  };

  const isSelfGuarantorCompleted = () => {
    if (proxyUser?.id) {
      user = proxyUser;
    }

    const foundSelfGuarantor = selectedBrokerGuarantors.find(x => x.id === user.organizationContactId);
    if (foundSelfGuarantor?.status === "Completed") {
      return true;
    }

    return false;
  };

  const ProjectQuestions = {
    WhiteLabeledWelcome: {
      content: <WhiteLabeledApplicationWelcome />
    },
    BrokerWelcome: {
      content: <BrokerApplicationWelcome />
    },
    SendApplicationInputs: {
      field: "name",
      content: <Grid.Row className="application-row"> 
        <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            label="First Name"
            placeholder="Jane"
            obj={startAppObject}
            field="firstName"
            inputType="text"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, startAppObject, setStartAppObject)}
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="firstName" />
        </Grid.Column>
        <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            label="Last Name"
            placeholder="Doe"
            obj={startAppObject}
            field="lastName"
            inputType="text"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, startAppObject, setStartAppObject)}
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="lastName" />
        </Grid.Column>
        <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            label="Email"
            placeholder="john.smith@gmail.com"
            obj={startAppObject}
            field="email"
            inputType="text"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, startAppObject, setStartAppObject, undefined, undefined, 100)}
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="email" />
        </Grid.Column>
      </Grid.Row>
    },
    ProjectName: {
      field: "name",
      content: <Grid.Row className="application-row"> 
        <Grid.Column width={16}>
          <BCFormInput
            type="input"
            inputKey="project"
            label="What is the name of the project?"
            placeholder="Builders Project"
            obj={startAppObject}
            field="name"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, startAppObject, setStartAppObject, GlobalConstants.InputTypes.STRING, undefined, 50)}
            disabled={isNonGuarantorDisabled}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="name" />
          <BCValidationMessage invalidProps={invalidProps} prop="custom-project-name" propText="This project name already exists." />
        </Grid.Column>
      </Grid.Row>
    },
    LoanProgram: {
      field: "loanProgramId",
      content: <Grid.Row className="application-row"> 
        <Grid.Column width={16}>
          <BCFormInput 
            type="radio"
            inputKey="project"
            inputArray={applicationMetadata.loanPrograms} 
            label="What type of loan are you looking for?"
            obj={startAppObject}
            field="loanProgramId"
            valueField="id"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, startAppObject, setStartAppObject, GlobalConstants.InputTypes.STRING, handleCustomFormChange)}
            disabled={isNonGuarantorDisabled}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="loanProgramId" />
        </Grid.Column>
      </Grid.Row>
    },
    RequestedClosingDate: {
      field: "requestedClosingDate",
      content: <Grid.Row className="application-row"> 
        {FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && <Grid.Column width={16}>
          <BCFormInput 
            type="calendar"
            inputKey="budget"
            label="What is the desired closing date?"
            obj={startAppObject}
            field="requestedClosingDate"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
            disabled={isNonGuarantorDisabled}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="requestedClosingDate" />
          <BCValidationMessage invalidProps={invalidProps} prop="invalid-requestedClosingDate" propText="You have selected a weekend or a company holiday. Please pick another day." />
        </Grid.Column>}
      </Grid.Row>
    },
    ProjectLocation: {
      fields: ["zip", "state"],
      content: <React.Fragment>
        <Grid.Row className="application-row"> 
          <Grid.Column width={16}>
            <BCFormInput
              label="What zip code is the project located in?"
              inputKey="project"
              type={GlobalConstants.FormInputTypes.PLACES}
              placeDetailsObject={startAppObject}
              setPlaceDetailsObject={setStartAppObject}
              placeholder="98052"
              defaultValue={handleAddressValue({
                zip: startAppObject.zip
              })}
              autofillOverrides={["zip"]}
              placeFields={["city", "state", "county", "zip"]}
              handleFormChange={(value, field) => FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? handleProjectLevelPropertyInfoChange(value, field) : handleApplicationFormChange(value, field)}
              fieldType={GlobalConstants.InputTypes.ZIP}
              searchScopeOptions={GlobalConstants.ZipSearchScopeOptions}
              required
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="zip"
              propText="This zip code is invalid."
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="application-row" columns={isGreaterThanMobile ? 3 : 1}> 
          <Grid.Column>
            <BCFormInput
              inputKey="project"
              type="input"
              label="City"
              obj={startAppObject}
              field="city"
              inputType="text"
              disabled
            />
          </Grid.Column>
          <Grid.Column>
            <BCFormInput
              inputKey="project"
              type="input"
              label="County"
              obj={startAppObject}
              field="county"
              inputType="text"
              disabled
            />
            <BCValidationMessage 
              invalidProps={invalidProps}
              prop="county"
              propText="This county is invalid."
            />
          </Grid.Column>
          <Grid.Column>
            <BCFormInput
              type="input"
              inputKey="project"
              label="State"
              obj={startAppObject}
              field="state"
              inputType="text"
              disabled
            />
            <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="state"
              propText="This state is invalid."
            />
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    },
    GuarantorBroker: {
      field: "brokerOrganizationContactId",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput 
            type="dropdown" 
            inputKey="guarantor-broker-dropdown"
            label="Who do you want to work with on this loan?"
            placeholder="Please Select"
            obj={startAppObject}
            field="brokerOrganizationContactId"
            dropdownOptions={getDropdownOptions(applicationMetadata.associatedBrokers ? applicationMetadata.associatedBrokers.map(associatedBroker => {
              associatedBroker.name = `${associatedBroker.firstName} ${associatedBroker.lastName}`;
              return associatedBroker;
            }) : [], ["id"], "name")}
            handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
            disabled={isNonGuarantorDisabled}
            required
          />
        </Grid.Column>
      </Grid.Row>
    },
    BrokerAssociatedWithLoan: {
      field: "isBrokerInvolved",
      content: <Grid.Row className="application-row">
        <BPAssociatedBrokerQuestion 
          obj={startAppObject} 
          handleFormChange={handleAssociatedBrokerChange}
          disabled={isNonGuarantorDisabled || persona === Personas.BROKER_ADMIN}
          invalidProps={invalidProps}
          flow={GlobalConstants.Flow.APPLICATION}
        />
      </Grid.Row>
    },
    BrokerEmail: {
      field: "brokerSearchEmail",
      content: <Grid.Row className="application-row">
        <BPBrokerEmailQuestion 
          isBrokerSelected={(isNewBrokerCreated || selectedBrokerEmail !== "")}
          handleAddBroker={handleAddBroker}
          handleOnSearchChange={handleBrokerSearchChange}
          obj={startAppObject}
          value={brokerSearch}
          handleRenderSuggestions={handleDoubleFilterBrokerSuggestions}
          handleSearchSelect={handleBrokerSelect}
          isSearchOpen={isBrokerSearchFocus}
          onSearchFocus={setIsBrokerSearchFocus}
          handleSearchKeyDown={handleBrokerSearchKeyDown}
          disabled={isNonGuarantorDisabled}
          invalidProps={invalidProps}
          flow={GlobalConstants.Flow.APPLICATION}
        />
      </Grid.Row>
    },
    BrokerFeeRate: {
      fields: ["brokerFeeRate", "wlbrokerFeeRate"],
      content: <Grid.Row className="application-row"> 
        {(persona === Personas.BROKER || ((isAdminBrmNwlOrLo) && startAppObject.isBrokerInvolved === true)) && <BPBrokerFeeRateQuestion 
          obj={startAppObject}
          setObj={setStartAppObject}
          handleFormChange={(value, field, obj, setObj, inputType) => handleApplicationFormChange(value, field, startAppObject, setStartAppObject, inputType, handleCustomFormChange)}
          disabled={isNonGuarantorDisabled}
          invalidProps={invalidProps}
          flow={GlobalConstants.Flow.APPLICATION}
          metadata={applicationMetadata}
        />}
      </Grid.Row>
    },
    SelectLoanOfficer: {
      field: "loanOfficerOrganizationContactId",
      content: <Grid.Row className="application-row">
        <BPSelectLoanOfficerQuestion 
          obj={startAppObject}
          setObj={setStartAppObject}
          value={startAppObject.loanOfficerOrganizationContactId || handleUserIsLoanOfficer(applicationMetadata, user)}
          dropdownOptions={getDropdownOptions(applicationMetadata.loanOfficers ? applicationMetadata.loanOfficers : [], ["id"], "name")}
          handleFormChange={handleFormChange}
          disabled={isNonGuarantorDisabled}
          invalidProps={invalidProps}
          flow={GlobalConstants.Flow.APPLICATION}
          required={isAdminBrmNwlOrLo}
        />
      </Grid.Row>
    },
    ExistingStructure: {
      field: "existingStructurePropertyTypeId",
      content: <Grid.Row className="application-row"> 
        <Grid.Column width={16}>
          <BCFormInput 
            type="radio"
            inputKey="project"
            inputArray={applicationMetadata.propertyTypes} 
            label="What type of structure(s) exists on the property?"
            obj={startAppObject}
            field="existingStructurePropertyTypeId"
            valueField="id"
            handleFormChange={(value, field) => handleProjectLevelPropertyInfoChange(value, field)}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="existingStructurePropertyTypeId" />
        </Grid.Column>
      </Grid.Row>
    },
    NewStructure: {
      field: "newStructurePropertyTypeId",
      content: <React.Fragment>
        {!(startAppObject.loanProgramId && [GlobalConstants.LoanProgramIds.BRIDGE, GlobalConstants.LoanProgramIds.FIX_AND_FLIP].indexOf(startAppObject.loanProgramId) > -1) && <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput 
              type="radio"
              inputKey="project"
              inputArray={(FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.ALL_IN_ONE) ? applicationMetadata.propertyTypes && 
                applicationMetadata.propertyTypes.filter(x => x.id !== GlobalConstants.PropertyTypeIds.APARTMENT) : applicationMetadata.propertyTypes} 
              label={BPQuestionLabels.NewStructure}
              obj={startAppObject}
              field="newStructurePropertyTypeId"
              valueField="id"
              handleFormChange={(value, field) => handleProjectLevelPropertyInfoChange(value, field)}
              required
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="newStructurePropertyTypeId" />
          </Grid.Column>
        </Grid.Row>}
      </React.Fragment>
    },
    Zoning: {
      field: "zoning",
      content: <Grid.Row className="application-row"> 
        {FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && <Grid.Column width={16}>
          <BCFormInput
            type="input"
            inputKey="zoning"
            label={BPQuestionLabels.Zoning}
            obj={startAppObject}
            field="zoning"
            handleFormChange={(value, field) => handleProjectLevelPropertyInfoChange(value, field)}
            disabled={isNonGuarantorDisabled}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="zoning" />
        </Grid.Column>}
      </Grid.Row>
    },
    DurationOwned: {
      field: "purchaseRefinanceOptionLookupId",
      content: <Grid.Row className="application-row"> 
        <Grid.Column width={16}>
          <BCFormInput 
            type="radio"
            inputKey="project"
            inputArray={handlePurchaseOrRefinanceOptions(applicationMetadata.purchaseRefinance)} 
            label={BPQuestionLabels.PurchaseRefinanceOptionLookupId}
            obj={startAppObject}
            field="purchaseRefinanceOptionLookupId"
            valueField="id"
            handleFormChange={(value, field) => handlePurchaseRefinanceOptionFormChange(value, field, handleCustomFormChange(field, value, startAppObject))}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="purchaseRefinanceOptionLookupId" />
        </Grid.Column>
        {FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && isRefinanceSelected && <Grid.Column width={16}>
          <BCFormInput 
            type="radio"
            inputKey="project"
            inputArray={handleRefinanceOptions(applicationMetadata.purchaseRefinance)} 
            label={BPQuestionLabels.TransactionType}
            obj={startAppObject}
            field="refinanceOptionLookupId"
            valueField="id"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, undefined, handleCustomFormChange(field, value, startAppObject))}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="refinanceOptionLookupId" />
        </Grid.Column>}
        {(startAppObject.purchaseRefinanceOptionLookupId && startAppObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE) && <Grid.Column width={16}>
          <BCFormInput 
            type="input"
            inputKey="project" 
            label={BPQuestionLabels.Purchase_OriginalPurchasePrice}
            placeholder="100,000"
            obj={startAppObject}
            field="originalPurchasePrice"
            fieldType="dollar"
            inputType="number"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.DOLLAR, handleCustomFormChange(field, value, startAppObject))}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="originalPurchasePrice" />
        </Grid.Column>}
        {(startAppObject.purchaseRefinanceOptionLookupId && startAppObject.purchaseRefinanceOptionLookupId !== GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE) && <Grid.Column width={16}>
          <BCFormInput 
            type="radio"
            inputKey="project"
            inputArray={applicationMetadata.ownershipInputs} 
            label={BPQuestionLabels.DurationOwnedId}
            obj={startAppObject}
            field="durationOwnedId"
            valueField="id"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="durationOwnedId" />
        </Grid.Column>}
        {((!FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && startAppObject.durationOwnedId && startAppObject.durationOwnedId === GlobalConstants.DurationOwnedIds.LESS_THAN_TWO_YEARS)
          || (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && startAppObject.purchaseRefinanceOptionLookupId && startAppObject.purchaseRefinanceOptionLookupId !== GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE))&& <React.Fragment>
          <Grid.Column width={16}>
            <BCFormInput 
              type="input" 
              inputKey="project"
              label={BPQuestionLabels.RefinanceOwn_OriginalPurchasePrice}
              placeholder="100,000"
              obj={startAppObject}
              field="originalPurchasePrice"
              fieldType="dollar"
              inputType="number"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.DOLLAR)}
              required
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="originalPurchasePrice" />
          </Grid.Column>
        </React.Fragment>}
        {((!FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && startAppObject.durationOwnedId && startAppObject.durationOwnedId === GlobalConstants.DurationOwnedIds.MORE_THAN_TWO_YEARS) 
          || (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && startAppObject.purchaseRefinanceOptionLookupId && startAppObject.purchaseRefinanceOptionLookupId !== GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE))  && <React.Fragment>
          <Grid.Column width={16}>
            <BCFormInput 
              type="input" 
              inputKey="project"
              label={BPQuestionLabels.EstimatePropertyValue}
              placeholder="100,000"
              obj={startAppObject}
              field={FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? "estimatePropertyValue" : "originalPurchasePrice"}
              fieldType="dollar"
              inputType="number"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.DOLLAR)}
              required
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="originalPurchasePrice" />
          </Grid.Column>
        </React.Fragment>}
        {((!FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && startAppObject.purchaseRefinanceOptionLookupId && startAppObject.purchaseRefinanceOptionLookupId !== GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE &&
          startAppObject.durationOwnedId) || (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && startAppObject.purchaseRefinanceOptionLookupId && startAppObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL)) && <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            inputKey="project"
            label={BPQuestionLabels.AmountOwed}
            placeholder="100,000"
            obj={startAppObject}
            field="amountOwed"
            fieldType="dollar"
            inputType="number"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.DOLLAR)}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="amountOwed" />
        </Grid.Column>}
        {(startAppObject.purchaseRefinanceOptionLookupId && startAppObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.OWN) && <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            inputKey="project"
            label={BPQuestionLabels.CashOutAmountRequested}
            placeholder="100,000"
            obj={startAppObject}
            field="cashOutAmountRequested"
            fieldType="dollar"
            inputType="number"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.DOLLAR)}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="cashOutAmountRequested" />
        </Grid.Column>}
      </Grid.Row>
    },
    SubordinatedDebt: {
      field: "isSubordinatedDebt",
      content: <Grid.Row className="application-row"> 
        <Grid.Column width={16}>
          <BCFormInput 
            type="radio"
            inputKey="project"
            inputArray={yesNoBooleanRadios} 
            label="Is there a seller carryback or subordinated debt?"
            obj={startAppObject}
            field="isSubordinatedDebt"
            valueField="value"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, undefined, handleCustomFormChange(field, value, startAppObject))}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="isSubordinatedDebt" />
        </Grid.Column>
        {startAppObject && startAppObject.isSubordinatedDebt === true && <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            inputKey="project"
            label="What is the amount of subordinated debt or seller carryback?"
            placeholder="100,000"
            obj={startAppObject}
            field="subordinatedDebtAmount"
            fieldType="dollar"
            inputType="number"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.DOLLAR)}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="subordinatedDebtAmount" />
        </Grid.Column>}
      </Grid.Row>
    },
    CumulativeProjectExperience: {
      field: "cumulativeProjectExperience",
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput 
              type="input" 
              inputKey="property"
              placeholder="10"
              inputType="number"
              label={"What is the cumulative project experience of the borrowing entity and Guarantor(s) in the last 18 months?"}
              obj={startAppObject}
              field="cumulativeProjectExperience"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, undefined, handleCustomFormChange)}
              disabled={isNonGuarantorDisabled}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="cumulativeProjectExperience" />
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    },
    ProjectDevelopment: {
      fields: ["sizeOfCurrentProperty", "sizeOfProposedLot", "noOfProposedLots", "developmentBeginsAfterClosingInMonths", "timeFrameToDevelopInMonths", "horizontalDevelopmentBudget", "districtReimbursementsAvailableBorrowerApplicationInputId", "bondingRequirementsBorrowerApplicationInputId", "seasonalityConcernsBorrowerApplicationInputId", ...UserFeatureFlags.IS_RETAIL_PHASE_2 ? ["sizeOfCurrentPropertyUnitOfMeasurementBorrowerApplicationInputId", "sizeOfProposedLotUnitOfMeasurementBorrowerApplicationInputId"]:[]].concat(FeatureFlags.IS_BETA && (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.ALL_IN_ONE || startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT) ? ["afterRepairValue"] : []),
      content: <React.Fragment>
        <Grid.Row className="application-row">
          {FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? (
            <>
              <Grid.Column width={16}>
                <BCFormInput 
                  type="input"
                  inptKey="property"
                  label="What is the size of the current plat?"
                  tooltip="A ballpark figure in Acres is fine. We can get specific details from the appraisal."
                  placeholder="5"
                  obj={startAppObject}
                  field="sizeOfCurrentProperty"
                  inputType="text"
                  unitType="Acres"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.INT, undefined, 50)}
                  required
                  disabled={isNonGuarantorDisabled}
                />
                <BCValidationMessage invalidProps={invalidProps} prop="sizeOfCurrentProperty" />
              </Grid.Column>
              <Grid.Column width={16}>
                <BCFormInput 
                  type="input"
                  inputKey="property" 
                  label="How many lots will be developed?"
                  placeholder="3"
                  obj={startAppObject}
                  field="noOfProposedLots"
                  inputType="text"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.INT)}
                  required
                  disabled={isNonGuarantorDisabled}
                />
                <BCValidationMessage invalidProps={invalidProps} prop="noOfProposedLots" />
              </Grid.Column>
              <Grid.Column width={16}>
                <BCFormInput 
                  type="input"
                  inputKey="property"
                  label="What is the average size of the proposed lots?"
                  tooltip="A ballpark figure in Square Feet is fine. We can get specific details from the appraisal."
                  placeholder="5000"
                  obj={startAppObject}
                  field="sizeOfProposedLot"
                  inputType="text"
                  unitType="Square Feet"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.INT, undefined, 50)}
                  required
                  disabled={isNonGuarantorDisabled}
                />
                <BCValidationMessage invalidProps={invalidProps} prop="sizeOfProposedLot" />
              </Grid.Column>
              {(startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.ALL_IN_ONE || startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT) &&
                <Grid.Column width={16}>
                  <BCFormInput 
                    type="input"
                    inputKey="property" 
                    label={BPQuestionLabels.AfterRepairValue}
                    tooltip="Combined finished lot value before vertical construction starts."
                    placeholder="1000"
                    obj={startAppObject}
                    field="afterRepairValue"
                    fieldType="dollar"
                    inputType="number"
                    unitType="$"
                    handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.DOLLAR)}
                    required
                    disabled={isNonGuarantorDisabled}
                  />
                  <BCValidationMessage invalidProps={invalidProps} prop="afterRepairValue" />
                </Grid.Column>
              }
            </>
          ) : (
            <Grid.Column width={16}>
              <BCFormInput 
                type="input"
                inputKey="property" 
                label="How many lots will be developed?"
                placeholder="3"
                obj={startAppObject}
                field="noOfProposedLots"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.INT)}
                required
                disabled={isNonGuarantorDisabled}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="noOfProposedLots" />
            </Grid.Column>
          )}
          <Grid.Column width={16}>
            <BCFormInput 
              type="input" 
              inputKey="property"
              label="How many months after closing will development begin?"
              placeholder="1"
              obj={startAppObject}
              field="developmentBeginsAfterClosingInMonths"
              inputType={GlobalConstants.InputTypes.INT}
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.INT)}
              required
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="developmentBeginsAfterClosingInMonths" />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="application-row"> 
          <Grid.Column width={16}>
            <BCFormInput 
              type="input" 
              inputKey="property"
              label="How many months will development last?"
              placeholder="5"
              obj={startAppObject}
              field="timeFrameToDevelopInMonths"
              inputType={GlobalConstants.InputTypes.INT}
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.INT)}
              required
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="timeFrameToDevelopInMonths" />
          </Grid.Column>
          <Grid.Column width={16}>
            <BCFormInput 
              type="input" 
              inputKey="property"
              label="How much is the horizontal development budget?"
              tooltip="Only the development portion of the budget. If applicable, we will ask for the vertical budget details later."
              placeholder="1000"
              obj={startAppObject}
              field="horizontalDevelopmentBudget"
              fieldType="dollar"
              inputType="number"
              unitType="$"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.DOLLAR)}
              required
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="horizontalDevelopmentBudget" />
          </Grid.Column>
          {
            !FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && (
              <>
                <Grid.Column width={16}>
                  <BCFormInput 
                    type="input"
                    inptKey="property"
                    label="What is the size of the current property?"
                    tooltip="A ballpark figure in Acres is fine. We can get specific details from the appraisal."
                    placeholder="5"
                    obj={startAppObject}
                    field="sizeOfCurrentProperty"
                    inputType="text"
                    unitType="Acres"
                    handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.INT, undefined, 50)}
                    required
                    disabled={isNonGuarantorDisabled}
                    />
                  <BCValidationMessage invalidProps={invalidProps} prop="sizeOfCurrentProperty" />
                </Grid.Column>
                <Grid.Column width={16}>
                  <BCFormInput 
                    type="input"
                    inputKey="property"
                    label="What is the size of the proposed lots?"
                    tooltip="A ballpark figure in Square Feet is fine. We can get specific details from the appraisal."
                    placeholder="5000"
                    obj={startAppObject}
                    field="sizeOfProposedLot"
                    inputType="text"
                    unitType="Square Feet"
                    handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.INT, undefined, 50)}
                    required
                    disabled={isNonGuarantorDisabled}
                  />
                  <BCValidationMessage invalidProps={invalidProps} prop="sizeOfProposedLot" />
                </Grid.Column>
              </>
            )
          },
          {
            UserFeatureFlags.IS_RETAIL_PHASE_2 && (
              <>
                <Grid.Column width={16}>
                  <BCFormInput 
                    type="input"
                    inptKey="property"
                    label={BPQuestionLabels.SizeOfCurrentProperty}
                    tooltip="A ballpark figure in Acres is fine. We can get specific details from the appraisal."
                    placeholder="5"
                    obj={startAppObject}
                    field="sizeOfCurrentProperty"
                    fieldType="inputSuffix"
                    unitField="sizeOfCurrentPropertyUnitOfMeasurementBorrowerApplicationInputId"
                    inputType="text"
                    defaultUnitValue = {(applicationMetadata.unitOfMeasurementInputs && applicationMetadata.unitOfMeasurementInputs.find((obj: { name: string; }) => obj.name === "acre") || {}).id}
                    dropdownOptions={getDropdownOptions(applicationMetadata.unitOfMeasurementInputs, ["id"], "name")}
                    handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.INT, undefined, 50)}
                    handleSelectFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.STRING, undefined, 50)}
                    required
                    disabled={isNonGuarantorDisabled}
                    />
                  <BCValidationMessage invalidProps={invalidProps} prop="sizeOfCurrentProperty" />
                </Grid.Column>
                <Grid.Column width={16}>
                  <BCFormInput 
                    type="input"
                    inputKey="property"
                    label={BPQuestionLabels.SizeOfProposedLots}
                    tooltip="A ballpark figure in Square Feet is fine. We can get specific details from the appraisal."
                    placeholder="5000"
                    obj={startAppObject}
                    field="sizeOfProposedLot"
                    inputType="text"
                    defaultUnitValue={(applicationMetadata.unitOfMeasurementInputs && applicationMetadata.unitOfMeasurementInputs.find((obj: { name: string; }) => obj.name === "sqft") || {}).id}
                    unitField="sizeOfProposedLotUnitOfMeasurementBorrowerApplicationInputId"
                    fieldType="inputSuffix"
                    dropdownOptions={getDropdownOptions(applicationMetadata.unitOfMeasurementInputs, ["id"], "name")}
                    handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.INT, undefined, 50)}
                    handleSelectFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.STRING, undefined, 50)}
                    required
                    disabled={isNonGuarantorDisabled}
                  />
                  <BCValidationMessage invalidProps={invalidProps} prop="sizeOfProposedLot" />
                </Grid.Column>
              </>
            )
          }
        </Grid.Row>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput 
              type="radio"
              inputKey="property"
              inputArray={applicationMetadata.yesNoUnknownInputs} 
              label={BPQuestionLabels.DistrictReimbursements}
              obj={startAppObject}
              field="districtReimbursementsAvailableBorrowerApplicationInputId"
              valueField="id"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
              required
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="districtReimbursementsAvailableBorrowerApplicationInputId" />
          </Grid.Column>
          <Grid.Column width={16}>
            {startAppObject.districtReimbursementsAvailableBorrowerApplicationInputId === GlobalConstants.YesNoUnknownIds.YES && <BCFormInput
              type="textarea"
              inputKey="property"
              label="Please describe the available district reimbursements:"
              placeholder="Write your description here..."
              obj={startAppObject}
              field="districtReimbursementsAvailableDescription"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, undefined, undefined, 2000)}
              required
              disabled={isNonGuarantorDisabled}
            />}
            <BCValidationMessage invalidProps={invalidProps} prop="districtReimbursementsAvailableDescription" />
          </Grid.Column>
          <Grid.Column width={16}>
            <BCFormInput 
              type="radio"
              inputKey="property"
              inputArray={applicationMetadata.yesNoUnknownInputs} 
              label={BPQuestionLabels.BondingRequirements}
              obj={startAppObject}
              field="bondingRequirementsBorrowerApplicationInputId"
              valueField="id"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
              required
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="bondingRequirementsBorrowerApplicationInputId" />
          </Grid.Column>
          <Grid.Column width={16}>
            {startAppObject.bondingRequirementsBorrowerApplicationInputId === GlobalConstants.YesNoUnknownIds.YES && <BCFormInput
              type="textarea"
              inputKey="property"
              label="Please describe the bonding requirements:"
              placeholder="Write your description here..."
              obj={startAppObject}
              field="bondingRequirementsDescription"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, undefined, undefined, 2000)}
              required
              disabled={isNonGuarantorDisabled}
            />}
            <BCValidationMessage invalidProps={invalidProps} prop="bondingRequirementsDescription" />
          </Grid.Column>
          <Grid.Column width={16}>
            <BCFormInput 
              type="radio"
              inputKey="property"
              inputArray={applicationMetadata.yesNoUnknownInputs} 
              label={BPQuestionLabels.SeasonalityConcerns}
              obj={startAppObject}
              field="seasonalityConcernsBorrowerApplicationInputId"
              valueField="id"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
              required
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="seasonalityConcernsBorrowerApplicationInputId" />
          </Grid.Column>
          <Grid.Column width={16}>
            {startAppObject.seasonalityConcernsBorrowerApplicationInputId === GlobalConstants.YesNoUnknownIds.YES && <BCFormInput
              type="textarea"
              inputKey="property"
              label="Please describe the seasonality concerns:"
              placeholder="Write your description here..."
              obj={startAppObject}
              field="seasonalityConcernsDescription"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, undefined, undefined, 2000)}
              required
              disabled={isNonGuarantorDisabled}
            />}
            <BCValidationMessage invalidProps={invalidProps} prop="seasonalityConcernsDescription" />
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    },
    PermitStatus: {
      field: "permitStatusId",
      fields: ["permitStatusId", "developmentOrVerticalPermitTimingInMonths", ...UserFeatureFlags.IS_RETAIL_PHASE_2 ? ["permitStatusExplanation"]:[]],
      content: <Grid.Row className="application-row"> 
        <Grid.Column width={16}>
          <BCFormInput 
            type="dropdown" 
            inputKey="property"
            label= {UserFeatureFlags.IS_RETAIL_PHASE_2 ? BPQuestionLabels.PermitStatusCurrent : BPQuestionLabels.PermitStatus }
            obj={startAppObject}
            field="permitStatusId"
            dropdownOptions={getDropdownOptions(applicationMetadata.permitStatuses, ["id"], "name")}
            handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="permitStatusId" />
        </Grid.Column>
        {(startAppObject.permitStatusId && isPermitTimingInMonthsNeeded) && <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            inputKey="property"
            label="How many months until permits are expected to be issued?"
            placeholder="3"
            obj={startAppObject}
            field="developmentOrVerticalPermitTimingInMonths"
            inputType="text"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.INT)}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="developmentOrVerticalPermitTimingInMonths" />
        </Grid.Column>}
        {( UserFeatureFlags.IS_RETAIL_PHASE_2 && startAppObject.permitStatusId && isAdditionalDetailsRegardingPermitStatusOtherOptions) && <Grid.Column width={16}>
        <BCFormInput 
          type="textarea"
          inputKey="permitStatusExplanation"
          label= {BPQuestionLabels.AdditionalDetailsPermitStatus}
          placeholder={BPQuestionLabels.AdditionalDetailsPermitStatus}
          obj={startAppObject}
          field="permitStatusExplanation"
          handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, undefined, undefined, 2000)}
          disabled={isNonGuarantorDisabled}
          required
        />
        <BCValidationMessage invalidProps={invalidProps} prop="permitStatusExplanation" />
      </Grid.Column>}
      </Grid.Row>
    },
    PercentComplete: {
      field: !UserFeatureFlags.IS_RETAIL_PHASE_2 && "workStageId",
      fields: UserFeatureFlags.IS_RETAIL_PHASE_2 ? ["permitStatusExplanation","workStageId"] : [],
      content: <Grid.Row className="application-row"> 
        {FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && <Grid.Column width={16}>
          <BCFormInput 
            type={GlobalConstants.FormInputTypes.DROPDOWN}
            inputKey="percentComplete"
            label={BPQuestionLabels.WorkStage}
            obj={startAppObject}
            field="workStageId"
            dropdownOptions={getDropdownOptions(applicationMetadata.workStages, ["id"], "name")}
            handleFormChange={(value, field) => handleProjectLevelPropertyInfoChange(value, field)}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="workStageId" />
        </Grid.Column>}
        {(UserFeatureFlags.IS_RETAIL_PHASE_2 && startAppObject.permitStatusId && startAppObject.permitStatusId === GlobalConstants.PermitStatusIds.ISSUED) && <Grid.Column width={16}>
          <BCFormInput 
            type="textarea"
            inputKey="permitStatusExplanation"
            label={BPQuestionLabels.AdditionalDetailsPermitStatus}
            placeholder={BPQuestionLabels.AdditionalDetailsPermitStatus}
            obj={startAppObject}
            field="permitStatusExplanation"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
            disabled={isNonGuarantorDisabled}
          />
          
        </Grid.Column>}
      </Grid.Row>
    }
  };

  const PropertyQuestions = {
    NumberOfProperties: {
      field: "numberOfProperties",
      content: <Grid.Row className="application-row"> 
        <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            inputKey="property"
            label="How many properties are being financed?"
            subLabel={`A property equals a foundation with a vertical budget. E.g. if you have a condo project with 4 buildings, you will have 4 properties. ${startAppObject.newStructurePropertyTypeId && 
              [GlobalConstants.PropertyTypeIds.TOWNHOME, GlobalConstants.PropertyTypeIds.CONDO, GlobalConstants.PropertyTypeIds.MULTI_UNIT, GlobalConstants.PropertyTypeIds.APARTMENT, GlobalConstants.PropertyTypeIds.OTHER].indexOf(startAppObject.newStructurePropertyTypeId) > -1 ? 
              " The number of sell-able units per property will be asked on the next screen." : ""}`}
            placeholder="1"
            obj={startAppObject}
            field="numberOfProperties"
            inputType="text"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.PROPERTIES, handleCustomFormChange(field, value, startAppObject))}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="numberOfProperties" />
        </Grid.Column>
      </Grid.Row>
    },
    UploadPropertyUnitMix: {
      field: "uploadOptionLookupId",
      content: <React.Fragment>
        {(startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.DEVELOPMENT && 
        startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.BRIDGE &&
        startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.FIX_AND_FLIP &&
        startAppObject.newStructurePropertyTypeId !== GlobalConstants.PropertyTypeIds.APARTMENT) && <React.Fragment>
          <Grid.Row className="application-row"> 
            <Grid.Column width={16}>
              <BCFormInput 
                type={GlobalConstants.FormInputTypes.RADIO} 
                inputKey="propertyUploadOption"
                inputArray={propertyUploadOptionRadios}
                label="Would you like to upload the excel or manually fill out the property and unit information?"
                obj={startAppObject}
                field="uploadOptionLookupId"
                valueField="value"
                handleFormChange={(value, field) => handlePropertyUploadOption(value, field)}
                required
                disabled={isNonGuarantorDisabled}
              />
            <BCValidationMessage invalidProps={invalidProps} prop="uploadOptionLookupId" />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="application-row"> 
          <Grid.Column width={16}>{(!isNonGuarantorDisabled && startAppObject.uploadOptionLookupId === GlobalConstants.UploadOptions.UPLOAD && startAppObject.numberOfProperties) ?
            <div className="borrower-application-upload">
              <label className="form-input-label">First download the excel then upload the finished version</label>
              <a className={"export-link"} href={exportURL} download={`${startAppObject.name}.propertyupload.${propertyUnitExcelDate}.xlsm`} ref={exportRef as any}>0</a>
              <button className="download-excel" onClick={() => downloadPropertyUnitExcelAsync(startAppObject.id, startAppObject.numberOfProperties)}>
                {isPropertyUnitMixUploaded ? `${startAppObject.name}.propertyupload.${propertyUnitExcelDate}.xlsm` : "Property/Unit Excel.xls"}
              </button>
              <BCValidationMessage invalidProps={invalidProps} prop="invalid-excel-upload" propText="Please upload a valid excel file." />
              {isLoadingPropertyUnitExcel ? <Loader active inline="centered" size={"big"} /> 
              :<BCUploadBox
                uploadTitle={isPropertyUnitMixUploaded ? "Excel uploaded, please redownload for any update" : "First download the excel then upload the finished version"}
                uploadText="Drag excel document here or browse"
                handleUploadFile={handleUploadPropertyUnitExcel}
                uploadBoxClass="application-details-upload-empty"
              />}
            </div>:<React.Fragment></React.Fragment>}
            <BCValidationMessage invalidProps={invalidProps} prop="missing-uploadPropertyUnitMix" propText="Please upload a completed excel or select fill it out option above." />
            </Grid.Column>
          </Grid.Row>
        </React.Fragment>}
      </React.Fragment>
    },
    Properties: {
      content: <React.Fragment>
        {FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCModal
              size="large"
              isModalOpen={isPropertyBulkEditModalOpen}
              onOpen={() => setIsPropertyBulkEditModalOpen(true)}
              header={
                <>
                  <div>Edit {checkedProperties.length} Propert{checkedProperties.length === 1 ? "y" : "ies"}</div>
                  <p className="gmr-modal-heading-description">The fields with question bubbles have superpowers. Click into the textboxes to see their superpowers or hold your cursor over the question bubble to read more. Change all inputs you would like to edit. Textboxes that say "Mixed" indicate that the properties you have selected have varied answers; if you override "Mixed" you will change the previous answers.</p>
                </>
              }
              content={
                <Form className="primary-form" onSubmit={(e) => e.preventDefault()}>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={16}>
                        <BCFormInput
                          icon="chevron down"
                          tooltip={"Click in the textbox to see the option to \"Assign unique identifiers\". This will populate all selected properties with a unique property number, starting with 1."}
                          isSearchOpen={isPropertyBulkEditAddressOpen}
                          onSearchFocus={() => setIsPropertyBulkEditAddressOpen(true)}
                          value={getPropertyBulkEditFieldValue("address")}
                          type={GlobalConstants.FormInputTypes.SEARCH_FILTER}
                          inputKey="property-edit-bulk"
                          label="Address (or unique identifier)"
                          renderSuggestions={[{
                            title: "Assign unique identifiers",
                            description: ""
                          }]}
                          field="address"
                          onSearchChange={handlePropertyAddressBulkEditFieldSearchChange}
                          handleSearchSelect={(_, data) => handleSelectPropertyAddressBulkEditField(data.result.title, "address")}
                          handleSearchKeyDown={() => {
                            return;
                          }}
                        />
                      </Grid.Column>
                      <Grid.Column width={16}>
                        <BCFormInput
                          inputKey="property-edit-bulk"
                          label="Zip"
                          type={GlobalConstants.FormInputTypes.PLACES}
                          placeDetailsObject={{
                            city: propertyInformationBulkEdit.city,
                            state: propertyInformationBulkEdit.state,
                            county: propertyInformationBulkEdit.county,
                            zip: propertyInformationBulkEdit.zip,
                          }}
                          setPlaceDetailsObject={(placeDetailsObject: {city: string, state: string, county: string, zip: string}) => {
                            Object.keys(placeDetailsObject).forEach((placeKey: string) => {
                              handlePropertyBulkEditFieldChange(placeDetailsObject[placeKey], placeKey);
                            });
                          }}
                          placeholder="98052"
                          autofillOverrides={["zip"]}
                          placeFields={["city", "state", "county", "zip"]}
                          fieldType={GlobalConstants.InputTypes.ZIP}
                          searchScopeOptions={GlobalConstants.ZipSearchScopeOptions}
                          defaultValue={getPropertyBulkEditFieldValue("zip")}
                        />
                      </Grid.Column>
                      <Grid.Column width={16}>
                        <BCFormInput 
                          label="No. of Units"
                          inputKey="property-edit-bulk"
                          type={GlobalConstants.FormInputTypes.INPUT}
                          placeholder="2"
                          field="numberOfUnits"
                          value={startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT || (startAppObject.newStructurePropertyTypeId && (startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.SINGLE_FAMILY ||
                            (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE && startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND))) ? 1 : getPropertyBulkEditFieldValue("numberOfUnits")}
                          handleFormChange={(value, field) => handlePropertyBulkEditFieldChange(value, field, GlobalConstants.InputTypes.INT)}
                          disabled={startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT || isNonGuarantorDisabled || (startAppObject.newStructurePropertyTypeId && (startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.SINGLE_FAMILY ||
                            (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE && startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND)))}
                          />
                      </Grid.Column>
                      {(startAppObject && startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.DEVELOPMENT && startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.BRIDGE) && <Grid.Column width={16}>
                        <BCFormInput
                          label="Existing Structure"
                          inputKey="property-edit-bulk"
                          type={GlobalConstants.FormInputTypes.DROPDOWN}
                          field="existingStructurePropertyTypeId"
                          dropdownOptions={getDropdownOptions(applicationMetadata.propertyTypes, ["id"], "name")}
                          value={getPropertyBulkEditFieldValue("existingStructurePropertyTypeId") || startAppObject.existingStructurePropertyTypeId}
                          placeholder={getPropertyBulkEditFieldValue("existingStructurePropertyTypeId") || "Please Select"}
                          handleFormChange={handlePropertyBulkEditFieldChange}
                          disabled={!allowMultiplePropertiesLoanType}
                        />
                      </Grid.Column>}
                      {(startAppObject && startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.DEVELOPMENT && startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.BRIDGE &&
                        startAppObject.newStructurePropertyTypeId !== GlobalConstants.PropertyTypeIds.APARTMENT) && <Grid.Column width={16}>
                          <BCFormInput 
                            label="New Structure"
                            inputKey="property-edit-bulk"
                            type={GlobalConstants.FormInputTypes.DROPDOWN}
                            field="newStructurePropertyTypeId"
                            dropdownOptions={handleFormatNewStructureDropdownOptions(applicationMetadata.propertyTypes)}
                            placeholder={getPropertyBulkEditFieldValue("newStructurePropertyTypeId") || "Please Select"}
                            value={getPropertyBulkEditFieldValue("newStructurePropertyTypeId") || startAppObject.newStructurePropertyTypeId}
                            handleFormChange={handlePropertyBulkEditFieldChange}
                            disabled={!allowMultiplePropertiesLoanType || startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.APARTMENT}
                          />
                      </Grid.Column>}
                      {([
                        GlobalConstants.LoanProgramIds.DEVELOPMENT,
                        GlobalConstants.LoanProgramIds.BRIDGE,
                        ].indexOf(startAppObject.loanProgramId) !== -1 || startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.APARTMENT) &&
                          <Grid.Column width={16}>
                            <BCFormInput
                              label={startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.APARTMENT ? BPQuestionLabels.EstimatedSalesPrice : "Finished Value (i.e. ARV)"}
                              type={GlobalConstants.FormInputTypes.INPUT}
                              inputKey="property-edit-bulk"
                              placeholder="100000"
                              field="completedValue"
                              fieldType="dollar"
                              onFocus={() => clearMixedValueBulkEdit(setPropertyInformationBulkEdit, getARVPropertyBulkEditValue(), "completedValue")}
                              value={getARVPropertyBulkEditValue()}
                              handleFormChange={(value, field) => handlePropertyBulkEditFieldChange(value, field, GlobalConstants.InputTypes.DOLLAR)}
                            />
                          </Grid.Column>
                      }
                      <Grid.Column width={16}>
                        <BCFormInput
                          label="Current Parcel No."
                          inputKey="property-edit-bulk"
                          type={GlobalConstants.FormInputTypes.INPUT}
                          placeholder="1"
                          field="parcelNumber"
                          value={getPropertyBulkEditFieldValue("parcelNumber")}
                          handleFormChange={handlePropertyBulkEditFieldChange}
                        />
                      </Grid.Column>
                      <Grid.Column width={16}>
                        <BCFormInput
                          icon="chevron down"
                          tooltip={"Click in the textbox to see the option to assign lot numbers automatically. It will default to \"Starting from 1\". Then, type in any number to begin the lot number assignment."}
                          isSearchOpen={isPropertyBulkEditLotOpen}
                          onSearchFocus={() => setIsPropertyBulkEditLotOpen(true)}
                          value={getAscendingLotEditFieldValue(checkedProperties, propertyInformationBulkEdit, startAppObject.properties)}
                          label="Lot Number"
                          inputKey="property-edit-bulk"
                          type={GlobalConstants.FormInputTypes.SEARCH_FILTER}
                          field="lotNumberStartingFrom"
                          renderSuggestions={[{
                            title: `Ascending starting from ${propertyInformationBulkEdit.lotNumber !== undefined ? propertyInformationBulkEdit.lotNumber : ""}`,
                            description: ""
                          }]}
                          onSearchChange={handlePropertyLotBulkEditFieldSearchChange}
                          handleSearchSelect={(_, data) => handleSelectPropertyLotBulkEditField(data.result.title, "lotNumberStartingFrom")}
                          handleSearchKeyDown={() => {
                            return;
                          }}
                        />
                      </Grid.Column>
                      {(propertyInformationBulkEdit.lotNumberStartingFrom && propertyInformationBulkEdit.lotNumberStartingFrom.startsWith("Ascending starting from")) &&
                        <>
                          <Grid.Column width={2} verticalAlign="middle" className="modal-edit-bulk-field-padding">
                            Starting from
                          </Grid.Column>
                          <Grid.Column width={14} className="modal-edit-bulk-field-padding">
                            <BCFormInput
                              isTextbox
                              inputClass="modal-edit-bulk-full-width"
                              inputKey="property-edit-bulk"
                              type={GlobalConstants.FormInputTypes.INPUT}
                              fieldType={GlobalConstants.InputTypes.INT}
                              field="lotNumber"
                              value={propertyInformationBulkEdit.lotNumber}
                              handleFormChange={(value, field) => handlePropertyBulkEditLotNumberChange(value, field, GlobalConstants.InputTypes.INT)}
                            />
                          </Grid.Column>
                        </>
                      }
                      <Grid.Column width={16}>
                        <BCFormInput
                          label="Zoning"
                          inputKey="property-edit-bulk"
                          type={GlobalConstants.FormInputTypes.INPUT}
                          field="zoning"
                          value={getPropertyBulkEditFieldValue("zoning")}
                          handleFormChange={handlePropertyBulkEditFieldChange}
                        />
                      </Grid.Column>
                      <Grid.Column width={16}>
                        <BCFormInput
                          label="% of Work Complete"
                          inputKey="property-edit-bulk"
                          type={GlobalConstants.FormInputTypes.DROPDOWN}
                          field="workStageId"
                          value={getPropertyBulkEditFieldValue("workStageId")}
                          placeholder={getPropertyBulkEditFieldValue("workStageId")}
                          dropdownOptions={getDropdownOptions(applicationMetadata.workStages, ["id"], "name")}
                          handleFormChange={handlePropertyBulkEditFieldChange}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Form>
              }
              actions={
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column>
                      <Button icon fluid onClick={handlePropertyBulkEditModalExit}>
                        <div className="gmr-button-container">
                          <div className="gmr-button-text">Cancel</div>
                        </div>
                      </Button>
                    </Grid.Column>
                    <Grid.Column>
                      <Button 
                        className="bp-button" 
                        style={backgroundColorStyle}
                        fluid 
                        onClick={handleApplyPropertyInformationBulkEdit}
                        >
                        <div className="gmr-button-container">
                          <div className="gmr-button-text">Apply Changes</div>
                        </div>
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              }
            />
            <Form.Field>
              <label className="form-input-label">Please fill in the property information below:</label>
              <label className="form-input-subLabel">{propertyUnitDescriptionText}</label>            
            </Form.Field>
            {!([
                GlobalConstants.LoanProgramIds.DEVELOPMENT,
                GlobalConstants.LoanProgramIds.BRIDGE,
                GlobalConstants.LoanProgramIds.FIX_AND_FLIP
              ].indexOf(startAppObject.loanProgramId) !== -1 && isNonGuarantorDisabled) && (
                <Button
                icon
                inverted
                color="green"
                className="table-button bottom-margin"
                onClick={() => handleOpenPropertyInformationBulkEdit()}
                disabled={checkedProperties.length === 0}
                >
                  <div className="gmr-button-container">Edit</div>
                </Button>
              )
            }
            <BCConfirmationModal
              isWarning={true}
              isModalOpen={isNumberOfUnitWarningModalOpen}
              setIsModalOpen={setIsNumberOfUnitWarningModalOpen}
              modalHeader="Be Aware..."
              modalContent="Reducing the number of units will remove units on the following screen, do you still wish to edit?"
              confirmButtonWord="Continue"
              handleConfirm={() => setIsNumberOfUnitWarningModalOpen(false)}
              handleCancel={() => handleUndoPropertyNumberOfUnitChange()}
            />
            <BCTable
              data={handlePropertyTableData()}
              dataRules={[{ field: "id", rule: "hide" }]}
              handleCheckbox={handlePropertyCheckbox}
              handleCheckboxAll={() => handleCheckAllProperties()}
              checkedItems={checkedProperties}
              checkbox
              thin
              dataSingleLine
              overflowX
              unstackable
              brokerColor={brokerColor}
              requiredFields={["Address (or unique identifier)", "Zip", "No. of Units", "Existing Structure", "New Structure", BPQuestionLabels.EstimatedSalesPrice, "Finished Value (ARV)", "Current Parcel No."]}
            />
          </Grid.Column>
          <Grid.Column width={16}>
            <BCValidationMessage invalidProps={invalidProps} prop={"custom-properties-unique"} propText="Property and additional collateral addresses must be unique." />
          </Grid.Column>
          </Grid.Row> : <React.Fragment>
          {startAppObject.properties && startAppObject.properties.map((property, i) => {
            return (
              <React.Fragment key={`property-form-${i}`}>
                <Grid.Row className="application-row">
                  <Grid.Column width={16}>
                    <div className={"button-input-header"}>
                      {i !== 0 && <Button 
                          className="bp-button application-button" 
                          style={backgroundColorStyle}
                          icon 
                          onClick={() => handleCopyFromAboveProperty(i)}
                          disabled={isNonGuarantorDisabled}
                        >
                          <div className="gmr-button-container">
                            <Icon name='copy' size="large" />
                            <div className="gmr-button-icon-text">Copy From Above</div>
                          </div>
                        </Button>}
                        {i !== 0 && <Button 
                          className="bp-button application-button" 
                          style={backgroundColorStyle}
                          icon 
                          onClick={() => handleCopyToAllProperty(i, startAppObject.properties.length - 1)}
                          disabled={isNonGuarantorDisabled}
                        >
                          <div className="gmr-button-container">
                            <Icon name='copy' size="large" />
                            <div className="gmr-button-icon-text">Copy to All Below</div>
                          </div>
                        </Button>}
                      </div>
                      <div className={`form-input-header ${brokerLabelBorderStyle}`}>
                        <label className="form-list-input-label">Property {i + 1}</label>     
                      </div>
                  </Grid.Column>
                  <Grid.Column width={16}>
                    <BCFormInput 
                      labelClass="gmr-background-label"
                      type="input" 
                      inputKey={`property-${property.id}`}
                      label="Address"
                      placeholder="123 Main Street"
                      obj={startAppObject}
                      field="address"
                      inputType="text"
                      value={property.address}
                      handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property, undefined)}
                      required
                      autoFocus
                      disabled={isNonGuarantorDisabled}
                    />
                    <BCValidationMessage invalidProps={invalidProps} prop={`custom-properties-address-${property.id}`} />
                  </Grid.Column>
                  <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
                    <BCFormInput
                      labelClass="gmr-background-label"
                      inputKey={`property-${property.id}`}
                      label="Zip"
                      type={GlobalConstants.FormInputTypes.PLACES}
                      placeDetailsObject={startAppObject}
                      placeDetailsNested={{
                        array: "properties",
                        index: i
                      }}
                      setPlaceDetailsObject={(placeDetailObject) => handlePropertiesZipChange(property, placeDetailObject)}
                      placeholder="98052"
                      defaultValue={handleAddressValue({
                        zip: property.zip
                      })}
                      autofillOverrides={["zip"]}
                      placeFields={["city", "state", "county", "zip"]}
                      fieldType={GlobalConstants.InputTypes.ZIP}
                      searchScopeOptions={GlobalConstants.ZipSearchScopeOptions}
                      required
                      disabled={isNonGuarantorDisabled}
                    />
                    {invalidProps.includes(`custom-properties-state-${property.id}`) ? <BCValidationMessage 
                      invalidProps={invalidProps} 
                      prop={`custom-properties-state-${property.id}`}
                      propText="This state for this zip is invalid." 
                    /> : <BCValidationMessage 
                      invalidProps={invalidProps} 
                      prop={`custom-properties-zip-${property.id}`}
                      propText="This zip is invalid." 
                    />}
                  </Grid.Column>
                  <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
                    {(startAppObject && !(startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE && startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND)) && <React.Fragment>
                    </React.Fragment>}
                    <BCFormInput 
                      labelClass="gmr-background-label"
                      inputKey={`property-${i}`}
                      type="input" 
                      label="Number of Units"
                      placeholder="2"
                      obj={startAppObject}
                      field="numberOfUnits"
                      inputType="text"
                      value={startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT || (startAppObject.newStructurePropertyTypeId && (startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.SINGLE_FAMILY ||
                        (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE && startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND))) ? 1 : property.numberOfUnits}
                      handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property, "int")}
                      required
                      disabled={startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT || isNonGuarantorDisabled || (startAppObject.newStructurePropertyTypeId && (startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.SINGLE_FAMILY ||
                        (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE && startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND)))}
                    />
                    <BCValidationMessage invalidProps={invalidProps} prop={`custom-properties-numberOfUnits-${property.id}`} />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="application-row">
                  <Grid.Column width={8}>
                    <BCFormInput 
                      labelClass="gmr-background-label"
                      inputKey={`property-${i}`}
                      type="input" 
                      label="Parcel Number"
                      placeholder="1"
                      obj={startAppObject}
                      field="parcelNumber"
                      inputType="text"
                      value={property.parcelNumber}
                      handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property, undefined)}
                      disabled={isNonGuarantorDisabled}
                    />
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <BCFormInput 
                      labelClass="gmr-background-label"
                      inputKey={`property-${i}`}
                      type="input" 
                      label="Lot Number"
                      placeholder="1"
                      obj={startAppObject}
                      field="lotNumber"
                      inputType="text"
                      value={property.lotNumber}
                      handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property, undefined)}
                      disabled={isNonGuarantorDisabled}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="application-row">
                  {(startAppObject && startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.DEVELOPMENT && startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.BRIDGE) && <Grid.Column width={8}>
                    <BCFormInput 
                      labelClass="gmr-background-label"
                      inputKey={`property-${i}`}
                      type="dropdown"
                      label="New Structure Property Type"
                      placeholder="Please Select"
                      obj={startAppObject}
                      field="newStructurePropertyTypeId"
                      dropdownOptions={getDropdownOptions(applicationMetadata.propertyTypes, ["id"], "name")}
                      value={property.newStructurePropertyTypeId ? property.newStructurePropertyTypeId : startAppObject.newStructurePropertyTypeId ? startAppObject.newStructurePropertyTypeId : ""}
                      handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property)}
                      required
                      disabled
                    />
                    <BCValidationMessage invalidProps={invalidProps} prop={`custom-properties-newStructurePropertyTypeId-${property.id}`} />
                  </Grid.Column>}
                  <Grid.Column width={8}>
                    <BCFormInput 
                      labelClass="gmr-background-label"
                      inputKey={`property-${i}`}
                      type="dropdown"
                      label="Existing Structure Property Type"
                      placeholder="Please Select"
                      obj={startAppObject}
                      field="existingStructurePropertyTypeId"
                      dropdownOptions={getDropdownOptions(applicationMetadata.propertyTypes, ["id"], "name")}
                      value={property.existingStructurePropertyTypeId ? property.existingStructurePropertyTypeId : startAppObject.existingStructurePropertyTypeId ? startAppObject.existingStructurePropertyTypeId : ""}
                      handleFormChange={(value, field) => handlePropertiesFormChange(value, field, property)}
                      required
                      disabled
                    />
                    <BCValidationMessage invalidProps={invalidProps} prop={`custom-properties-existingStructurePropertyTypeId-${property.id}`} />
                  </Grid.Column>
                </Grid.Row>
              </React.Fragment>
            );
          })}
        </React.Fragment>}
      </React.Fragment>
    },
    Plans: {
      content: <React.Fragment>
        {(startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.DEVELOPMENT && !FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) && <React.Fragment>
          <Grid.Row className="application-row">
            <Grid.Column width={16}>
              <BCFormInput
                inputKey="property"
                label="Tell us about the building plans:"
                subLabel={"If there is not a plan yet, please fill in the AIV and ARV for the units below."}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <BCTable
                data={handlePlanTableData()}
                thin
                dataSingleLine
                overflowX
                unstackable
                brokerColor={brokerColor}
                actions={(startAppObject.unitPlans && startAppObject.unitPlans.length > 1 && !isNonGuarantorDisabled) && ["delete"]}
                handleTableDelete={(index) => handleDeletePlan(index)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="application-row">
            <Grid.Column width={16}>
              <Button className="bp-button plan-button" style={backgroundColorStyle} icon disabled={isNonGuarantorDisabled} onClick={() => handleAddToArray("unitPlans", unitPlan)}>
                <div className="gmr-button-container">
                  <Icon name="add" size="large"/>
                  <div className="gmr-button-icon-text">Add Plan</div>
                </div>
              </Button>
            </Grid.Column>
          </Grid.Row>
        </React.Fragment>}
        {FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <Form.Field>
              <label className="form-input-label">Tell us about your units:</label>
              <label className="form-input-subLabel">{propertyUnitDescriptionText}</label> 
            </Form.Field>
            {!isNonGuarantorDisabled && (
              <Button
                icon
                inverted
                color="green"
                className="table-button bottom-margin"
                disabled={checkedUnits.length === 0}
                onClick={() => setIsUnitBulkEditModalOpen(true)}
              >
                <div className="gmr-button-container">Edit</div>
              </Button>
            )}
            <BPPropertyUnitsTable
              properties={startAppObject.properties}
              info={startAppObject}
              setInfo={setStartAppObject}
              checkedUnits={checkedUnits}
              setCheckedUnits={setCheckedUnits}
              isUnitBulkEditModalOpen={isUnitBulkEditModalOpen}
              setIsUnitBulkEditModalOpen={setIsUnitBulkEditModalOpen}
              brokerColor={brokerColor}
              handleUnitFormChange={handleUnitFormChange}
              disabled={isNonGuarantorDisabled}
              invalidProps={invalidProps}
              unitRef={unitRef}
            />
          </Grid.Column></Grid.Row> : <React.Fragment>
            <Grid.Row className="application-row">
              <Grid.Column width={16}>
                <BCFormInput
                  inputKey="property"
                  label="Please fill in the unit information below:"
                  required
                />
              </Grid.Column>
              {startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.DEVELOPMENT && <Grid.Column width={16}>
                <Button 
                  className="bp-button group-button" 
                  style={backgroundColorStyle}
                  icon 
                  onClick={() => handleModal("group plan")} 
                  disabled={checkedUnits.length === 0 || isNonGuarantorDisabled}
                >
                  <div className="gmr-button-container">
                  <Icon name="add" size="large"/>
                    <div className="gmr-button-icon-text">Assign Group</div>
                  </div>
                </Button>
              </Grid.Column>}
            <Grid.Column width={16}>
              <BCTable
                data={handleUnitTableData()}
                dataRules={[{ field: "id", rule: "hide" }]}
                handleCheckbox={(unitId) => handleUnitCheckbox(unitId)}
                handleCheckboxAll={() => handleCheckAllUnits()}
                checkedItems={checkedUnits}
                checkbox
                thin
                dataSingleLine
                unstackable
                brokerColor={brokerColor}
                overflowX
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="application-row">
            <Grid.Column width={16}>
              <BCValidationMessage invalidProps={invalidProps} prop={"unitPlanTable"} propText="Each unit needs to have AIV and ARV." />
            </Grid.Column>
          </Grid.Row>
        </React.Fragment>}
      </React.Fragment>
    },
    LoanTerm: {
      content: <React.Fragment>
        {(startAppObject.properties && startAppObject.properties.length > 0 && startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.BRIDGE) && <Grid.Row className="application-row">
          {FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && <React.Fragment>
            {startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.BRIDGE && <React.Fragment><Grid.Column width={16}>
              <BCFormInput
                inputKey="loan-term"
                label="Construction Completion Schedule and Loan Term"
                subLabel={`The Construction Completion Date and Anticipated Payoff Date are based upon the inputs below, 
                  the desired closing date of ${convertToDateString(startAppObject.requestedClosingDate, "date")}, and ${handleHorizontalDevelopmentValue(startAppObject.developmentBeginsAfterClosingInMonths,startAppObject.timeFrameToDevelopInMonths)} 
                  months of horizontal development. This schedule will be included in the loan docs.`}
                required
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <BPConstructionScheduleTable 
                setGreatestTotalToComplete={setGreatestTotalToComplete}
                setInfo={setStartAppObject}
                properties={startAppObject.properties}
                checkedPropertySchedules={checkedPropertySchedules}
                setCheckedPropertySchedules={setCheckedPropertySchedules}
                projectInfo={{
                  "loanProgramId" : startAppObject.loanProgramId, 
                  "developmentBeginsAfterClosingInMonths" : startAppObject.developmentBeginsAfterClosingInMonths, 
                  "timeFrameToDevelopInMonths" : startAppObject.timeFrameToDevelopInMonths,
                  "requestedClosingDate" : startAppObject.requestedClosingDate,
                }}
                handlePropertyLoanTermChange={handlePropertyLoanTermChange}
                brokerColor={brokerColor}
                disabled={isNonGuarantorDisabled}
                invalidProps={invalidProps}
              />
            </Grid.Column></React.Fragment>}
          </React.Fragment>}
          {!FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && <React.Fragment><Grid.Column width={16}>
            {startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.BRIDGE && <BCFormInput
              inputKey="budget"
              label="Calculate the loan term:"
              tooltip="Help us calculate your loan term. Fill in your details below."
              subLabel={`The calculated loan term is ${handleCalculateFullLoanTerm(startAppObject.developmentBeginsAfterClosingInMonths, startAppObject.timeFrameToDevelopInMonths, greatestTotalToComplete)} months based upon the inputs below.`}
              required
            />}
          </Grid.Column>
          <Grid.Column width={16}>
            {startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.BRIDGE && <BCTable
              data={handleLoanTermTableData()}
              thin
              dataSingleLine
              overflowX={isGreaterThanTablet ? false : true}
              unstackable
              brokerColor={brokerColor}
            />}
          </Grid.Column>
          <Grid.Column width={16}>
            <BCValidationMessage invalidProps={invalidProps} prop="loanTermTable" />
          </Grid.Column></React.Fragment>}
        </Grid.Row>}
        {(startAppObject && startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE) && <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput 
              type="input" 
              label="What is your preferred loan term in months?"
              placeholder="6"
              obj={startAppObject}
              field="preferredLoanTerm"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.LOAN_TERM)}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="preferredLoanTerm" propText="Your preferred loan term must be greater than your greatest total to complete." />
          </Grid.Column>
        </Grid.Row>}
      </React.Fragment>
    }
  };

  const BudgetQuestions = {
    RequestedBudget: {
      field: "budget",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            inputKey="budget"
            label="What is the requested construction budget?"
            placeholder="100,000"
            tooltip="We understand this number may change. We will use your estimate as our basis for the loan amount."
            obj={startAppObject}
            field="budget"
            fieldType="dollar"
            inputType="number"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.DOLLAR)}
            required
            disabled={isNonGuarantorDisabled}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="budget" />
        </Grid.Column>
      </Grid.Row>
    },
    PaidCosts: {
      fields: ["useInterestReserveId", "paidCosts"],
      content: <React.Fragment>
        <Grid.Row className="application-row"> 
          <Grid.Column width={16}>
            <BCFormInput 
              type="radio"
              inputKey="budget"
              inputArray={applicationMetadata.interestCalculationMethods} 
              label="Will an interest reserve be established or monthly payments made?"
              tooltip="With interest reserve, your payments are made on your behalf as part of your loan."
              obj={startAppObject}
              field="useInterestReserveId"
              valueField="id"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
              required
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="useInterestReserveId" />
          </Grid.Column>
          <Grid.Column width={16}>
            <BCFormInput 
              type="radio"
              inputKey="budget"
              inputArray={yesNoBooleanRadios} 
              label="Have any costs been paid on the project to date?"
              tooltip="Include anything from engineering plans and permits, to purchasing the lot."
              obj={startAppObject}
              field="paidCosts"
              valueField="value"
              handleFormChange={(value, field) => handlePaidCostsFormChange(value, field)}
              required
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="paidCosts" />
          </Grid.Column>
        </Grid.Row>
        {startAppObject && startAppObject.paidCosts && startAppObject.gmrCostPaids && <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput inputKey="budget" label="What are the costs paid?" />
          </Grid.Column>
        </Grid.Row>}
        {startAppObject && startAppObject.paidCosts && startAppObject.gmrCostPaids && isGreaterThanTablet && <Grid.Row className="application-row">
          <Grid.Column width={5}>
            <BCFormInput inputKey="budget" labelClass="gmr-background-label" label="Project Cost Paid to Date" required />
          </Grid.Column>
          <Grid.Column width={4}>
            <BCFormInput inputKey="budget" labelClass="gmr-background-label" label="Amount" required />
          </Grid.Column>
          <Grid.Column width={5}>
            <BCFormInput inputKey="budget" labelClass="gmr-background-label" label="Description" />
          </Grid.Column>
        </Grid.Row>}
        {startAppObject && startAppObject.paidCosts && startAppObject.gmrCostPaids && startAppObject.gmrCostPaids.map((paidCost, i) => {
          if (isGreaterThanTablet) {
            return (
              <React.Fragment key={`paid-cost-${i}`}>
                <Grid.Row className="application-row">
                  <Grid.Column width={5}>
                    <BCFormInput 
                      type="dropdown"
                      inputKey="budget" 
                      labelClass="gmr-background-label"
                      placeholder="Please Select"
                      obj={startAppObject}
                      field="costPaidId"
                      dropdownOptions={getDropdownOptions(applicationMetadata.gmrprojectCosts, ["id"], "name")}
                      value={paidCost.costPaidId}
                      handleFormChange={(value, field) => handleCostPaidsArrayFormChange(value, field, i)}
                      required
                      disabled={isNonGuarantorDisabled}
                    />
                    <BCValidationMessage invalidProps={invalidProps} prop={`custom-gmrCostPaids-costPaidId-${i}`} />
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <BCFormInput 
                      labelClass="gmr-background-label"
                      type="input"
                      inputKey="budget"
                      placeholder="10000"
                      obj={startAppObject}
                      field="amount"
                      fieldType="dollar"
                      inputType="number"
                      value={paidCost.amount}
                      handleFormChange={(value, field) => handleCostPaidsArrayFormChange(value, field, i, "dollar")}
                      required
                      disabled={isNonGuarantorDisabled}
                    />
                    <BCValidationMessage invalidProps={invalidProps} prop={`custom-gmrCostPaids-amount-${i}`} />
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <BCFormInput 
                      labelClass="gmr-background-label"
                      type="input"
                      inputKey="budget"
                      obj={startAppObject}
                      field="description"
                      inputType="text"
                      value={paidCost.description}
                      handleFormChange={(value, field) => handleCostPaidsArrayFormChange(value, field, i, undefined, 50)}
                      disabled={isNonGuarantorDisabled}
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <Button icon onClick={() => handleDeleteCostsPaid(i)} disabled={isNonGuarantorDisabled}>
                      <Icon name="trash" size="large" />
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </React.Fragment>
            );
          }
          else {
            return (
              <React.Fragment key={`paid-cost-mobile-${i}`}>
                <Grid.Row className="application-row">
                  <Grid.Column width={16}>
                    <div className={`form-input-header ${getIsWhiteLabeled() ? brokerLabelBorderOverrideCSS : "form-input-border"}`}
                    >
                      <label className="form-list-input-label">Paid Cost {i + 1}</label>
                      <Button icon disabled={isNonGuarantorDisabled} onClick={() => handleDeleteCostsPaid(i)}>
                        <Icon name="trash" size="large" />
                      </Button>
                    </div>
                  </Grid.Column>
                  <Grid.Column width={16}>
                    <BCFormInput 
                      type="dropdown" 
                      inputKey={`budget-paidcost-${i}`}
                      labelClass="gmr-background-label"
                      label="Project Cost Paid to Date"
                      placeholder="Please Select"
                      obj={startAppObject}
                      field="costPaidId"
                      dropdownOptions={getDropdownOptions(applicationMetadata.gmrprojectCosts, ["id"], "name")}
                      value={paidCost.costPaidId}
                      handleFormChange={(value, field) => handleCostPaidsArrayFormChange(value, field, i)}
                      required
                      disabled={isNonGuarantorDisabled}
                    />
                    <BCValidationMessage invalidProps={invalidProps} prop={`custom-gmrCostPaids-costPaidId-${i}`} />
                  </Grid.Column>
                  <Grid.Column width={16}>
                    <BCFormInput 
                      labelClass="gmr-background-label"
                      type="input"
                      inputKey={`budget-paidcost-${i}`}
                      label="Amount"
                      placeholder="10000"
                      obj={startAppObject}
                      field="amount"
                      fieldType="dollar"
                      inputType="number"
                      value={paidCost.amount}
                      handleFormChange={(value, field) => handleCostPaidsArrayFormChange(value, field, i, "dollar")}
                      required
                      disabled={isNonGuarantorDisabled}
                    />
                    <BCValidationMessage invalidProps={invalidProps} prop={`custom-gmrCostPaids-amount-${i}`} />
                  </Grid.Column>
                  <Grid.Column width={16}>
                    <BCFormInput 
                      labelClass="gmr-background-label"
                      type="input"
                      inputKey={`budget-paidcost-${i}`}
                      label="Description"
                      obj={startAppObject}
                      field="description"
                      inputType="text"
                      value={paidCost.description}
                      handleFormChange={(value, field) => handleCostPaidsArrayFormChange(value, field, i, undefined, 50)}
                      disabled={isNonGuarantorDisabled}
                    />
                  </Grid.Column>
                </Grid.Row>
              </React.Fragment>
            );
          }
        })}
        {startAppObject && startAppObject.paidCosts === true && startAppObject.gmrCostPaids && <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <Button className="bp-button gmr-costs-paid-button" disabled={isNonGuarantorDisabled} style={backgroundColorStyle} icon onClick={() => handleAddCostPaid()}>
              <div className="gmr-button-container">
              <Icon name="add" size="large"/>
                <div className="gmr-button-icon-text">Add</div>
              </div>
            </Button>
          </Grid.Column>
        </Grid.Row>}
        <Grid.Row>
          {(startAppObject && startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.NEW_CONSTRUCTION) && <Grid.Column width={16}>
            <BCFormInput 
              type="input" 
              inputKey="budget"
              label="What is the planned amount of money to put down?"
              placeholder="10000"
              obj={startAppObject}
              field="cashDown"
              fieldType="dollar"
              inputType="number"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, GlobalConstants.InputTypes.DOLLAR)}
              disabled={isNonGuarantorDisabled}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="cashDown" />
          </Grid.Column>}
        </Grid.Row>
      </React.Fragment>
    },
    PayoffStrategy: {
      content: <Grid.Row className="application-row">
        {startAppObject && startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.BRIDGE && <Grid.Column width={16}>
          <BCFormInput 
            type="radio"
            inputKey="budget"
            inputArray={applicationMetadata.builderInputs} 
            label="Who will be doing the construction work?"
            obj={startAppObject}
            field="whoWillDoConstructionBorrowerApplicationInputId"
            valueField="id"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
            disabled={isNonGuarantorDisabled}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="whoWillDoConstructionBorrowerApplicationInputId" />
        </Grid.Column>}
        {startAppObject && startAppObject.whoWillDoConstructionBorrowerApplicationInputId === GlobalConstants.WhoWillDoConstructionBorrowerApplicationInputIds.HIRING_GENERAL_CONTRACTOR && <Grid.Column width={16}>
          <BCFormInput 
            type="dropdown" 
            inputKey="budget"
            actionLabel="What is the builder's name?"
            actionText="+ Add Builder"
            labelAction={() => handleModal("new builder")}
            placeholder="Please Select"
            obj={startAppObject}
            field="generalContractorId"
            dropdownOptions={getDropdownOptions(applicationMetadata.builders, ["id"], "name")}
            handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
            disabled={isNonGuarantorDisabled}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="generalContractorId" />
        </Grid.Column>}
        {startAppObject && startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.FIX_AND_FLIP && <Grid.Column width={16}>
          <BCFormInput 
            type="radio"
            inputKey="budget"
            inputArray={applicationMetadata.payoffStrategies}
            label="What is the payoff strategy?"
            obj={startAppObject}
            field="payoffStrategyId"
            valueField="id"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
            disabled={isNonGuarantorDisabled}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="payoffStrategyId" />
        </Grid.Column>}
        {startAppObject && startAppObject.payoffStrategyId === GlobalConstants.PayoffStrategyIds.OTHER && <Grid.Column width={16}>
          <BCFormInput 
            type="textarea"
            inputKey="budget"
            label="Please describe the payoff strategy:"
            placeholder="Write your description here..."
            obj={startAppObject}
            field="payoffStrategyDescription"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, undefined, undefined, 2000)}
            disabled={isNonGuarantorDisabled}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="payoffStrategyDescription" />
        </Grid.Column>}
        {!FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && <Grid.Column width={16}>
          <BCFormInput 
            type="calendar"
            inputKey="budget"
            label="What is the desired closing date?"
            obj={startAppObject}
            field="requestedClosingDate"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
            disabled={isNonGuarantorDisabled}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="requestedClosingDate" />
          <BCValidationMessage invalidProps={invalidProps} prop="invalid-requestedClosingDate" propText="You have selected a weekend or a company holiday. Please pick another day." />
        </Grid.Column>}
      </Grid.Row>
    },
    ProjectDetails: {
      field: "projectComment",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput 
            type="textarea"
            inputKey="budget"
            label="Are there any other project details to add?"
            subLabel="It's helpful to know any additional project details that haven't been addressed such as size, scope and scale."
            placeholder="Please add any details here..."
            obj={startAppObject}
            field="projectComment"
            handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, undefined, undefined, 255)}
            disabled={isNonGuarantorDisabled}
          />
        </Grid.Column>
      </Grid.Row>
    }
  };

  const EntityQuestions = {
    ExistingBorrower: {
      content: <BPBorrowerEntitySelection 
        obj={startAppObject}
        handleApplicationFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, undefined, handleCustomFormChange)}
        handleBorrowerFormChange={(value, field) => handleIsBorrowerFormChange(value, field)}
        isDisabled={isNonGuarantorDisabled}
        dropdownOptions={getDropdownOptions(associatedBorrowers, ["id"], "name")}
        invalidProps={invalidProps}
        brokerColor={brokerColor}
      />
    },
    AdditionalInformation: {
      content: <BPBorrowerEntityAdditionalInformation
        obj={startAppObject}
        brokerColor={brokerColor}
        isGreaterThanMobile={isGreaterThanMobile}
        entityObj={newBorrowerEntity}
        setEntityObj={setNewBorrowerEntity}
        handleEntityFormChange={(value, field, type, charLimit) => handleApplicationFormChange(value, field, newBorrowerEntity, setNewBorrowerEntity, type, undefined, charLimit)}
        isDisabled={isNonGuarantorDisabled}
        invalidProps={invalidProps}
        entityDropdownOptions={getDropdownOptions(applicationMetadata.entitySubTypes, ["id"], "name")}
        isExtended
      />
    },
    Assets: {
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput inputKey="entity" labelClass="primary-title-label" label={`Asset Information${newBorrowerEntity.organizationName ? ` for ${convertToOrganizationString(newBorrowerEntity.organizationName)}` : ""}`} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {getFilteredAL(entityAssetsAndLiabilities, "Asset") && getFilteredAL(entityAssetsAndLiabilities, "Asset").length > -1 ? <React.Fragment>
            <Grid.Column width={16}>
              <BCTable
                data={formatAssets(true, newBorrowerEntity, setNewBorrowerEntity)}
                dataRules={[
                  { field: "Class", rule: "hide" }, 
                  { field: "Status", rule: "hide" }, 
                  { field: "id", rule: "hide" }, 
                  { field: "Current Balance", rule: "format", display: "dollar"},
                  { field: "Monthly Liability", rule: "hide"},
                  { field: "isEditHide", rule: "hide"},
                  { field: "isDeleteHide", rule: "hide"}
                ]}
                thin
                dataSingleLine
                actions={newBorrowerEntity.assetsAndLiabilities && newBorrowerEntity.assetsAndLiabilities.filter((x) => x.alOption === "Asset").length !== 0 && ["delete"]}
                handleTableDelete={(index) => !isNonGuarantorDisabled && handleDeleteBorrowerEntityAL(index, "Asset")}
                overflowX
                unstackable
                brokerColor={wlBrokerHex}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <Button className="bp-button primary-under-table-button" disabled={isNonGuarantorDisabled} style={backgroundColorStyle} icon onClick={() => addAL(newBorrowerEntity, setNewBorrowerEntity, "Asset")}>
                <div className="gmr-button-container">
                <Icon name="add" size="large"/>
                  <div className="gmr-button-icon-text">Add Asset</div>
                </div>
              </Button>
            </Grid.Column>
          </React.Fragment> : <React.Fragment>
            <Grid.Column width={16}>
              <BrokerApplicationEmptyState 
                iconName="archive" 
                label="Looks like there isn't any assets. Add more detail to strengthen your application."
                action={() => handleModal("borrower entity al", false, "Asset")}
                buttonLabel="Add Asset"
              />
            </Grid.Column>
          </React.Fragment>}
        </Grid.Row>
      </React.Fragment>
    },
    Liabilities: {
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput labelClass="primary-title-label" label={`Liability Information${newBorrowerEntity.organizationName ? ` for ${convertToOrganizationString(newBorrowerEntity.organizationName)}` : ""}`} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {getFilteredAL(entityAssetsAndLiabilities, "Liability") && getFilteredAL(entityAssetsAndLiabilities, "Liability").length > -1 ? <React.Fragment>
            <Grid.Column width={16}>
              <BCTable
                data={formatLiabilities(true, newBorrowerEntity, setNewBorrowerEntity)}
                dataRules={[
                  { field: "Class", rule: "hide" }, 
                  { field: "Status", rule: "hide" }, 
                  { field: "id", rule: "hide" }, 
                  { field: "Current Balance", rule: "format", display: "dollar"},
                  { field: "Monthly Liability", rule: "format", display: "dollar"},
                  { field: "isEditHide", rule: "hide"},
                  { field: "isDeleteHide", rule: "hide"}
                ]}
                thin
                dataSingleLine
                actions={newBorrowerEntity.assetsAndLiabilities && newBorrowerEntity.assetsAndLiabilities.filter((x) => x.alOption === "Liability").length !== 0 && ["delete"]}
                handleTableDelete={(index) => !isNonGuarantorDisabled && handleDeleteBorrowerEntityAL(index, "Liability")}
                overflowX
                unstackable
                brokerColor={wlBrokerHex}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <Button className="bp-button primary-under-table-button" disabled={isNonGuarantorDisabled} style={backgroundColorStyle} icon onClick={() => addAL(newBorrowerEntity, setNewBorrowerEntity, "Liability")}>
                <div className="gmr-button-container">
                <Icon name="add" size="large"/>
                  <div className="gmr-button-icon-text">Add Liability</div>
                </div>
              </Button>
            </Grid.Column> 
          </React.Fragment> : <React.Fragment>
            <Grid.Column width={16}>
              <BrokerApplicationEmptyState 
                iconName="archive" 
                label="Looks like you don't have any liabilities. Please add outstanding liabilities to give us an accurate picture of your financial situation."
                action={() => handleModal("borrower entity al", false, "Liability")}
                buttonLabel="Add Liability"
              />
            </Grid.Column>
          </React.Fragment>}
        </Grid.Row>
      </React.Fragment>
    },
    RealEstateOwned: {
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput labelClass="primary-title-label" label={`Real Estate Owned${newBorrowerEntity.organizationName ? ` By ${convertToOrganizationString(newBorrowerEntity.organizationName)}` : ""}`} />
          </Grid.Column>
          <Grid.Column width={16}>{realEstateOwnedText}</Grid.Column>
          <Grid.Column width={16}><div className="reo-initial-review">{startAppObject.submittedOn && <span><b>The application has been submitted for initial review.</b> Please coordinate with your Broker to remove any Additional Collateral from the loan.</span>}</div></Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {entityReoSchedules && entityReoSchedules.length > -1 ? <React.Fragment>
            <Grid.Column width={16}>
              <BCTable
                data={formatReos(newBorrowerEntity, setNewBorrowerEntity)}
                dataRules={[
                  { field: "id", rule: "hide" },
                  { field: "Monthly Tax", rule: "format", display: "dollar"},
                  { field: "Total Mortgage Payment", rule: "hide", display: "dollar"},
                  { field: "isDeleteHide", rule: "hide"}
                ]}
                thin
                actions={(newBorrowerEntity.reoSchedules && newBorrowerEntity.reoSchedules !== 0) && ["delete"]}
                handleTableDelete={(index) => !isNonGuarantorDisabled && handleTableRemove("entityReoSchedules", index, "borrower entity")}
                overflowX
                unstackable
                brokerColor={wlBrokerHex}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <Button className="bp-button primary-under-table-button" disabled={isNonGuarantorDisabled} style={backgroundColorStyle} icon onClick={() => handleAddEntityReoSchedule()}>
                <div className="gmr-button-container">
                <Icon name="add" size="large"/>
                  <div className="gmr-button-icon-text">Add Real Estate</div>
                </div>
              </Button>
            </Grid.Column> 
          </React.Fragment> : <React.Fragment>
            <Grid.Column width={16}>
              <BrokerApplicationEmptyState 
                iconName="home"
                label="Looks like there isn't any real estate. Select Add a Property if this is not the case. Otherwise, select Next Page."
                action={() => handleModal("borrower entity reo")}
                buttonLabel="Add Real Estate"
              />
            </Grid.Column>
          </React.Fragment>}
        </Grid.Row>
      </React.Fragment>
    }
  };

  const GuarantorQuestions = {
    SelfGuarantor: {
      field: "isSelfGuarantor",
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput
              labelClass={`primary-title-label form-input-header ${getIsWhiteLabeled() ? brokerLabelBorderOverrideCSS : "form-input-border"}`}
              label={`Guarantor Information${startAppObject.name ? ` for ${startAppObject.name}` : ""}`}
            />
          </Grid.Column>
          <Grid.Column width={16}>
            <BCFormInput
              type="radio"
              inputArray={yesNoBooleanRadios}
              label={`Will you be a Guarantor${startAppObject.name ? ` for ${startAppObject.name}` : ""}?`}
              obj={startAppObject}
              field="isSelfGuarantor"
              valueField="value"
              handleFormChange={(value, field) => handleSelfGuarantorChange(value, field)}
              disabled={isNonGuarantorDisabled || isSelfGuarantorCompleted()}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="isSelfGuarantor" />
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    },
    BorrowerGuarantor: {
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput 
              labelClass={`primary-title-label form-input-header ${getIsWhiteLabeled() ? brokerLabelBorderOverrideCSS : "form-input-border"}`} 
              label={`Guarantor Information${startAppObject.name ? ` for ${startAppObject.name}` : ""}`} 
            />
          </Grid.Column>
          <Grid.Column width={16}>
            <BCFormInput 
              type="radio"
              inputArray={yesNoBooleanRadios} 
              label={`Will you be a Guarantor${startAppObject.name ? ` for ${startAppObject.name}` : ""}?`}
              obj={startAppObject}
              field="isProjectGuarantor"
              valueField="value"
              handleFormChange={(value, field) => handleBorrowerGuarantorFormChange(value, field)}
              disabled={isNonGuarantorDisabled}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="isProjectGuarantor" />
          </Grid.Column>
          {startAppObject.isProjectGuarantor === true && <Grid.Column width={16}>
            <BCFormInput 
              type="radio"
              inputArray={yesNoBooleanRadios} 
              label={`Will there be additional Guarantors${startAppObject.name ? ` for ${startAppObject.name}` : ""}?`}
              obj={startAppObject}
              field="isAdditionalGuarantors"
              valueField="value"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, undefined, undefined, undefined, handleCustomFormChange)}
              disabled={isNonGuarantorDisabled}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="isAdditionalGuarantors" />
          </Grid.Column>}
        </Grid.Row>
        {(startAppObject.isAdditionalGuarantors === true) && <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput label="Additional Guarantors:" />
            Additional Guarantors will be invited to provide their review the applicaiton, provide contact details, personal background, Assets and Liabilities and Real Estate Owned Schedule. They will also be asked to sign Loan Application disclosures.
          </Grid.Column>
        </Grid.Row>}
        {startAppObject.isProjectGuarantor === false && <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput label={`Who will the Guarantors${startAppObject.name ? ` for ${startAppObject.name}` : ""} be?`} />
            Guarantors will be invited to review the application, provide contact details, personal background, Assets and Liabilities and Real Estate Owned Schedule. They will also be asked to sign Loan Application disclosures.
          </Grid.Column>
        </Grid.Row>}
        <React.Fragment>
          {startAppObject.invitedGuarantors && startAppObject.invitedGuarantors.map((invitedGuarantor, i) => {
            return (
              <React.Fragment key={`invited-guarantor-${i}`}>
                <Grid.Row className="application-row">
                  <Grid.Column width={4}>
                    <BCFormInput 
                      labelClass="gmr-background-label"
                      type="input" 
                      label="First Name:"
                      placeholder="John"
                      obj={startAppObject}
                      field="firstName"
                      inputType="text"
                      value={invitedGuarantor.firstName}
                      handleFormChange={(value, field) => handleArrayFormChange(value, field, "invitedGuarantors", i, GlobalConstants.InputTypes.STRING, 25)}
                      disabled={isNonGuarantorDisabled}
                      required
                    />
                    <BCValidationMessage invalidProps={invalidProps} prop={`custom-invitedGuarantors-firstName-${i}`} />
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <BCFormInput 
                      labelClass="gmr-background-label"
                      type="input" 
                      label="Last Name:"
                      placeholder="Smith"
                      obj={startAppObject}
                      field="lastName"
                      inputType="text"
                      value={invitedGuarantor.lastName}
                      handleFormChange={(value, field) => handleArrayFormChange(value, field, "invitedGuarantors", i, GlobalConstants.InputTypes.STRING, 25)}
                      disabled={isNonGuarantorDisabled}
                      required
                    />
                    <BCValidationMessage invalidProps={invalidProps} prop={`custom-invitedGuarantors-lastName-${i}`} />
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <BCFormInput 
                      labelClass="gmr-background-label"
                      type="input" 
                      label="Email:"
                      placeholder="john.smith@gmail.com"
                      obj={startAppObject}
                      field="email"
                      inputType="text"
                      value={invitedGuarantor.email}
                      handleFormChange={(value, field) => handleArrayFormChange(value, field, "invitedGuarantors", i, undefined, 100)}
                      disabled={isNonGuarantorDisabled}
                      required
                    />
                    <BCValidationMessage invalidProps={invalidProps} prop={`custom-invitedGuarantors-email-${i}`} />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    {i !== 0 && <Button disabled={isNonGuarantorDisabled} icon onClick={() => handleRemoveInvitedGuarantors("invitedGuarantors", i)}>
                      <Icon name="trash" size="large" />
                    </Button>}
                  </Grid.Column>
                </Grid.Row>
              </React.Fragment>
            );
          })}
          {(startAppObject.isProjectGuarantor === false || startAppObject.isAdditionalGuarantors) && <Grid.Row className="application-row">
            <Grid.Column width={16}>
              <Button className="bp-button gmr-costs-paid-button" disabled={isNonGuarantorDisabled} style={backgroundColorStyle} icon onClick={() => handleAddToArray("invitedGuarantors", { id: guid() })}>
                <div className="gmr-button-container">
                <Icon name="add" size="large"/>
                  <div className="gmr-button-icon-text">Add</div>
                </div>
              </Button>
            </Grid.Column>
          </Grid.Row>}
          <Grid.Column width={16}>
            <BCValidationMessage invalidProps={invalidProps} prop="custom-borrower-guarantor-empty" propText="There must be at least one guarantor." />
          </Grid.Column>
        </React.Fragment>
      </React.Fragment>
    },
    AdditionalInformation: {
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput labelClass="primary-title-label" label={`Guarantor Information${newGuarantor.firstName ? ` for ${newGuarantor.firstName}` : ""}${newGuarantor.lastName ? ` ${newGuarantor.lastName}` : ""}`} />
          </Grid.Column>
          <Grid.Column width={16}>
            <BCFormInput labelClass={`form-input-label form-input-header ${getIsWhiteLabeled() ? brokerLabelBorderOverrideCSS : "form-input-border"}`} label="Contact Information" />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="application-row">
          <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="First Name"
              placeholder="John"
              obj={newGuarantor}
              field="firstName"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.STRING, undefined, 25)}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="firstName" />
          </Grid.Column>
          <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Last Name"
              placeholder="Smith"
              obj={newGuarantor}
              field="lastName"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.STRING, undefined, 25)}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="lastName" />
          </Grid.Column>  
        </Grid.Row>
        <Grid.Row className="application-row">
          <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Email"
              placeholder="john.smith@gmail.com"
              obj={newGuarantor}
              field="email"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 100)}
              required
              disabled
            />
            <BCValidationMessage invalidProps={invalidProps} prop="email" />
          </Grid.Column>
          <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Mobile Phone"
              placeholder="2061234567"
              obj={newGuarantor}
              field="mobilePhone"
              fieldType="phone"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.MASKED)}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="mobilePhone" />
          </Grid.Column>
          <Grid.Column width={16}>
            <BCFormInput 
              labelClass="gmr-background-label"
              type="checkbox"
              inputKey="guarantor"
              checkboxText="Mailing Same As Physical"
              obj={newGuarantor}
              field="isMailingSameAsPhysical"
              value={newGuarantor.isMailingSameAsPhysical}
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              required
            />
          </Grid.Column>
          <Grid.Column width={16}>
            <BCFormInput
              label="Phsyical Address"
              labelClass="gmr-background-label"
              type={GlobalConstants.FormInputTypes.PLACES}
              inputKey="guarantor"
              placeDetailsObject={newGuarantor}
              setPlaceDetailsObject={setNewGuarantor}
              placeholder="1234 Main Street, Seattle, WA 98052, USA"
              defaultValue={handleAddressValue({
                address: newGuarantor.physicalAddress,
                city: newGuarantor.physicalCity,
                state: newGuarantor.physicalState,
                zip: newGuarantor.physicalZip,
                country: newGuarantor.physicalCountry
              })}
              placeFields={["address", "city", "state", "county", "zip", "country"]}
              placeFieldsNameOverrides={[
                {
                  addressComponent: "address",
                  field: "physicalAddress"
                },
                {
                  addressComponent: "city",
                  field: "physicalCity"
                },
                {
                  addressComponent: "state",
                  field: "physicalState"
                },
                {
                  addressComponent: "county",
                  field: "physicalCounty"
                },
                {
                  addressComponent: "zip",
                  field: "physicalZip"
                },
                {
                  addressComponent: "country",
                  field: "physicalCountry"
                },
              ]}
              required
            />
            {invalidProps.includes("physicalCity") ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="physicalCity" 
              propText="This city is invalid." 
            /> : invalidProps.includes("physicalState") ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="physicalState"
              propText="This state is invalid."
            /> : invalidProps.includes("physicalZip") ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="physicalZip"
              propText="This zip code is invalid."
            /> : invalidProps.includes("physicalCounty") ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="physicalCounty"
              propText="This county is invalid."
            /> : <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="physicalAddress" 
              propText={ErrorMessages.Address} />
            }
          </Grid.Column>
          <Grid.Column width={16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Address Line 2"
              placeholder="Apartment, suite, unit, building, floor, etc."
              obj={newGuarantor}
              field="physicalAddressLine2"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
            />
          </Grid.Column>
        </Grid.Row>
        {newGuarantor.isMailingSameAsPhysical === false && <React.Fragment>
          <Grid.Row className="application-row">
            <Grid.Column width={16}>
              <BCFormInput
                label="Mailing Address"
                inputKey="guarantor-mailing"
                labelClass="gmr-background-label"
                type={GlobalConstants.FormInputTypes.PLACES}
                placeDetailsObject={newGuarantor}
                setPlaceDetailsObject={setNewGuarantor}
                placeholder="1234 Main Street, Seattle, WA 98052, USA"
                defaultValue={handleAddressValue({
                  address: newGuarantor.mailingAddress,
                  city: newGuarantor.mailingCity,
                  state: newGuarantor.mailingState,
                  zip: newGuarantor.mailingZip
                })}
                placeFields={["address", "city", "state", "county", "zip"]}
                placeFieldsNameOverrides={[
                  {
                    addressComponent: "address",
                    field: "mailingAddress"
                  },
                  {
                    addressComponent: "city",
                    field: "mailingCity"
                  },
                  {
                    addressComponent: "state",
                    field: "mailingState"
                  },
                  {
                    addressComponent: "county",
                    field: "mailingCounty"
                  },
                  {
                    addressComponent: "zip",
                    field: "mailingZip"
                  },
                ]}
                required
              />
              {invalidProps.includes("mailingCity") ? <BCValidationMessage 
                invalidProps={invalidProps} 
                prop="mailingCity" 
                propText="This city is invalid." 
              /> : invalidProps.includes("mailingState") ? <BCValidationMessage 
                invalidProps={invalidProps} 
                prop="mailingState"
                propText="This state is invalid."
              /> : invalidProps.includes("mailingZip") ? <BCValidationMessage 
                invalidProps={invalidProps} 
                prop="mailingZip"
                propText="This zip code is invalid."
              /> : invalidProps.includes("mailingCounty") ? <BCValidationMessage 
                invalidProps={invalidProps} 
                prop="mailingCounty"
                propText="This county is invalid."
              /> : <BCValidationMessage 
                invalidProps={invalidProps} 
                prop="mailingAddress" 
                propText={ErrorMessages.Address} />
              }
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor-mailing"
                label="Address Line 2"
                placeholder="Apartment, suite, unit, building, floor, etc."
                obj={newGuarantor}
                field="mailingAddressLine2"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
          </Grid.Row>
        </React.Fragment>}
        <Grid.Row className="application-row">
          <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Home Phone"
              placeholder="2061234567"
              obj={newGuarantor}
              field="homePhone"
              fieldType="phone"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.MASKED)}
            />
          </Grid.Column>
          <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Business Phone"
              placeholder="2061234567"
              obj={newGuarantor}
              field="businessPhone"
              fieldType="phone"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.MASKED)}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="businessPhone" />
          </Grid.Column>
          <Grid.Column width={isGreaterThanMobile ? 4 : 8}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Extension"
              placeholder="3"
              obj={newGuarantor}
              field="extension"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput labelClass={`form-input-label form-input-header ${getIsWhiteLabeled() ? brokerLabelBorderOverrideCSS : "form-input-border"}`} label="Personal Details" />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            {GuarantorSocialSecurity()}
            <BCValidationMessage invalidProps={invalidProps} prop="socialSecurityNumber" />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="application-row" columns={isGreaterThanMobile ? 3 : 1}>
          <Grid.Column>
            {GuarantorDateOfBirth()}
            <BCValidationMessage invalidProps={invalidProps} prop="dateOfBirth" />
          </Grid.Column>
          <Grid.Column>
            <BCFormInput 
              labelClass="gmr-background-label"
              type="dropdown"
              inputKey="guarantor" 
              label="Marital Status"
              obj={newGuarantor}
              field="maritalStatus"
              dropdownOptions={getDropdownOptions(applicationMetadata.maritalStatuses, ["id"], "name")}
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
            />
          </Grid.Column>
          <Grid.Column>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Spouse Name"
              placeholder="Jane Doe"
              obj={newGuarantor}
              field="spouseName"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 50)}
              required={newGuarantor.maritalStatus === GlobalConstants.MaritalStatusIds.MARRIED}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="spouseName" />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="application-row" columns={isGreaterThanMobile ? 3 : 1}>
          <Grid.Column>
            <BCFormInput
              labelClass="gmr-background-label"
              type="checkbox"
              inputKey="guarantor"
              checkboxText="Self Employed"
              obj={newReoSchedule}
              field="isSelfEmployed"
              value={newGuarantor.isSelfEmployed}
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
            />
          </Grid.Column>
          <Grid.Column>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Employer Name"
              placeholder="Construction Loan Services II"
              obj={newGuarantor}
              field="employerName"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 250)}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="employerName" />
          </Grid.Column>
          <Grid.Column>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Title"
              placeholder="Owner"
              obj={newGuarantor}
              field="position"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 50)}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="position" />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="application-row">
          <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Gross Revenue (Two Year Average)"
              placeholder="$100,000"
              obj={newGuarantor}
              field="grossRevenue"
              fieldType="dollar"
              inputType="number"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.DOLLAR)}
            />
          </Grid.Column>
          <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Net Income (Two Year Average)"
              placeholder="$100,000"
              obj={newGuarantor}
              field="netIncome"
              fieldType="dollar"
              inputType="number"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.DOLLAR)}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="netIncome" />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="application-row" columns={isGreaterThanMobile ? 3 : 1}>
          <Grid.Column>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Years In Industry"
              placeholder="3"
              obj={newGuarantor}
              field="yearsInIndustry"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.INT)}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="yearsInIndustry" />
          </Grid.Column>
          <Grid.Column>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Years In Job"
              placeholder="3"
              obj={newGuarantor}
              field="yearsInJob"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.INT)}
              required
            />
            <BCValidationMessage invalidProps={invalidProps} prop="yearsInJob" />
          </Grid.Column>
          <Grid.Column>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              inputKey="guarantor"
              label="Years In Business"
              placeholder="3"
              obj={newGuarantor}
              field="yearsInBusiness"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.INT)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={isGreaterThanMobile ? 6 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="checkbox"
              checkboxText="US Citizen"
              obj={newReoSchedule}
              field="isUSCitizen"
              value={newGuarantor.isUSCitizen}
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
            />
          </Grid.Column>
          <Grid.Column width={isGreaterThanMobile ? 10 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              label="Status"
              obj={newGuarantor}
              field="citizenStatus"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 255)}
            />
          </Grid.Column>
          <Grid.Column width={isGreaterThanMobile ? 6 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="checkbox"
              checkboxText="Pending Legal Action"
              obj={newReoSchedule}
              field="isPendingLegalAction"
              value={newGuarantor.isPendingLegalAction}
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
            />
          </Grid.Column>
          <Grid.Column width={isGreaterThanMobile ? 10 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              label="Legal Action Description"
              obj={newGuarantor}
              field="legalActionDescription"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 1000)}
            />
          </Grid.Column>
          <Grid.Column width={isGreaterThanMobile ? 6 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="checkbox"
              checkboxText="Is Foreclosure Initiated"
              obj={newReoSchedule}
              field="isForeclosureInitiated"
              value={newGuarantor.isForeclosureInitiated}
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
            />
          </Grid.Column>
          <Grid.Column width={isGreaterThanMobile ? 10 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              label="Forclosure Description"
              obj={newGuarantor}
              field="forclosureDescription"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 1000)}
            />
          </Grid.Column>
          <Grid.Column width={16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              label="Any other names in which you've been granted credit?"
              obj={newGuarantor}
              field="otherCreditNames"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 1000)}
            />
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    },
    CreditScore: {
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput labelClass="primary-title-label" label={`Guarantor Information${newGuarantor.firstName ? ` for ${newGuarantor.firstName}` : ""}${newGuarantor.lastName ? ` ${newGuarantor.lastName}` : ""}`} />
          </Grid.Column>
          <Grid.Column width={16}>
            {isCreditScoreSkipped ? <BCEmptyState
              emptyStateClass="application-details-empty-state"
              brokerColor={wlBrokerHex}
              content={
                <React.Fragment>
                  <div className="application-credit-score-title">Credit Score</div>
                  <BCFormInput
                    inputClass="credit-score-input"
                    labelClass="gmr-background-label"
                    type="input"
                    label="Enter your estimated Credit Score"
                    placeholder="600"
                    obj={newGuarantor}
                    field="estimatedCreditScore"
                    inputType="text"
                    handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.CREDIT)}
                  />
                  <div className="application-credit-score-text">{authorizationText}</div>
                  <div className="application-credit-instead" onClick={() => handlePullCreditScore()}>Pull Credit Instead</div>
                </React.Fragment>
              }
            /> : (newGuarantor && (newGuarantor.isCreditScorePulled || isCreditScorePulled)) ? <BCEmptyState
              emptyStateClass="application-details-empty-state"
              brokerColor={wlBrokerHex}
              content={
                <React.Fragment>
                  <div className="application-credit-score-title">Credit Score</div>
                  <div className="application-credit-score-text">This is your median credit score from Experian, Transunion, and Equifax. A copy of your credit scores will be mailed to you along with instructions to obtain your full credit report.</div>
                  <div className="application-credit-score-pulled">{newGuarantor.creditScore}</div>
                </React.Fragment>
              }
            /> : <BCEmptyState
              emptyStateClass="application-details-empty-state"
              brokerColor={wlBrokerHex}
              content={<React.Fragment>
                  <div className="application-credit-score-title">Credit Score</div>
                  <div className="application-credit-score-text">{authorizationText}</div>
                  <Button 
                    className="bp-button primary-under-table-button" 
                    style={backgroundColorStyle} 
                    icon 
                    onClick={() => handlePullCreditScore()}
                  >
                    <div className="gmr-button-container">
                      <div className="gmr-button-text">Pull Credit</div>
                    </div>
                  </Button>
                  <div className="application-credit-score-skip" onClick={() => handleSkipCreditScore()}>Skip For Now</div>
                </React.Fragment>}
              />}
          </Grid.Column>
          <Grid.Column width={16}>
            {isCreditScoreSkipped ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="estimatedCreditScore"
              propText="You must provide a credit score."
            /> :
            <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="creditScore"
              propText="You must either pull or provide a credit score."
            />}
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    },
    Assets: {
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput labelClass="primary-title-label" label={`Asset Information${newGuarantor.firstName ? ` for ${newGuarantor.firstName}` : ""}${newGuarantor.lastName ? ` ${newGuarantor.lastName}` : ""}`} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {getFilteredAL(guarantorAssetsAndLiabilities, "Asset") && getFilteredAL(guarantorAssetsAndLiabilities, "Asset").length > -1 ? <React.Fragment>
            <Grid.Column width={16}>
              <BCTable
                data={formatAssets(true, newGuarantor, setNewGuarantor, true)}
                dataRules={[
                  { field: "Class", rule: "hide" }, 
                  { field: "Status", rule: "hide" }, 
                  { field: "id", rule: "hide" }, 
                  { field: "Current Balance", rule: "format", display: "dollar"},
                  { field: "Monthly Liability", rule: "hide"},
                  { field: "isEditHide", rule: "hide"},
                  { field: "isDeleteHide", rule: "hide"}
                ]}
                thin
                dataSingleLine
                actions={newGuarantor.assetsAndLiabilities && newGuarantor.assetsAndLiabilities.filter((x) => x.alOption === "Asset").length !== 0 && ["edit", "delete"]}
                handleTableDelete={(index) => handleDeleteGuarantorAL(index, "Asset")}
                handleTableEdit={(index) => handleGuarantorAssetTableEdit(index)}
                overflowX
                unstackable
                brokerColor={brokerColor}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <Button className="bp-button primary-under-table-button" style={backgroundColorStyle} icon onClick={() => addAL(newGuarantor, setNewGuarantor, "Asset")}>
                <div className="gmr-button-container">
                <Icon name="add" size="large"/>
                  <div className="gmr-button-icon-text">Add Asset</div>
                </div>
              </Button>
            </Grid.Column> 
          </React.Fragment> : <React.Fragment>
            <Grid.Column width={16}>
              <BrokerApplicationEmptyState 
                iconName="archive" 
                label="Looks like you don’t have any assets. Add more detail to strengthen your application."
                action={() => handleModal("guarantor al", false, "Asset")}
                buttonLabel="Add Asset"
              />
            </Grid.Column>
          </React.Fragment>}
        </Grid.Row>
      </React.Fragment>
    },
    Liabilities: {
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput labelClass="primary-title-label" label={`Liability Information${newGuarantor.firstName ? ` for ${newGuarantor.firstName}` : ""}${newGuarantor.lastName ? ` ${newGuarantor.lastName}` : ""}`} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {getFilteredAL(guarantorAssetsAndLiabilities, "Liability") && getFilteredAL(guarantorAssetsAndLiabilities, "Liability").length > -1 ? <React.Fragment>
            <Grid.Column width={16}>
              <BCTable
                data={formatLiabilities(true, newGuarantor, setNewGuarantor, true)}
                dataRules={[
                  { field: "Class", rule: "hide" }, 
                  { field: "Status", rule: "hide" }, 
                  { field: "id", rule: "hide" }, 
                  { field: "Current Balance", rule: "format", display: "dollar"},
                  { field: "Monthly Liability", rule: "format", display: "dollar"},
                  { field: "isEditHide", rule: "hide"},
                  { field: "isDeleteHide", rule: "hide"}
                ]}
                thin
                dataSingleLine
                actions={["delete"]}
                handleTableDelete={(index) => handleDeleteGuarantorAL(index, "Liability")}
                handleTableEdit={(index) => handleGuarantorLiabilityTableEdit(index)}
                overflowX
                unstackable
                brokerColor={brokerColor}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <Button className="bp-button primary-under-table-button" style={backgroundColorStyle} icon onClick={() => addAL(newGuarantor, setNewGuarantor, "Liability")}>
                <div className="gmr-button-container">
                <Icon name="add" size="large"/>
                  <div className="gmr-button-icon-text">Add Liability</div>
                </div>
              </Button>
            </Grid.Column> 
          </React.Fragment> : <React.Fragment>
            <Grid.Column width={16}>
              <BrokerApplicationEmptyState 
                iconName="archive" 
                label="Looks like there isn't any liabilities. Please add outstanding liabilities to give us an accurate picture of your financial situation."
                action={() => handleModal("guarantor al", false, "Liability")}
                buttonLabel="Add Liability"
              />
            </Grid.Column>
          </React.Fragment>}
        </Grid.Row>
      </React.Fragment>
    },
    RealEstateOwned: {
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput labelClass="primary-title-label" label={`Real Estate Owned${newGuarantor.firstName ? ` for ${newGuarantor.firstName}` : ""}${newGuarantor.lastName ? ` ${newGuarantor.lastName}` : ""}`} />
          </Grid.Column>
          <Grid.Column width={16}>{realEstateOwnedText}</Grid.Column>
          <Grid.Column width={16}><div className="reo-initial-review">{startAppObject.submittedOn && <span><b>The application has been submitted for initial review.</b> Please coordinate with your Broker to remove any Additional Collateral from the loan.</span>}</div></Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {guarantorReoSchedules && guarantorReoSchedules.length > -1 ? <React.Fragment>
            <Grid.Column width={16}>
              <BCTable
                data={formatReos(newGuarantor, setNewGuarantor, true)}
                dataRules={[
                  { field: "id", rule: "hide" },
                  { field: "Total Mortgage Payment", rule: "format", display: "dollar"},
                  { field: "isDeleteHide", rule: "hide"}
                ]}
                thin
                actions={(newGuarantor.reoSchedules && newGuarantor.reoSchedules !== 0) && ["edit", "delete"]}
                handleTableDelete={(index) => handleTableRemove("guarantorReoSchedules", index, "guarantor")}
                handleTableEdit={(index) => handleGuarantorREOTableEdit(index)}
                overflowX
                unstackable
                brokerColor={brokerColor}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <Button className="bp-button primary-under-table-button" style={backgroundColorStyle} icon onClick={() => handleAddGuarantorReoSchedule()}>
                <div className="gmr-button-container">
                <Icon name="add" size="large"/>
                  <div className="gmr-button-icon-text">Add Real Estate</div>
                </div>
              </Button>
            </Grid.Column> 
          </React.Fragment> : <React.Fragment>
            <Grid.Column width={16}>
              <BrokerApplicationEmptyState 
                iconName="home"
                label="Looks like you don’t own any real estate. Select Add a Property if this is not the case. Otherwise, select Next Page."
                action={() => handleModal("guarantor reo")}
                buttonLabel="Add Real Estate"
              />
            </Grid.Column>
          </React.Fragment>}
        </Grid.Row>
      </React.Fragment>
    },
    Disclosure: {
      content: <React.Fragment>
        <GuarantorDisclosure />
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCValidationMessage invalidProps={invalidProps} prop="custom-disclosure" propText="Please sign your disclosure before continuing the application." />
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    },
    DoubleFilterGuarantor: {
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput 
              labelClass={`primary-title-label form-input-header ${getIsWhiteLabeled() ? brokerLabelBorderOverrideCSS : "form-input-border"}`}
              label={`Guarantor Information${startAppObject.name ? ` for ${startAppObject.name}` : ""}`} 
            />
          </Grid.Column>
          <Grid.Column width={16}>
            <AddGuarantorHelper />
          </Grid.Column>
          <Grid.Column width={16}>
            <button className="export-link"></button>
            <BCFormInput
              tooltip="Add the guarantors for the loan below. Once added they will recieve an email inviting them to review the application and to sign any necessary disclosures." 
              label={guarantorSearch === "" ? "Add Guarantor" : ""}
              inputKey="guarantor"
              actionLabel="Add Guarantor"
              actionText={guarantorSearch !== "" ? "+ Add New Guarantor" : ""}
              labelAction={() => handleAddBrokerGuarantor()}
              type={GlobalConstants.FormInputTypes.SEARCH_FILTER}
              onSearchChange={(value, field) => handleGuarantorSearchChange(value, field)}
              value={guarantorSearch}
              renderSuggestions={handleDoubleFilterGuarantorSuggestions(guarantorSearch)}
              handleSearchSelect={(e, data) => handleGuarantorSelect(data.result)}
              isSearchOpen={!isBrokerGuarantorSelected}
              onSearchFocus={() => handleGuarantorFocus()}
              noSearchResultsMessage="To add a new Guarantor, type their email address and press enter."
              searchClass="bc-search-input-full"
              handleSearchKeyDown={handleGuarantorSearchKeyDown}
              disabled={isNonGuarantorDisabled}
            />
            <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="custom-broker-guarantor-email"
              propText="This email is invalid."
            />
          </Grid.Column>
        </Grid.Row>
        {selectedBrokerGuarantors.length > 0 ? <Grid.Row>
          <Grid.Column width={16}>
            <BCTable
              data={formatGuarantors(selectedBrokerGuarantors)}
              dataRules={[{ field: "Id", rule: "hide" }]}
              thin
              required
              tooltip={<React.Fragment>
                <div className="access-level-tooltip">
                  <span>Full Edit:</span>
                  <div className="access-level-tooltip-indent">Allows for full access to the loan and ability to edit the application. Individuals with this access level can add more Guarantors to the loan, but not see any personal identification information for those Guarantors.</div>
                  <p></p>
                  <span>View Only:</span>
                  <div className="access-level-tooltip-indent">Provides the ability to see the entire application (minus other Guarantor's personal identification information) and the ability to edit their own information.</div>
                  <p></p>
                  <span>Limited:</span>
                  <div className="access-level-tooltip-indent">Allows for a limited viewing of the application. Individuals with this access level will only be able to see the summary of the loan and edit their own information.</div>
                </div>
              </React.Fragment>}
              dataSingleLine
              unstackable
              overflowX
              brokerColor={wlBrokerHex}
            />
            <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="custom-invite-broker-guarantor"
              propText="It looks like the Borrowing Entity name, type, and/or addresses have not been identified yet. Enter that data first, then invite the Guarantor."
            />
          </Grid.Column>
        </Grid.Row> : <Grid.Row>
          <Grid.Column width={16}>
            <BrokerApplicationEmptyState 
              iconName="users"
              label="Looks like no guarantors have been added yet. Use the search above to add guarantors."
            />
            <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="guarantorTable"
              propText="You must have at least one guarantor."
            />
          </Grid.Column>
        </Grid.Row>}
      </React.Fragment>
    },
  };

  const ProjectConfirmation = {
    index: 0,
    title: "Project",
    content: [
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: "What is the name of the project?",
        value: startAppObject.name
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: "What type of loan are you looking for?",
        value: handleGetValueFromId(applicationMetadata.loanPrograms, startAppObject.loanProgramId)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: "What is the desired closing date?",
        value: startAppObject.requestedClosingDate,
        type: "date",
        condition: !FeatureFlags.IS_UNIT_PROPERTY_REDESIGN
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: "Which city is the project located in?",
        value: startAppObject.city
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: "Which state is the project located in?",
        value: startAppObject.state
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: "Which county is the project located in?",
        value: startAppObject.county
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: "What zip code is the project located in?",
        value: startAppObject.zip
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: BPQuestionLabels.BrokerAssociated,
        value: startAppObject.isBrokerInvolved ? "Yes" : "No",
        condition: !(FeatureFlags.IS_BETA && isAdminBrmNwlOrLo)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: "What is the broker's email address?",
        value: startAppObject.brokerSearchEmail,
        condition: !(FeatureFlags.IS_BETA && startAppObject.isBrokerInvolved === true && isAdminBrmNwlOrLo)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: FeatureFlags.IS_BROKER_FEE_ALLIANCE ? BPQuestionLabels.BrokerFeeRate : BPQuestionLabels.BrokerFeeRateRebate,
        value: convertToMinFraction(startAppObject.brokerFeeRate, 3, 3),
        condition: persona === Personas.WL_GUARANTOR
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: BPQuestionLabels.CombineOriginationFeeRate,
        value: startAppObject.isCombineOriginationFee ? "Yes" : "No",
        condition: FeatureFlags.IS_BROKER_FEE_ALLIANCE
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: BPQuestionLabels.WlBrokerFeeRate,
        value: convertToMinFraction(startAppObject.wlbrokerFeeRate, 3, 3),
        condition: (persona === Personas.WL_GUARANTOR || !FeatureFlags.IS_BROKER_FEE_ALLIANCE)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: BPQuestionLabels.MinMandatoryBrokerFeeRate,
        value: convertToMinFraction(minMandatoryBrokerFee, 3, 3),
        condition: (persona === Personas.WL_GUARANTOR || !FeatureFlags.IS_BROKER_FEE_ALLIANCE)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: BPQuestionLabels.TotalBrokerFeeRate,
        value: convertToMinFraction(operationOfNumberArray("sum", [startAppObject.brokerFeeRate, startAppObject.wlbrokerFeeRate, minMandatoryBrokerFee]), 3, 3),
        condition: (persona === Personas.WL_GUARANTOR || !FeatureFlags.IS_BROKER_FEE_ALLIANCE)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectOverview.id),
        label: BPQuestionLabels.LoanOfficer,
        value: handleGetValueFromId(applicationMetadata.loanOfficers, startAppObject.loanOfficerOrganizationContactId),
        condition: persona === Personas.WL_GUARANTOR
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectStructure.id),
        label: "What type of structure(s) exists on the property?",
        value: handleGetValueFromId(applicationMetadata.propertyTypes, startAppObject.existingStructurePropertyTypeId)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectStructure.id),
        label: BPQuestionLabels.NewStructure,
        value: handleGetValueFromId(applicationMetadata.propertyTypes, startAppObject.newStructurePropertyTypeId)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectStructure.id),
        label: BPQuestionLabels.Zoning,
        value: startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT 
        ? ((startAppObject.properties && startAppObject.properties[0]) && startAppObject.properties[0].zoning)
        : startAppObject.zoning,
        condition: !(FeatureFlags.IS_UNIT_PROPERTY_REDESIGN)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.DurationOwned.id),
        label: BPQuestionLabels.PurchaseRefinanceOptionLookupId,
        value: handleRefinanceSummaryText(startAppObject.purchaseRefinanceOptionLookupId)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.DurationOwned.id),
        label: BPQuestionLabels.DurationOwnedId,
        value: handleGetValueFromId(applicationMetadata.ownershipInputs, startAppObject.durationOwnedId),
        condition: startAppObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE,
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.DurationOwned.id),
        label: startAppObject.durationOwnedId === GlobalConstants.DurationOwnedIds.MORE_THAN_TWO_YEARS ? BPQuestionLabels.EstimatePropertyValue :
          startAppObject.durationOwnedId === GlobalConstants.DurationOwnedIds.LESS_THAN_TWO_YEARS ? "What is the original purchase price?" : "The purchase price is?",
        value: startAppObject.originalPurchasePrice,
        type: "dollar",
        condition: FeatureFlags.IS_UNIT_PROPERTY_REDESIGN
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.DurationOwned.id),
        label: startAppObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE ? BPQuestionLabels.Purchase_OriginalPurchasePrice : BPQuestionLabels.RefinanceOwn_OriginalPurchasePrice,
        value: startAppObject.originalPurchasePrice,
        type: "dollar",
        condition: !FeatureFlags.IS_UNIT_PROPERTY_REDESIGN || !startAppObject.purchaseRefinanceOptionLookupId
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.DurationOwned.id),
        label: BPQuestionLabels.EstimatePropertyValue,
        value: startAppObject.estimatePropertyValue,
        condition: (!FeatureFlags.IS_UNIT_PROPERTY_REDESIGN || startAppObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE),
        type: "dollar"
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.DurationOwned.id),
        label: BPQuestionLabels.AmountOwed,
        value: startAppObject.amountOwed,
        condition: (!FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && startAppObject.durationOwnedId === GlobalConstants.DurationOwnedIds.NEW_PURCHASE)
          || (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && startAppObject.purchaseRefinanceOptionLookupId !== GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL),
        type: "dollar"
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.DurationOwned.id),
        label: BPQuestionLabels.CashOutAmountRequested,
        value: startAppObject.cashOutAmountRequested,
        condition: startAppObject.purchaseRefinanceOptionLookupId !== GlobalConstants.PurchaseOrRefinanceOptionIds.OWN,
        type: "dollar"
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.SubordinatedDebt.id),
        label: "Is there a seller carryback or subordinated debt?",
        value: startAppObject.isSubordinatedDebt,
        type: "bool"
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.SubordinatedDebt.id),
        label: "What is the amount of subordinated debt or seller carryback?",
        value: startAppObject.subordinatedDebtAmount,
        condition: startAppObject.isSubordinatedDebt === false,
        type: "dollar"
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? "What is the size of the current plat?" : "What is the size of the current property?",
        value: startAppObject.sizeOfCurrentProperty
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: "How many lots will be developed?",
        value: startAppObject.noOfProposedLots
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? "What is the average size of the proposed lots?" : "What is the size of the proposed lots?",
        value: startAppObject.sizeOfProposedLot
      },
      ...(FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.ALL_IN_ONE || startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT) ? [{
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: BPQuestionLabels.AfterRepairValue,
        value: startAppObject.afterRepairValue,
        type: "dollar"
      }] : []),
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: "How many months after closing will development begin?",
        value: startAppObject.developmentBeginsAfterClosingInMonths,
        type: "month"
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: "How many months will development last?",
        value: startAppObject.timeFrameToDevelopInMonths,
        type: "month"
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: "How much is the horizontal development budget?",
        value: startAppObject.horizontalDevelopmentBudget,
        type: "dollar"
      },
      ...(UserFeatureFlags.IS_RETAIL_PHASE_2 && (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.ALL_IN_ONE || startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT || startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE)) ? [{
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: BPQuestionLabels.SizeOfCurrentProperty,
        value: startAppObject.sizeOfCurrentProperty,
        type: handleGetValueFromId(applicationMetadata.unitOfMeasurementInputs, startAppObject.sizeOfCurrentPropertyUnitOfMeasurementBorrowerApplicationInputId)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: BPQuestionLabels.SizeOfProposedLots,
        value: startAppObject.sizeOfProposedLot,
        type: handleGetValueFromId(applicationMetadata.unitOfMeasurementInputs, startAppObject.sizeOfProposedLotUnitOfMeasurementBorrowerApplicationInputId)
      }] : [],
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: BPQuestionLabels.DistrictReimbursements,
        value: handleGetValueFromId(applicationMetadata.yesNoUnknownInputs, startAppObject.districtReimbursementsAvailableBorrowerApplicationInputId)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: "Please describe the available district reimbursements:",
        value: startAppObject.districtReimbursementsAvailableDescription,
        condition: startAppObject.districtReimbursementsAvailableBorrowerApplicationInputId !== "11aeecd1-13cc-4236-b7f1-865734ac7465"
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: BPQuestionLabels.BondingRequirements,
        value: handleGetValueFromId(applicationMetadata.yesNoUnknownInputs, startAppObject.bondingRequirementsBorrowerApplicationInputId)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: "Please describe the bonding requirements:",
        value: startAppObject.bondingRequirementsDescription,
        condition: startAppObject.bondingRequirementsBorrowerApplicationInputId !== "11aeecd1-13cc-4236-b7f1-865734ac7465"
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: BPQuestionLabels.SeasonalityConcerns,
        value: handleGetValueFromId(applicationMetadata.yesNoUnknownInputs, startAppObject.seasonalityConcernsBorrowerApplicationInputId)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.ProjectDevelopment.id),
        label: "Please describe the seasonality concerns:",
        value: startAppObject.seasonalityConcernsDescription,
        condition: startAppObject.seasonalityConcernsBorrowerApplicationInputId !== "11aeecd1-13cc-4236-b7f1-865734ac7465"
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.PermitStatus.id),
        label: UserFeatureFlags.IS_RETAIL_PHASE_2 ? BPQuestionLabels.PermitStatusCurrent : BPQuestionLabels.PermitStatus,
        value: handleGetValueFromId(applicationMetadata.permitStatuses, startAppObject.permitStatusId)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.PermitStatus.id),
        label: BPQuestionLabels.WorkStage,
        value: handleGetValueFromId(applicationMetadata.workStages, startAppObject.workStageId),
        condition: !(FeatureFlags.IS_UNIT_PROPERTY_REDESIGN)
      },
      {
        onClick: () => handleNavigateToStep(ProjectSteps.PermitStatus.id),
        label: "How many months until permits are expected to be issued?",
        value: startAppObject.developmentOrVerticalPermitTimingInMonths,
        condition: (startAppObject.permitStatusId && [GlobalConstants.PermitStatusIds.ISSUED, GlobalConstants.PermitStatusIds.NOT_APPLICABLE].indexOf(startAppObject.permitStatusId) > -1)
      },
      ...(UserFeatureFlags.IS_RETAIL_PHASE_2 && (startAppObject.permitStatusId && GlobalConstants.PermitStatusIds.NOT_APPLICABLE != startAppObject.permitStatusId) ? [{
        onClick: () => handleNavigateToStep(ProjectSteps.PermitStatus.id),
        label: BPQuestionLabels.AdditionalDetailsPermitStatus,
        value: startAppObject.permitStatusExplanation
      }] : [])
    ] 
  };

  const PropertyConfirmation = {
    index: 0,
    title: "Property",
    content: [
      {
        onClick: () => handleNavigateToStep(PropertySteps.NumberOfProperties.id),
        label: "How many properties are being built?",
        value: startAppObject.properties && startAppObject.properties.length
      },
      {
        onClick: () => handleNavigateToStep(PropertySteps.Properties.id),
        label: "What are the properties?",
        value: startAppObject.properties && startAppObject.properties.map((item, i) => {
          return (
            <Grid key={`properties-confirmation-${i}`}>
              <Grid.Column width={8}>{item.address && item.address}</Grid.Column>
            </Grid>
          );
        }),
      },
      {
        onClick: () => handleNavigateToStep(PropertySteps.Plans.id),
        label: "What are the property plans?",
        value: startAppObject.properties && startAppObject.properties.map((property, i) => {
          return (
            <React.Fragment key={`property-units-plan-confirmation-${i}`}>
              {property.units && property.units.map((unit, j) => {
                return (
                  <Grid key={`property-unit-plan-confirmation-${i}-${j}`}>
                    <Grid.Column width={6}>{property.address && property.address} Unit: {unit.unitNumber}</Grid.Column>
                    <Grid.Column width={5}>Plan: {unit.plan && unit.plan}</Grid.Column>
                  </Grid>
                );
              })}
            </React.Fragment>
          );
        }),
        condition: FeatureFlags.IS_UNIT_PROPERTY_REDESIGN
      },
      {
        onClick: () => handleNavigateToStep(PropertySteps.LoanTerm.id),
        label: "What is the calculated loan term?",
        value: startAppObject.properties && startAppObject.properties.map((property, i) => {
          return (
            <React.Fragment key={`property-units-loan-term-confirmation-${i}`}>
              <Grid key={`property-unit-loan-term-confirmation-${i}`}>
                <Grid.Column width={6}>Property {property.address && property.address}</Grid.Column>
                  <Grid.Column width={10}>{operationOfNumberArray("sum", [property.monthOfFirstDraw, property.buildTimeInMonths, property.timeFrameToSellOrRefinanceInMonths, -1])} Months
                  </Grid.Column>
              </Grid>
            </React.Fragment>
          );
        }),
        condition: startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE
      },
      {
        onClick: () => handleNavigateToStep(PropertySteps.LoanTerm.id),
        label: "What is your preferred loan term in months?",
        value: startAppObject.preferredLoanTerm,
        condition: startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.BRIDGE
      }
    ]
  };

  const BudgetConfirmation = {
    index: 0,
    title: "Budget",
    content: [
      {
        onClick: () => handleNavigateToStep(BudgetSteps.RequestedBudget.id),
        label: "What is the requested construction budget?",
        value: startAppObject.budget,
        condition: startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.BRIDGE
      },
      {
        onClick: () => handleNavigateToStep(BudgetSteps.PaidCosts.id),
        label: "Will an interest reserve be established or monthly payments made?",
        value: handleGetValueFromId(applicationMetadata.interestCalculationMethods, startAppObject.useInterestReserveId)
      },
      {
        onClick: () => handleNavigateToStep(BudgetSteps.PaidCosts.id),
        label: "Have any costs been paid on the project to date?",
        value: startAppObject.paidCosts ? "Yes" : "No"
      },
      {
        onClick: () => handleNavigateToStep(BudgetSteps.PaidCosts.id),
        label: "What are the costs paid?",
        value: startAppObject.gmrCostPaids && startAppObject.gmrCostPaids.map((item, i) => {
          return (
            <Grid key={`properties-confirmation-${i}`} row={3}>
              <Grid.Column width={8}>{handleGetValueFromId(applicationMetadata.gmrprojectCosts, item.costPaidId)}</Grid.Column>
              <Grid.Column width={8}>{item.amount && item.amount}</Grid.Column>
            </Grid>
          );
        }),
        condition: startAppObject.paidCosts === false
      },
      {
        onClick: () => handleNavigateToStep(BudgetSteps.PaidCosts.id),
        label: "What is the planned amount of money to put down?",
        value: startAppObject.cashDown,
        condition: startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.NEW_CONSTRUCTION
      },
      {
        onClick: () => handleNavigateToStep(BudgetSteps.PayoffStrategy.id),
        label: "Who will be doing the construction work?",
        value: startAppObject.whoWillDoConstructionBorrowerApplicationInputId ? "The Borrowing Entity will be hiring a licensed General Contractor" : "The Borrower will be acting as General Contractor"
      },
      {
        onClick: () => handleNavigateToStep(BudgetSteps.PayoffStrategy.id),
        label: "What is the builder's name?",
        value: handleGetValueFromId(applicationMetadata.builders, startAppObject.generalContractorId),
        condition: startAppObject.whoWillDoConstructionBorrowerApplicationInputId === GlobalConstants.WhoWillDoConstructionBorrowerApplicationInputIds.IS_GENERAL_CONTRACTOR
      },
      {
        onClick: () => handleNavigateToStep(BudgetSteps.PayoffStrategy.id),
        label: "What is the payoff strategy?",
        value: handleGetValueFromId(applicationMetadata.payoffStrategies, startAppObject.payoffStrategyId),
        condition: startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.FIX_AND_FLIP
      },
      {
        onClick: () => handleNavigateToStep(BudgetSteps.PayoffStrategy.id),
        label: "Please describe the payoff strategy:",
        value: startAppObject.payoffStrategyDescription,
        condition: startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.FIX_AND_FLIP
      },
      {
        onClick: () => handleNavigateToStep(BudgetSteps.PayoffStrategy.id),
        label: "What is the desired closing date?",
        value: startAppObject.requestedClosingDate,
        type: "date",
        condition: FeatureFlags.IS_UNIT_PROPERTY_REDESIGN
      }
    ]
  };

  const EntityConfirmation = {
    index: 0,
    title: "Entity",
    content:  [
      {
        onClick: () => handleNavigateToStep(EntitySteps.ExistingBorrower.id),
        label: BPQuestionLabels.BorrowingEntity,
        value: newBorrowerEntity && newBorrowerEntity.name
      }
    ]
  };

  const GuarantorConfirmation = {
    index: 0,
    title: "Guarantor",
    content: [
      {
        onClick: () => handleNavigateToStep(GuarantorSteps.DoubleFilterGuarantor.id),
        label: "Who are the guarantors?",
        value: selectedBrokerGuarantors && selectedBrokerGuarantors.map((selectedBrokerGuarantor, i) => {
          return (
            <Grid key={`guarantor-confirmation-${i}`}>
              <Grid.Column width={8}>{selectedBrokerGuarantor.firstName} {selectedBrokerGuarantor.lastName}</Grid.Column>
              <Grid.Column width={8}>{selectedBrokerGuarantor.email}</Grid.Column>
            </Grid>
          );
        })
      }
    ]
  };

  const SummaryQuestions = {
    AdditionalCollateral: {
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput 
              labelClass={`primary-title-label form-input-header ${getIsWhiteLabeled() ? brokerLabelBorderOverrideCSS : "form-input-border"}`}
              label="Summary of Additional Collateral" 
              style={backgroundColorStyle}
            />
          </Grid.Column>
          <Grid.Column width={16}>Additional Collateral is a property to provide value to the loan in lieu of a cash down payment. This is a summary of all properties marked as Additional Collateral for this loan by the Borrowing Entity and Guarantors.</Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {formatAdditionalCollateral().length > 0 ? <React.Fragment>
            <Grid.Column width={16}>
              <BCTable
                data={formatAdditionalCollateral()}
                dataRules={[
                  { field: "id", rule: "hide" },
                  { field: "Market Value", rule: "format", display: "dollar"}]}
                thin
                dataSingleLine
                overflowX
                unstackable
                brokerColor={brokerColor}
              />
            </Grid.Column>
          </React.Fragment> : <React.Fragment>
            <Grid.Column width={16}>
              <BrokerApplicationEmptyState 
                iconName="home"
                label="Looks like there isn't any additional collateral."
              />
            </Grid.Column>
          </React.Fragment>}
        </Grid.Row>
      </React.Fragment>
    },
    Summary: {
      content: <Grid.Row className="application-row">
        <Grid.Column className="primary-header-weight" width={16}>
          <Header className="primary-accordion-header" as='h2' dividing>Confirmation</Header>
          <BCAccordion permissions={permissions} accordion={ProjectConfirmation} disabled={isLimited}></BCAccordion>
          <BCAccordion permissions={permissions} accordion={PropertyConfirmation} disabled={isLimited}></BCAccordion>
          <BCAccordion permissions={permissions} accordion={BudgetConfirmation} disabled={isLimited}></BCAccordion>
          <BCAccordion permissions={permissions} accordion={EntityConfirmation} disabled={isLimited}></BCAccordion>
          <BCAccordion permissions={permissions} accordion={GuarantorConfirmation}></BCAccordion>
        </Grid.Column>
        <Grid.Column width={16}>
          <BCValidationMessage invalidProps={invalidProps} prop="custom-application-unfinished" propText={incompleteApplicationText} />
          <BCValidationMessage invalidProps={invalidProps} prop="custom-guarantor-completed" propText="At least one guarantor must sign their disclosures before you may submit." />
          <BCValidationMessage invalidProps={invalidProps} prop="custom-can-submit" propText="Only brokers can submit the application." />
        </Grid.Column>
      </Grid.Row>
    },
    Calculation: {
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
        <React.Fragment>
          {isValidPermission(permissions, "BrokerGMRPricingInfo", "export") && <a className={"export-link"} href={exportURL} download ref={exportRef as any}>0</a>}
          <div className="landing-page-menu-container">
              <div className="landing-page-button-group">
                {isValidPermission(permissions, "BrokerGMRPricingInfo", "export") && <BCButton labelPosition="left" iconName="share square" loading={exportLoading} handleOnClick={() => handleExport(startAppObject.gmrId)}>
                  <div>Export</div> 
                </BCButton>}
              </div>
          </div>
          <Table className="gmr-table" textAlign="center" unstackable>
            <Table.Body>
              {Array.from({ length: isGreaterThanTablet ? 3 : isGreaterThanMobile ? 4 : 6 }, (_, j) => (
                <Table.Row key={`gmr-summary-row-${j}`}>
                  {Array.from({ length: GmrSummaryDimensions }, (_, k) => (
                      <Table.Cell key={`gmr-summary-cell-${k}`} width={GmrSummaryDimensions}>
                        {GmrSummaryTable[k + j * (GmrSummaryDimensions)] && 
                          <Card className="gmr-table-card" fluid>
                            <Card.Content>
                              <Card.Header className={brokerColor ? brokerTableOverrideCSS : "gmr-table-header"}>{GmrSummaryTable[k + j * (GmrSummaryDimensions)].name}</Card.Header>
                              <Card.Description>{applicationCalculationObject[GmrSummaryTable[k + j * (GmrSummaryDimensions)].value] !== undefined && GmrSummaryTable[k + j * (GmrSummaryDimensions)].format === "dollar" ?
                                convertToDollar(applicationCalculationObject[GmrSummaryTable[k + j * (GmrSummaryDimensions)].value]) :
                                applicationCalculationObject[GmrSummaryTable[k + j * (GmrSummaryDimensions)].value] !== undefined && GmrSummaryTable[k + j * (GmrSummaryDimensions)].format === "percent" ?
                                convertToPercentString(applicationCalculationObject[GmrSummaryTable[k + j * (GmrSummaryDimensions)].value]) :
                                applicationCalculationObject[GmrSummaryTable[k + j * (GmrSummaryDimensions)].value] !== undefined && GmrSummaryTable[k + j * (GmrSummaryDimensions)].format === "bool" ?
                                convertToYesNo(applicationCalculationObject[GmrSummaryTable[k + j * (GmrSummaryDimensions)].value]) :
                                applicationCalculationObject[GmrSummaryTable[k + j * (GmrSummaryDimensions)].value] !== undefined ?
                                applicationCalculationObject[GmrSummaryTable[k + j * (GmrSummaryDimensions)].value] : null}</Card.Description>
                            </Card.Content>
                          </Card>
                        }
                      </Table.Cell>
                  ))}
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </React.Fragment>
        </Grid.Column>
      </Grid.Row>
    },
    Confirmation: {
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <div className="gmr-submitted-title">
            <Icon className="gmr-submitted-icon" name='check circle' size="large" />
            {getIsWhiteLabeled() ? <span>Thank you for completing the application{startAppObject.name ? ` for ${startAppObject.name}` : ""}!</span> : 
            <span>We have received your submission!</span>}
          </div>
        </Grid.Column>
        <Grid.Column width={16}>
          <div className="gmr-submitted-text">Our Sales Team will be in contact with you shortly to discuss your project and put our innovative, creative structure to work for you.</div>
        </Grid.Column>
      </Grid.Row>
    }
  };

  const ProjectSteps = {
    BrokerWelcome: {
      id: BrokerWelcomeStepId,
      questions: [ProjectQuestions.BrokerWelcome],
      patchProps: [ProjectQuestions.ProjectName.field, ProjectQuestions.LoanProgram.field, ProjectQuestions.NewStructure.field].concat(FeatureFlags.IS_BROKER_FEE_ALLIANCE ? ProjectQuestions.BrokerFeeRate.fields : ["brokerFeeRate", "isCombineOriginationFee"])
    },
    WhiteLabeledWelcome: {
      id: "b8411c30-ad22-4cc9-b1ec-6df195073654",
      questions: [ProjectQuestions.WhiteLabeledWelcome]
    },
    ProjectOverview: {
      id: "f0a258ca-4375-4040-807c-afe661dd330d",
      questions: [(applicationChoice === ApplicationChoices.Send.type ? ProjectQuestions.SendApplicationInputs : null), 
        ProjectQuestions.ProjectName, 
        ProjectQuestions.LoanProgram, 
        ...(FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? [ProjectQuestions.RequestedClosingDate] : []),
        ProjectQuestions.ProjectLocation].concat(isAdminBrmNwlOrLo ? [ProjectQuestions.BrokerAssociatedWithLoan, ProjectQuestions.BrokerEmail, ProjectQuestions.BrokerFeeRate, ProjectQuestions.SelectLoanOfficer]
        : persona === Personas.LOAN_OFFICER ? [ProjectQuestions.BrokerAssociatedWithLoan, ProjectQuestions.BrokerEmail, ProjectQuestions.BrokerFeeRate, ProjectQuestions.SelectLoanOfficer]
        : isGuarantorPersona && FeatureFlags.IS_BETA && applicationMetadata.associatedBrokers && applicationMetadata.associatedBrokers.length > 1 ? [ProjectQuestions.GuarantorBroker]
        : isGuarantorPersona && FeatureFlags.IS_BETA ? []
        : [ProjectQuestions.BrokerFeeRate, ...((persona === Personas.BROKER && FeatureFlags.IS_BETA) ? [ProjectQuestions.SelectLoanOfficer] : [])]),
      validatingProps: [ProjectQuestions.ProjectName.field, ProjectQuestions.LoanProgram.field].concat(ProjectQuestions.ProjectLocation.fields).concat(getIsWhiteLabeled() ? []
        : isAdminBrmNwlOrLo ? [ProjectQuestions.BrokerAssociatedWithLoan.field, ProjectQuestions.SelectLoanOfficer.field]
        : persona === Personas.LOAN_OFFICER ? [ProjectQuestions.BrokerAssociatedWithLoan.field, ProjectQuestions.BrokerEmail.field, ProjectQuestions.SelectLoanOfficer.field].concat(FeatureFlags.IS_BROKER_FEE_ALLIANCE ? ProjectQuestions.BrokerFeeRate.fields : ["brokerFeeRate", "isCombineOriginationFee"])
        : isGuarantorPersona ? FeatureFlags.IS_BETA ?
          applicationMetadata.associatedBrokers && applicationMetadata.associatedBrokers.length > 1 ? [ProjectQuestions.GuarantorBroker.field] : []
          : [ProjectQuestions.GuarantorBroker.field]
        : FeatureFlags.IS_BROKER_FEE_ALLIANCE ? ProjectQuestions.BrokerFeeRate.fields : ["brokerFeeRate", "isCombineOriginationFee"]),
      patchProps: handleProjectOverviewPatchProps(),
      customNext: true
    },
    ProjectStructure: {
      id: "da020f97-1f05-4dc0-92ae-95352db9f67e",
      questions: FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? [ProjectQuestions.ExistingStructure, ProjectQuestions.NewStructure,ProjectQuestions.Zoning] : [ProjectQuestions.ExistingStructure, ProjectQuestions.NewStructure],
      validatingProps: FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? [ProjectQuestions.ExistingStructure.field, ProjectQuestions.Zoning.field] : [ProjectQuestions.ExistingStructure.field],
      patchProps: [ProjectQuestions.ExistingStructure.field, ProjectQuestions.NewStructure.field, ProjectQuestions.Zoning.field],
      customNext: true
    },
    DurationOwned: {
      id: "1971c915-679b-484a-9ae5-e232de5f5f73",
      questions: [ProjectQuestions.DurationOwned],
      validatingProps: FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && startAppObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL ? 
        [ProjectQuestions.DurationOwned.field, "refinanceOptionLookupId"] : [ProjectQuestions.DurationOwned.field],
      patchProps: ["purchaseRefinanceOptionLookupId", "howLongOwnedBorrowerApplicationInputId", "originalPurchasePrice", "amountOwed", "cashOutAmountRequested", "estimatePropertyValue"]
    },
    SubordinatedDebt: {
      id: "d2cad93d-2df4-4404-893b-67754078a1a5",
      questions: [ProjectQuestions.SubordinatedDebt],
      validatingProps: [ProjectQuestions.SubordinatedDebt.field],
      patchProps: ["subordinatedDebtAmount"]
    },
    CumulativeProjectExperience: {
      id: "073cb630-0d9d-4d43-a6db-5ce38e3d9ea8",
      questions: [ProjectQuestions.CumulativeProjectExperience],
      validatingProps: [ProjectQuestions.CumulativeProjectExperience.field],
      patchProps: [ProjectQuestions.CumulativeProjectExperience.field]
    },
    ProjectDevelopment: {
      id: "08ef7570-0cc0-4314-9891-ed5fa01e0f28",
      questions: [ProjectQuestions.ProjectDevelopment],
      validatingProps: ProjectQuestions.ProjectDevelopment.fields,
      patchProps: ProjectQuestions.ProjectDevelopment.fields.concat(["districtReimbursementsAvailableDescription", "bondingRequirementsDescription", "seasonailtyConcernsDescription", "requestedLoanTermInMonths"])
    },
    PermitStatus: {
      id: "d0c9e9d7-7c1e-45c3-bcac-05e3f3283d47",
      questions: FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? [ProjectQuestions.PermitStatus, ProjectQuestions.PercentComplete] : [ProjectQuestions.PermitStatus],
      validatingProps: FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? [ProjectQuestions.PermitStatus.field, ProjectQuestions.PercentComplete.field] : [ProjectQuestions.PermitStatus.field],
      ...UserFeatureFlags.IS_RETAIL_PHASE_2 && { validatingProps:[ProjectQuestions.PermitStatus.field,...ProjectQuestions.PercentComplete.fields.filter(e => e !== "permitStatusExplanation")]},
      patchProps: isPermitTimingInMonthsNeeded ? [...ProjectQuestions.PermitStatus.fields, ...UserFeatureFlags.IS_RETAIL_PHASE_2 ? [...ProjectQuestions.PercentComplete.fields] : [ProjectQuestions.PercentComplete.field]] : [ProjectQuestions.PermitStatus.field, ...UserFeatureFlags.IS_RETAIL_PHASE_2 ? [...ProjectQuestions.PercentComplete.fields] : [ProjectQuestions.PercentComplete.field] ],
      customNext: true
    }
  };
  
  const PropertySteps = {
    NumberOfProperties: {
      id: "40358761-f55f-46c8-bd3e-34cd2138113c",
      questions: FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? [PropertyQuestions.NumberOfProperties, PropertyQuestions.UploadPropertyUnitMix] : [PropertyQuestions.NumberOfProperties],
      validatingProps: FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? [PropertyQuestions.NumberOfProperties.field, PropertyQuestions.UploadPropertyUnitMix.field] : [PropertyQuestions.NumberOfProperties.field],
      patchProps: [PropertyQuestions.NumberOfProperties.field, PropertyQuestions.UploadPropertyUnitMix.field],
      customNext: true
    },
    Properties: {
      id: "0524ef83-899e-4577-8bce-06351c3c57be",
      questions: [PropertyQuestions.Properties],
      customNext: true
    },
    Plans: {
      id: "7b871e2f-5523-40fd-ad3a-c17739c3d692",
      questions: [PropertyQuestions.Plans]
    },
    LoanTerm: {
      id: "41dba333-7fa8-4ba1-ba25-06a686a76e45",
      questions: [PropertyQuestions.LoanTerm],
      patchProps: ["requestedLoanTermInMonths"]
    }
  };

  const BudgetSteps = {
    RequestedBudget: {
      id: "1bb2106c-746a-47b5-a12e-24f364c9f402",
      questions: [BudgetQuestions.RequestedBudget],
      validatingProps: [BudgetQuestions.RequestedBudget.field],
      patchProps: [BudgetQuestions.RequestedBudget.field]
    },
    PaidCosts: {
      id: "8d76bce1-00b2-4829-9dca-e7b0951b54f7",
      questions: [BudgetQuestions.PaidCosts],
      validatingProps: BudgetQuestions.PaidCosts.fields,
      patchProps: ["useInterestReserveBorrowerApplicationInputId", "cashDown"]
    },
    PayoffStrategy: {
      id: "a9ea24f6-7bee-4ffc-91d1-ba627e79744c",
      questions: [BudgetQuestions.PayoffStrategy],
      patchProps: ["whoWillDoConstructionBorrowerApplicationInputId", "builderOrganizationId", "payoffStrategyId", "payoffStrategyDescription", "requestedClosingDate"]
    },
    ProjectDetails: {
      id: "b25dc933-8eb3-4844-8ca7-733a850a42a3",
      questions: [BudgetQuestions.ProjectDetails],
      patchProps: [BudgetQuestions.ProjectDetails.field]
    }
  };

  const EntitySteps = {
    ExistingBorrower: {
      id: "a5ae21e9-b640-4b99-9f31-aedca62ae572",
      questions: [EntityQuestions.ExistingBorrower],
      validatingProps: startAppObject.isExistingBorrower ? ["isExistingBorrower", "borrowerOrganizationId"] : ["isExistingBorrower"],
      patchProps: ["borrowerOrganizationId"],
      customNext: true
    },
    AdditionalInformation: {
      id: "b0aa1fe8-b326-47f0-a5a0-8e4b33fec4c2",
      questions: [EntityQuestions.AdditionalInformation],
      patchProps: ["borrowerOrganizationId"],
      customNext: true
    },
    Assets: {
      id: "bb10bbaa-514c-4cd6-b9f4-558b451eeb87",
      questions: [EntityQuestions.Assets],
      customNext: true
    },
    Liabilities: {
      id: "beeae977-d1fe-407f-a955-f861358b6f7e",
      questions: [EntityQuestions.Liabilities],
      customNext: true
    },
    RealEstateOwned: {
      id: "f298152f-73ca-4f0c-8194-e128f32b2fe5",
      questions: [EntityQuestions.RealEstateOwned],
      customNext: true
    }
  };

  const GuarantorSteps = {
    SelfGuarantor: {
      id: "27033ed2-2d6a-4af3-9d86-c81301edXOXO",
      questions: [GuarantorQuestions.SelfGuarantor],
      validatingProps: [GuarantorQuestions.SelfGuarantor.field],
      patchProps: ["guarantors"],
      customNext: true
    },
    BorrowerGuarantor: {
      id: "27033ed2-2d6a-4af3-9d86-c81301edff0d",
      questions: [GuarantorQuestions.BorrowerGuarantor],
      customNext: true
    },
    AdditionalInformation: {
      id: "5d9603d9-7b57-47a4-b571-d95c35b18175",
      questions: [GuarantorQuestions.AdditionalInformation],
      customNext: true
    },
    CreditScore: {
      id: "95821977-e862-4b24-8bbd-831b015e7d7a",
      questions: [GuarantorQuestions.CreditScore],
      customNext: true
    },
    Assets: {
      id: "ca6f02d0-e4ca-4e1a-969a-451574ee8343",
      questions: [GuarantorQuestions.Assets],
      customNext: true
    },
    Liabilities: {
      id: "c80fd431-e486-4a51-8a31-3e1ceb460874",
      questions: [GuarantorQuestions.Liabilities],
      customNext: true
    },
    RealEstateOwned: {
      id: "4a9933dd-465a-4da1-9064-5f14fbb477f0",
      questions: [GuarantorQuestions.RealEstateOwned],
      customNext: true
    },
    Disclosure: {
      id: "5699457a-0b56-485a-b888-84b17810a078",
      questions: [GuarantorQuestions.Disclosure],
      customNext: true
    },
    DoubleFilterGuarantor: {
      id: "cbe6098a-c9f5-4268-98c4-9567a8e8ee99",
      questions: [GuarantorQuestions.DoubleFilterGuarantor],
      patchProps: ["guarantors"],
      customNext: true
    },
  };

  const SummarySteps = {
    AdditionalCollateral: {
      id: "dc7569a4-61e2-4568-8b5d-71dc35e10847",
      questions: [SummaryQuestions.AdditionalCollateral]
    },
    Summary: {
      id: "7b67a069-772e-4d5b-91ca-736c68e5824d",
      questions: [SummaryQuestions.Summary]
    },
    Calculation: {
      id: "e63773ea-9fed-4a59-ac8a-7383af1d12e4",
      questions: [SummaryQuestions.Calculation]
    },
    Confirmation: {
      id: "6e3dcc4d-4c03-4ccc-9cf4-03a760b1e182",
      questions: [SummaryQuestions.Confirmation]
    }
  };

  const handleStepIsActive = (activeStep, inactiveStep) => {
    const currentStepIndex = ApplicationSteps.findIndex(x => x.id === currentStepId);
    const activeStepIndex = ApplicationSteps.findIndex(x => x.id === activeStep.id);
    const inactiveStepIndex = ApplicationSteps.findIndex(x => x.id === inactiveStep.id);
    return (currentStepIndex >= activeStepIndex && currentStepIndex < inactiveStepIndex);
  };

  const handleStepIsVisited = (visitedStepId, minVisitedStep, maxVisitedStep) => {
    const visitedStepIndex = ApplicationSteps.findIndex(x => x.id === visitedStepId);
    const minStepIndex = ApplicationSteps.findIndex(x => x.id === minVisitedStep.id);
    const maxStepIndex = ApplicationSteps.findIndex(x => x.id === maxVisitedStep.id);
    return (visitedStepIndex >= minStepIndex && visitedStepIndex <= maxStepIndex);
  };

  const handleStepIsDisabled = (disabledStepId, maxDisabledStep) => {
    const furthestDisabledStepIndex = ApplicationSteps.findIndex(x => x.id === disabledStepId);
    const maxDisabledStepIndex = ApplicationSteps.findIndex(x => x.id === maxDisabledStep.id);
    return furthestDisabledStepIndex < maxDisabledStepIndex;
  };

  const ApplicationSteps = [].concat.apply([], [
    Object.values(ProjectSteps) as any, 
    Object.values(PropertySteps) as any, 
    Object.values(BudgetSteps) as any, 
    Object.values(EntitySteps) as any,
    Object.values(GuarantorSteps) as any,
    Object.values(SummarySteps) as any
  ]) as any;

  const ApplicationMainSteps = [
    {
      step: ProjectSteps.ProjectOverview.id,
      name: "Project",
      icon: "warehouse",
      completed: applicationScreenStatus.Projects === ProjectSteps.PermitStatus.id,
      active: handleStepIsActive(ProjectSteps.ProjectOverview, PropertySteps.NumberOfProperties),
      visited: handleStepIsVisited(applicationScreenStatus.Projects,  ProjectSteps.ProjectOverview, PropertySteps.NumberOfProperties),
      disabled: handleStepIsDisabled(applicationScreenStatus.Projects, ProjectSteps.ProjectOverview)
    },
    {
      step: PropertySteps.NumberOfProperties.id,
      name: "Property",
      icon: "home",
      completed: applicationScreenStatus.Property === PropertySteps.LoanTerm.id,
      active: handleStepIsActive(PropertySteps.NumberOfProperties, BudgetSteps.RequestedBudget),
      visited: handleStepIsVisited(applicationScreenStatus.Property, PropertySteps.NumberOfProperties, BudgetSteps.RequestedBudget),
      disabled: handleStepIsDisabled(applicationScreenStatus.Property, PropertySteps.NumberOfProperties)
    },
    {
      step: BudgetSteps.RequestedBudget.id,
      name: "Budget",
      icon: "calculator",
      completed: applicationScreenStatus.Budget === BudgetSteps.ProjectDetails.id,
      active: handleStepIsActive(BudgetSteps.RequestedBudget, EntitySteps.ExistingBorrower),
      visited: handleStepIsVisited(applicationScreenStatus.Budget, BudgetSteps.RequestedBudget, EntitySteps.ExistingBorrower),
      disabled: handleStepIsDisabled(applicationScreenStatus.Budget, BudgetSteps.RequestedBudget)
    },
    {
      step: EntitySteps.ExistingBorrower.id,
      name: "Entity",
      icon: "building",
      completed: applicationScreenStatus.Entity === EntitySteps.RealEstateOwned.id,
      active: handleStepIsActive(EntitySteps.ExistingBorrower, GuarantorSteps.SelfGuarantor),
      visited: handleStepIsVisited(applicationScreenStatus.Entity, EntitySteps.ExistingBorrower, GuarantorSteps.SelfGuarantor),
      disabled: handleStepIsDisabled(applicationScreenStatus.Entity, EntitySteps.ExistingBorrower)
    },
    {
      step: GuarantorSteps.SelfGuarantor.id,
      name: "Guarantor",
      icon: "user",
      completed: applicationScreenStatus.Guarantor === GuarantorSteps.DoubleFilterGuarantor.id,
      active: handleStepIsActive(GuarantorSteps.SelfGuarantor, SummarySteps.AdditionalCollateral),
      visited: handleStepIsVisited(applicationScreenStatus.Guarantor, GuarantorSteps.SelfGuarantor, SummarySteps.AdditionalCollateral),
      disabled: handleStepIsDisabled(applicationScreenStatus.Guarantor, GuarantorSteps.SelfGuarantor)
    },
    {
      step: SummarySteps.AdditionalCollateral.id,
      name: "Summary",
      icon: "clipboard list",
      completed: applicationScreenStatus.Summary === SummarySteps.Confirmation.id,
      active: handleStepIsActive(SummarySteps.AdditionalCollateral, SummarySteps.Confirmation),
      visited: handleStepIsVisited(applicationScreenStatus.Summary, SummarySteps.AdditionalCollateral, SummarySteps.Confirmation),
      disabled: handleStepIsDisabled(applicationScreenStatus.Summary, SummarySteps.AdditionalCollateral)
    }
  ];

  const AllInOneExcludeIds = [] as string[];

  const BridgeExcludeIds = [
    ProjectSteps.SubordinatedDebt.id,
    ProjectSteps.PermitStatus.id,
    PropertySteps.NumberOfProperties.id,
    BudgetSteps.RequestedBudget.id,
    BudgetSteps.PaidCosts.id
  ];

  const DevelopmentExcludeIds = [
    ProjectSteps.ProjectStructure.id,
    PropertySteps.NumberOfProperties.id,
    PropertySteps.LoanTerm.id,
    BudgetSteps.RequestedBudget.id
  ];

  const FixAndFlipExcludeIds = [
    ProjectSteps.ProjectDevelopment.id,
    PropertySteps.NumberOfProperties.id
  ];
  
  const NewConstructionExcludeIds = [
    ProjectSteps.ProjectDevelopment.id
  ];

  const BridgeToBuildExcludeIds = [
    ProjectSteps.ProjectDevelopment.id
  ];

  const handleNavigateToStep = (stepId) => {
    const limitedRestrcitedSteps = [ProjectSteps.WhiteLabeledWelcome.id, ProjectSteps.BrokerWelcome.id, PropertySteps.NumberOfProperties.id, BudgetSteps.RequestedBudget.id, EntitySteps.ExistingBorrower.id];
    if (!(isLimited && limitedRestrcitedSteps.indexOf(stepId) > -1)) {
      const requiredScreenIds = [ProjectSteps.WhiteLabeledWelcome.id, ProjectSteps.BrokerWelcome.id, ProjectSteps.ProjectOverview.id];
      if ((applicationScreenStatus.Projects && requiredScreenIds.indexOf(applicationScreenStatus.Projects) === -1) || getIsWhiteLabeled()) {
        const isProjectSection = handleStepIsVisited(currentStepId, ProjectSteps.WhiteLabeledWelcome, ProjectSteps.PermitStatus);
        const isPropertySection = handleStepIsVisited(currentStepId, PropertySteps.NumberOfProperties, PropertySteps.LoanTerm);
        const isBudgetSection = handleStepIsVisited(currentStepId, BudgetSteps.RequestedBudget, BudgetSteps.ProjectDetails);
        const isEntitySection = handleStepIsVisited(currentStepId, EntitySteps.ExistingBorrower, EntitySteps.RealEstateOwned);
        const isGuarantorSection = handleStepIsVisited(currentStepId, GuarantorSteps.SelfGuarantor, GuarantorSteps.DoubleFilterGuarantor);
        const isSummarySection = handleStepIsVisited(currentStepId, SummarySteps.AdditionalCollateral, SummarySteps.Confirmation);
        if (handleStepIsVisited(stepId, ProjectSteps.WhiteLabeledWelcome, ProjectSteps.PermitStatus) && !isProjectSection) {
          handlePrev(ProjectSteps.ProjectOverview.id, "");
        }
        else if (handleStepIsVisited(stepId, PropertySteps.NumberOfProperties, PropertySteps.LoanTerm) && !isPropertySection) {
          handlePrev(PropertySteps.NumberOfProperties.id, "");
        }
        else if (handleStepIsVisited(stepId, BudgetSteps.RequestedBudget, BudgetSteps.ProjectDetails) && !isBudgetSection) {
          handlePrev(BudgetSteps.RequestedBudget.id, "");
        }
        else if (handleStepIsVisited(stepId, EntitySteps.ExistingBorrower, EntitySteps.RealEstateOwned) && !isEntitySection) {
          handlePrev(EntitySteps.ExistingBorrower.id, "");
        }
        else if (handleStepIsVisited(stepId, GuarantorSteps.SelfGuarantor, GuarantorSteps.DoubleFilterGuarantor) && !isGuarantorSection) {
          handlePrev(GuarantorSteps.SelfGuarantor.id, "");
        }
        else if (handleStepIsVisited(stepId, SummarySteps.AdditionalCollateral, SummarySteps.Confirmation) && !isSummarySection) {
          handlePrev(SummarySteps.AdditionalCollateral.id, "");
        }
      } 
    }
  };

  const handlePaging = () => {
    setWarningIds([]);
    setInvalidProps([]);
    if (unfocusRef.current) {
      unfocusRef.current.focus();
    }
  };

  const handleProgress = (stepIndex) => {
    const applicationProgress = (100 / (ApplicationSteps.length - 1)) * stepIndex;
    setCurrentProgress(applicationProgress);
  };

  const handleCalculateSectionChange = (currentStepId, destinationStepId) => {
    let currentSection = "";
    if (handleStepIsVisited(currentStepId, ProjectSteps.WhiteLabeledWelcome, ProjectSteps.PermitStatus)) {
      currentSection = ApplicationMainSteps[0].name;
    }
    else if (handleStepIsVisited(currentStepId, PropertySteps.NumberOfProperties, PropertySteps.LoanTerm)) {
      currentSection = ApplicationMainSteps[1].name;
    }
    else if (handleStepIsVisited(currentStepId, BudgetSteps.RequestedBudget, BudgetSteps.ProjectDetails)) {
      currentSection = ApplicationMainSteps[2].name;
    }
    else if (handleStepIsVisited(currentStepId, EntitySteps.ExistingBorrower, EntitySteps.RealEstateOwned)) {
      currentSection = ApplicationMainSteps[3].name;
    }
    else if (handleStepIsVisited(currentStepId, GuarantorSteps.SelfGuarantor, GuarantorSteps.DoubleFilterGuarantor)) {
      currentSection = ApplicationMainSteps[4].name;
    }
    else if (handleStepIsVisited(currentStepId, SummarySteps.AdditionalCollateral, SummarySteps.Confirmation)) {
      currentSection = ApplicationMainSteps[5].name;
    }
    
    let prevSection = "";
    if (handleStepIsVisited(destinationStepId, ProjectSteps.WhiteLabeledWelcome, ProjectSteps.PermitStatus)) {
      prevSection = ApplicationMainSteps[0].name;
    }
    else if (handleStepIsVisited(destinationStepId, PropertySteps.NumberOfProperties, PropertySteps.LoanTerm)) {
      prevSection = ApplicationMainSteps[1].name;
    }
    else if (handleStepIsVisited(destinationStepId, BudgetSteps.RequestedBudget, BudgetSteps.ProjectDetails)) {
      prevSection = ApplicationMainSteps[2].name;
    }
    else if (handleStepIsVisited(destinationStepId, EntitySteps.ExistingBorrower, EntitySteps.RealEstateOwned)) {
      prevSection = ApplicationMainSteps[3].name;
    }
    else if (handleStepIsVisited(destinationStepId, GuarantorSteps.SelfGuarantor, GuarantorSteps.DoubleFilterGuarantor)) {
      prevSection = ApplicationMainSteps[4].name;
    }
    else if (handleStepIsVisited(destinationStepId, SummarySteps.AdditionalCollateral, SummarySteps.Confirmation)) {
      prevSection = ApplicationMainSteps[5].name;
    }

    return {
      currentSection: currentSection,
      prevSection: prevSection
    };
  };

  const handlePrev = (stepId: string | undefined = undefined, skipModalType: string | undefined = undefined) => {
    const requiredScreenIds = [ProjectSteps.WhiteLabeledWelcome.id, ProjectSteps.ProjectOverview.id, ProjectSteps.ProjectStructure.id];
    handlePaging();
    setInvalidProps([]);
    const currentStepIndex = ApplicationSteps.findIndex(x => x.id === currentStepId);
    let prevStepIndex = -1;
    prevStepIndex = currentStepIndex - 1;
    let notValidProps = [];
    if (stepId) {
      const specifiedStepIndex = ApplicationSteps.findIndex(x => x.id === stepId);
      prevStepIndex = specifiedStepIndex;
      const currentStepItem = ApplicationSteps.find(x => x.id === currentStepId);
      if (isScreenFormChanged && skipModalType !== "Close and Continue" && skipModalType !== "Save and Continue" && requiredScreenIds.indexOf(currentStepId) === -1) {
        setIsSkipModalOpen(true);
        setSkipModalId(stepId);
        notValidProps = handleValidation(currentStepItem);
      }
      else if (skipModalType === "Save and Continue" && requiredScreenIds.indexOf(currentStepId) === -1) {
        notValidProps = handleValidation(currentStepItem);
        if (notValidProps.length === 0) {
          setIsLoading(true);
          handleSaveApplication();
          setIsLoading(false);
        }
      }
    }
    else {
      while (ApplicationSteps[prevStepIndex] && excludedStepIds.concat(metadataExcludedIds).includes(ApplicationSteps[prevStepIndex].id)) {
        prevStepIndex--;
      }
    }

    const sectionObj = handleCalculateSectionChange(ApplicationSteps[currentStepIndex].id, prevStepIndex !== -1 ? ApplicationSteps[prevStepIndex].id : ApplicationSteps[currentStepIndex].id);
    if (requiredScreenIds.indexOf(currentStepId) === -1) {
      if (sectionObj.currentSection === sectionObj.prevSection) {
        skipModalType = undefined;
      }
      else if (sectionObj.prevSection === ApplicationMainSteps[0].name) {
        prevStepIndex = ApplicationSteps.findIndex(x => x.id === ProjectSteps.ProjectOverview.id);
        skipModalType = "";
      }
      else if (sectionObj.prevSection === ApplicationMainSteps[1].name) {
        prevStepIndex = ApplicationSteps.findIndex(x => x.id === PropertySteps.NumberOfProperties.id);
        skipModalType = "";
      }
      else if (sectionObj.prevSection === ApplicationMainSteps[2].name) {
        prevStepIndex = ApplicationSteps.findIndex(x => x.id === BudgetSteps.RequestedBudget.id);
        skipModalType = "";
      }
      else if (sectionObj.prevSection === ApplicationMainSteps[3].name) {
        prevStepIndex = ApplicationSteps.findIndex(x => x.id === EntitySteps.ExistingBorrower.id);
        skipModalType = "";
      }
      else if (sectionObj.prevSection === ApplicationMainSteps[4].name) {
        prevStepIndex = ApplicationSteps.findIndex(x => x.id === GuarantorSteps.SelfGuarantor.id);
        skipModalType = "";
      }
      else if (sectionObj.prevSection === ApplicationMainSteps[5].name) {
        prevStepIndex = ApplicationSteps.findIndex(x => x.id === SummarySteps.AdditionalCollateral.id);
        skipModalType = "";
      }
    }

    while (ApplicationSteps[prevStepIndex] && excludedStepIds.concat(metadataExcludedIds).includes(ApplicationSteps[prevStepIndex].id)) {
      if (skipModalType || skipModalType === "") {
        prevStepIndex++;
      }
      else {
        prevStepIndex--;
      }
    }

    if (notValidProps.length === 0) {
      if (prevStepIndex === -1) {
        handleRouteToApplications();
      }
      else {
        setIsScreenFormChanged(false);
        if (isLimited && GuarantorSteps.AdditionalInformation.id === currentStepId) {
          prevStepIndex = ApplicationSteps.findIndex(x => x.id === ProjectSteps.WhiteLabeledWelcome.id);
        }

        setCurrentStepId(ApplicationSteps[prevStepIndex].id);
        handleProgress(prevStepIndex);
      }
    }
    else {
      setTimeout(() => {
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleCustomNext = async (stepId) => {
    let isApiSuccess = true;
    let currentExcludedIds = excludedStepIds;
    if ([EntitySteps.ExistingBorrower.id, EntitySteps.AdditionalInformation.id].indexOf(stepId) > -1 && newBorrowerEntity.id) {
      if (persona === Personas.WL_GUARANTOR) {
        await handleGetGuarantorGuarantorsAsync(newBorrowerEntity.id);
      }
      else {
        await handleGetBrokerGuarantorsAsync(newBorrowerEntity.id, applicationId);
      }
    }

    if (stepId === ProjectSteps.ProjectOverview.id) {
      const allExcludeIds = AllInOneExcludeIds.concat(BridgeExcludeIds).concat(DevelopmentExcludeIds).concat(FixAndFlipExcludeIds).concat(NewConstructionExcludeIds);
      currentExcludedIds = removeFromArrayByValues(currentExcludedIds, allExcludeIds);
      if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.ALL_IN_ONE) {
        currentExcludedIds = excludedStepIds.concat(AllInOneExcludeIds);
      }
      else if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE) {
        startAppObject.newStructurePropertyTypeId = GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
        handleDefaultOneProperty();        
        currentExcludedIds = excludedStepIds.concat(BridgeExcludeIds);
        if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
          currentExcludedIds = [...currentExcludedIds, PropertySteps.Plans.id];
        }
      }
      else if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT) {
        startAppObject.newStructurePropertyTypeId = GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
        startAppObject.existingStructurePropertyTypeId = FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? GlobalConstants.PropertyTypeIds.LAND_UNDEVELOPED : GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
        handleDefaultOneProperty();
        currentExcludedIds = excludedStepIds.concat(DevelopmentExcludeIds); 
        if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
          currentExcludedIds = [...currentExcludedIds, PropertySteps.Plans.id];
          startAppObject.properties?.forEach(property => {
            property.existingStructurePropertyTypeId = startAppObject.existingStructurePropertyTypeId;
            property.newStructurePropertyTypeId = startAppObject.newStructurePropertyTypeId;
          });
    
          startAppObject.hasPropertiesChanged = true;
        }
      }
      else if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.FIX_AND_FLIP) {
        if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
          startAppObject.existingStructurePropertyTypeId = startAppObject.existingStructurePropertyTypeId || GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
          startAppObject.newStructurePropertyTypeId = startAppObject.newStructurePropertyTypeId || GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
        } 
        else {
          startAppObject.existingStructurePropertyTypeId = startAppObject.existingStructurePropertyTypeId || GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
          startAppObject.newStructurePropertyTypeId = startAppObject.newStructurePropertyTypeId || GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
        }

        handleDefaultOneProperty();
        currentExcludedIds = excludedStepIds.concat(FixAndFlipExcludeIds);
      }
      else if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.NEW_CONSTRUCTION) {
        currentExcludedIds = excludedStepIds.concat(NewConstructionExcludeIds);
      }
      else if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE_TO_BUILD) {
        currentExcludedIds = excludedStepIds.concat(BridgeToBuildExcludeIds);
      }

      if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
        startAppObject.properties?.forEach(property => {
          property.city = property.city || startAppObject.city;
          property.state = property.state || startAppObject.state;
          property.county = property.county || startAppObject.county;
          property.zip = property.zip || startAppObject.zip;
        });

        startAppObject.hasPropertiesChanged = true;
      }

      setExcludedStepIds([...currentExcludedIds]);
      if (!isAllBorrowersPersona) {
        await handleAssociatedBorrowers(
          isAllBorrowersPersona, 
          handleAssociatedOrganizationContactId(startAppObject, persona === Personas.BROKER && user.organizationContactId),
          setAssociatedBorrowers,
          proxyUser,
          setIsMessage,
          setErrorResponse
        );
      }
    }
    else if (stepId === ProjectSteps.ProjectStructure.id) {
      if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN){
        if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT) {
          startAppObject.newStructurePropertyTypeId = GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
          startAppObject.existingStructurePropertyTypeId = GlobalConstants.PropertyTypeIds.LAND_UNDEVELOPED;
        }

        if ([GlobalConstants.LoanProgramIds.FIX_AND_FLIP, GlobalConstants.LoanProgramIds.BRIDGE].indexOf(startAppObject.loanProgramId) > -1) {
          startAppObject.newStructurePropertyTypeId = startAppObject.existingStructurePropertyTypeId;
          startAppObject.properties?.forEach(property => {
            property.newStructurePropertyTypeId = startAppObject.existingStructurePropertyTypeId;
          });
    
          startAppObject.hasPropertiesChanged = true;
        }

        if (startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.APARTMENT) {
          currentExcludedIds = [...currentExcludedIds, PropertySteps.Plans.id];
          setExcludedStepIds([...currentExcludedIds]);
        }
      }
      else {
        const isDevelopmentOrFixAndFlip = [GlobalConstants.LoanProgramIds.FIX_AND_FLIP, GlobalConstants.LoanProgramIds.DEVELOPMENT].indexOf(startAppObject.loanProgramId) > -1;
        startAppObject.newStructurePropertyTypeId = isDevelopmentOrFixAndFlip ? startAppObject.existingStructurePropertyTypeId : startAppObject.newStructurePropertyTypeId;
        startAppObject.properties?.forEach(property => {
          property.newStructurePropertyTypeId = startAppObject.newStructurePropertyTypeId;
        });
  
        startAppObject.hasPropertiesChanged = true;
      }

      if (startAppObject.properties) {
        startAppObject.properties.forEach(property => {
          property.existingStructurePropertyTypeId = property.existingStructurePropertyTypeId || startAppObject.existingStructurePropertyTypeId;
          property.newStructurePropertyTypeId = property.newStructurePropertyTypeId || startAppObject.existingStructurePropertyTypeId;
          property.zoning = property.zoning || startAppObject.zoning;
          property.numberOfUnits = ([...singleUnitPropertyTypeArray].indexOf(property.newStructurePropertyTypeId) > -1) ? 1 : (property.numberOfUnits || 1);
        });

        startAppObject.hasPropertiesChanged = true;
      }
    }
    else if (stepId === PropertySteps.NumberOfProperties.id) {
      if (!startAppObject.properties) {
        startAppObject.properties = [];
      }

      if (FeatureFlags.IS_BETA && startAppObject.properties) {
        const properties = [] as any[];
        for (const property of startAppObject.properties) {
          const newProperty = {
            id: property.id || guid(),
            address: property.street,
            city: property.city || startAppObject.city,
            state: property.state || startAppObject.state,
            county: property.county || startAppObject.county,
            zip: property.zip || startAppObject.zip,
            existingStructurePropertyTypeId: property.existingStructurePropertyTypeId || startAppObject.existingStructurePropertyTypeId,
            newStructurePropertyTypeId: property.newStructurePropertyTypeId || startAppObject.newStructurePropertyTypeId,
            numberOfUnits: property.numberOfUnits || 1,
            workStageId: property.workStageId || startAppObject.workStageId,
            zoning: property.zoning || startAppObject.zoning,
          }; 
          
          if (property.borrowerApplicationPropertyUnits && property.borrowerApplicationPropertyUnits.length) {
            const units = [] as any;
            for (const unit of property.borrowerApplicationPropertyUnits) {
              units.push({
                ...unit,
                id: unit.id || guid(),
                address: property.street
              });
            }
          }
          
          properties.push(newProperty);
        }
      }

      if (startAppObject.properties.length !== startAppObject.numberOfProperties) {
        if (initialStartAppObject.properties && initialStartAppObject.properties.length > 0) {
          isApiSuccess = await handleDeletePropertiesAndUnitsAsync(Array.from(startAppObject.properties as any[], x => x.id));
        }
        
        if (isApiSuccess) {
          const properties = [] as any[];
          for (let i=0; i<startAppObject.numberOfProperties; i++) {
            properties.push({
              id: guid(),
              city: startAppObject.city,
              state: startAppObject.state,
              county: startAppObject.county,
              zip: startAppObject.zip,
              existingStructurePropertyTypeId: startAppObject.existingStructurePropertyTypeId,
              newStructurePropertyTypeId: (startAppObject.loanProgramId && [GlobalConstants.LoanProgramIds.BRIDGE, GlobalConstants.LoanProgramIds.FIX_AND_FLIP].indexOf(startAppObject.loanProgramId) > -1) ?
                startAppObject.existingStructurePropertyTypeId : startAppObject.newStructurePropertyTypeId,
              workStageId: startAppObject.workStageId,
              zoning: startAppObject.zoning
            });
          }
  
          startAppObject.properties = properties;
          setStartAppObject({...startAppObject});
        }
      }
    }
    else if (stepId === PropertySteps.Properties.id) {
      await Promise.all(startAppObject.properties.map(async (property, i) => {
        property.units = property.units ? property.units : [];
        if (property.units && property.units.length !== property.numberOfUnits) {
          const foundInitialProperty = initialStartAppObject.properties && initialStartAppObject.properties.find(x => x.id === property.id);
          if (foundInitialProperty && foundInitialProperty.units && foundInitialProperty.units.length > 0) {
            isApiSuccess = await handleDeleteUnitsAsync(Array.from(property.units as any[], x => x.id));
          }
          
          const propertyUnits = [] as any[];
          if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
            for (let j=0; j<property.numberOfUnits; j++) {
              propertyUnits.push({ id: guid(), propertyIndex: i, unitIndex: j, unitNumber: (j + 1).toString(), completedValue: property.completedValue });
            }

            property.units = propertyUnits;
          }
          else {
            for (let j=0; j<property.numberOfUnits; j++) {
              propertyUnits.push({ id: guid(), propertyIndex: i, unitIndex: j, unitNumber: (j + 1).toString() });
            }
            
            startAppObject.properties[i].units = propertyUnits;
          }

          setStartAppObject({...startAppObject});
        }
      }));
    }
    else if ([EntitySteps.AdditionalInformation.id, EntitySteps.Assets.id, EntitySteps.Liabilities.id, EntitySteps.RealEstateOwned.id].indexOf(stepId) > -1) {
      if (!newBorrowerEntity.id) {
        newBorrowerEntity.id = guid();
        setNewBorrowerEntity({...newBorrowerEntity});
      }

      isApiSuccess = await handleUpsertBorrowerEntityAsync(newBorrowerEntity);
      if (stepId === EntitySteps.RealEstateOwned.id && isApiSuccess) {
        isApiSuccess = await handleGetBorrowerEntityAsync(applicationId, newBorrowerEntity.id);
      }
    }
    else if (stepId === GuarantorSteps.SelfGuarantor.id) {
      setIsLoading(true);
      if (proxyUser && proxyUser.id) {
        user = proxyUser;
      }

      const foundSelectedBrokerGuarantor = selectedBrokerGuarantors.find(x => x.id === user.organizationContactId);
      if (!foundSelectedBrokerGuarantor || foundSelectedBrokerGuarantor?.confirmationStatus !== "Declined") {
        isApiSuccess = await handleGetGuarantorAsync(user.organizationContactId);
        if (isApiSuccess) {
          const borrowerEntities = await getBorrowerEntitiesAsync();
          const foundEntity = borrowerEntities.find(x => x.organizationContactId === user.organizationContactId);
          const guarantorId = foundEntity ? foundEntity.id : guid();
          const guarantorEntity = {
            id: guarantorId,
            borrowerApplicationId: applicationId,
            organizationContactId: user.organizationContactId,
            roleOption: "Guarantor",
            confirmationStatus: foundEntity && foundEntity.confirmationStatus !== "Declined" ? foundEntity.confirmationStatus : "BrokerInitiated",
            accessLevelId: foundEntity ? foundEntity.accessLevelId : GlobalConstants.AccessLevelIds.FULL_EDIT,
            isActive: true
          };
  
          isApiSuccess = await patchEntitiesAsync([guarantorEntity], foundEntity ? false : true);
        }
      }
      
      if (startAppObject.isSelfGuarantor === false && foundSelectedBrokerGuarantor?.confirmationStatus !== "Declined") {
        const declineObj = {
          borrowerApplicationId: applicationId,
          guarantorOrganizationContactId: user.organizationContactId,
          guarantorEmail: user.email
        };

        isApiSuccess = await handleApiPromise(
          () => declineGuarantorInvitation(undefined, declineObj),
          () => declineMockGuarantorInvitation(undefined, declineObj),
          (response) => handleErrorResponse(response, setIsMessage, setErrorResponse),
          false
        ) || false;
      }

      if (isApiSuccess) {
        isApiSuccess = await handleGetGuarantorsAsync();
      }
    }
    else if (stepId === GuarantorSteps.BorrowerGuarantor.id) {
      if (isApplicationBorrower(permissions, "BorrowerWhiteLabeledApplication", "read", startAppObject.borrowerContactOrganizationContactId, organizationContactId) && startAppObject.invitedGuarantors && startAppObject.invitedGuarantors.length > 0) {
        setIsLoading(true);
        isApiSuccess = await handleAddBorrowerGuarantorsAsync();
      }
    }
    else if ([GuarantorSteps.AdditionalInformation.id, GuarantorSteps.CreditScore.id, GuarantorSteps.Assets.id, GuarantorSteps.Liabilities.id, GuarantorSteps.RealEstateOwned.id, GuarantorSteps.Disclosure.id].indexOf(stepId) > -1) {
      if (persona === Personas.WL_GUARANTOR) {
        setIsLoading(true);
        isApiSuccess = await handleUpsertGuarantorAsync(newGuarantor);
        if (stepId === GuarantorSteps.CreditScore.id && newGuarantor.id) {
          isApiSuccess = await handleGetGuarantorAsync(newGuarantor.id);
        }

        if (stepId === GuarantorSteps.RealEstateOwned.id) {
          startAppObject.additionalCollateral = [];
          setStartAppObject({...startAppObject});
          isApiSuccess = await handleGetGuarantorsAsync();
        }
      }
    }

    return {
      isApiSuccess: isApiSuccess,
      currentExcludedIds: currentExcludedIds
    };
  };

  const handleNestedValidation = (array, props, obj = startAppObject) => {
    const invalidProps = [] as string[];
    if (obj[array]) {
      obj[array].forEach((item) => {
        props.forEach((prop) => {
          if (!(item && item[prop] && item[prop] !== "" && item[prop]) && item[prop] !== false && item[prop] !== 0) {
            invalidProps.push(`custom-${array}-${prop}-${item.id}`);
          }
        });
      });
    }

    return invalidProps;
  };

  const handleProjectNameValidation = async () => {
    const projectNameExists = await handleProjectNameExistsAsync(startAppObject.name, startAppObject.id);
    return projectNameExists ? ["custom-project-name"] : [] as string[];
  };

  const handleValidation = (step) => {
    let validatingProps = step.validatingProps ? step.validatingProps : [];
    let notValidProps = validateObj(startAppObject, validatingProps);
    if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && step.id === ProjectSteps.ProjectOverview.id) {
      if (!startAppObject.requestedClosingDate) {
        notValidProps = notValidProps.concat(["requestedClosingDate"]);
      } 
      else if (checkWeekend(startAppObject.requestedClosingDate) || checkHoliday(startAppObject.requestedClosingDate)) {
        notValidProps = notValidProps.concat(["invalid-requestedClosingDate"]);
      }
    }

    if (FeatureFlags.IS_BETA && step.id === ProjectSteps.ProjectOverview.id && isAdminBrmNwlOrLo) {
      if (startAppObject.isBrokerInvolved) {
        notValidProps = notValidProps.concat(validateObj(startAppObject, [ProjectQuestions.BrokerEmail.field, "brokerOrganizationContactId"].concat(FeatureFlags.IS_BROKER_FEE_ALLIANCE ? ProjectQuestions.BrokerFeeRate.fields : ["brokerFeeRate", "isCombineOriginationFee"])));
      }
    }
    else if (step.id === ProjectSteps.ProjectOverview.id && !isGuarantorPersona) {
      notValidProps = notValidProps.concat(validateObj(startAppObject, FeatureFlags.IS_BROKER_FEE_ALLIANCE ? ProjectQuestions.BrokerFeeRate.fields : ["brokerFeeRate", "isCombineOriginationFee"]));
    }

    if (step.id === ProjectSteps.ProjectStructure.id) {
      if ([GlobalConstants.LoanProgramIds.FIX_AND_FLIP, GlobalConstants.LoanProgramIds.BRIDGE].indexOf(startAppObject.loanProgramId) === -1) {
        notValidProps = notValidProps.concat(validateObj(startAppObject, [ProjectQuestions.NewStructure.field]));
        if (FeatureFlags.IS_BETA) {
          notValidProps = notValidProps.concat(validateObj(startAppObject, [ProjectQuestions.Zoning.field]));
        }
      }      
    }
    else if (step.id === ProjectSteps.DurationOwned.id) {
      notValidProps = notValidProps.concat(validateObj(startAppObject, ["originalPurchasePrice"]));
      if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
        if (startAppObject[ProjectQuestions.DurationOwned.field] !== GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE) {
          notValidProps = notValidProps.concat(validateObj(startAppObject, ["durationOwnedId", "estimatePropertyValue"]));
          if (startAppObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL) {
            notValidProps = notValidProps.concat(validateObj(startAppObject, ["amountOwed"]));
          }
          else {
            notValidProps = notValidProps.concat(validateObj(startAppObject, ["cashOutAmountRequested"]));
          }
        }
      }
      else {
        if (startAppObject[ProjectQuestions.DurationOwned.field] !== GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE) {
          notValidProps = notValidProps.concat(validateObj(startAppObject, ["durationOwnedId", "amountOwed"]));
          if (startAppObject[ProjectQuestions.DurationOwned.field] === GlobalConstants.PurchaseOrRefinanceOptionIds.OWN) {
            notValidProps = notValidProps.concat(validateObj(startAppObject, ["cashOutAmountRequested"]));
          }
        }
      }
    }
    else if (step.id === ProjectSteps.SubordinatedDebt.id && startAppObject[ProjectQuestions.SubordinatedDebt.field]) {
      notValidProps = validateObj(startAppObject, ["subordinatedDebtAmount"]);
    }
    else if (step.id === ProjectSteps.ProjectDevelopment.id) {
      if (startAppObject.districtReimbursementsAvailableBorrowerApplicationInputId === GlobalConstants.YesNoUnknownIds.YES) {
        notValidProps = notValidProps.concat(validateObj(startAppObject, ["districtReimbursementsAvailableDescription"]));
      }

      if (startAppObject.bondingRequirementsBorrowerApplicationInputId === GlobalConstants.YesNoUnknownIds.YES) {
        notValidProps = notValidProps.concat(validateObj(startAppObject, ["bondingRequirementsDescription"]));
      }

      if (startAppObject.seasonalityConcernsBorrowerApplicationInputId === GlobalConstants.YesNoUnknownIds.YES) {
        notValidProps = notValidProps.concat(validateObj(startAppObject, ["seasonalityConcernsDescription"]));
      }
    }
    else if (step.id === ProjectSteps.PermitStatus.id) {
      if (isPermitTimingInMonthsNeeded) {
        notValidProps = notValidProps.concat(validateObj(startAppObject, ["developmentOrVerticalPermitTimingInMonths"]));
      }

      if (UserFeatureFlags.IS_RETAIL_PHASE_2 && [GlobalConstants.PermitStatusIds.PENDING, GlobalConstants.PermitStatusIds.FINAL_ENGINEERING, GlobalConstants.PermitStatusIds.EXPIRED, GlobalConstants.PermitStatusIds.NO_APPLICATION, GlobalConstants.PermitStatusIds.OTHER, GlobalConstants.PermitStatusIds.SUBMITTED, GlobalConstants.PermitStatusIds.PRELIM_ENGINEERING].indexOf(startAppObject.permitStatusId) > -1) {
          notValidProps = notValidProps.concat(validateObj(startAppObject, ["permitStatusExplanation"]));
      }
    }
    else if (step.id === PropertySteps.NumberOfProperties.id) {
      if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
        if ([GlobalConstants.LoanProgramIds.FIX_AND_FLIP, GlobalConstants.LoanProgramIds.BRIDGE, GlobalConstants.LoanProgramIds.DEVELOPMENT].indexOf(startAppObject.loanProgramId) !== -1 || startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.APARTMENT) {
          notValidProps = notValidProps.filter(x => x !== PropertyQuestions.UploadPropertyUnitMix.field);
        }

        if (startAppObject.uploadOptionLookupId === GlobalConstants.UploadOptions.UPLOAD && !isPropertyUnitMixUploaded) {
          notValidProps = notValidProps.concat(validateObj(startAppObject, ["missing-uploadPropertyUnitMix"]));
        }
      }
    }
    else if (step.id === PropertySteps.Properties.id) {
      validatingProps = validatingProps.concat(["address", "zip", "state", "existingStructurePropertyTypeId", "newStructurePropertyTypeId"]);
      if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
        validatingProps = validatingProps.concat(["parcelNumber"]);
        if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE) {
          if (startAppObject.properties[0] && startAppObject.properties[0].units) {
            if (startAppObject.properties[0].units[0] && !startAppObject.properties[0].units[0].completedValue) {
              validatingProps = validatingProps.concat(["completedValue"]);
            }
          }
          else if (!startAppObject.properties[0].units && !startAppObject.properties[0].completedValue) {
            validatingProps = validatingProps.concat(["completedValue"]);
          }
        }
      }

      if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.FIX_AND_FLIP) {
        validatingProps = validatingProps.concat(["numberOfUnits"]);
      }
      else if (startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.BRIDGE && startAppObject.newStructurePropertyTypeId !== GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND &&
        startAppObject.newStructurePropertyTypeId !== GlobalConstants.PropertyTypeIds.SINGLE_FAMILY) {
        validatingProps = validatingProps.concat(["numberOfUnits"]);
      }
      else {
        startAppObject.properties.forEach(property => {
          property.numberOfUnits = 1;
        });

        setStartAppObject({...startAppObject});
      }

      notValidProps = handleNestedValidation("properties", validatingProps);
      if (startAppObject.properties && startAppObject.properties.length > 0) {
        const propertyArray = Array.from(startAppObject.properties as any[], x => x.address);
        let isDuplicate = hasDuplicates(propertyArray);
        if (startAppObject.additionalCollateral && startAppObject.additionalCollateral.length > 0) {
          const additionalCollateralArray = Array.from(startAppObject.additionalCollateral as any[], x => combineAddresses(x.address, x.addressLine2));
          isDuplicate = hasDuplicatesArray(propertyArray, additionalCollateralArray);
        }

        if (isDuplicate) {
          notValidProps = notValidProps.concat(["custom-properties-unique"]);
        }

        if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
          if (startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.APARTMENT && (startAppObject.properties && startAppObject.properties.length)) {
            startAppObject.properties.map(property => {
              if (!(property.units && property.units[0] && property.units[0].completedValue)) {
                notValidProps = notValidProps.concat([`custom-properties-completedValue-${property.id}`]);
              }
            });
          }
        }
      }
    }
    else if (step.id === PropertySteps.Plans.id) {
      if (startAppObject.properties && startAppObject.properties.length > 0) {
        startAppObject.properties.forEach(property => {
          if (property.units && FeatureFlags.IS_UNIT_PROPERTY_REDESIGN === false) {
            property.units.forEach(unit => {
              if (unit.plan && startAppObject.unitPlans && startAppObject.unitPlans.length > 0) {
                const validatingProps = ["name", "numberOfBedroom", "numberOfBathroom", "numberOfCarGarage", "squareFootage"] as string[];   
                const foundPlanIndex = startAppObject.unitPlans.findIndex(x => x.name === unit.plan);
                if (foundPlanIndex > -1) {
                  const notValidPlanProps = validateObj(startAppObject.unitPlans[foundPlanIndex], validatingProps);
                  const notValidPlanIndexProps = [] as string[];
                  notValidPlanProps.forEach(notValidPlanProp => {
                    notValidPlanIndexProps.push(`custom-${notValidPlanProp}-${foundPlanIndex}`);
                  });

                  notValidProps = notValidProps.concat(notValidPlanIndexProps);
                }
              }
            });
          }
        });

        for (const property of startAppObject.properties) {
          const unitNumbers = [] as any[];
          for (const unit of property.units) {
            if (unitNumbers.includes(unit.unitNumber)) {
              notValidProps = notValidProps.concat([`custom-unit-duplicated-${unit.id}`]);
            }
            else {
              unitNumbers.push(unit.unitNumber);
            }

            if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
              if (!unit.unitNumber) {
                notValidProps = notValidProps.concat([`custom-unit-${unit.id}-unitNumber`]);
              }
              
              if (!unit.completedValue) {
                notValidProps = notValidProps.concat([`custom-unit-${unit.id}-completedValue`]);
              }
            }
            else {
              if (!unit.currentValue || !unit.completedValue) {
                notValidProps = notValidProps.concat(["unitPlanTable"]);
                break;
              }
            }
          }
        }
      }
      else {
        notValidProps = FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? [] : ["unitPlanTable"];
      }
    }
    else if (step.id === PropertySteps.LoanTerm.id) {
      if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
        if ([GlobalConstants.LoanProgramIds.DEVELOPMENT, GlobalConstants.LoanProgramIds.BRIDGE].indexOf(startAppObject.loanProgramId) === -1) {
          notValidProps = notValidProps.concat(handleNestedValidation("properties", ["monthOfFirstDraw", "buildTimeInMonths", "timeFrameToSellOrRefinanceInMonths"]));
        }

        if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE) {
          notValidProps = validateObj(startAppObject, ["preferredLoanTerm"]);
          if (startAppObject.preferredLoanTerm < greatestTotalToComplete) {
            notValidProps.push("preferredLoanTerm");
          }
        }
      }
      else {
        if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE) {
          notValidProps = validateObj(startAppObject, ["preferredLoanTerm"]);
          if (startAppObject.preferredLoanTerm < greatestTotalToComplete) {
            notValidProps.push("preferredLoanTerm");
          }
        }
        else {
          for (const property of startAppObject.properties) {
            if (!(property && property.monthOfFirstDraw && property.buildTimeInMonths && (property.timeFrameToSellOrRefinanceInMonths || property.timeFrameToSellOrRefinanceInMonths === 0))) {
              notValidProps = notValidProps.concat(["loanTermTable"]);
              break;
            } 
          }
        }
      }
    }
    else if (step.id === BudgetSteps.PaidCosts.id) {
      if (startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.NEW_CONSTRUCTION) {
        validatingProps = validatingProps.concat(["cashDown"]);
      }

      notValidProps = validateObj(startAppObject, validatingProps);
      if (startAppObject.paidCosts) {
        const invalidNestedProps = handleNestedValidation("gmrCostPaids", ["costPaidId", "amount"]);
        notValidProps = notValidProps.concat(invalidNestedProps);
      }
    }
    else if (step.id === BudgetSteps.PayoffStrategy.id) {
      if (startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.BRIDGE) {
        validatingProps = validatingProps.concat(["whoWillDoConstructionBorrowerApplicationInputId"]);
      }

      if (startAppObject.whoWillDoConstructionBorrowerApplicationInputId === GlobalConstants.WhoWillDoConstructionBorrowerApplicationInputIds.HIRING_GENERAL_CONTRACTOR) {
        validatingProps = validatingProps.concat(["generalContractorId"]);
      }

      if (startAppObject.loanProgramId !== GlobalConstants.LoanProgramIds.FIX_AND_FLIP) {
        validatingProps = validatingProps.concat(["payoffStrategyId"]);
      }

      if (startAppObject.payoffStrategyId === GlobalConstants.PayoffStrategyIds.OTHER) {
        validatingProps = validatingProps.concat(["payoffStrategyDescription"]);
      }

      if (!FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
        if (!startAppObject.requestedClosingDate) {
          validatingProps = validatingProps.concat(["requestedClosingDate"]);
        } 
        else if (checkWeekend(startAppObject.requestedClosingDate) || checkHoliday(startAppObject.requestedClosingDate)) {
          validatingProps = validatingProps.concat(["invalid-requestedClosingDate"]);
        }
      }
      
      notValidProps = validateObj(startAppObject, validatingProps);
    }
    else if (step.id === EntitySteps.AdditionalInformation.id) {
      notValidProps = validateObj(newBorrowerEntity, ["name", "entitySubTypeId", "physicalStreet", "physicalCityName", "physicalStateName", "physicalZipCode"]);
    }
    else if (step.id === EntitySteps.RealEstateOwned.id) {
      validatingProps = ["city", "holder1", "marketValue", "mortgageAmount1", "reoStatus", "state", "street", "zip"];
      const modifiedReos = newBorrowerEntity.reoSchedules.filter(reoSchedule => {
        let hasProp = false;
        validatingProps.forEach(validatingProp => {
          if (reoSchedule[validatingProp]) {
            hasProp = true;
          }
        });

        if (hasProp) {
          return reoSchedule;
        }
      });

      newBorrowerEntity.reoSchedules = modifiedReos;
      validatingProps = validatingProps.concat(["id"]);
      notValidProps = handleNestedValidation("reoSchedules", validatingProps, newBorrowerEntity);
    }
    else if (step.id === GuarantorSteps.DoubleFilterGuarantor.id) {
      if (selectedBrokerGuarantors.length === 0) {
        notValidProps = ["guarantorTable"];
      }
      else {
        notValidProps = validateNestedObj(selectedBrokerGuarantors, "selectedBrokerGuarantors", ["accessLevelId"]);
      }
    }
    else if (step.id === GuarantorSteps.BorrowerGuarantor.id) {
      let validatingProps = ["isProjectGuarantor"];
      if (startAppObject.isProjectGuarantor === true) {
        validatingProps = validatingProps.concat(["isAdditionalGuarantors"]);
      }

      let invalidNestedProps = [] as string[];
      if (startAppObject.isAdditionalGuarantors === true || startAppObject.isProjectGuarantor === false) {
        invalidNestedProps = handleNestedValidation("invitedGuarantors", ["firstName", "lastName", "email"]);
      }

      if (startAppObject.isProjectGuarantor === false || (startAppObject.isAdditionalGuarantors === true && startAppObject.isProjectGuarantor === true)) {
        if (!startAppObject.invitedGuarantors || startAppObject.invitedGuarantors.length === 0) {
          notValidProps = ["custom-borrower-guarantor-empty"];
        }
      }

      notValidProps = notValidProps.concat(validateObj(startAppObject, validatingProps).concat(invalidNestedProps));
    }
    else if (step.id === GuarantorSteps.AdditionalInformation.id) {
      let additionalInfoProps = ["firstName", "lastName", "email", "physicalAddress", "mobilePhone", "businessPhone", "socialSecurityNumber", "dateOfBirth", "employerName", "position", "netIncome", "yearsInIndustry", "yearsInJob"];
      if (newGuarantor.isMailingSameAsPhysical === false) {
        additionalInfoProps = additionalInfoProps.concat(["mailingAddress"]);
      }

      if (newGuarantor.maritalStatus === GlobalConstants.MaritalStatusIds.MARRIED) {
        additionalInfoProps = additionalInfoProps.concat(["spouseName"]);
      }

      notValidProps = validateObj(newGuarantor, additionalInfoProps);
    }
    else if (step.id === GuarantorSteps.CreditScore.id) {
      if (isCreditScoreSkipped) {
        notValidProps = validateObj(newGuarantor, ["estimatedCreditScore"]);
      }
      else {
        notValidProps = validateObj(newGuarantor, ["creditScore"]);
      }
    }
    else if (step.id === GuarantorSteps.RealEstateOwned.id) {
      validatingProps = ["city", "holder1", "marketValue", "mortgageAmount1", "reoStatus", "state", "street", "zip"];
      const modifiedReos = newGuarantor.reoSchedules.filter(reoSchedule => {
        let hasProp = false;
        validatingProps.forEach(validatingProp => {
          if (reoSchedule[validatingProp]) {
            hasProp = true;
          }
        });

        if (hasProp) {
          return reoSchedule;
        }
      });

      newGuarantor.reoSchedules = modifiedReos;
      validatingProps = validatingProps.concat(["id"]);
      notValidProps = handleNestedValidation("reoSchedules", validatingProps, newGuarantor);
    }
    else if (step.id === GuarantorSteps.Disclosure.id) {
      if (!newGuarantor.isDisclosureCompleted) {
        notValidProps = ["custom-disclosure"];
      }
    }

    return notValidProps;
  };

  // TODO: Temporary method while we disable calculate
  const handleSubmitNoCalculate = async () => {
    if (startAppObject.submittedOn && newGuarantor.submittedOn) {
      handleSaveAndClose();
    }
    else {
      setInvalidProps([]);
      const isProjectsComplete = applicationScreenStatus.Projects === ProjectSteps.PermitStatus.id;
      const isPropertyComplete = applicationScreenStatus.Property === PropertySteps.LoanTerm.id;
      const isBudgetComplete = applicationScreenStatus.Budget === BudgetSteps.ProjectDetails.id;
      const isEntityComplete = applicationScreenStatus.Entity === EntitySteps.RealEstateOwned.id;
      const isGuarantorComplete = applicationScreenStatus.Guarantor === GuarantorSteps.DoubleFilterGuarantor.id;
      if (isProjectsComplete && isPropertyComplete && isBudgetComplete && isEntityComplete && isGuarantorComplete) {
        setIsLoading(true);
        const atLeastOneGuarantorCompleted = await handleGetIsGuarantorSignedAsync();
        if (atLeastOneGuarantorCompleted) {
          let isCaluclateSuccess = true;
          if (isSubmitPersona || (!startAppObject.brokerOrganizationContactId && persona === Personas.NWL_GUARANTOR)) {
            isCaluclateSuccess = await handleCalculateAsync();
            if (isCaluclateSuccess) {
              await handleSubmit();
            }
          }
          else if ((startAppObject.brokerOrganizationContactId && persona === Personas.NWL_GUARANTOR) || persona === Personas.WL_GUARANTOR) {
            setCurrentStepId(SummarySteps.Confirmation.id);
            setCurrentProgress(100);
            applicationScreenStatus.Summary = SummarySteps.Confirmation.id;
            setApplicationScreenStatus({...applicationScreenStatus});
          }
          else {
            setTimeout(() => {
              setInvalidProps(["custom-can-submit"]);
            }, 50);
          }
        }
        else {
          setTimeout(() => {
            setInvalidProps(["custom-guarantor-completed"]);
          }, 50);
        }

        setIsLoading(false);
      }
      else {
        setTimeout(() => {
          const incompletionText = `You must finish the${isProjectsComplete ? "" : " project"}${isPropertyComplete ? "" : ", property"}${isBudgetComplete ? "" : ", budget"}${isEntityComplete ? "" : ", entity"}${isGuarantorComplete ? "" : ", guarantor"} sections before you can calculate.`;
          setIncompleteApplicationText(incompletionText);
          setInvalidProps(["custom-application-unfinished"]);
        }, 50);
      }
    }
  };

  const handleSubmit = async () => {
    const submittedDate = new Date();
    const isWholesaleGuarantor = getIsWhiteLabeled() && isApplicationGuarantor(permissions, "GuarantorWhiteLabeledApplication", "read", startAppObject.guarantors ? startAppObject.guarantors : [], organizationContactId);
    let isGuarantorSubmitSuccess = true;
    if (isWholesaleGuarantor && SummarySteps.Summary.id === currentStepId) {
      newGuarantor.submittedOn = new Date();
      isGuarantorSubmitSuccess = await handleUpsertGuarantorAsync(newGuarantor);
    }
    
    let isApiSuccess = await handleSaveApplication();
    if (!isWholesaleGuarantor) {
      isApiSuccess = await handleSubmitApplication(submittedDate);
      setIsLoading(false);
    }
    else if (startAppObject.hasUnpaidInvoices) {
      setIsPaymentModalOpen(true);
    }
    
    if (isApiSuccess && isGuarantorSubmitSuccess) {
      setCurrentStepId(SummarySteps.Confirmation.id);
      setCurrentProgress(100);
      applicationScreenStatus.Summary = SummarySteps.Confirmation.id;
      setApplicationScreenStatus({...applicationScreenStatus});
    }
  };

  const handleCalculate = async () => {
    setInvalidProps([]);
    const isProjectsComplete = applicationScreenStatus.Projects === ProjectSteps.PermitStatus.id;
    const isPropertyComplete = applicationScreenStatus.Property === PropertySteps.LoanTerm.id;
    const isBudgetComplete = applicationScreenStatus.Budget === BudgetSteps.ProjectDetails.id;
    const isEntityComplete = applicationScreenStatus.Entity === EntitySteps.RealEstateOwned.id;
    const isGuarantorComplete = applicationScreenStatus.Guarantor === GuarantorSteps.DoubleFilterGuarantor.id;
    if (isProjectsComplete && isPropertyComplete && isBudgetComplete && isEntityComplete && isGuarantorComplete) {
      setIsLoading(true);
      const isCaluclateSuccess = await handleCalculateAsync();
      if (isCaluclateSuccess) {
        handleTryNext();
      }
    }
    else {
      setTimeout(() => {
        const incompletionText = `You must finish the${isProjectsComplete ? "" : " project"}${isPropertyComplete ? "" : ", property"}${isBudgetComplete ? "" : ", budget"}${isEntityComplete ? "" : ", entity"}${isGuarantorComplete ? "" : ", guarantor"} sections before you can calculate.`;
        setIncompleteApplicationText(incompletionText);
        setInvalidProps(["custom-application-unfinished"]);
      }, 50);
    }
  };

  const handleExport = async (applicationId) => { 
    setExportLoading(true);
    try {
      const response = FeatureFlags.IS_MOCK ? await exportMockGMRQuote(applicationId) : await exportGMRQuote(applicationId, proxyUser.id);
      if (response && response.ok) {
        const data = await response.blob();
        const exportQuote = await createFile(data, "gmr-quote", data.type);
        setExportURL(URL.createObjectURL(exportQuote));
        if (exportRef.current) {
          exportRef.current.click();
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }

    setExportLoading(false);
  };

  const handleEnterKeyNext = (e, currentStepId) => {
    const isDoubleFilterGuarantorScreen = e.keyCode === 13 && currentStepId === GuarantorSteps.DoubleFilterGuarantor.id && !isBrokerGuarantorSelected;
    const isProjectOverviewScreen = e.keyCode === 13 && currentStepId === ProjectSteps.ProjectOverview.id && isBrokerSearchFocus;
    const isSummaryScreen = e.keyCode === 13 && currentStepId === SummarySteps.Summary.id;
    if (e.keyCode === 13 && currentStepId === PropertySteps.Properties.id && isPropertyBulkEditModalOpen) {
      handleApplyPropertyInformationBulkEdit();
    }
    else if (e.keyCode === 13 && currentStepId === PropertySteps.Plans.id && isUnitBulkEditModalOpen) {
      if (unitRef && unitRef.current) {
        unitRef.current.applyUnitInformationBulkEdit();
      }
    }
    else if (e.keyCode === 13 && currentStepId !== SummarySteps.Confirmation.id && !isSummaryScreen && !isDoubleFilterGuarantorScreen && !isProjectOverviewScreen) {
      handleTryNext();
    }
  };

  const handleCheckSectionIdValid = (sectionSteps, currentStepId) => {
    let isSectionValid = false;
    Object.keys(sectionSteps).map(stepName => {
      if (sectionSteps[stepName].id === currentStepId) {
        isSectionValid = true;
      }
    });

    return isSectionValid;
  };

  const handleTryNext = async (stepId = undefined as string | undefined) => {
    handlePaging();
    const currentStepIndex = ApplicationSteps.findIndex(x => x.id === currentStepId);
    const currentStepItem = ApplicationSteps.find(x => x.id === currentStepId);
    let notValidProps = [] as string[];
    if (!stepId) {
      notValidProps = handleValidation(currentStepItem);
      if (currentStepItem.id === ProjectSteps.ProjectOverview.id && notValidProps.length === 0) {
        notValidProps = await handleProjectNameValidation();
      }

      setIsScreenFormChanged(true);
    }

    if (notValidProps.length === 0 && !isEnteredNext) {
      setIsEnteredNext(true);
      handleNext(currentStepIndex, stepId);
      setTimeout(() => { 
        setIsEnteredNext(false);
      }, 800);
    }
    else {
      setTimeout(() => { 
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleNext = async (currentStepIndex, stepId = undefined as string | undefined) => {
    let nextStepIndex = currentStepIndex + 1;
    if (stepId) {
      const specifiedStepIndex = ApplicationSteps.findIndex(x => x.id === stepId);
      nextStepIndex = specifiedStepIndex;
    }

    let isApiSuccess = true;
    let currentExcludedStepIds = excludedStepIds;
    if (ApplicationSteps[currentStepIndex].customNext) {
      const customNextObj = await handleCustomNext(ApplicationSteps[currentStepIndex].id); 
      currentExcludedStepIds = currentExcludedStepIds.concat(customNextObj.currentExcludedIds);
      isApiSuccess = customNextObj.isApiSuccess;
    }
    
    currentExcludedStepIds = currentExcludedStepIds.concat(metadataExcludedIds);
    while (ApplicationSteps[nextStepIndex] && currentExcludedStepIds.includes(ApplicationSteps[nextStepIndex].id)) {
      nextStepIndex++;
    }
    
    if ([ProjectSteps.WhiteLabeledWelcome.id, ProjectSteps.BrokerWelcome.id].indexOf(currentStepId) === -1 && isApiSuccess) {
      setIsLoading(true);
      isApiSuccess = await handleSaveApplication();
      if (ApplicationSteps[currentStepIndex].id === ProjectSteps.ProjectOverview.id && startAppObject.id && isApplicationNew) {
        const emailObj = {
          id: startAppObject.id,
          name: startAppObject.name,
          originatingGmrId: startAppObject.originatingGmrId
        };

        const dealObj = {
          borrowerApplicationId: startAppObject.id,
          originatingGmrId: startAppObject.originatingGmrId
        };

        isApiSuccess = await handleSendApplicationStartEmailAsync(emailObj);
        if (isApiSuccess && startAppObject.originatingGmrId) {
          isApiSuccess = await createDealFromGmr(dealObj);
        }

        setIsLoading(false);
        setIsApplicationNew(false);
      }

      if (ApplicationSteps[currentStepIndex].id === GuarantorSteps.DoubleFilterGuarantor.id && isApiSuccess) {
        isApiSuccess = await handleEntities();
      }

      setIsLoading(false);
    }

    if (isApiSuccess) {     
      if (isLimited && ProjectSteps.WhiteLabeledWelcome.id === currentStepId) {
        nextStepIndex = ApplicationSteps.findIndex(x => x.id === GuarantorSteps.AdditionalInformation.id);
      } 

      setCurrentStepId(ApplicationSteps[nextStepIndex].id);
      const isMultiSection = {
        Project: false,
        Property: false,
        Budget: false,
        Entity: false,
        Guarantor: false
      };
  
      if (!stepId) {
        if (handleStepIsVisited(ApplicationSteps[currentStepIndex].id, ProjectSteps.WhiteLabeledWelcome, ProjectSteps.PermitStatus)) {
          const projectFurthestStepIndex = ApplicationSteps.findIndex(x => x.id === applicationScreenStatus.Projects);
          const projectMaxStepIndex = ApplicationSteps.findIndex(x => x.id === ProjectSteps.PermitStatus.id);
          if (nextStepIndex >= projectFurthestStepIndex) {
            if (nextStepIndex >= projectMaxStepIndex + 1) {
              isMultiSection.Project = true;
              applicationScreenStatus.Projects = ProjectSteps.PermitStatus.id;
            }
            else if (handleCheckSectionIdValid(ProjectSteps, ApplicationSteps[nextStepIndex - 1].id)) {
              applicationScreenStatus.Projects = ApplicationSteps[nextStepIndex - 1].id;
            }
          }
        }
  
        if (handleStepIsVisited(ApplicationSteps[currentStepIndex].id, PropertySteps.NumberOfProperties, PropertySteps.LoanTerm) || isMultiSection.Project) {
          const propertyFurthestStepIndex = ApplicationSteps.findIndex(x => x.id === applicationScreenStatus.Property);
          const propertyMaxStepIndex = ApplicationSteps.findIndex(x => x.id === PropertySteps.LoanTerm.id);
          if (nextStepIndex >= propertyFurthestStepIndex) {
            if (nextStepIndex >= propertyMaxStepIndex + 1) {
              isMultiSection.Property = true;
              applicationScreenStatus.Property = PropertySteps.LoanTerm.id;
            }
            else if (handleCheckSectionIdValid(PropertySteps, ApplicationSteps[nextStepIndex - 1].id)) {
              applicationScreenStatus.Property = ApplicationSteps[nextStepIndex - 1].id;
            }
          }
        }
  
        if (handleStepIsVisited(ApplicationSteps[currentStepIndex].id, BudgetSteps.RequestedBudget, BudgetSteps.ProjectDetails) || isMultiSection.Property) {
          const budgetFurthestStepIndex = ApplicationSteps.findIndex(x => x.id === applicationScreenStatus.Budget);
          const budgetMaxStepIndex = ApplicationSteps.findIndex(x => x.id === BudgetSteps.ProjectDetails.id);
          if (nextStepIndex >= budgetFurthestStepIndex) {
            if (nextStepIndex >= budgetMaxStepIndex + 1) {
              isMultiSection.Budget = true;
              applicationScreenStatus.Budget = BudgetSteps.ProjectDetails.id;
            }
            else if (handleCheckSectionIdValid(BudgetSteps, ApplicationSteps[nextStepIndex - 1].id)) {
              applicationScreenStatus.Budget = ApplicationSteps[nextStepIndex - 1].id;
            }
          }
        }

        if (handleStepIsVisited(ApplicationSteps[currentStepIndex].id, EntitySteps.ExistingBorrower, EntitySteps.RealEstateOwned) || isMultiSection.Budget) {
          const entityFurthestStepIndex = ApplicationSteps.findIndex(x => x.id === applicationScreenStatus.Entity);
          const entityMaxStepIndex = ApplicationSteps.findIndex(x => x.id === EntitySteps.RealEstateOwned.id);
          if (nextStepIndex >= entityFurthestStepIndex) {
            if (nextStepIndex >= entityMaxStepIndex + 1) {
              isMultiSection.Entity = true;
              applicationScreenStatus.Entity = EntitySteps.RealEstateOwned.id;
            }
            else if (handleCheckSectionIdValid(EntitySteps, ApplicationSteps[nextStepIndex - 1].id)) {
              applicationScreenStatus.Entity = ApplicationSteps[nextStepIndex - 1].id;
            }
          }
        }
  
        if (handleStepIsVisited(ApplicationSteps[currentStepIndex].id, GuarantorSteps.SelfGuarantor, GuarantorSteps.DoubleFilterGuarantor) || isMultiSection.Entity) {
          const guarantorFurthestStepIndex = ApplicationSteps.findIndex(x => x.id === applicationScreenStatus.Guarantor);
          const guarantorMaxStepIndex = ApplicationSteps.findIndex(x => x.id === GuarantorSteps.DoubleFilterGuarantor.id);
          if (nextStepIndex >= guarantorFurthestStepIndex) {
            if (nextStepIndex >= guarantorMaxStepIndex + 1) {
              isMultiSection.Guarantor = true;
              applicationScreenStatus.Guarantor = GuarantorSteps.DoubleFilterGuarantor.id;
            }
            else if (handleCheckSectionIdValid(GuarantorSteps, ApplicationSteps[nextStepIndex - 1].id)) {
              applicationScreenStatus.Guarantor = ApplicationSteps[nextStepIndex - 1].id;
            }
          }
        }

        if (handleStepIsVisited(ApplicationSteps[currentStepIndex].id, SummarySteps.AdditionalCollateral, SummarySteps.Confirmation) || isMultiSection.Guarantor) {
          const guarantorFurthestStepIndex = ApplicationSteps.findIndex(x => x.id === applicationScreenStatus.Summary);
          if (nextStepIndex >= guarantorFurthestStepIndex) {
            applicationScreenStatus.Summary = ApplicationSteps[nextStepIndex - 1].id;
          }
        }
      }
  
      setApplicationScreenStatus({...applicationScreenStatus});
      handleProgress(nextStepIndex);
      setIsScreenFormChanged(false);
    }
  };

  const handlePreviousButtonText = (currentStepId) => {
    const currentStepIndex = ApplicationSteps.findIndex(x => x.id === currentStepId);
    let prevStepIndex = currentStepIndex - 1;
    while (ApplicationSteps[prevStepIndex] && excludedStepIds.concat(metadataExcludedIds).includes(ApplicationSteps[prevStepIndex].id)) {
      prevStepIndex--;
    }

    let sectionObj = {
      prevSection: "",
      currentSection: ""
    };
    
    if (prevStepIndex > -1) {
      sectionObj = handleCalculateSectionChange(ApplicationSteps[currentStepIndex].id, ApplicationSteps[prevStepIndex].id);
    }
    
    if (sectionObj.prevSection === sectionObj.currentSection) {
      return "Previous";
    }
    else if (sectionObj.prevSection === ApplicationMainSteps[0].name) {
      return ApplicationMainSteps[0].name;
    }
    else if (sectionObj.prevSection === ApplicationMainSteps[1].name) {
      return ApplicationMainSteps[1].name;
    }
    else if (sectionObj.prevSection === ApplicationMainSteps[2].name) {
      return ApplicationMainSteps[2].name;
    }
    else if (sectionObj.prevSection === ApplicationMainSteps[3].name && !isLimited) {
      return ApplicationMainSteps[3].name;
    }
    else if (sectionObj.prevSection === ApplicationMainSteps[4].name) {
      return ApplicationMainSteps[4].name;
    }
    else if (sectionObj.prevSection === ApplicationMainSteps[5].name) {
      return ApplicationMainSteps[5].name;
    }
    else {
      return "Previous";
    }
  };

  const handleModalClose = () => {
    setNewAssetAndLiability({});
    setNewReoSchedule({ isMortgageFree: true });
    setIsSocialSecurityEdit(false);
    setIsModalSubmitted(false);
    setIsModalOpen(false);
    setInvalidProps([]);
    setNewBuilder([]);
  };

  const handleEditAL = () => {
    const foundGuarantorAssetIndex = guarantorAssetsAndLiabilities.findIndex(x => x.id === newAssetAndLiability.id);
    if (foundGuarantorAssetIndex > -1) {
      setInvalidProps([]);
      let validatingProps = ["alType", "institutionName", "currentBalance"];
      if (newAssetAndLiability.alOption === "Liability") {
        validatingProps = validatingProps.concat(["monthlyLiability"]);
      }
  
      const notValidProps = validateObj(newAssetAndLiability, validatingProps);
      if (notValidProps.length === 0) {
        const newAssetAndLiabilityObj = {
          id: newAssetAndLiability.id,
          "Class": newAssetAndLiability.alOption,
          "Type": newAssetAndLiability.alOption === "Asset" ? handleGetValueFromId(applicationMetadata.assetTypes, newAssetAndLiability.alType) : handleGetValueFromId(applicationMetadata.liabilityTypes, newAssetAndLiability.alType),
          "Name of Institution": newAssetAndLiability.institutionName,
          "Current Balance": newAssetAndLiability.currentBalance,
          "Monthly Liability": newAssetAndLiability.monthlyLiability,
          "Status": handleGetValueFromId(applicationMetadata.alStatuses, newAssetAndLiability.status)
        };

        guarantorAssetsAndLiabilities[foundGuarantorAssetIndex] = newAssetAndLiabilityObj;
        if (newGuarantor && newGuarantor.assetsAndLiabilities) {
          const foundGuarantorALIndex = newGuarantor.assetsAndLiabilities.findIndex(x => x.id === newAssetAndLiability.id);
          if (foundGuarantorALIndex > -1) {
            newGuarantor.assetsAndLiabilities[foundGuarantorALIndex] = newAssetAndLiability;
            setNewGuarantor({...newGuarantor});
            setGuarantorAssetAndLiabilities([...guarantorAssetsAndLiabilities]);
          }
        }

        handleModalClose();
      }
      else {
        setTimeout(() => { 
          setInvalidProps(notValidProps);
        }, 50);
      }
    }
  };

  const handleEditReo = () => {
    const foundGuarantorREOIndex = guarantorReoSchedules.findIndex(x => x.id === newReoSchedule.id);
    if (foundGuarantorREOIndex > -1) {  
      setInvalidProps([]);
      let validatingProps = ["street", "zip", "city", "state", "marketValue", "reoType", "reoStatus"];
      if (newReoSchedule.isMortgageFree === false) {
        validatingProps = validatingProps.concat(["alSchedule1", "mortgageAmount1", "mortgagePayment1"]);
        if (newReoSchedule.mortgageAmount2 || newReoSchedule.mortgagePayment2 || newReoSchedule.holder2) {
          validatingProps = validatingProps.concat(["alSchedule2", "mortgageAmount2", "mortgagePayment2"]);
        }
  
        if (newReoSchedule.mortgageAmount3 || newReoSchedule.mortgagePayment3 || newReoSchedule.holder3) {
          validatingProps = validatingProps.concat(["alSchedule3","mortgageAmount3", "mortgagePayment3"]);
        }
      }

      const notValidProps = validateObj(newReoSchedule, validatingProps);
      if (notValidProps.length === 0) {
        const newReoScheduleObj = {
          id: newReoSchedule.id,
          "Address": `${newReoSchedule.street}, ${newReoSchedule.city}, ${newReoSchedule.state}`,
          "Market Value": newReoSchedule.marketValue,
          "Parcel No.": newReoSchedule.parcelNumber,
          "Total Mortgage Amount": (newReoSchedule.mortgageAmount1 ? newReoSchedule.mortgageAmount1 : 0) + 
            (newReoSchedule.mortgageAmount2 ? newReoSchedule.mortgageAmount2 : 0) + (newReoSchedule.mortgageAmount3 ? newReoSchedule.mortgageAmount3 : 0),
          "Total Mortgage Payment": (newReoSchedule.mortgagePayment1 ? newReoSchedule.mortgagePayment1 : 0) + 
          (newReoSchedule.mortgagePayment2 ? newReoSchedule.mortgagePayment2 : 0) + (newReoSchedule.mortgagePayment3 ? newReoSchedule.mortgagePayment3 : 0),
          "REO Type": handleGetValueFromId(applicationMetadata.reoTypes, newReoSchedule.reoType),
          "Reo Status": handleGetValueFromId(applicationMetadata.reoStatuses, newReoSchedule.reoStatus)
        };
    
        if (!newGuarantor.reoSchedules) {
          newGuarantor.reoSchedules = [];
        }

        guarantorReoSchedules[foundGuarantorREOIndex] = newReoScheduleObj;
        if (newGuarantor && newGuarantor.reoSchedules) {
          const foundNewGuarantorREOIndex = newGuarantor.reoSchedules.findIndex(x => x.id === newReoSchedule.id);
          if (foundNewGuarantorREOIndex > -1) {
            newGuarantor.reoSchedules[foundNewGuarantorREOIndex] = newReoSchedule;
            setNewGuarantor({...newGuarantor});
            setGuarantorReoSchedules([...guarantorReoSchedules]);
          }
        }

        handleModalClose();
      }
      else {
        setTimeout(() => { 
          setInvalidProps(notValidProps);
        }, 50);
      }
    }
  };

  const handleAlForm = (type, alType) => {
    newAssetAndLiability.alOption = alType;
    return (
      <React.Fragment>
        <Grid.Row className="application-row">
          {(type === "guarantor wizard" && alType === "Asset") ? <Grid.Column width={16}>
            
            <BCTable
              data={getFilteredAL(guarantorAssetsAndLiabilities, alType) && getFilteredAL(guarantorAssetsAndLiabilities, alType).length > -1 ? formatAssets(true, newGuarantor, setNewGuarantor, false, type) : [
                {
                  "Class": undefined,
                  "Type": undefined,
                  "Name of Institution": undefined,
                  "Current Balance": undefined,
                  "Monthly Liability": undefined,
                  "Status": undefined
                }
              ]}
              dataRules={[
                { field: "Class", rule: "hide" }, 
                { field: "Status", rule: "hide" }, 
                { field: "id", rule: "hide" }, 
                { field: "Current Balance", rule: "format", display: "dollar"},
                { field: "Monthly Liability", rule: alType === "Asset" ? "hide" : "format", display: "dollar"},
                { field: "isDeleteHide", rule: "hide"}
              ]}
              thin
              dataSingleLine
              actions={newGuarantor.assetsAndLiabilities && newGuarantor.assetsAndLiabilities.filter((x) => x.alOption === "Asset").length !== 1 && ["delete"]}
              handleTableDelete={(index) => handleTableRemove("guarantorAssetsAndLiabilities", index, "guarantor", "Asset")}
              overflowX
              unstackable
              brokerColor={wlBrokerHex}
            />
          </Grid.Column>
          : <Grid.Column width={16}>
          <BCTable
            data={getFilteredAL(guarantorAssetsAndLiabilities, alType) && getFilteredAL(guarantorAssetsAndLiabilities, alType).length > -1 ? formatLiabilities(true, newGuarantor, setNewGuarantor, false, type) : [
              {
                "Class": undefined,
                "Type": undefined,
                "Name of Institution": undefined,
                "Current Balance": undefined,
                "Monthly Liability": undefined,
                "Status": undefined
              }
            ]}
            dataRules={[
              { field: "Class", rule: "hide" }, 
              { field: "Status", rule: "hide" }, 
              { field: "id", rule: "hide" }, 
              { field: "Current Balance", rule: "format", display: "dollar"},
              { field: "Monthly Liability", rule: alType === "Asset" ? "hide" : "format", display: "dollar"},
              { field: "isDeleteHide", rule: "hide"}
            ]}
            thin
            dataSingleLine
            actions={newGuarantor.assetsAndLiabilities && newGuarantor.assetsAndLiabilities.filter((x) => x.alOption === "Liability").length !== 1 && ["delete"]}
            handleTableDelete={(index) => handleTableRemove("guarantorAssetsAndLiabilities", index, "guarantor", "Liability")}
            overflowX
            unstackable
            brokerColor={wlBrokerHex}
          />
        </Grid.Column>}
        </Grid.Row>
        <React.Fragment>
          {type !== "guarantor wizard" && <Grid.Row className="application-row" columns={isGreaterThanMobile ? 3 : 1}>
            <Grid.Column>
              <BCFormInput 
                labelClass="gmr-background-label"
                type="dropdown"
                inputKey="guarantor-asset"
                label="Type"
                placeholder="Please Select"
                obj={newAssetAndLiability}
                field="alType"
                dropdownOptions={alType === "Asset" ? getDropdownOptions(applicationMetadata.assetTypes, ["id"], "name") : getDropdownOptions(applicationMetadata.liabilityTypes, ["id"], "name")}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newAssetAndLiability, setNewAssetAndLiability)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="alType" />
            </Grid.Column>
            <Grid.Column>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor-asset"
                label="Name of Institution"
                placeholder="Construction Loan Services II"
                obj={newAssetAndLiability}
                field="institutionName"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newAssetAndLiability, setNewAssetAndLiability)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="institutionName" />
            </Grid.Column>
            <Grid.Column>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor-asset"
                label="Current Balance"
                placeholder="100"
                obj={newAssetAndLiability}
                field="currentBalance"
                fieldType={GlobalConstants.InputTypes.DOLLAR}
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newAssetAndLiability, setNewAssetAndLiability, GlobalConstants.InputTypes.DOLLAR)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="currentBalance" />
            </Grid.Column>
          </Grid.Row>}
          <Grid.Row className="application-row" columns={isGreaterThanMobile ? 3 : 1}>
            {(newAssetAndLiability.alOption === "Liability" && type !== "guarantor wizard") && <Grid.Column>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Monthly Liability"
                placeholder="100"
                obj={newAssetAndLiability}
                field="monthlyLiability"
                fieldType={GlobalConstants.InputTypes.DOLLAR}
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newAssetAndLiability, setNewAssetAndLiability, GlobalConstants.InputTypes.DOLLAR)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="monthlyLiability" />
            </Grid.Column>}
          </Grid.Row>
          {type === "guarantor wizard" && <Grid.Row className="application-row">
            <Grid.Column width={16}>
              <Button 
                className="bp-button application-button" 
                fluid
                onClick={() => addAL(newGuarantor, setNewGuarantor, alType)}
              >
                <div className="gmr-button-container">
                  <div className="gmr-button-text">{alType === "Asset" ? "Add Asset" : "Add Liability"}</div>
                </div>
              </Button>
            </Grid.Column>
          </Grid.Row>}
        </React.Fragment>
      </React.Fragment>
    );
  };

  const handleReoForm = (type) => {
    let assetsAndLiabilities = entityAssetsAndLiabilities;
    if (type === "guarantor reo" || type === "guarantor reo wizard") {
      assetsAndLiabilities = guarantorAssetsAndLiabilities;
    }

    return (
      <React.Fragment>
        <Grid.Row className="application-row">
          {type === "guarantor reo" && <Grid.Column width={16}>
            <BCTable
              data={formatReos(newGuarantor, setNewGuarantor,true, type)}
              dataRules={[
                { field: "id", rule: "hide" },
                { field: "Total Mortgage Payment", rule: "format", display: "dollar"},
                { field: "isDeleteHide", rule: "hide"}
              ]}
              thin
              actions={(newGuarantor.reoSchedules && newGuarantor.reoSchedules !== 1) && ["delete"]}
              handleTableDelete={(index) => handleTableRemove("guarantorReoSchedules", index, "guarantor")}
              overflowX
              unstackable
              columns={6}
              brokerColor={wlBrokerHex}
            />
          </Grid.Column>}
        </Grid.Row>
        {type !== "guarantor reo" && <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
            <BCFormInput 
              labelClass="gmr-background-label"
              type="dropdown"
              label="REO Type"
              placeholder="Please Select"
              obj={newReoSchedule}
              field="reoType"
              dropdownOptions={getDropdownOptions(applicationMetadata.reoTypes, ["id"], "name")}
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="reoType" />
          </Grid.Column>
          <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
            <BCFormInput 
              labelClass="gmr-background-label"
              type="dropdown"
              label="REO Status"
              placeholder="Please Select"
              obj={newReoSchedule}
              field="reoStatus"
              dropdownOptions={getDropdownOptions(applicationMetadata.reoStatuses, ["id"], "name")}
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="reoStatus" />
          </Grid.Column>
          <Grid.Column width={16}>
            <BCFormInput
                label="Address"
                labelClass="gmr-background-label"
                type={GlobalConstants.FormInputTypes.PLACES}
                placeDetailsObject={newReoSchedule}
                setPlaceDetailsObject={setNewReoSchedule}
                placeholder="1234 Main Street, Seattle, WA 98052, USA"
                defaultValue={handleAddressValue({
                  address: newReoSchedule.street,
                  city: newReoSchedule.city,
                  state: newReoSchedule.state,
                  zip: newReoSchedule.zip
                })}
                placeFields={["address", "city", "state", "county", "zip"]}
                placeFieldsNameOverrides={[
                  {
                    addressComponent: "address",
                    field: "street"
                  },
                ]}
                required
              />
             {invalidProps.includes("city") ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="city" 
              propText="This city is invalid." 
            /> : invalidProps.includes("state") ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="state"
              propText="This state is invalid."
            /> : invalidProps.includes("zip") ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="zip"
              propText="This zip code is invalid."
            /> : invalidProps.includes("county") ? <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="county"
              propText="This county is invalid."
            /> : <BCValidationMessage 
              invalidProps={invalidProps} 
              prop="street" 
              propText={ErrorMessages.Address} />
            }
          </Grid.Column>
          <Grid.Column width={16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              label="Address Line 2"
              placeholder="Apartment, suite, unit, building, floor, etc."
              obj={newReoSchedule}
              field="addressLine2"
              inputType="text"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              label="Market Value"
              placeholder="10000"
              obj={newReoSchedule}
              field="marketValue"
              fieldType="dollar"
              inputType="number"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="marketValue" />
          </Grid.Column>
          <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              label="Monthly Tax Insurance and Maintenance"
              placeholder="1000"
              obj={newReoSchedule}
              field="maintenance"
              fieldType="dollar"
              inputType="number"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="application-row">
          {type === "borrower entity" && <Grid.Column width={16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="input"
              label="How much is owed?"
              placeholder="1000"
              obj={newReoSchedule}
              field="amountOwed"
              fieldType="dollar"
              inputType="number"
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
            />
            <BCValidationMessage invalidProps={invalidProps} prop="mortgageAmount1" />
          </Grid.Column>}
          {(type === "guarantor wizard" || type === "guarantor reo" || type === "guarantor reo wizard") && <Grid.Column width={16}>
            <BCFormInput
              labelClass="gmr-background-label"
              type="checkbox"
              checkboxText="Mortgage Free"
              obj={newReoSchedule}
              field="isMortgageFree"
              value={newReoSchedule.isMortgageFree}
              handleFormChange={(value, field) => assetsAndLiabilities && assetsAndLiabilities.length > 0 ? handleFormChange(value, field, undefined, undefined, newReoSchedule, setNewReoSchedule) : void 0}
            />
          </Grid.Column>}
          {(newReoSchedule.isMortgageFree === false && type.includes("guarantor")) && <React.Fragment>
            <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
              <BCFormInput 
                labelClass="gmr-background-label"
                type="dropdown"
                label="AL Schedule 1"
                placeholder="Please Select"
                obj={newReoSchedule}
                field="alSchedule1"
                dropdownOptions={getDropdownOptions(assetsAndLiabilities, ["Name of Institution"], "Name of Institution")}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="alSchedule1" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Amount 1"
                placeholder="1000"
                obj={newReoSchedule}
                field="mortgageAmount1"
                fieldType="dollar"
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, GlobalConstants.InputTypes.DOLLAR)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="mortgageAmount1" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Payment 1"
                placeholder="1000"
                obj={newReoSchedule}
                field="mortgagePayment1"
                fieldType="dollar"
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, GlobalConstants.InputTypes.DOLLAR)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="mortgagePayment1" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Holder 1"
                placeholder="Construction Loan Services II"
                obj={newReoSchedule}
                field="holder1"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, undefined, undefined, 50)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
              <BCFormInput 
                labelClass="gmr-background-label"
                type="dropdown"
                label="AL Schedule 2"
                placeholder="Please Select"
                obj={newReoSchedule}
                field="alSchedule2"
                dropdownOptions={getDropdownOptions(assetsAndLiabilities, ["Name of Institution"], "Name of Institution")}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="alSchedule2" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Amount 2"
                placeholder="1000"
                obj={newReoSchedule}
                field="mortgageAmount2"
                fieldType="dollar"
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, GlobalConstants.InputTypes.DOLLAR)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="mortgageAmount2" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Payment 2"
                placeholder="1000"
                obj={newReoSchedule}
                field="mortgagePayment2"
                fieldType="dollar"
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, GlobalConstants.InputTypes.DOLLAR)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="mortgagePayment2" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Holder 2"
                placeholder="Construction Loan Services II"
                obj={newReoSchedule}
                field="holder2"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, undefined, undefined, 50)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
              <BCFormInput 
                labelClass="gmr-background-label"
                type="dropdown"
                label="AL Schedule 3"
                placeholder="Please Select"
                obj={newReoSchedule}
                field="alSchedule3"
                dropdownOptions={getDropdownOptions(assetsAndLiabilities, ["Name of Institution"], "Name of Institution")}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="alSchedule3" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Amount 3"
                placeholder="1000"
                obj={newReoSchedule}
                field="mortgageAmount3"
                inputType="number"
                fieldType="dollar"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, GlobalConstants.InputTypes.DOLLAR)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="mortgageAmount3" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Payment 3"
                placeholder="1000"
                obj={newReoSchedule}
                field="mortgagePayment3"
                fieldType="dollar"
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, GlobalConstants.InputTypes.DOLLAR)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="mortgagePayment3" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Holder 3"
                placeholder="Construction Loan Services II"
                obj={newReoSchedule}
                field="holder3"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, undefined, undefined, 50)}
              />
            </Grid.Column>
          </React.Fragment>}
          <Grid.Column width={16}>
            <BCFormInput 
              labelClass="gmr-background-label"
              type="textarea"
              label="Description"
              placeholder="Write your description here..."
              obj={newReoSchedule}
              field="reoScheduleDescription"
              value={newReoSchedule.reoScheduleDescription}
              handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
            />
          </Grid.Column>
        </Grid.Row></React.Fragment>}
        {type === "guarantor reo" && <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <Button 
              className="bp-button application-button" 
              fluid
              style={backgroundColorStyle}
              onClick={() => handleAddGuarantorReoSchedule()}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Add REO Schedule</div>
              </div>
            </Button>
          </Grid.Column>
        </Grid.Row>}
      </React.Fragment>
    );
  };

  const handleSocialSecurityUndo = () => {
    setIsSocialSecurityEdit(false);
    newGuarantor.socialSecurityNumber = undefined;
    setNewGuarantor({...newGuarantor});
  };

  const handleDateOfBirthHidden = (show = false) => {
    if (show) {
      newGuarantor.isDateOfBirthEdit = false;
    }
    else {
      newGuarantor.isDateOfBirthEdit = true;
    }
    setNewGuarantor({...newGuarantor});
  };

  const handleGuarantorModalCancel = async () => {
    newGuarantor.assetsAndLiabilities = [];
    setNewGuarantor({...newGuarantor});
    setGuarantorAssetAndLiabilities([]);
    setGuarantorReoSchedules([]);
    handlePaging();
    handleModalClose();
  };

  const handleModalPrevNext = (prevModal, nextModal, isNew = false) => {
    return (
      <Grid>
        <Grid.Row columns={3}>
          <Grid.Column>
            {prevModal && <Button
              fluid 
              onClick={() => handleModal(prevModal, isNew, undefined, true)}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Previous</div>
              </div>
            </Button>}
          </Grid.Column>
          <Grid.Column>
            <Button
              fluid 
              onClick={() => handleGuarantorModalCancel()}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Cancel</div>
              </div>
            </Button>
          </Grid.Column>
          <Grid.Column>
            {nextModal && <Button 
              className="bp-button" 
              style={backgroundColorStyle}
              fluid 
              onClick={() => handleModal(nextModal)}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Next</div>
              </div>
            </Button>}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  const handleAddNewAssetsAndLiablity = (type) => {
    setInvalidProps([]);
    let validatingProps = ["alType", "institutionName", "currentBalance"];
    if (newAssetAndLiability.alOption === "Liability") {
      validatingProps = validatingProps.concat(["monthlyLiability"]);
    }

    const notValidProps = validateObj(newAssetAndLiability, validatingProps);
    if (notValidProps.length === 0) {
      const alGuid = guid();
      const newAssetAndLiabilityObj = {
        id: alGuid,
        "Class": newAssetAndLiability.alOption,
        "Type": newAssetAndLiability.alOption === "Asset" ? handleGetValueFromId(applicationMetadata.assetTypes, newAssetAndLiability.alType) : handleGetValueFromId(applicationMetadata.liabilityTypes, newAssetAndLiability.alType),
        "Name of Institution": newAssetAndLiability.institutionName,
        "Current Balance": newAssetAndLiability.currentBalance,
        "Monthly Liability": newAssetAndLiability.monthlyLiability,
        "Status": handleGetValueFromId(applicationMetadata.alStatuses, newAssetAndLiability.status)
      };

      if (type === "borrower entity") {
        if (!newBorrowerEntity.assetsAndLiabilities) {
          newBorrowerEntity.assetsAndLiabilities = [];
        }

        entityAssetsAndLiabilities.push(newAssetAndLiabilityObj);
        setEntityAssetAndLiabilities([...entityAssetsAndLiabilities]);
        newAssetAndLiability.id = alGuid;
        newBorrowerEntity.assetsAndLiabilities.push(newAssetAndLiability);
        setNewBorrowerEntity({...newBorrowerEntity});
      }
      else if (type === "guarantor" || type === "guarantor wizard") {
        if (!newGuarantor.assetsAndLiabilities) {
          newGuarantor.assetsAndLiabilities = [];
        }
        
        guarantorAssetsAndLiabilities.push(newAssetAndLiabilityObj);
        setGuarantorAssetAndLiabilities([...guarantorAssetsAndLiabilities]);
        newAssetAndLiability.id = alGuid;
        newGuarantor.assetsAndLiabilities.push(newAssetAndLiability);
        setNewGuarantor({...newGuarantor});
        setNewAssetAndLiability({});
      }

      if (type === "guarantor" || type === "borrower entity") {
        handleModalClose();
      }
    }
    else {
      setTimeout(() => { 
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleAddNewReoSchedule = (type) => {
    setInvalidProps([]);
    let validatingProps = ["street", "zip", "city", "state", "marketValue", "reoType", "reoStatus"];
    if (newReoSchedule.isMortgageFree === false) {
      validatingProps = validatingProps.concat(["alSchedule1", "mortgageAmount1", "mortgagePayment1"]);
      if (newReoSchedule.mortgageAmount2 || newReoSchedule.mortgagePayment2 || newReoSchedule.holder2) {
        validatingProps = validatingProps.concat(["alSchedule2", "mortgageAmount2", "mortgagePayment2"]);
      }

      if (newReoSchedule.mortgageAmount3 || newReoSchedule.mortgagePayment3 || newReoSchedule.holder3) {
        validatingProps = validatingProps.concat(["alSchedule3","mortgageAmount3", "mortgagePayment3"]);
      }
    }
    const notValidProps = validateObj(newReoSchedule, validatingProps);
    if (notValidProps.length === 0) {
      const reoGuid = guid();
      const newReoScheduleObj = {
        id: reoGuid,
        "Address": `${newReoSchedule.street}, ${newReoSchedule.city}, ${newReoSchedule.state}`,
        "Market Value": newReoSchedule.marketValue,
        "Parcel Number": newReoSchedule.parcelNumber,
        "Total Mortgage Amount": (newReoSchedule.mortgageAmount1 ? newReoSchedule.mortgageAmount1 : 0) + 
          (newReoSchedule.mortgageAmount2 ? newReoSchedule.mortgageAmount2 : 0) + (newReoSchedule.mortgageAmount3 ? newReoSchedule.mortgageAmount3 : 0),
        "Total Mortgage Payment": (newReoSchedule.mortgagePayment1 ? newReoSchedule.mortgagePayment1 : 0) + 
        (newReoSchedule.mortgagePayment2 ? newReoSchedule.mortgagePayment2 : 0) + (newReoSchedule.mortgagePayment3 ? newReoSchedule.mortgagePayment3 : 0),
        "REO Type": handleGetValueFromId(applicationMetadata.reoTypes, newReoSchedule.reoType),
        "Reo Status": handleGetValueFromId(applicationMetadata.reoStatuses, newReoSchedule.reoStatus)
      };
  
      if (type === "borrower entity") {
        if (!newBorrowerEntity.reoSchedules)   {
          newBorrowerEntity.reoSchedules = [];
        }
    
        entityReoSchedules.push(newReoScheduleObj);
        setEntityReoSchedules([...entityReoSchedules]);
        newReoSchedule.id = reoGuid;
        newBorrowerEntity.reoSchedules.push(newReoSchedule);
        setNewBorrowerEntity({...newBorrowerEntity});
      }
      else if (type === "guarantor" || type === "guarantor wizard") {
        if (!newGuarantor.reoSchedules) {
          newGuarantor.reoSchedules = [];
        }
        
        guarantorReoSchedules.push(newReoScheduleObj);
        setGuarantorReoSchedules([...guarantorReoSchedules]);
        newReoSchedule.id = reoGuid;
        newGuarantor.reoSchedules.push(newReoSchedule);
        setNewBorrowerEntity({...newGuarantor});
      } 
  
      setNewReoSchedule({ isMortgageFree: true });
      if (type === "borrower entity" || type === "guarantor") {
        handleModalClose();
      }
    }
    else {
      setTimeout(() => { 
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleAddEntityReoSchedule = () => {
    newBorrowerEntity.hasReoChanged = true;
    newBorrowerEntity.reoSchedules.push({ id: guid() });
    setNewBorrowerEntity({...newBorrowerEntity});
  };

  const handleAddGuarantorReoSchedule = () => {
    newGuarantor.hasReoChanged = true;
    newGuarantor.reoSchedules.push({ id: guid(), additionalCollateral: false });
    setNewGuarantor({...newGuarantor});
  };

  const handleGuarantorModalSubmit = async () => {
    setInvalidProps([]);
    let notValidProps = [] as string[];
    let validatingProps = ["city", "holder1", "marketValue", "mortgageAmount1", "reoStatus", "state", "street", "zip"];
    const modifiedReos = newGuarantor.reoSchedules.filter(reoSchedule => {
      let hasProp = false;
      validatingProps.forEach(validatingProp => {
        if (reoSchedule[validatingProp]) {
          hasProp = true;
        }
      });

      if (hasProp) {
        return reoSchedule;
      }
    });

    newGuarantor.reoSchedules = modifiedReos;
    validatingProps = validatingProps.concat(["id"]);
    notValidProps = handleNestedValidation("reoSchedules", validatingProps, newGuarantor);
    if (notValidProps.length === 0) {
      handleModalSubmit("guarantor");
    }
    else {
      setTimeout(() => { 
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleModalSubmit = async (type) => {
    let notValidProps = [];
    switch (type) {
      case "group plan": {
        startAppObject.properties.forEach((property) => {
          if (property.units && property.units.length > 0) {
            property.units.forEach((unit) => {
              if (checkedUnits.includes(unit.id)) {
                unit.plan = startAppObject.groupPlan;
              }
            });
          }
        });

        setIsModalOpen(false);
        break;
      }
      case "builder":
        setInvalidProps([]);
        notValidProps = validateObj(newBuilder, ["organizationName", "physicalStreet", "physicalZip", "physicalCity", "physicalState", "physicalCounty"]);
        if (notValidProps.length === 0) {
          newBuilder.id = guid();
          setIsModalSubmitted(true);
          setIsLoading(true);
          const isApiSuccess = await handleCreateBuilderAsync(convertBuilder(newBuilder));
          if (isApiSuccess) {
            const foundBuilder = await handleGetBuilderAsync(newBuilder.id);
            if (foundBuilder) {
              applicationMetadata.builders.push(foundBuilder);
              setApplicationMetadata(applicationMetadata);
            }
          }

          handleModalClose();
          setIsLoading(false);
        }
        else {
          setTimeout(() => { 
            setInvalidProps(notValidProps);
          }, 50);
        }

        break;
      case "borrower entity":
        setInvalidProps([]);
        notValidProps = validateObj(newBorrowerEntity, ["organizationName", "physicalStreet", "physicalZip", "physicalCity", "physicalState", "physicalCounty"]);
        if (notValidProps.length === 0) {
          await handleUpsertBorrowerEntityAsync(newBorrowerEntity);
        }
        else {
          handleModal("new organization");
          setTimeout(() => { 
            setInvalidProps(notValidProps);
          }, 50);
        }
        break;
      case "guarantor": {
        if (!newGuarantor.id) {
          newGuarantor.id = guid();
        }

        const additonalCollateralViews = [] as any[];
        newGuarantor.reoSchedules.forEach(reoschedule => {
          if (reoschedule.additionalCollateral) {
            const additonalCollateralView = {
              "Address": handleAddressValue({
                address: reoschedule.street,
                city: reoschedule.cityName,
                state: reoschedule.stateName,
                zip: reoschedule.zipCode
              }),
              "Market Value": reoschedule.marketValue,
              "Parcel No.": reoschedule.parcelNumber,
              "Owner": `${newGuarantor.firstName} ${newGuarantor.lastName}`
            };

            additonalCollateralViews.push(additonalCollateralView);
          }
        });

        setGuarantorAdditionalCollateral({...additonalCollateralViews});
        setIsLoading(true);
        setIsModalSubmitted(true);
        await handleUpsertGuarantorAsync(newGuarantor);
        setIsLoading(false);
        await handleGetGuarantorsAsync();
        newGuarantor.assetsAndLiabilities = [];
        setNewGuarantor({...newGuarantor});
        setGuarantorAssetAndLiabilities([]);
        setGuarantorReoSchedules([]);
        handlePaging();
        handleModalClose();
        if (startAppObject.id, startAppObject.borrowerOrganizationId && selectedBrokerGuarantors && selectedBrokerGuarantors.length > 0) {
          await handleEntities();
        }

        break;
      }
      case "borrower entity al": 
        handleAddNewAssetsAndLiablity("borrower entity");
        break;
      case "borrower entity reo": 
        handleAddNewReoSchedule("borrower entity");
        break;
      case "guarantor al": 
        handleAddNewAssetsAndLiablity("guarantor");
        setIsGuarantorAssetEdit(false);
        break;
      case "edit guarantor al":
        handleEditAL();
        break;
      case "guarantor al wizard": {
        handleAddNewAssetsAndLiablity("guarantor wizard");
        break;
      }
      case "guarantor reo": 
        setIsGuarantorAssetEdit(false);
        handleAddNewReoSchedule("guarantor");
        break;
      case "guarantor reo wizard": {
        setIsGuarantorAssetEdit(false);
        handleAddNewReoSchedule("guarantor wizard");
        break;
      }
      case "edit guarantor reo wizard": {
        handleEditReo();
        break;
      }
      default:
        createErrorResponse("Warning", "Modal type " + type + " does not exist");
        break;
    }
  };

  const handleBrokerModalHeader = (modal, subModal) => {
    return (
      <Breadcrumb size={"huge"}>
        {!subModal && <Breadcrumb.Section className="primary-breadcrumb" active>{modal}</Breadcrumb.Section>}
        {subModal && <React.Fragment>
          <Breadcrumb.Section className="primary-breadcrumb" 
            link 
            onClick={() => setModalType(modal === "New Borrower Entity" ? "new organization": "new guarantor")}
          >
            {modal}
          </Breadcrumb.Section>
          <Breadcrumb.Divider icon='right chevron' />
        </React.Fragment>}
        {subModal && <Breadcrumb.Section active>{subModal}</Breadcrumb.Section>}
      </Breadcrumb>
    );
  };

  const handleBrokerModal = (type) => {
    const brokerModal = [] as any;
    if (type === "group plan") {
      brokerModal.header = <div>Group Plans</div>;
      brokerModal.content = <Form className="primary-form">
        <Grid>
          <Grid.Row className="application-row">
            <Grid.Column width={16}>
              <BCFormInput 
                labelClass="gmr-background-label"
                type="dropdown"
                placeholder="Please Select"
                obj={startAppObject}
                field="groupPlan"
                dropdownOptions={getDropdownOptions(Array.from(startAppObject.unitPlans as any[], x => x.name))}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>;
      brokerModal.actions = <Button 
        className="bp-button" 
        style={backgroundColorStyle}
        fluid 
        onClick={() => handleModalSubmit("group plan")}
      >
      <div className="gmr-button-container">
        <div className="gmr-button-text">Assign Group Plan</div>
      </div>
    </Button>;
    }
    else if (type === "new builder") {
      brokerModal.header = <div>New Builder</div>;
      brokerModal.content = <Form className="primary-form">
        <Grid>
          <Grid.Row className="application-row">
            <Grid.Column width={isGreaterThanMobile ? 10 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                inputKey="budget-newbuilder"
                type="input"
                label="Organization Name"
                placeholder="Construction Loan Services II, LLC"
                obj={newBuilder}
                field="organizationName"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newBuilder, setNewBuilder, GlobalConstants.InputTypes.ORGANIZATION, undefined, 50)}
                required
              />
              <BCValidationMessage invalidProps={invalidProps} prop="organizationName" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 6 : 16}>
              <BCFormInput 
                labelClass="gmr-background-label"
                inputKey="budget-newbuilder"
                type="dropdown"
                label="Type"
                placeholder="Please Select"
                obj={newBuilder}
                field="entitySubType"
                dropdownOptions={getDropdownOptions(applicationMetadata.entitySubTypes, ["id"], "name")}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newBuilder, setNewBuilder)}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                label="Address"
                inputKey="budget-newbuilder"
                labelClass="gmr-background-label"
                type={GlobalConstants.FormInputTypes.PLACES}
                placeDetailsObject={newBuilder}
                setPlaceDetailsObject={setNewBuilder}
                placeholder="1234 Main Street, Seattle, WA 98052, USA"
                defaultValue={handleAddressValue({
                  address: newBuilder.address,
                  city: newBuilder.city,
                  state: newBuilder.state,
                  zip: newBuilder.zip
                })}
                placeFields={["address", "city", "state", "county", "zip"]}
                placeFieldsNameOverrides={[
                  {
                    addressComponent: "address",
                    field: "physicalStreet"
                  },
                  {
                    addressComponent: "city",
                    field: "physicalCity"
                  },
                  {
                    addressComponent: "state",
                    field: "physicalState"
                  },
                  {
                    addressComponent: "county",
                    field: "physicalCounty"
                  },
                  {
                    addressComponent: "zip",
                    field: "physicalZip"
                  },
                ]}
                required
              />
              {invalidProps.includes("physicalCity") ? <BCValidationMessage 
                invalidProps={invalidProps} 
                prop="physicalCity" 
                propText="This city is invalid." 
              /> : invalidProps.includes("physicalState") ? <BCValidationMessage 
                invalidProps={invalidProps} 
                prop="physicalState"
                propText="This state is invalid."
              /> : invalidProps.includes("physicalZip") ? <BCValidationMessage 
                invalidProps={invalidProps} 
                prop="physicalZip"
                propText="This zip code is invalid."
              /> : invalidProps.includes("physicalCounty") ? <BCValidationMessage 
                invalidProps={invalidProps} 
                prop="physicalCounty"
                propText="This county is invalid."
              /> : <BCValidationMessage 
                invalidProps={invalidProps} 
                prop="physicalStreet" 
                propText={ErrorMessages.Address} />
              }
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="budget-newbuilder"
                label="Address Line 2"
                placeholder="Apartment, suite, unit, building, floor, etc."
                obj={newBuilder}
                field="addressLine2"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newBuilder, setNewBuilder)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="application-row">
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="budget-newbuilder"
                label="EIN/TIN"
                placeholder="474996817"
                obj={newBuilder}
                field="eintin"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newBuilder, setNewBuilder, GlobalConstants.InputTypes.EIN)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="eintin" propText={"EIN/TIN must be greater than 9 numbers"}/>
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="budget-newbuilder"
                label="Website"
                placeholder="https://serviceyourloan.com"
                obj={newBuilder}
                field="website"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newBuilder, setNewBuilder)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>;
      brokerModal.actions = <Button 
        className="bp-button"
        style={backgroundColorStyle}
        fluid
        disabled={isModalSubmitted}
        onClick={() => handleModalSubmit("builder")}>
        <div className="gmr-button-container">
          <div className="gmr-button-text">{isModalSubmitted ? <Loader active inline="centered" size={"tiny"} /> : "Add Builder"}</div>
        </div>
      </Button>;
    }
    else if (type === "new guarantor" || type === "edit guarantor") {
      brokerModal.header = <div>New Guarantor</div>;
      brokerModal.content = <Form className="primary-form">
        <Grid>
          <Grid.Row className="application-row">
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="First Name"
                placeholder="John"
                obj={newGuarantor}
                field="firstName"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.STRING, undefined, 25)}
                required
              />
              <BCValidationMessage invalidProps={invalidProps} prop="firstName" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Last Name"
                placeholder="Smith"
                obj={newGuarantor}
                field="lastName"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.STRING, undefined, 25)}
                required
              />
              <BCValidationMessage invalidProps={invalidProps} prop="lastName" />
            </Grid.Column>  
          </Grid.Row>
          <Grid.Row className="application-row">
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Email"
                placeholder="john.smith@gmail.com"
                obj={newGuarantor}
                field="email"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 100)}
                required
                disabled
              />
              <BCValidationMessage invalidProps={invalidProps} prop="email" />
              <BCValidationMessage 
                invalidProps={invalidProps} 
                prop="custom-guarantor-invalid-email"
                propText="This email is invalid.."
              />
              <BCValidationMessage
                invalidProps={invalidProps} 
                prop="custom-guarantor-email"
                propText="You have already added a guarantor with this email."
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Mobile Phone"
                placeholder="2061234567"
                obj={newGuarantor}
                field="mobilePhone"
                fieldType="phone"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.MASKED)}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput 
                labelClass="gmr-background-label"
                type="checkbox"
                checkboxText="Mailing Same As Physical"
                obj={newGuarantor}
                field="isMailingSameAsPhysical"
                value={newGuarantor.isMailingSameAsPhysical}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                label="Address"
                inputKey="guarantor"
                labelClass="gmr-background-label"
                type={GlobalConstants.FormInputTypes.PLACES}
                placeDetailsObject={newGuarantor}
                setPlaceDetailsObject={setNewGuarantor}
                placeholder="1234 Main Street, Seattle, WA 98052, USA"
                defaultValue={handleAddressValue({
                  address: newGuarantor.physicalAddress,
                  city: newGuarantor.physicalCity,
                  state: newGuarantor.physicalState,
                  zip: newGuarantor.physicalZip
                })}
                placeFields={["address", "city", "state", "county", "zip"]}
                placeFieldsNameOverrides={[
                  {
                    addressComponent: "address",
                    field: "physicalAddress"
                  },
                  {
                    addressComponent: "city",
                    field: "physicalCity"
                  },
                  {
                    addressComponent: "state",
                    field: "physicalState"
                  },
                  {
                    addressComponent: "county",
                    field: "physicalCounty"
                  },
                  {
                    addressComponent: "zip",
                    field: "physicalZip"
                  },
                ]}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Address Line 2"
                placeholder="Apartment, suite, unit, building, floor, etc."
                obj={newGuarantor}
                field="physicalAddressLine2"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
          </Grid.Row>
          {newGuarantor.isMailingSameAsPhysical === false && <React.Fragment>
            <Grid.Row className="application-row">
              <Grid.Column width={16}>
                <BCFormInput
                  label="Address"
                  inputKey="guarantor"
                  labelClass="gmr-background-label"
                  type={GlobalConstants.FormInputTypes.PLACES}
                  placeDetailsObject={newGuarantor}
                  setPlaceDetailsObject={setNewGuarantor}
                  placeholder="1234 Main Street, Seattle, WA 98052, USA"
                  defaultValue={handleAddressValue({
                    address: newGuarantor.mailingAddress,
                    city: newGuarantor.mailingCity,
                    state: newGuarantor.mailingState,
                    zip: newGuarantor.mailingZip
                  })}
                  placeFields={["address", "city", "state", "county", "zip"]}
                  placeFieldsNameOverrides={[
                    {
                      addressComponent: "address",
                      field: "mailingAddress"
                    },
                    {
                      addressComponent: "city",
                      field: "mailingCity"
                    },
                    {
                      addressComponent: "state",
                      field: "mailingState"
                    },
                    {
                      addressComponent: "county",
                      field: "mailingCounty"
                    },
                    {
                      addressComponent: "zip",
                      field: "mailingZip"
                    },
                  ]}
                />
              </Grid.Column>
              <Grid.Column width={16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="input"
                  inputKey="guarantor"
                  label="Address Line 2"
                  placeholder="Apartment, suite, unit, building, floor, etc."
                  obj={newGuarantor}
                  field="mailingAddressLine2"
                  inputType="text"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
                />
              </Grid.Column>
            </Grid.Row>
          </React.Fragment>}
          <Grid.Row className="application-row">
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Home Phone"
                placeholder="2061234567"
                obj={newGuarantor}
                field="homePhone"
                fieldType="phone"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.MASKED)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Business Phone"
                placeholder="2061234567"
                obj={newGuarantor}
                field="businessPhone"
                fieldType="phone"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.MASKED)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 4 : 8}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Extension"
                placeholder="3"
                obj={newGuarantor}
                field="extension"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>;
      brokerModal.actions = <React.Fragment>{handleModalPrevNext(undefined, "guarantor additional", true)}</React.Fragment>;
    }
    else if (type === "guarantor additional") {
      brokerModal.header = <div>{handleBrokerModalHeader("New Guarantor", "Additonal Information")}</div>;
      brokerModal.content = <Form className="primary-form">
        <Grid>
          <Grid.Row className="application-row">
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              {newGuarantor.socialSecurityDisplay && isSocialSecurityEdit === false ? <BCFormInput
                inputKey="guarantor"
                labelClass="gmr-background-label"
                type="input"
                actionLabel="Social Security Number"
                actionLabelClass="sub-action-label"
                actionText="Update"
                labelAction={() => setIsSocialSecurityEdit(true)}
                obj={newGuarantor}
                field="socialSecurityDisplay"
                fieldType="socialSecurityHidden"
                disabled
                setColor={wlColorStyle}
              /> :
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                actionLabel="Social Security Number"
                actionLabelClass="sub-action-label"
                actionText="Cancel"
                labelAction={() => handleSocialSecurityUndo()}
                placeholder="123-45-6789"
                obj={newGuarantor}
                field="socialSecurityNumber"
                fieldType="socialSecurity"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.MASKED)}
                setColor={wlColorStyle}
              />}
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Credit Score"
                placeholder="600"
                obj={newGuarantor}
                field="estimatedCreditScore"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.CREDIT)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="application-row" columns={isGreaterThanMobile ? 3 : 1}>
            <Grid.Column>
              {newGuarantor.isDateOfBirthEdit ? <BCFormInput 
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                actionLabel="Date Of Birth"
                actionLabelClass="sub-action-label"
                actionText="Update"
                labelAction={() => handleDateOfBirthHidden(true)}
                obj={newGuarantor}
                fieldType="hidden"
                disabled
                setColor={wlColorStyle}
              /> : newGuarantor.isDateOfBirthEdit === false ? <BCFormInput 
                labelClass="gmr-background-label"
                inputKey="guarantor"
                type="calendar"
                actionLabel="Date Of Birth"
                actionLabelClass="sub-action-label"
                actionText="Cancel"
                labelAction={() => handleDateOfBirthHidden(false)}
                obj={newGuarantor}
                field="dateOfBirth"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
                setColor={wlColorStyle}
              /> : <BCFormInput 
                labelClass="gmr-background-label"
                inputKey="guarantor"
                type="calendar"
                label="Date Of Birth"
                obj={newGuarantor}
                field="dateOfBirth"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />}
            </Grid.Column>
            <Grid.Column>
              <BCFormInput 
                labelClass="gmr-background-label"
                type="dropdown" 
                inputKey="guarantor"
                label="Marital Status"
                obj={newGuarantor}
                field="maritalStatus"
                dropdownOptions={getDropdownOptions(applicationMetadata.maritalStatuses, ["id"], "name")}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
            <Grid.Column>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Spouse Name"
                placeholder="Jane Doe"
                obj={newGuarantor}
                field="spouseName"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="application-row">
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="checkbox"
                inputKey="guarantor"
                checkboxText="Self Employed"
                obj={newReoSchedule}
                field="isSelfEmployed"
                value={newGuarantor.isSelfEmployed}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Employer Name"
                placeholder="Construction Loan Services II, LLC"
                obj={newGuarantor}
                field="employerName"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 200)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Position"
                placeholder="Owner"
                obj={newGuarantor}
                field="position"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 50)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Gross Revenue (Two Year Average)"
                placeholder="$100,000"
                obj={newGuarantor}
                field="grossRevenue"
                fieldType="dollar"
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.DOLLAR)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Net Income (Two Year Average)"
                placeholder="$100,000"
                obj={newGuarantor}
                field="netIncome"
                fieldType="dollar"
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.DOLLAR)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="application-row" columns={isGreaterThanMobile ? 3 : 1}>
            <Grid.Column>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Years In Industry"
                inputKey="guarantor"
                placeholder="3"
                obj={newGuarantor}
                field="yearsInIndustry"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.INT)}
              />
            </Grid.Column>
            <Grid.Column>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Years In Job"
                placeholder="3"
                obj={newGuarantor}
                field="yearsInJob"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.INT)}
              />
            </Grid.Column>
            <Grid.Column>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Years In Business"
                placeholder="3"
                obj={newGuarantor}
                field="yearsInBusiness"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.INT)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={isGreaterThanMobile ? 6 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="checkbox"
                inputKey="guarantor"
                checkboxText="US Citizen"
                obj={newReoSchedule}
                field="isUSCitizen"
                value={newGuarantor.isUSCitizen}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 10 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Status"
                obj={newGuarantor}
                field="citizenStatus"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 255)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 6 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="checkbox"
                inputKey="guarantor"
                checkboxText="Pending Legal Action"
                obj={newReoSchedule}
                field="isPendingLegalAction"
                value={newGuarantor.isPendingLegalAction}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 10 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Legal Action Description"
                obj={newGuarantor}
                field="legalActionDescription"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 1000)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 6 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="checkbox"
                inputKey="guarantor"
                checkboxText="Is Foreclosure Initiated"
                obj={newReoSchedule}
                field="isForeclosureInitiated"
                value={newGuarantor.isForeclosureInitiated}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 10 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Foreclosure Description"
                obj={newGuarantor}
                field="forclosureDescription"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 1000)}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey="guarantor"
                label="Any other names in which you've been granted credit?"
                obj={newGuarantor}
                field="otherCreditNames"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>;
      brokerModal.actions = <React.Fragment>{handleModalPrevNext("new guarantor", "guarantor wizard assets", true)}</React.Fragment>;
    }
    else if (type === "guarantor wizard assets") {
      brokerModal.header = <div>{handleBrokerModalHeader("New Guarantor", "Assets")}</div>;
      brokerModal.content = <Form className="primary-form">
        <Grid>
          {handleAlForm("guarantor wizard", "Asset")}
        </Grid>
      </Form>;
      brokerModal.actions = <React.Fragment>{handleModalPrevNext("guarantor additional", "guarantor wizard liabilites", true)}</React.Fragment>;
    }
    else if (type === "guarantor wizard liabilites") {
      brokerModal.header = <div>{handleBrokerModalHeader("New Guarantor", "Liabilities")}</div>;
      brokerModal.content = <Form className="primary-form">
        <Grid>
          {handleAlForm("guarantor wizard", "Liability")}
        </Grid>
      </Form>;
      brokerModal.actions = <React.Fragment>{handleModalPrevNext("guarantor wizard assets", "guarantor wizard reo", true)}</React.Fragment>;
    }
    else if (type === "guarantor wizard reo") {
      brokerModal.header = <div>{handleBrokerModalHeader("New Guarantor", "REO Schedule")}</div>;
      brokerModal.content = <Form className="primary-form">
        <Grid>
          {handleReoForm("guarantor reo")}
        </Grid>
      </Form>;
      brokerModal.actions = <Grid>
        <Grid.Row columns={3}>
          <Grid.Column>
            <Button
              fluid 
              onClick={() => handleModal("guarantor wizard liabilites", true)}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Previous</div>
              </div>
            </Button>
          </Grid.Column>
          <Grid.Column>
            <Button
              fluid 
              onClick={() => handleGuarantorModalCancel()}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Cancel</div>
              </div>
            </Button>
          </Grid.Column>
          <Grid.Column>
            <Button 
              className="bp-button" 
              style={backgroundColorStyle}
              fluid
              disabled={isModalSubmitted}
              onClick={() => handleGuarantorModalSubmit()}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">{isModalSubmitted ? <Loader active inline="centered" size={"tiny"} /> : "Save Guarantor"}</div>
              </div>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>;
    }
    else if (type === "borrower entity al" || type === "guarantor al") {
      brokerModal.header = <div>{alType === "Asset" ? "Add Asset" : "Add Liability"}</div>;
      brokerModal.content = <Form className="primary-form">
        <Grid>
          {handleAlForm((type === "guarantor al" ? "guarantor" : alType === "Asset" ? "borrower asset" : "borrower liability"), alType)}
        </Grid>
      </Form>;
      brokerModal.actions = <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <Button
              fluid
              onClick={() => handleModalClose()}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Close</div>
              </div>
            </Button>
          </Grid.Column>
          <Grid.Column width={8}>
            <Button 
              className="bp-button" 
              fluid
              onClick={() => isGuarantorAssetEdit ? handleModalSubmit("edit guarantor al") : handleModalSubmit(type)}
              style={isWhiteLabeled(permissions) ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Add</div>
              </div>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>;
    }
    else if (type === "borrower entity reo" || type === "guarantor reo") {
      brokerModal.header = <div>Add Real Estate Owned</div>;
      brokerModal.content = <Form className="primary-form">
        <Grid>
          {type === "borrower entity reo" ? handleReoForm("borrower entity") : handleReoForm("guarantor reo wizard")}
        </Grid>
      </Form>;
      brokerModal.actions = <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <Button
              fluid
              onClick={() => handleModalClose()}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Close</div>
              </div>
            </Button>
          </Grid.Column>
          <Grid.Column width={8}>
            <Button 
              className="bp-button"
              fluid
              onClick={() => isGuarantorAssetEdit ? handleModalSubmit("edit guarantor reo wizard") : handleModalSubmit(type)}
              style={isWhiteLabeled(permissions) ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Add</div>
              </div>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>;
    }

    return brokerModal;
  };

  const handleSave = async () => {
    const stepId = currentStepId;
    let isApiSuccess = true;
    if (stepId === ProjectSteps.ProjectOverview.id) {
      const notValidProps = await handleProjectNameValidation();
      if (notValidProps.length > 0) {
        isApiSuccess = false;
        setTimeout(() => { 
          setInvalidProps(notValidProps);
        }, 50);
      }
    }
    else if ([EntitySteps.AdditionalInformation.id, EntitySteps.Assets.id, EntitySteps.Liabilities.id, EntitySteps.RealEstateOwned.id].indexOf(stepId) > -1) {
      if (!newBorrowerEntity.id) {
        newBorrowerEntity.id = guid();
        setNewBorrowerEntity({...newBorrowerEntity});
      }

      const notValidProps = validateObj(newBorrowerEntity, ["name", "entitySubTypeId", "physicalStreet", "physicalCityName", "physicalStateName", "physicalZipCode"]);
      if (notValidProps.length === 0) {
        isApiSuccess = await handleUpsertBorrowerEntityAsync(newBorrowerEntity);
      }
    }
    else if (stepId === PropertySteps.NumberOfProperties.id) {
      if (startAppObject.properties && (startAppObject.properties.length < startAppObject.numberOfProperties)) {
        for(let i = startAppObject.properties.length; i < startAppObject.numberOfProperties; i++) {
          const newProperty = {
            id: guid(),
            city: startAppObject.city,
            state: startAppObject.state,
            county: startAppObject.county,
            zip: startAppObject.zip,
            existingStructurePropertyTypeId: startAppObject.existingStructurePropertyTypeId,
            newStructurePropertyTypeId: (startAppObject.loanProgramId && [GlobalConstants.LoanProgramIds.BRIDGE, GlobalConstants.LoanProgramIds.FIX_AND_FLIP].indexOf(startAppObject.loanProgramId) > -1) ?
                startAppObject.existingStructurePropertyTypeId : startAppObject.newStructurePropertyTypeId,
              numberOfUnits: startAppObject.numberOfUnits || 1,
              workStageId: startAppObject.workStageId,
              zoning: startAppObject.zoning,
          };

          startAppObject.properties = startAppObject.properties.concat(newProperty);
        }
      }
      else if (startAppObject.properties && (startAppObject.properties.length > startAppObject.numberOfProperties)) {
        const deleteProperties = startAppObject.properties.slice(startAppObject.numberOfProperties);
        await handleDeletePropertiesAndUnitsAsync(Array.from(deleteProperties as any[], x => x.id));
      }
    }
    else if (stepId === PropertySteps.Properties.id) {
      let isPropertiesAddressInvalid = false;
      const notValidProps = handleNestedValidation("properties", ["address"]);
      if (notValidProps.length === 0) {
        const propertyArray = Array.from(startAppObject.properties as any[], x => x.address);
        if (hasDuplicates(propertyArray)) {
          isPropertiesAddressInvalid = true;
        }
      }
      else {
        isPropertiesAddressInvalid = true;
      }

      if (isPropertiesAddressInvalid) {
        delete startAppObject.properties;
        setStartAppObject({...startAppObject});
      }
    }
    else if (stepId === GuarantorSteps.BorrowerGuarantor.id) {
      if (isApplicationBorrower(permissions, "BorrowerWhiteLabeledApplication", "read", startAppObject.borrowerContactOrganizationContactId, organizationContactId) && startAppObject.invitedGuarantors && startAppObject.invitedGuarantors.length > 0) {
        isApiSuccess = await handleAddBorrowerGuarantorsAsync();
      }
    }
    else if ([GuarantorSteps.AdditionalInformation.id, GuarantorSteps.CreditScore.id, GuarantorSteps.Assets.id, GuarantorSteps.Liabilities.id, GuarantorSteps.RealEstateOwned.id, GuarantorSteps.Disclosure.id].indexOf(stepId) > -1) {
      const isBorrowerGuarantor = isApplicationBorrower(permissions, "BorrowerWhiteLabeledApplication", "read", startAppObject.borrowerContactOrganizationContactId, organizationContactId) && startAppObject.isProjectGuarantor;
      if (isApplicationGuarantor(permissions, "GuarantorWhiteLabeledApplication", "read", startAppObject.guarantors ? startAppObject.guarantors : [], organizationContactId) || isBorrowerGuarantor) {
        setIsLoading(true);
        const notValidProps = validateObj(newGuarantor, ["firstName", "lastName", "email"]);
        if (notValidProps.length === 0) {
          isApiSuccess = await handleUpsertGuarantorAsync(newGuarantor);
        }
      }
    }

    if (isApiSuccess) {
      await handleSaveApplication();
    }
    
    setIsLoading(false);
    return isApiSuccess;
  };

  const handleSaveAndClose = async () => {
    const isApiSuccess = await handleSave();
    if (isApiSuccess) {
      handleRouteToHome();
    }
  };

  const handleNotifyLoanOfficer = async () => {
    setIsLoading(true);
    const loanOfficerEmailObj = {
      borrowerApplicationId: applicationId,
      loanOfficerOrganizationContactId: startAppObject.loanOfficerOrganizationContactId
    };

    const isApiSuccess = await notifyLoanOfficerAsync(loanOfficerEmailObj);
    if (isApiSuccess) {
      await handleSave();
      setSuccessMessage("Your Loan Officer has been notified and will reach out to you to discuss pricing.");
      setTimeout(() => { 
        setSuccessMessage("");
      }, 5000);
    }
    
    setIsLoanOfficerMessage(false);
    setIsLoading(false);
  };

  const handleSendApplication = async () => {
    const sendObj = {
      borrowerApplicationId: guid(),
      firstName: startAppObject.firstName,
      lastName: startAppObject.lastName,
      email: startAppObject.email,
      name: startAppObject.name,
      loanProgramId: startAppObject.loanProgramId,
      cityName: startAppObject.city,
      stateName: startAppObject.state,
      countyName: startAppObject.county,
      zip: startAppObject.zip,
      brokerFeeRate: startAppObject.brokerFeeRate,
      wlbrokerFeeRate: startAppObject.wlbrokerFeeRate
    };

    setInvalidProps([]);
    let notValidProps = validateObj(sendObj, ["firstName", "lastName", "email", "name", "loanProgramId", "cityName", "stateName", "zip", "brokerFeeRate", "wlbrokerFeeRate"]);
    notValidProps = notValidProps.concat(validateEmails(sendObj, ["email"]));
    if (notValidProps.length === 0) {
      setIsLoading(true);
      const isSendApplicationSuccess = await handleSendApplicationAsync(sendObj);
      if (isSendApplicationSuccess) {
        setCurrentStepId(SummarySteps.Confirmation.id);
        setCurrentProgress(100);
      }

      setIsLoading(false);
    }
    else {
      setTimeout(() => {
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handlePatchProjectProperties = (patchObj, publishObject, patchProps) => {
    for (const [key, value] of Object.entries(publishObject)) {
      if (patchProps.includes(key)) {
        patchObj[key] = value;
      }
    }

    return patchObj;
  };

  const handleSaveApplication = async () => {
    let isApiSuccess = true;
    const convertedStartAppObject = convertToPublishObj();
    const propertyEditStepIds = [...Array.from(Object.values(PropertySteps), x => x.id), ProjectSteps.ProjectStructure.id, ProjectSteps.PermitStatus.id];
    let patchObj = handlePatchProjectProperties({}, convertedStartAppObject, ["id"]);
    if (!getIsWhiteLabeled() || currentStepId === GuarantorSteps.Disclosure.id) {
      patchObj = handlePatchProjectProperties(patchObj, convertedStartAppObject, ["screenStatus"]);
    }

    let propertyObj = {};
    let isCreateApplication = false;
    let isDoInsert = false;
    const foundApplicationStep = ApplicationSteps.find(x => x.id === currentStepId);
    if (PropertySteps.Plans.id === currentStepId && convertedStartAppObject.borrowerApplicationPlans &&
      convertedStartAppObject.borrowerApplicationPlans.length > 0 && startAppObject.hasPlansChanged) {
      initialStartAppObject.unitPlans = (initialStartAppObject.unitPlans && initialStartAppObject.unitPlans[0] && initialStartAppObject.unitPlans[0].name) ? initialStartAppObject.unitPlans : [];
      let unsavedPlans = deepCopy(convertedStartAppObject.borrowerApplicationPlans);
      unsavedPlans = unsavedPlans.filter(x => !Array.from(initialStartAppObject.unitPlans as any[], y => y.id).includes(x.id));
      isDoInsert = unsavedPlans.length > 0 ? true : false;
      isApiSuccess = await handlePatchPlansAsync(convertedStartAppObject.borrowerApplicationPlans, isDoInsert);
      if (isApiSuccess) {
        startAppObject.hasPlansChanged = false;
        if (isDoInsert) {
          initialStartAppObject.unitPlans = deepCopy(startAppObject.unitPlans);
          setInitialStartAppObject({...initialStartAppObject});
        }
      }
    }

    if (propertyEditStepIds.includes(currentStepId) && convertedStartAppObject.borrowerApplicationProperties && 
      convertedStartAppObject.borrowerApplicationProperties.length > 0 && startAppObject.hasPropertiesChanged) {
      initialStartAppObject.properties = initialStartAppObject.properties ? initialStartAppObject.properties : [];
      let unsavedProperties = deepCopy(convertedStartAppObject.borrowerApplicationProperties);
      unsavedProperties = unsavedProperties.filter(x => !Array.from(initialStartAppObject.properties as any[], y => y.id).includes(x.id));
      isDoInsert = unsavedProperties.length > 0 ? true : false;
      if (!isDoInsert) {
        for (let i=0; i<convertedStartAppObject.borrowerApplicationProperties.length; i++) {
          const borrowerApplicationProperty = convertedStartAppObject.borrowerApplicationProperties[i];
          const foundInitialProperty = initialStartAppObject.properties.find(x => x.id === borrowerApplicationProperty.id);
          if (foundInitialProperty) {
            foundInitialProperty.units = foundInitialProperty.units ? foundInitialProperty.units : [];
            let unsavedUnits = deepCopy(borrowerApplicationProperty.borrowerApplicationPropertyUnits);
            unsavedUnits = unsavedUnits.filter(x => !Array.from(foundInitialProperty.units as any[], y => y.id).includes(x.id));
            if (unsavedUnits.length > 0) {
              isDoInsert = true;
              break;
            }
          }
        }
      }

      propertyObj = { borrowerApplicationProperties: convertedStartAppObject.borrowerApplicationProperties };      
      isApiSuccess = await handlePatchPropertiesAsync(propertyObj, isDoInsert);
      if (isApiSuccess) {
        startAppObject.hasPropertiesChanged = false;
        if (isDoInsert) {
          initialStartAppObject.properties = deepCopy(startAppObject.properties);
          setInitialStartAppObject({...initialStartAppObject});
        }
      }
    }
    if (BudgetSteps.PaidCosts.id === currentStepId && convertedStartAppObject.borrowerApplicationCostPaids && 
      convertedStartAppObject.borrowerApplicationCostPaids.length > 0 && startAppObject.hasCostPaidsChanged) {
      initialStartAppObject.gmrCostPaids = initialStartAppObject.gmrCostPaids ? initialStartAppObject.gmrCostPaids : [];
      let unsavedCostPaids = deepCopy(convertedStartAppObject.borrowerApplicationCostPaids);
      unsavedCostPaids = unsavedCostPaids.filter(x => !Array.from(initialStartAppObject.gmrCostPaids as any[], y => y.id).includes(x.id));
      isDoInsert = unsavedCostPaids.length > 0 ? true : false;
      isApiSuccess = await handlePatchCostsPaidAsync(applicationId, convertedStartAppObject.borrowerApplicationCostPaids, isDoInsert);
      if (isApiSuccess && isDoInsert) {
        startAppObject.hasCostPaidsChanged = false;
        if (isDoInsert) {
          initialStartAppObject.gmrCostPaids = deepCopy(startAppObject.gmrCostPaids);
          setInitialStartAppObject({...initialStartAppObject});
        }
      }
    }

    if (foundApplicationStep && foundApplicationStep.patchProps) {
      patchObj = handlePatchProjectProperties(patchObj, convertedStartAppObject, foundApplicationStep.patchProps);
    }

    const isNewApplicationScreen = [ProjectSteps.BrokerWelcome.id, ProjectSteps.ProjectOverview.id].indexOf(currentStepId) > -1 && isApplicationNewRef.current;
    if (isNewApplicationScreen) {
      isCreateApplication = true;
      patchObj = handlePatchProjectProperties(patchObj, convertedStartAppObject, ["persona", "channel", "brokerOrganizationContactId", "regionId"]);
    }
    else if (ProjectSteps.BrokerWelcome.id === currentStepId && !isApplicationNewRef.current) {
      patchObj = handlePatchProjectProperties(patchObj, convertedStartAppObject, ["borrowerOrganizationId"]);
    }
    
    if (currentStepId === PropertySteps.NumberOfProperties.id && startAppObject.uploadOptionLookupId) {
      if (startAppObject.uploadOptionLookupId === GlobalConstants.UploadOptions.UPLOAD && !isPropertyUnitMixUploaded) {
        delete patchObj.uploadOptionLookupId;
      }

      if (initialStartAppObject.uploadOptionLookupId === GlobalConstants.UploadOptions.FILL_OUT && startAppObject.uploadOptionLookupId === GlobalConstants.UploadOptions.UPLOAD && isPropertyUnitMixUploaded === false) {
        patchObj.uploadOptionLookupId = null;
      }
    }

    if (isApiSuccess) {
      if (isPatchedFromGmr) {
        patchObj = handlePatchProjectProperties(patchObj, convertedStartAppObject, [
          "id", 
          "originatingGmrId", 
          "applicationGmrId",
          "name", 
          "loanProgramId",
          "zip",
          "cityName",
          "stateName",
          "countyName",
          "brokerFeeRate", 
          "wlbrokerFeeRate", 
          "newStructurePropertyTypeId",
          "existingStructurePropertyTypeId",
          "zoning",
          "originalPurchasePrice",
          "amountOwed",
          "requestedLoanTermInMonths",
          "subordinatedDebtAmount",
          "noOfProposedLots",
          "uploadOptionLookupId",
          "developmentBeginsAfterClosingInMonths",
          "timeFrameToDevelopInMonths",
          "afterRepairValue",
          "timeFrameToDevelopInMonths",
          "horizontalDevelopmentBudget",
          "sizeOfCurrentProperty",
          "sizeOfCurrentPropertyUnitOfMeasurementBorrowerApplicationInputId",
          "sizeOfProposedLotUnitOfMeasurementBorrowerApplicationInputId",
          "sizeOfProposedLot",
          "districtReimbursementsAvailableBorrowerApplicationInputId",
          "districtReimbursementsAvailableDescription",
          "bondingRequirementsBorrowerApplicationInputId",
          "bondingRequirementsDescription",
          "seasonalityConcernsBorrowerApplicationInputId",
          "seasonailtyConcernsDescription",
          "permitStatusId",
          "workStageId",
          "developmentOrVerticalPermitTimingInMonths",
          "purchaseRefinanceOptionLookupId",
          "howLongOwnedBorrowerApplicationInputId",
          "estimatePropertyValue",
          "useInterestReserveBorrowerApplicationInputId",
          "cashDown",
          "cashOutAmountRequested",
          "loanOfficerOrganizationContactId",
          "brokerOrganizationContactId",
          "payoffStrategyId",
          "budget",
          "builderOrganizationId",
          "whoWillDoConstructionBorrowerApplicationInputId",
          "payoffStrategyDescription",
          "requestedClosingDate",
          "projectComment",
          "borrowerOrganizationId",
          "hasCollateralPropertiesChanged",
          "cumulativeProjectExperience",
          "submittedOn"
        ]);
      }

      isApiSuccess = await handlePatchProjectAsync(patchObj, isCreateApplication);
      if (isApiSuccess && isCreateApplication) {
        isApiSuccess = await handlePatchPropertiesAsync({ borrowerApplicationProperties: convertedStartAppObject.borrowerApplicationProperties }, true);
        if (isApiSuccess) {
          if (isPatchedFromGmr) {
            if (convertedStartAppObject.borrowerApplicationCostPaids && convertedStartAppObject.borrowerApplicationCostPaids.length > 0) {
              await handlePatchCostsPaidAsync(applicationId, convertedStartAppObject.borrowerApplicationCostPaids, true);
            }
            
            setIsPatchedFromGmr(false);
          }
          
          startAppObject.hasPropertiesChanged = false;
          initialStartAppObject.properties = startAppObject.properties ? deepCopy(startAppObject.properties) : [];
          setInitialStartAppObject({...initialStartAppObject});
        }
      }
    }

    if (isApiSuccess && foundApplicationStep.patchProps && foundApplicationStep.patchProps.includes("brokerOrganizationContactId") && (isAdminBrmNwlOrLo || persona === Personas.WL_GUARANTOR)) {
      isApiSuccess = await handleCreateOrPatchBrokerEntity(convertedStartAppObject);
    }

    if (isApiSuccess) {
      if (isNewApplicationScreen && isGuarantorPersona) {
        await handleGetWhitelabeledGuarantorPersona(applicationId);
      }
      
      setStartAppObject({...startAppObject});
    }
    
    return isApiSuccess;
  };

  const handleCreateOrPatchBrokerEntity = async (convertedStartAppObject) => {
    let isApiSuccess = true;
    let borrowerApplicationEntities = await getBorrowerEntitiesAsync();
    if (!borrowerApplicationEntities) {
      borrowerApplicationEntities = [];
    }

    const foundEntity = borrowerApplicationEntities.find(x => x.roleOption === "Broker" && x.borrowerApplicationId === convertedStartAppObject.id);
    if (foundEntity && foundEntity.id) {
      isApiSuccess = await patchEntitiesAsync([{
        id: foundEntity.id,
        organizationContactId: convertedStartAppObject.brokerOrganizationContactId,
      }], false);
    }
    else {
      isApiSuccess = await patchEntitiesAsync([{
        id: guid(),
        roleOption: "Broker",
        organizationContactId: convertedStartAppObject.brokerOrganizationContactId,
        borrowerApplicationId: applicationId
      }], true);
    }

    return isApiSuccess;
  };

  const handleCreateOrPatchBorrowerEntity = async (convertedStartAppObject, borrowerObj) => {
    let isApiSuccess = true;
    let borrowerApplicationEntities = await getBorrowerEntitiesAsync();
    if (!borrowerApplicationEntities) {
      borrowerApplicationEntities = [];
    }

    const foundEntity = borrowerApplicationEntities.find(x => x.roleOption === "Borrower" && x.borrowerApplicationId === convertedStartAppObject.id);
    if (foundEntity && foundEntity.id && borrowerObj.id) {
      isApiSuccess = await patchEntitiesAsync([{
        id: foundEntity.id,
        organizationId: borrowerObj.id
      }], false);
    }
    else {
      if (borrowerObj) {
        isApiSuccess = await handleUpsertBorrowerEntityAsync(borrowerObj);
        setIsLoading(false);
      }
    }

    return isApiSuccess;
  };

  const handleCreateOrPatchGuarantor = async (guarantorOrganicationContactId, newGuarantorObj) => {
    let isApiSuccess = true;
    let borrowerApplicationEntities = await getBorrowerEntitiesAsync();
    if (!borrowerApplicationEntities) {
      borrowerApplicationEntities = [];
    }

    const foundEntity = borrowerApplicationEntities.find(x => x.organizationContactId === guarantorOrganicationContactId);
    const firstFoundSelectedBrokerGuarantor = selectedBrokerGuarantors.find(x => x.id === guarantorOrganicationContactId);
    const entityObj = {
      id: foundEntity ? foundEntity.id : guid(),
      borrowerApplicationId: applicationId,
      organizationContactId: guarantorOrganicationContactId,
      roleOption: "Guarantor",
      confirmationStatus: foundEntity ? foundEntity.confirmationStatus : "BrokerInitiated",
      accessLevelId: firstFoundSelectedBrokerGuarantor ? firstFoundSelectedBrokerGuarantor.accessLevelId : GlobalConstants.AccessLevelIds.FULL_EDIT,
      isActive: true
    } as any;

    if (foundEntity) {
      isApiSuccess = await patchEntitiesAsync([entityObj], false);
    }
    else {
      if (newGuarantorObj) {
        entityObj.firstName = newGuarantorObj.firstName;
        entityObj.lastName = newGuarantorObj.lastName;
        entityObj.email = newGuarantorObj.email;
        entityObj.borrowerOrganizationId = newGuarantorObj.borrowerOrganizationId;
      }
      
      isApiSuccess = await createBorrowerApplicationGuarantorsAsync([entityObj]);
    }

    return isApiSuccess;
  };

  const handleSubmitApplication = async (submittedOn) => {
    let isApiSuccess = true;
    const convertedStartAppObject = convertToPublishObj(submittedOn);
    if (SummarySteps.Summary.id === currentStepId) {
      const submitObj = {
        id: applicationId,
        name: convertedStartAppObject.name,
        screenStatus: convertedStartAppObject.screenStatus,
        borrowerOrganizationId: convertedStartAppObject.borrowerOrganizationId,
        guarantors: convertedStartAppObject.guarantors,
        submittedOn: convertedStartAppObject.submittedOn
      };

      isApiSuccess = await handleSubmitApplicationAsync(submitObj);
    }

    return isApiSuccess;
  };

  const convertBuilder = (builder) => {
    const publishBuilder = {
      id: builder.id ? builder.id : undefined,
      borrowerApplicationId: startAppObject.id,
      organizationName: builder.organizationName,
      entitySubTypeId: builder.entitySubType,
      physicalStreet: combineAddresses(builder.physicalStreet, builder.addressLine2),
      physicalZipCode: builder.physicalZip,
      physicalCityName: builder.physicalCity,
      physicalStateName: builder.physicalState,
      physicalCountyName: builder.physicalCounty,
      employerIdentificationNumber: builder.eintin,
      website: builder.website
    };

    FeatureFlags.IS_DEBUG && console.log(publishBuilder);
    return publishBuilder;
  };

  const convertAlandReo = (obj) => {
    const publishAssetsAndLiabilities = [] as any[];
    if (obj && obj.assetsAndLiabilities) {
      obj.assetsAndLiabilities.forEach(al => {
        let isLiabilityValid = false;
        if ((al.alOption === "Liability" && al.monthlyLiability) || al.alOption === "Asset") {
          isLiabilityValid = true;
        }

        if (al.id && al.alType && al.alOption && al.institutionName && al.currentBalance && isLiabilityValid) {
          const publishAssetOrLiability = {
            id: al.id ? al.id : undefined,
            "alclassName": al.alOption,
            "altypeId": al.alType,
            "institution": al.institutionName,
            "value": al.currentBalance,
            "monthlyLiability": al.monthlyLiability,
            "alstatusId": al.status
          };

          publishAssetsAndLiabilities.push(publishAssetOrLiability);
        }
      });
    }
    
    const publishReoSchedules = [] as any[];
    if (obj && obj.reoSchedules) {
      obj.reoSchedules.forEach(reoSchedule => {
        if (reoSchedule.id && reoSchedule.reoStatus && reoSchedule.street && reoSchedule.zip && reoSchedule.state && reoSchedule.city && reoSchedule.parcelNumber && reoSchedule.marketValue && reoSchedule.holder1) {
          const publishReoSchedule = {
            id: reoSchedule.id ? reoSchedule.id : undefined,
            "reotypeId": reoSchedule.reoType,
            "reostatusId": reoSchedule.reoStatus,
            "amountOwed": reoSchedule.amountOwed,
            "mortgageFree": reoSchedule.isMortgageFree,
            "street": combineAddresses(reoSchedule.street, reoSchedule.addressLine2),
            "zipCode": reoSchedule.zip,
            "stateName": reoSchedule.state,
            "cityName": reoSchedule.city,
            "countyName": reoSchedule.county,
            "parcelNumber": reoSchedule.parcelNumber,
            "marketValue": reoSchedule.marketValue,
            "monthlyTaxInsuranceAndMaintenance": reoSchedule.maintenance,
            "mortgage1AlscheduleName": reoSchedule.alSchedule1,
            "mortgage2ALScheduleName": reoSchedule.alSchedule2,
            "mortgage3ALScheduleName": reoSchedule.alSchedule3,
            "mortgageAmount1": reoSchedule.mortgageAmount1,
            "mortgageAmount2": reoSchedule.mortgageAmount2,
            "mortgageAmount3": reoSchedule.mortgageAmount3,
            "mortgagePayment1": reoSchedule.mortgagePayment1,
            "mortgagePayment2": reoSchedule.mortgagePayment2,
            "mortgagePayment3": reoSchedule.mortgagePayment3,
            "mortgageHolder1": reoSchedule.holder1,
            "mortgageHolder2": reoSchedule.holder2,
            "mortgageHolder3": reoSchedule.holder3,
            "description": reoSchedule.reoScheduleDescription,
            "additionalCollateral": reoSchedule.additionalCollateral
          };
  
          publishReoSchedules.push(publishReoSchedule);
        }
      });
    }

    return {
      publishAssetsAndLiabilities: publishAssetsAndLiabilities,
      publishReoSchedules:  publishReoSchedules
    };
  };

  const convertBorrowerEntity = (borrowerEntity) => {
    const alAndReoObj = convertAlandReo(borrowerEntity) as any;
    const publishBorrowerEntity = {
      id: borrowerEntity.id ? borrowerEntity.id : undefined,
      borrowerApplicationId: startAppObject.id,
      name: borrowerEntity.name,
      entitySubTypeId: borrowerEntity.entitySubTypeId,
      physicalStreet: combineAddresses(borrowerEntity.physicalStreet, borrowerEntity.addressLine2),
      physicalZipCode: borrowerEntity.physicalZipCode,
      physicalCityName: borrowerEntity.physicalCityName,
      physicalStateName: borrowerEntity.physicalStateName,
      physicalCountyName: borrowerEntity.physicalCountyName,
      mailingStreet: borrowerEntity.physicalStreet,
      mailingZipCode: borrowerEntity.physicalZipCode,
      mailingCityName: borrowerEntity.physicalCityName,
      mailingStateName: borrowerEntity.physicalStateName,
      mailingCountyName: borrowerEntity.physicalCountyName,
      employerIdentificationNumber: borrowerEntity.eintin,
      website: borrowerEntity.website,
      yearsInIndustry: borrowerEntity.yearsInBusiness,
      monthlyRevenue: borrowerEntity.grossRevenue,
      monthlyIncome: borrowerEntity.netIncome,
      alschedules: alAndReoObj && alAndReoObj.publishAssetsAndLiabilities,
      reoschedules : alAndReoObj && alAndReoObj.publishReoSchedules,
      hasALChanged: borrowerEntity.hasALChanged ? borrowerEntity.hasALChanged : false,
      hasReoChanged: borrowerEntity.hasReoChanged ? borrowerEntity.hasReoChanged : false
    };

    FeatureFlags.IS_DEBUG && console.log(publishBorrowerEntity);
    return publishBorrowerEntity;
  };

  const convertGuarantor = (guarantor) => {
    const alAndReoObj = convertAlandReo(guarantor) as any;
    const guarantorPhysicalStreet = combineAddresses(guarantor.physicalAddress, guarantor.physicalAddressLine2);
    const guarantorMailingStreet = combineAddresses(guarantor.mailingAddress, guarantor.mailingAddressLine2);
    let accessLevelId = guarantor.accessLevelId;
    if (getIsWhiteLabeled()) {
      if (isLimited) {
        accessLevelId = GlobalConstants.AccessLevelIds.LIMITED;
      }
      else if (isViewOnly) {
        accessLevelId = GlobalConstants.AccessLevelIds.VIEW_ONLY;
      }
      else {
        accessLevelId = GlobalConstants.AccessLevelIds.FULL_EDIT;
      }
    }

    const publishGuarantor = {
      id: guarantor.id ? guarantor.id : undefined,
      borrowerApplicationId: startAppObject.id,
      firstName: guarantor.firstName,
      lastName: guarantor.lastName,
      email: guarantor.email,
      mobilePhone: guarantor.mobilePhone,
      physicalStreet: guarantorPhysicalStreet,
      physicalZipCode: guarantor.physicalZip,
      physicalCityName: guarantor.physicalCity,
      physicalStateName: guarantor.physicalState,
      physicalCountyName: guarantor.physicalCounty,
      mailingStreet: guarantor.isMailingSameAsPhysical ? guarantorPhysicalStreet : guarantorMailingStreet,
      mailingZipCode: guarantor.isMailingSameAsPhysical ? guarantor.physicalZip : guarantor.mailingZip,
      mailingCityName: guarantor.isMailingSameAsPhysical ? guarantor.physicalCity : guarantor.mailingCity,
      mailingStateName: guarantor.isMailingSameAsPhysical ? guarantor.physicalState : guarantor.mailingState,
      mailingCountyName: guarantor.isMailingSameAsPhysical ? guarantor.physicalCounty : guarantor.mailingCounty,
      positionInCompany: guarantor.position,
      homePhone: guarantor.homePhone,
      officePhone: guarantor.businessPhone,
      officePhoneExtension: guarantor.extension,
      "socialSecurityNumber": guarantor.socialSecurityNumber,
      "creditScore": guarantor.creditScore,
      "estimatedCreditScore": guarantor.estimatedCreditScore,
      "isCreditScorePulled": isCreditScorePulled,
      "dateOfBirth": guarantor.dateOfBirth,
      "maritalStatusId": guarantor.maritalStatus,
      "spouseName": guarantor.spouseName,
      "selfEmployed": guarantor.isSelfEmployed,
      "employerName": guarantor.employerName,
      "employerPosition": guarantor.position,
      "monthlyIncome": guarantor.netIncome,
      "monthlyRevenue": guarantor.grossRevenue,
      "yearsInIndustry": guarantor.yearsInIndustry,
      "yearsInBusiness": guarantor.yearsInBusiness,
      "yearsInJob": guarantor.yearsInJob,
      "uscitizen": guarantor.isUSCitizen,
      "citizenshipStatus": guarantor.citizenStatus,
      "pendingLegalAction": guarantor.isPendingLegalAction,
      "legalActionDescription": guarantor.legalActionDescription,
      "isForeclosureInitiated": guarantor.isForeclosureInitiated,
      "foreclosureDescription": guarantor.forclosureDescription,
      "otherCreditName": guarantor.otherCreditNames,
      alschedules: alAndReoObj && alAndReoObj.publishAssetsAndLiabilities,
      reoschedules : alAndReoObj && alAndReoObj.publishReoSchedules,
      hasALChanged: guarantor.hasALChanged ? guarantor.hasALChanged : false,
      hasReoChanged: guarantor.hasReoChanged ? guarantor.hasReoChanged : false,
      accessLevelId: accessLevelId,
      submittedOn: guarantor.submittedOn
    };

    FeatureFlags.IS_DEBUG && console.log(publishGuarantor);
    return publishGuarantor;
  };

  const convertToPublishObj = (submittedOn: Date | undefined = undefined) => {
    const guarantorsToSend = [] as any[];
    if (isApplicationBorrower(permissions, "BorrowerWhiteLabeledApplication", "read", startAppObject.borrowerContactOrganizationContactId, organizationContactId)) {
      if (startAppObject.invitedGuarantors && startAppObject.invitedGuarantors.length > 0) {
        startAppObject.invitedGuarantors.forEach((invitedGuarantor) => {
          if (invitedGuarantor.id) {
            const guarantorToSendObj = {
              id: invitedGuarantor.id,
              email: invitedGuarantor.email
            };
            
            guarantorsToSend.push(guarantorToSendObj);
          }
        });
      }

      if (startAppObject.isProjectGuarantor === true) {
        const guarantorToSendObj = {
          id: organizationContactId,
          email: user.email
        };
  
        guarantorsToSend.push(guarantorToSendObj);
      }
    }
    else if (selectedBrokerGuarantors.length > 0) {
      selectedBrokerGuarantors.forEach((selectedBrokerGuarantor) => {
        if (selectedBrokerGuarantor && selectedBrokerGuarantor.id && selectedBrokerGuarantor.email) {
          const guarantorToSendObj = {
            id: selectedBrokerGuarantor.id,
            email: selectedBrokerGuarantor.email,
            firstName: selectedBrokerGuarantor.firstName,
            lastName: selectedBrokerGuarantor.lastName,
            accessLevelId: selectedBrokerGuarantor.accessLevelId
          };
          
          guarantorsToSend.push(guarantorToSendObj);
        }
      });
    }

    const publishProperties = [] as any[];
    if (startAppObject.properties) {
      startAppObject.properties.forEach((property, i) => {
        const publishUnits = [] as any[];
        if (property.units) {
          property.units.forEach((unit, j) => {
            let foundUnitPlan = undefined as any;
            if (startAppObject.unitPlans && startAppObject.unitPlans.length > 0) {
              foundUnitPlan = startAppObject.unitPlans.find(x => x.name === unit.plan && x.name && unit.plan);
            }

            const publishUnit = {
              id: unit.id ? unit.id : undefined,
              borrowerApplicationPropertyId: property.id,
              unitNumber: unit.unitNumber,
              buildTimeInMonths: unit.buildTimeInMonths,
              timeFrameToSellOrRefinanceInMonths: unit.timeFrameToSellOrRefinanceInMonths,
              monthOfFirstDraw: unit.monthOfFirstDraw,
              borrowerApplicationPlanId: foundUnitPlan ? foundUnitPlan.id : undefined,
              asIsValue: unit.currentValue,
              afterRepairValue: unit.completedValue,
              sortOrder: j,
              numberOfBedroom: unit.numberOfBedroom,
              numberOfBathroom: unit.numberOfBathroom,
              numberOfCarGarage: unit.numberOfCarGarage,
              squareFootage: unit.squareFootage,
            };

            publishUnits.push(publishUnit);
          });
        }

        if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && property.numberOfUnits && (property.units && property.units.length < property.numberOfUnits)) {
          for (let i = property.units.length; i < property.numberOfUnits; i++) {
            publishUnits.push({
              id: guid(),
              borrowerApplicationPropertyId: property.id,
              unitNumber: i + 1,
            });
          }
        }

        const publishProperty = {
          id: property.id ? property.id : undefined,
          borrowerApplicationId: startAppObject.id,
          street: property.address,
          zip: property.zip,
          cityName: property.city,
          stateName: property.state,
          countyName: property.county,
          parcelNumber: property.parcelNumber,
          lotNumber: property.lotNumber,
          zoning: property.zoning,
          existingStructurePropertyTypeId: property.existingStructurePropertyTypeId,
          newStructurePropertyTypeId: property.newStructurePropertyTypeId,
          buildTimeInMonths: property.buildTimeInMonths,
          timeFrameToSellOrRefinanceInMonths: property.timeFrameToSellOrRefinanceInMonths,
          monthOfFirstDraw: property.monthOfFirstDraw,
          workStageId: property.workStageId,
          collateralProperty: false,
          borrowerApplicationPropertyUnits: publishUnits,
          numberOfUnits: publishUnits && publishUnits.length,
          sortOrder: i
        };

        publishProperties.push(publishProperty);
      });
    }

    const publishPlans = [] as any[];
    if (startAppObject.unitPlans) {
      startAppObject.unitPlans.forEach(unitPlan => {
        if (unitPlan.name && unitPlan.numberOfBedroom !== undefined && unitPlan.numberOfBathroom !== undefined && unitPlan.numberOfCarGarage !== undefined && unitPlan.squareFootage !== undefined) {
          const publishPlanObj = {
            id: unitPlan.id && unitPlan.id,
            borrowerApplicationId: startAppObject.id,
            name: unitPlan.name,
            numberOfBedroom: unitPlan && unitPlan.numberOfBedroom,
            numberOfBathroom: unitPlan && unitPlan.numberOfBathroom,
            numberOfCarGarage: unitPlan && unitPlan.numberOfCarGarage,
            squareFootage: unitPlan && unitPlan.squareFootage
          };
  
          publishPlans.push(publishPlanObj);
        }
      });
    }

    const publishCollaterals = [] as any;
    if (startAppObject.additionalCollateral) {
      startAppObject.additionalCollateral.forEach((collateral, i) => {
        const collateralObj = {
          id: collateral.id ? collateral.id : undefined,
          borrowerApplicationId: startAppObject.id,
          street: combineAddresses(collateral.address, collateral.addressLine2),
          zip: collateral.zip,
          cityName: collateral.city,
          stateName: collateral.state,
          countyName: collateral.county,
          parcelNumber: collateral.parcelNumber,
          lotNumber: collateral.lotNumber,
          zoning: collateral.zoning,
          asIsValue: collateral.currentValue,
          collateralProperty: true,
          numberOfUnits: collateral.numberOfUnits,
          sortOrder: i
        };

        publishCollaterals.push(collateralObj);
      });
    }

    const publishGmrCostsPaids = [] as any;
    if (startAppObject.gmrCostPaids) {
      startAppObject.gmrCostPaids.forEach(gmrCostPaid => {
        const publishGmrCostsPaid = {
          id: gmrCostPaid.id ? gmrCostPaid.id : undefined,
          borrowerApplicationId: startAppObject.id,
          gmrprojectCostId : gmrCostPaid.costPaidId,
          amount: gmrCostPaid.amount,
          description: gmrCostPaid.description
        };

        publishGmrCostsPaids.push(publishGmrCostsPaid);
      });
    }
   
    let builderOrganizationId = startAppObject.generalContractorId; 
    const borrowerOrganizationId = (startAppObject.borrowerEntity && startAppObject.borrowerEntity.id) ? startAppObject.borrowerEntity.id : startAppObject.borrowerOrganizationId;
    if (startAppObject.whoWillDoConstructionBorrowerApplicationInputId === GlobalConstants.WhoWillDoConstructionBorrowerApplicationInputIds.IS_GENERAL_CONTRACTOR && borrowerOrganizationId) {
      builderOrganizationId = borrowerOrganizationId;
    }
    
    const allPublishProperties = publishProperties.concat(publishCollaterals);
    const publishScreenStatus = { maxScreens: applicationScreenStatus } as IApplicationScreenStatus;
    if (isGuarantorPersona) {
      publishScreenStatus.wlScreenNo = currentStepId;
      publishScreenStatus.screenNo = brokerScreenStatus;
    }
    else {
      publishScreenStatus.screenNo = currentStepId;
    }

    let requestedLoanTermInMonths = 0 as any;
    if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE) {
      requestedLoanTermInMonths = startAppObject.preferredLoanTerm;
    }
    else if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT) {
      requestedLoanTermInMonths = operationOfNumberArray("sum", [startAppObject.developmentBeginsAfterClosingInMonths, startAppObject.timeFrameToDevelopInMonths]);
    }
    else {
      requestedLoanTermInMonths = greatestTotalToComplete;
    }

    let brokerFeeRate = startAppObject.brokerFeeRate ? Number(startAppObject.brokerFeeRate) : null;
    let wlBrokerFeeRate = startAppObject.wlbrokerFeeRate ? Number(startAppObject.wlbrokerFeeRate) + minMandatoryBrokerFee : null;
    if (!FeatureFlags.IS_BROKER_FEE_ALLIANCE) {
      if (startAppObject.isCombineOriginationFee) {
        if (brokerFeeRate && brokerFeeRate > 1.5) {
          wlBrokerFeeRate = 1.5;
          brokerFeeRate = Number((Number(startAppObject.brokerFeeRate) - 1.5).toFixed(3));
        }
        else {
          wlBrokerFeeRate = brokerFeeRate;
          brokerFeeRate = 0;
        }
      }
      else {
        wlBrokerFeeRate = 0;
      }
    }
    
    const publishObj = {
      afterRepairValue: startAppObject.afterRepairValue,
      id: startAppObject.id,
      originatingGmrId: startAppObject.originatingGmrId,
      applicationGmrId: startAppObject.applicationGmrId,
      screenStatus: JSON.stringify(publishScreenStatus),
      name: startAppObject.name,
      loanProgramId: startAppObject.loanProgramId,
      zip: startAppObject.zip,
      cityName: startAppObject.city ? startAppObject.city : null,
      stateName: startAppObject.state,
      countyName: startAppObject.county,
      brokerFeeRate: brokerFeeRate,
      wlbrokerFeeRate: wlBrokerFeeRate,
      newStructurePropertyTypeId: startAppObject.newStructurePropertyTypeId,
      existingStructurePropertyTypeId: startAppObject.existingStructurePropertyTypeId,
      zoning: startAppObject.zoning,
      originalPurchasePrice: startAppObject.originalPurchasePrice,
      amountOwed: startAppObject.amountOwed,
      requestedLoanTermInMonths: requestedLoanTermInMonths,
      subordinatedDebtAmount: startAppObject.subordinatedDebtAmount,
      noOfProposedLots: startAppObject.noOfProposedLots,
      uploadOptionLookupId: startAppObject.uploadOptionLookupId,
      developmentBeginsAfterClosingInMonths: startAppObject.developmentBeginsAfterClosingInMonths,
      timeFrameToDevelopInMonths: startAppObject.timeFrameToDevelopInMonths,
      horizontalDevelopmentBudget: startAppObject.horizontalDevelopmentBudget,
      sizeOfCurrentProperty: startAppObject.sizeOfCurrentProperty,
      sizeOfCurrentPropertyUnitOfMeasurementBorrowerApplicationInputId: UserFeatureFlags.IS_RETAIL_PHASE_2 ? startAppObject.sizeOfCurrentPropertyUnitOfMeasurementBorrowerApplicationInputId ? startAppObject.sizeOfCurrentPropertyUnitOfMeasurementBorrowerApplicationInputId : GlobalConstants.UnitMeasurements.ACRE : GlobalConstants.UnitMeasurements.ACRE,
      sizeOfProposedLotUnitOfMeasurementBorrowerApplicationInputId: UserFeatureFlags.IS_RETAIL_PHASE_2 ? startAppObject.sizeOfProposedLotUnitOfMeasurementBorrowerApplicationInputId ? startAppObject.sizeOfProposedLotUnitOfMeasurementBorrowerApplicationInputId : GlobalConstants.UnitMeasurements.SQFT :GlobalConstants.UnitMeasurements.SQFT,
      sizeOfProposedLot: startAppObject.sizeOfProposedLot,
      districtReimbursementsAvailableBorrowerApplicationInputId: startAppObject.districtReimbursementsAvailableBorrowerApplicationInputId,
      districtReimbursementsAvailableDescription: startAppObject.districtReimbursementsAvailableDescription,
      bondingRequirementsBorrowerApplicationInputId: startAppObject.bondingRequirementsBorrowerApplicationInputId,
      bondingRequirementsDescription: startAppObject.bondingRequirementsDescription,
      seasonalityConcernsBorrowerApplicationInputId: startAppObject.seasonalityConcernsBorrowerApplicationInputId,
      seasonailtyConcernsDescription: startAppObject.seasonalityConcernsDescription,
      permitStatusId: startAppObject.permitStatusId,
      workStageId: startAppObject.workStageId,
      developmentOrVerticalPermitTimingInMonths: startAppObject.developmentOrVerticalPermitTimingInMonths ? startAppObject.developmentOrVerticalPermitTimingInMonths : 0,
      purchaseRefinanceOptionLookupId: !FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? startAppObject.purchaseRefinanceOptionLookupId : [GlobalConstants.PurchaseOrRefinanceOptionIds.OWN, GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE].indexOf(startAppObject.purchaseRefinanceOptionLookupId) > -1 ?
        startAppObject.purchaseRefinanceOptionLookupId : [GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_INTERNAL, GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL].indexOf(startAppObject.refinanceOptionLookupId) > -1 ?    
        startAppObject.refinanceOptionLookupId : undefined,
      howLongOwnedBorrowerApplicationInputId: startAppObject.durationOwnedId,
      estimatePropertyValue: startAppObject.estimatePropertyValue,
      useInterestReserveBorrowerApplicationInputId: startAppObject.useInterestReserveId,
      cashDown: startAppObject.cashDown,
      cashOutAmountRequested: startAppObject.cashOutAmountRequested,
      loanOfficerOrganizationContactId: startAppObject.loanOfficerOrganizationContactId ? startAppObject.loanOfficerOrganizationContactId : undefined,
      brokerOrganizationContactId: persona === Personas.BROKER && proxyUser.organizationContactId ? proxyUser.organizationContactId : 
        persona === Personas.BROKER ? user.organizationContactId : startAppObject.brokerOrganizationContactId,
      payoffStrategyId: startAppObject.payoffStrategyId,
      budget: startAppObject.budget,
      builderOrganizationId: startAppObject.whoWillDoConstructionBorrowerApplicationInputId === GlobalConstants.WhoWillDoConstructionBorrowerApplicationInputIds.HIRING_GENERAL_CONTRACTOR ? builderOrganizationId : null,
      whoWillDoConstructionBorrowerApplicationInputId: startAppObject.whoWillDoConstructionBorrowerApplicationInputId,
      payoffStrategyDescription: startAppObject.payoffStrategyId === GlobalConstants.PayoffStrategyIds.OTHER ? startAppObject.payoffStrategyDescription : null,
      requestedClosingDate: startAppObject.requestedClosingDate ? startAppObject.requestedClosingDate : new Date(),
      projectComment: (startAppObject.projectComment && startAppObject.projectComment !== "") ? startAppObject.projectComment : null,
      borrowerOrganizationId: borrowerOrganizationId,
      guarantors: guarantorsToSend,
      borrowerApplicationCostPaids: publishGmrCostsPaids,
      borrowerApplicationProperties: allPublishProperties,
      hasCollateralPropertiesChanged: startAppObject.hasCollateralPropertiesChanged === true ? startAppObject.hasCollateralPropertiesChanged : false,
      borrowerApplicationPlans: publishPlans,
      cumulativeProjectExperience: startAppObject.cumulativeProjectExperience,
      submittedOn: submittedOn,
      channel: [Personas.BROKER, Personas.WL_GUARANTOR].indexOf(persona) > -1 ? "Wholesale" : 
      [Personas.NWL_GUARANTOR].indexOf(persona) > -1 ? "Retail" :
        "Unknown",
      regionId: persona.includes("Wholesale") ? GlobalConstants.Channels.WHOLESALE : persona.includes("Retail") ? GlobalConstants.Channels.RETAIL : null,
      permitStatusExplanation: startAppObject.permitStatusExplanation && startAppObject.permitStatusExplanation
    };

    return publishObj;
  };

  const handleConvertALandReoToView = (obj) => {
    const editAssetsAndLiabilities = [] as any[];
    const assetsAndLiabilitiesViews = [] as any[];
    if (obj.alschedules && obj.alschedules.length > 0) {
      obj.alschedules.forEach(al => {
        const editAssetAndLiability = {
          id: al.id,
          alOption: al.alclassName,
          alType: al.altypeId,
          institutionName: al.institution,
          currentBalance: al.value,
          monthlyLiability: al.monthlyLiability,
          status: al.alstatusId,
          isEditHide: al.pulledByApi === true,
          isDeleteHide: al.pulledByApi === true
        };

        const assetAndLiabilityView = {
          id: al.id,
          "Class": al.alclassName,
          "Type": al.alclassName === "Asset" ? handleGetValueFromId(applicationMetadata.assetTypes, al.altypeId) : handleGetValueFromId(applicationMetadata.liabilityTypes, al.altypeId),
          "Name of Institution": al.institution,
          "Current Balance": al.value,
          "Monthly Liability": al.monthlyLiability,
          "Status": handleGetValueFromId(applicationMetadata.alStatuses, al.alstatusId),
          isEditHide: al.pulledByApi === true,
          isDeleteHide: al.pulledByApi === true
        };

        assetsAndLiabilitiesViews.push(assetAndLiabilityView);
        editAssetsAndLiabilities.push(editAssetAndLiability);
      });
    }

    const editReoSchedules = [] as any[];
    const reoSchedulesViews = [] as any[];
    if (obj.reoschedules && obj.reoschedules.length > 0) {
      obj.reoschedules.forEach(reoSchedule => {
        const editReoSchedule = {
          id: reoSchedule.id,
          reoType: reoSchedule.reotypeId,
          reoStatus: reoSchedule.reostatusId,
          amountOwed: reoSchedule.amountOwed,
          isMortgageFree: reoSchedule.mortgageFree,
          street: reoSchedule.street,
          zip: reoSchedule.zipCode,
          state: reoSchedule.stateName,
          city: reoSchedule.cityName,
          marketValue: reoSchedule.marketValue,
          parcelNumber: reoSchedule.parcelNumber,
          maintenance: reoSchedule.monthlyTaxInsuranceAndMaintenance,
          alSchedule1: reoSchedule.mortgage1AlscheduleName,
          alSchedule2: reoSchedule.mortgage2AlscheduleName,
          alSchedule3: reoSchedule.mortgage3AlscheduleName,
          mortgageAmount1: reoSchedule.mortgageAmount1,
          mortgageAmount2: reoSchedule.mortgageAmount2,
          mortgageAmount3: reoSchedule.mortgageAmount3,
          mortgagePayment1: reoSchedule.mortgagePayment1,
          mortgagePayment2: reoSchedule.mortgagePayment2,
          mortgagePayment3: reoSchedule.mortgagePayment3,
          holder1: reoSchedule.mortgageHolder1,
          holder2: reoSchedule.mortgageHolder2,
          holder3: reoSchedule.mortgageHolder3,
          reoScheduleDescription: reoSchedule.description,
          additionalCollateral: reoSchedule.additionalCollateral
        };

        const reoScheduleView = {
          id: reoSchedule.id,
          "Address": `${reoSchedule.street}, ${reoSchedule.cityName}, ${reoSchedule.stateName}`,
          "Market Value": reoSchedule.marketValue,
          "Parcel Number": reoSchedule.parcelNumber,
          "Total Mortgage Amount": (reoSchedule.mortgageAmount1 ? reoSchedule.mortgageAmount1 : 0) + 
            (reoSchedule.mortgageAmount2 ? reoSchedule.mortgageAmount2 : 0) + (reoSchedule.mortgageAmount3 ? reoSchedule.mortgageAmount3 : 0),
          "Total Mortgage Payment": (reoSchedule.mortgagePayment1 ? reoSchedule.mortgagePayment1 : 0) + 
            (reoSchedule.mortgagePayment2 ? reoSchedule.mortgagePayment2 : 0) + (reoSchedule.mortgagePayment3 ? reoSchedule.mortgagePayment3 : 0),
          "REO Type": handleGetValueFromId(applicationMetadata.reoTypes, reoSchedule.reotypeId),
          "Reo Status": handleGetValueFromId(applicationMetadata.reoStatuses, reoSchedule.reostatusId)
        }; 

        reoSchedulesViews.push(reoScheduleView);
        editReoSchedules.push(editReoSchedule);
      });
    }

    return {
      assetsAndLiabilitiesViews: assetsAndLiabilitiesViews,
      editAssetsAndLiabilities: editAssetsAndLiabilities,
      reoSchedulesViews: reoSchedulesViews,
      editReoSchedules: editReoSchedules
    };
  };

  const handleSubmitText = () => {
    if ((ProjectSteps.BrokerWelcome.id === currentStepId) || (startAppObject.submittedOn && SummarySteps.Summary.id === currentStepId)) {
      return "Save and Close";
    }
    
    return "Submit";
  };

  const handleLoanOfficerWarningText = () => {
    const sectionTextArray = [] as string[];
    if (applicationScreenStatus.Projects !== ProjectSteps.PermitStatus.id) {
      sectionTextArray.push("Project");
    }

    if (applicationScreenStatus.Property !== PropertySteps.LoanTerm.id) {
      sectionTextArray.push("Property");
    }

    if (applicationScreenStatus.Budget !== BudgetSteps.ProjectDetails.id) {
      sectionTextArray.push("Budget");
    }

    return `It looks like you skipped some screens. If you complete the ${convertArrayToOxfordString(sectionTextArray, "and", "")} section${sectionTextArray.length > 1 ? "s" : ""}, you can send preliminary pricing to your loan officer for further negotiations.`;
  };

  const handleDisclosure = async (applicationId) => {
    setIsLoading(true);
    await handleDisclosureAsync(applicationId);
  };

  const handleEntities = async () => {
    let isApiSuccess = true;
    const borrowerEntities = await getBorrowerEntitiesAsync();
    if (borrowerEntities) {
      isApiSuccess = await handlePatchEntities(borrowerEntities);
      if (isApiSuccess) {
        isApiSuccess = await handleGetGuarantorsAsync();
      }
    }
    else {
      isApiSuccess = false;
    }
    
    return isApiSuccess;
  };

  const handlePatchEntities = async (borrowerEntities) => {
    const postEntities = [] as any[];
    const patchEntities = [] as any[];
    const selectedBrokerGuarantorIds = Array.from(new Set(Array.from(selectedBrokerGuarantors, x => x.id)));
    selectedBrokerGuarantorIds.map(selectedBrokerGuarantorId => {
      const foundEntity = borrowerEntities.find(x => x.organizationContactId === selectedBrokerGuarantorId);
      const firstFoundSelectedBrokerGuarantor = selectedBrokerGuarantors.find(x => x.id === selectedBrokerGuarantorId);
      const entityObj = {
        id: foundEntity ? foundEntity.id : guid(),
        borrowerApplicationId: applicationId,
        organizationContactId: selectedBrokerGuarantorId,
        roleOption: "Guarantor",
        confirmationStatus: foundEntity ? foundEntity.confirmationStatus : "BrokerInitiated",
        accessLevelId: firstFoundSelectedBrokerGuarantor.accessLevelId,
        isActive: true
      };

      if (foundEntity) {
        patchEntities.push(entityObj);
      }
      else {
        postEntities.push(entityObj);
      }
    });

    let isApiSuccess = true;
    if (postEntities.length > 0) {
      isApiSuccess = await patchEntitiesAsync(postEntities, true);
    }

    if (patchEntities.length > 0) {
      isApiSuccess = await patchEntitiesAsync(patchEntities, false);
    }

    return isApiSuccess;
  };

  const handleGetBrokerEmailExistsAsync = async (email) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockBrokerEmailExists(email) : await getBrokerEmailExists(email, proxyUser.id) as any;
      if (response && response.ok) {
        setIsMessage(false);
        if (response.status === 204) {
          return false;
        }
        else {
          const apiFoundBroker = await response.json();
          if (apiFoundBroker.id) {
            setStartAppObject({...startAppObject, brokerOrganizationContactId: apiFoundBroker.id });
          }
          
          return apiFoundBroker.email;
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  const downloadPropertyUnitExcelAsync = async (borrowerApplicationId, numberOfProperties) => {
    setIsLoadingPropertyUnitExcel(true);
    try {
      const response = process.env.REACT_APP_IS_MOCK === "YES" ? await downloadMockPropertyUnitExcel(numberOfProperties) : await downloadPropertyUnitExcel(borrowerApplicationId, numberOfProperties, proxyUser.id) as any;
      if (response && response.ok) {        
        const data = await response.blob();
        const propertyUnitTemplate = await createFile(data, "property-unit-upload", data.type);
        setExportURL(URL.createObjectURL(propertyUnitTemplate));
        const today = new Date();
        setPropertyUnitExcelDate(`${today.getMonth() + 1}.${today.getDate()}.${today.getFullYear()}`);
        if (exportRef.current) {
          exportRef.current.click();
        }

        setIsLoadingPropertyUnitExcel(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsLoadingPropertyUnitExcel(false);
      }
    }
    catch (error) {
      setIsMessage(false);
      setIsLoadingPropertyUnitExcel(false);
    }

    return false;
  };

  const importPropertyUnitExcelAsync = async (filledPropertyUnitExcel, forceUpdate = false) => {
    try {
      const response = process.env.REACT_APP_IS_MOCK === "YES" ? await importMockPropertyUnitExcel() : await importPropertyUnitExcel(filledPropertyUnitExcel, startAppObject.id, proxyUser.id, forceUpdate) as any;
      if (response && response.ok) {
        setIsLoadingPropertyUnitExcel(false);
        const propertyInfo = await response.json();
        setIsPropertyUnitMixUploaded(true);
        setIsPropertyUnitUploadedMessage(true);
        setStartAppObject({...startAppObject, uploadOptionLookupId: GlobalConstants.UploadOptions.UPLOAD});
        setInvalidProps([...invalidProps.filter(prop => prop !== "missing-uploadPropertyUnitMix")]);
        setTimeout(() => {
          setIsPropertyUnitUploadedMessage(false);
        }, 3000);
        return propertyInfo;
      }
      else if (response && response.status === 400) {
        const modifiedResponse = await response.json();
        if (modifiedResponse && modifiedResponse.errorNo === 1131) {
          setIsPropertyUploadModalOpen(true);
          setPropertyUploadModalMessage(modifiedResponse.errorMessage);
          setPropertyUploadModalFile(filledPropertyUnitExcel);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }

      setIsLoadingPropertyUnitExcel(false);
    }
    catch (error) {
      setIsMessage(false);
      setIsLoadingPropertyUnitExcel(false);
    }

    return false;
  };

  const getBorrowerEntitiesAsync = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockBorrowerApplicationEntities(applicationId) : await getBorrowerApplicationEntities(applicationId, proxyUser.id) as any;
      if (response && response.ok) { 
        return await response.json();
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleGetBorrowerEntityAsync = async (applicationId, entityId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockBorrowerEntity(applicationId, entityId) : await getBorrowerEntity(applicationId, entityId, proxyUser.id) as any;
      if (response && response.ok) {        
        const apiBorrower = await response.json();
        const alAndReoObj = handleConvertALandReoToView(apiBorrower) as any;
        const newEditBorrowerEntity = {
          id: apiBorrower.id,
          name: apiBorrower.name,
          physicalStreet: parseAddressLine1(apiBorrower.physicalStreet),
          addressLine2: parseAddressLine2(apiBorrower.physicalStreet),
          physicalZipCode: apiBorrower.physicalZipCode,
          physicalCityName: apiBorrower.physicalCityName,
          physicalStateName: apiBorrower.physicalStateName,
          physicalCountyName: apiBorrower.physicalCountyName,
          entitySubTypeId: apiBorrower.entitySubTypeId,
          eintin: apiBorrower.employerIdentificationNumber,
          website: apiBorrower.website,
          yearsInBusiness: apiBorrower.yearsInIndustry,
          grossRevenue: apiBorrower.monthlyRevenue,
          netIncome: apiBorrower.monthlyIncome,
          assetsAndLiabilities: alAndReoObj && alAndReoObj.editAssetsAndLiabilities,
          reoSchedules: alAndReoObj && alAndReoObj.editReoSchedules
        };
  
        setNewBorrowerEntity({...newEditBorrowerEntity});
        setEntityAssetAndLiabilities(alAndReoObj && alAndReoObj.assetsAndLiabilitiesViews);

        const additonalCollateralViews = [] as any[];
        if (newEditBorrowerEntity.reoSchedules && newEditBorrowerEntity.reoSchedules.length > 0) {
          newEditBorrowerEntity.reoSchedules.forEach(reoschedule => {
            if (reoschedule.additionalCollateral) {
              const additonalCollateralView = {
                id: reoschedule.id,
                "Address": handleAddressValue({
                  address: reoschedule.street,
                  city: reoschedule.cityName,
                  state: reoschedule.stateName,
                  zip: reoschedule.zipCode
                }),
                "Market Value": reoschedule.marketValue,
                "Parcel No.": reoschedule.parcelNumber,
                "Owner": newEditBorrowerEntity.name
              };

              additonalCollateralViews.push(additonalCollateralView);
            }
          });

          setEntityAdditionalCollateral(additonalCollateralViews);
        }

        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const patchEntitiesAsync = async (patchObj, isUpsert) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await patchMockBorrowerApplicationEntities(patchObj, isUpsert) : await patchBorrowerApplicationEntities(patchObj, isUpsert, proxyUser.id) as any;
      if (response && response.ok) {        
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const createBorrowerApplicationGuarantorsAsync = async (guarantors) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await createMockBorrowerApplicationGuarantors(guarantors) : await createBorrowerApplicationGuarantors(guarantors, proxyUser.id) as any;
      if (response && response.ok) {        
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleGetGuarantorsAsync = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockGuarantors(applicationId) : await getGuarantors(applicationId, proxyUser.id) as any;
      if (response && response.ok) {
        const apiGuarantors = await response.json();
        const additonalCollateralViews = [] as any[];
        apiGuarantors.forEach(apiGuarantor => {
          if (apiGuarantor.reoschedules && apiGuarantor.reoschedules.length > 0) {
            apiGuarantor.reoschedules.forEach(reoschedule => {
              if (reoschedule.additionalCollateral) {
                const additonalCollateralView = {
                  "Address": handleAddressValue({
                    address: reoschedule.street,
                    city: reoschedule.cityName,
                    state: reoschedule.stateName,
                    zip: reoschedule.zipCode
                  }),
                  "Market Value": reoschedule.marketValue,
                  "Parcel No.": reoschedule.parcelNumber,
                  "Owner": `${apiGuarantor.firstName} ${apiGuarantor.lastName}`
                };

                additonalCollateralViews.push(additonalCollateralView);
              }
            });
          }
        });
        
        const additionalCollateralAddresses = Array.from(additonalCollateralViews, x => x.Address);
        if (newGuarantor.reoSchedules && newGuarantor.reoSchedules.length > 0) {
          newGuarantor.reoSchedules.forEach(reoschedule => {
            const reoscheduleAddress = handleAddressValue({
              address: reoschedule.street,
              city: reoschedule.city,
              state: reoschedule.state,
              zip: reoschedule.zip
            });
  
            if (additionalCollateralAddresses.includes(reoscheduleAddress)) {
              const foundAdditonalCollateralView = additonalCollateralViews.find(x => x.Address === reoscheduleAddress);
              if (foundAdditonalCollateralView && foundAdditonalCollateralView.Owner !== `${newGuarantor.firstName} ${newGuarantor.lastName}`) {
                setAdditionalCollateralWarning({
                  name: foundAdditonalCollateralView.Owner,
                  property: foundAdditonalCollateralView.Address
                });
                setIsAdditionalCollateralWarning(true);
        
                setTimeout(() => {
                  setIsAdditionalCollateralWarning(false);
                }, 3000);
              }
            }
          });
        }

        setGuarantorAdditionalCollateral([...additonalCollateralViews]);
        setSelectedBrokerGuarantors(apiGuarantors);
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleCreateBuilderAsync = async (newBuilder) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await createMockBuilder(newBuilder) : await createBuilder(newBuilder, proxyUser.id);
      if (response && response.ok) {
        const builderResponse = await response.json();
        const builderObj = {
          id: builderResponse.id,
          name: builderResponse.organizationName
        };

        generalContractors.push(builderObj);
        setGeneralContractors([...generalContractors]);
        startAppObject.generalContractorId = builderObj.id;
        setStartAppObject({...startAppObject});
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleGetGuarantorExistsAsync = async (email) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockGuarantorExists(email) : await getGuarantorExists(email, proxyUser.id) as any;
      if (response && response.ok) {
        setIsMessage(false);
        if (response.status === 204) {
          return false;
        }
        else {
          const apiFoundGuarantor = await response.json();
          const foundGuarantorIndex = selectedBrokerGuarantors.findIndex(x => x.email === apiFoundGuarantor.email);
          if (foundGuarantorIndex === -1) {
            selectedBrokerGuarantors.push({
              id: apiFoundGuarantor.id,
              email: apiFoundGuarantor.email,
              firstName: apiFoundGuarantor.firstName,
              lastName: apiFoundGuarantor.lastName,
              accessLevelId: apiFoundGuarantor.accessLevelId,
              status: apiFoundGuarantor.status
            });

            setSelectedBrokerGuarantors([...selectedBrokerGuarantors]);
          }
          
          return true;
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  const handleDeleteGuarantorAsync = async (guarantorObj) => {
    let isGuarantorDelete = false;
    try {
      const response = FeatureFlags.IS_MOCK ? await deleteMockGuarantor(guarantorObj) : await deleteGuarantor(guarantorObj, proxyUser.id);
      if (response && response.ok) {
        isGuarantorDelete = true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
    
    return isGuarantorDelete;
  };

  const handleSubmitApplicationAsync = async (submitObj) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await submitMockBorrowerApplication(submitObj) : await submitBorrowerApplication(submitObj, proxyUser.id);
      if (response && response.ok) {
        const submitResponse = await response.json();
        if (submitResponse.hasUnpaidInvoices) {
          setIsPaymentModalOpen(true);
        }

        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handlePatchProjectAsync = async (patchObj, isUpsert = false) => {
    try {
      const patchFormat = [patchObj];
      const response = FeatureFlags.IS_MOCK ? await patchMockBorrowerApplicationProjectSection(patchFormat, isUpsert) : await patchBorrowerApplicationProjectSection(patchFormat, isUpsert, proxyUser.id);
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handlePatchPropertiesAsync = async (patchObj, isUpsert = false) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await patchMockBorrowerApplicationProperties(patchObj, isUpsert) : await patchBorrowerApplicationProperties(patchObj, isUpsert, proxyUser.id);
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handlePatchPlansAsync = async (patchObj, isUpsert = false) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await patchMockBorrowerApplicationPlans(patchObj, isUpsert) : await patchBorrowerApplicationPlans(patchObj, isUpsert, proxyUser.id);
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handlePatchCostsPaidAsync = async (applicationId, patchObj, isUpsert = false) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await patchMockBorrowerApplicationCostsPaids(applicationId, patchObj, isUpsert) : await patchBorrowerApplicationCostsPaids(applicationId, patchObj, isUpsert, proxyUser.id);
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleDeleteCostsPaidsAsync = async (deleteIds) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await deleteMockBorrowerApplicationCostsPaids(deleteIds) : await deleteBorrowerApplicationCostsPaids(deleteIds, proxyUser.id);
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleDeletePlanAsync = async (deleteIds) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await deleteMockBorrowerApplicationPlans(deleteIds) : await deleteBorrowerApplicationPlans(deleteIds, proxyUser.id);
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleDeletePropertiesAndUnitsAsync = async (deleteIds) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await deleteMockBorrowerApplicationPropertiesAndUnits(deleteIds) : await deleteBorrowerApplicationPropertiesAndUnits(deleteIds, proxyUser.id);
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleDeleteUnitsAsync = async (deleteIds) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await deleteMockBorrowerApplicationUnits(deleteIds) : await deleteBorrowerApplicationUnits(deleteIds, proxyUser.id);
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleGetGuarantorAsync = async (guarantorId) => {
    try {
      const getGuarantorObj = {
        "BorrowerApplicationId": applicationId,
        "OrganizationContactId": guarantorId
      };
      const response = FeatureFlags.IS_MOCK ? await getMockGuarantor(getGuarantorObj) : await getGuarantor(getGuarantorObj, proxyUser.id) as any;
      if (response && response.ok) {
        const apiGuarantor = await response.json();
        let alAndReoObj = undefined as any;
        if (applicationMetadata) {
          alAndReoObj = await handleConvertALandReoToView(apiGuarantor);
        }

        const newEditGuarantor = {
          id: apiGuarantor.id,
          firstName: apiGuarantor.firstName,
          lastName: apiGuarantor.lastName,
          email: apiGuarantor.email,
          mobilePhone: apiGuarantor.mobilePhone,
          physicalAddress: parseAddressLine1(apiGuarantor.physicalStreet),
          physicalAddressLine2: parseAddressLine2(apiGuarantor.physicalStreet),
          physicalZip: apiGuarantor.physicalZipCode,
          physicalCity: apiGuarantor.physicalCityName,
          physicalState: apiGuarantor.physicalStateName,
          physicalCounty: apiGuarantor.physicalCountyName,
          isMailingSameAsPhysical: apiGuarantor.physicalAddress === apiGuarantor.mailingAddress,
          mailingAddress: parseAddressLine1(apiGuarantor.mailingStreet),
          mailingAddressLine2: parseAddressLine2(apiGuarantor.mailingStreet),
          mailingZip: apiGuarantor.mailingZipCode,
          mailingCity: apiGuarantor.mailingCityName,
          mailingState: apiGuarantor.mailingStateName,
          mailingCounty: apiGuarantor.mailingCountyName,
          organizationRole: apiGuarantor.employerPosition,
          homePhone: apiGuarantor.homePhone,
          businessPhone: apiGuarantor.officePhone,
          extension: apiGuarantor.officePhoneExtension,
          socialSecurityNumber: apiGuarantor.socialSecurityNumber,
          creditScore: apiGuarantor.creditScore,
          estimatedCreditScore: apiGuarantor.estimatedCreditScore,
          isCreditScorePulled: apiGuarantor.isCreditScorePulled,
          dateOfBirth: apiGuarantor.dateOfBirth ? new Date(apiGuarantor.dateOfBirth).toISOString().substr(0, 10) : undefined,
          maritalStatus: apiGuarantor.maritalStatusId,
          spouseName: apiGuarantor.spouseName,
          isSelfEmployed: apiGuarantor.selfEmployed,
          employerName: apiGuarantor.employerName,
          position: apiGuarantor.employerPosition,
          netIncome: apiGuarantor.monthlyIncome,
          grossRevenue: apiGuarantor.monthlyRevenue,
          yearsInIndustry: apiGuarantor.yearsInIndustry,
          yearsInBusiness: apiGuarantor.yearsInBusiness,
          yearsInJob: apiGuarantor.yearsInJob,
          isUSCitizen: apiGuarantor.uscitizen,
          citizenStatus: apiGuarantor.citizenshipStatus,
          isPendingLegalAction: apiGuarantor.pendingLegalAction,
          legalActionDescription: apiGuarantor.legalActionDescription,
          isForeclosureInitiated: apiGuarantor.isForeclosureInitiated,
          forclosureDescription: apiGuarantor.foreclosureDescription,
          otherCreditNames: apiGuarantor.otherCreditName,
          assetsAndLiabilities: alAndReoObj && alAndReoObj.editAssetsAndLiabilities,
          reoSchedules: alAndReoObj && alAndReoObj.editReoSchedules,
          isDisclosureCompleted: apiGuarantor.isDisclosureCompleted,
        };
        
        setNewGuarantor(newEditGuarantor);
        setGuarantorAssetAndLiabilities(alAndReoObj && alAndReoObj.assetsAndLiabilitiesViews);
        setGuarantorReoSchedules(alAndReoObj && alAndReoObj.reoSchedulesViews);
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handlePullCreditScoreAsync = async (creditUser) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await pullMockCreditScore(creditUser) : await pullCreditScore(creditUser, proxyUser.id) as any;
      if (response && response.ok) {
        setIsMessage(false);
        newGuarantor.creditScore = await response.json();
        setIsCreditScorePulled(true);
        setNewGuarantor({...newGuarantor});
        return true;
      }
      else {
        setCreditModalStage("pull failed");
      }
    }
    catch (error) {
      setCreditModalStage("pull failed");
    }

    return false;
  };

  const handleUpsertBorrowerEntityAsync = async (newBorrowerEntity) => {
    try {
      setIsLoading(true);
      const convertedBorrowerEntity = convertBorrowerEntity(newBorrowerEntity);
      const response = FeatureFlags.IS_MOCK ? await upsertMockBorrowerEntity(convertedBorrowerEntity) : await upsertBorrowerEntity(convertedBorrowerEntity, proxyUser.id);
      if (response && response.ok) {        
        setIsMessage(false);
        const borrowerEntityFull = await response.json();
        const borrowerEntityObj = {
          id: borrowerEntityFull.id,
          name: borrowerEntityFull.name
        };

        newBorrowerEntity.id = borrowerEntityFull.id;
        startAppObject.borrowerEntity = borrowerEntityObj;
        const foundBorrowerIndex = associatedBorrowers.findIndex(x => x.id === borrowerEntityObj.id);
        if (foundBorrowerIndex > -1) {
          associatedBorrowers.push(borrowerEntityObj);
          setApplicationMetadata({...applicationMetadata});
        }

        setNewBorrowerEntity({...newBorrowerEntity});
        setStartAppObject({...startAppObject});
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    setIsLoading(false);
    return false;
  };

  const handleUpsertGuarantorAsync = async (newGuarantor) => {
    try {
      if (startAppObject.borrowerOrganizationId) {
        newGuarantor.borrowerOrganizationId = startAppObject.borrowerOrganizationId;
      }
      
      const response = FeatureFlags.IS_MOCK ? await upsertMockGuarantor() : await upsertGuarantor(convertGuarantor(newGuarantor), proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);                                                                                                                       
        const guarantorFull = await response.json();
        if (isValidPermission(permissions, "BrokerBorrowerApplication", "read") && !getIsWhiteLabeled()) {
          const newMetaGuarantor = {
            id: guarantorFull.id,
            firstName: newGuarantor.firstName,
            lastName: newGuarantor.lastName,
            email: newGuarantor.email,
            status: newGuarantor.status,
            accessLevelId: newGuarantor.accessLevelId
          };

          selectedBrokerGuarantors.push(newMetaGuarantor);
          metaGuarantors.push(newMetaGuarantor);
          setMetaGuarantors([...metaGuarantors]);
          setNewGuarantor({ isMailingSameAsPhysical: true, isUSCitizen: true });
        }
        else {
          const guarantorRenewReoschedules = [] as any[];
          if (guarantorFull && guarantorFull.reoschedules && guarantorFull.reoschedules.length > 0) {
            guarantorFull.reoschedules.forEach(reoschedule => {
              const guarantorRenewReoschedule = {
                additionalCollateral: reoschedule.additionalCollateral,
                city: reoschedule.cityName,
                county: reoschedule.countyName,
                holder1: reoschedule.mortgageHolder1,
                id: reoschedule.id,
                marketValue: reoschedule.marketValue,
                parcelNumber: reoschedule.parcelNumber,
                mortgageAmount1: reoschedule.mortgageAmount1,
                reoStatus: reoschedule.reostatusId,
                reoType: reoschedule.reotypeId,
                state: reoschedule.stateName,
                street: reoschedule.street,
                zip: reoschedule.zipCode
              };
  
              guarantorRenewReoschedules.push(guarantorRenewReoschedule);
            });
          }

          newGuarantor.reoSchedules = guarantorRenewReoschedules;
          setNewGuarantor({...newGuarantor});
        }
        
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleSendApplicationStartEmailAsync = async (emailObj) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await sendMockApplicationStartEmail(emailObj) : await sendApplicationStartEmail(emailObj, proxyUser.id);
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    setIsLoading(false);
    return false;
  };

  const handleCalculateAsync = async () => {
    const calculatePublishObj = convertToPublishObj();
    try {
      const response = FeatureFlags.IS_MOCK ? await calculateMockGmrFromApplication(calculatePublishObj) : await calculateGmrFromApplication(calculatePublishObj, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
        const apiGmrSummaryObject = await response.json();
        setApplicationCalculationObject(apiGmrSummaryObject);
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    setIsLoading(false);
    return false;
  };

  const handleSendApplicationAsync = async (sendAppObject) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await sendMockLoanApplication(sendAppObject) : await sendLoanApplication(sendAppObject, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleDisclosureAsync = async (applicationId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockDisclosures(user.id) : await getDisclosure(window.location.href, applicationId, proxyUser.id) as any;
      if (response && response.ok) {
        const getReturnURL = await response.json();
        if (getReturnURL) {
          const isSaveSuccess = await handleSaveApplication();
          if (isSaveSuccess) {
            window.location.replace(getReturnURL);
          }
          else {
            setIsLoading(false);
          }
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsLoading(false);
      }
    }
    catch (error) {
      setIsLoading(false);
      setIsMessage(false);
    }
  };

  const handleAddBorrowerGuarantorsAsync = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await addMockBorrowerGuarantors(applicationId, startAppObject.invitedGuarantors) : await addBorrowerGuarantors(applicationId, startAppObject.invitedGuarantors, proxyUser.id) as any;
      if (response && response.ok) {
        const addedBorrowerGuarantors = await response.json();
        startAppObject.invitedGuarantors.forEach(invitedGuarantor => {
          const foundAddedBorrowerGuarantor = addedBorrowerGuarantors.find(x => x.email === invitedGuarantor.email);
          if (foundAddedBorrowerGuarantor) {
            invitedGuarantor.id = foundAddedBorrowerGuarantor.id;
          }
        });

        setStartAppObject({...startAppObject});
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsLoading(false);
      }
    }
    catch (error) {
      setIsLoading(false);
      setIsMessage(false);
    }

    return false;
  };

  const handleProjectNameExistsAsync = async (projectName, id) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await isMockProjectNameExists(projectName) : await isProjectNameExists(projectName, id, proxyUser.id) as any;
      if (response && response.ok) {
        if (response.status === 204) {
          return false;
        }
        
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsLoading(false);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleBrokerGuarantorInviteAsync = async (guarantorInviteObj) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await resendMockGuarantorInvite(guarantorInviteObj) : await resendGuarantorInvite(guarantorInviteObj, proxyUser.id) as any;
      if (response && response.ok) {
        if (response.status === 204) {
          return false;
        }
        
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsLoading(false);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const clearInviteGuarantorFormInputs = async () => {
    setPrimeGuarantorModal(false);
    let startAppObjectScope = startAppObject;
    if (startAppObjectFromGmr.id) {
      startAppObjectScope = startAppObjectFromGmr;
    }
    else {
      startAppObjectScope.name = null;
      startAppObjectScope.loanProgramId = null;
      startAppObjectScope.newStructurePropertyTypeId = null;
      startAppObjectScope.brokerFeeRate = null;
      startAppObjectScope.wlbrokerFeeRate = null;
      startAppObjectScope.borrowerOrganizationName = null;
      startAppObjectScope.guarantorEmailAddress = null;
      startAppObjectScope.guarantorFirstName = null;
      startAppObjectScope.guarantorLastName = null;
    }
    
    setStartAppObject({ ...startAppObjectScope });   
  };

  const handleDeleteAlScheduleAsync = async (alscheduleId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await deleteMockGuarantorALSchedule(alscheduleId) : await deleteGuarantorALSchedule(alscheduleId, proxyUser.id) as any;
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsLoading(false);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const patchGuarantorAccessLevelAsync = async (guarantorAccessPatchObj) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await patchMockBorrowerApplicationEntities(guarantorAccessPatchObj, false) : await patchBorrowerApplicationEntities(guarantorAccessPatchObj, false, proxyUser.id) as any;
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsLoading(false);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const createDealFromGmr = async (dealObj) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await createMockDeal(dealObj) : await createDeal(dealObj, proxyUser.id);
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }

    return false;
  };

  const getAllBrokersAsync = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockAllBrokers() : await getAllBrokers(proxyUser.id);
      if (response && response.ok) {
        const allBrokers = await response.json();
        return allBrokers;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }
  };

  const handleGetBrokerGuarantorsAsync = async (borrowerOrganizationId, applicationId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockBrokerGuarantors(borrowerOrganizationId, applicationId) : await getBrokerGuarantors(borrowerOrganizationId, applicationId, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
        const apiBrokerGuarantors = await response.json();
        setBrokerGuarantors(apiBrokerGuarantors);
        setBrokerApiGuarantors(apiBrokerGuarantors);
        setAssociatedGuarantors(apiBrokerGuarantors);
        setIsBrokerGuarantorsLoading(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  const handleGetGuarantorGuarantorsAsync = async (borrowerOrganizationId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockGuarantorGuarantors(borrowerOrganizationId) : await getGuarantorGuarantors(borrowerOrganizationId, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
        const apiGuarantorGuarantors = await response.json();
        setBrokerGuarantors(apiGuarantorGuarantors);
        setBrokerApiGuarantors(apiGuarantorGuarantors);
        setAssociatedGuarantors(apiGuarantorGuarantors);
        setIsBrokerGuarantorsLoading(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  const handleGetBuilderAsync = async (builderOrganizationId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockBrokerBuilder(builderOrganizationId) : await getBrokerBuilder(builderOrganizationId, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
        const builderResponse = await response.json();
        const builderObj = {
          id: builderResponse.id,
          name: builderResponse.name
        };
        
        generalContractors.push(builderObj);
        setGeneralContractors([...generalContractors]);
        startAppObject.generalContractorId = builderObj.id;
        setStartAppObject({...startAppObject});
        return builderObj;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  const handleGetIsGuarantorSignedAsync = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockBorrowerApplicationGuarantorSigned(applicationId) : await getBorrowerApplicationGuarantorSigned(applicationId, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
        const isGuarantorSigned = await response.json();
        return isGuarantorSigned;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const notifyLoanOfficerAsync = async (loanOfficerEmailObj) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await notifyMockLoanOfficer(loanOfficerEmailObj) : await notifyLoanOfficer(loanOfficerEmailObj, proxyUser.id);
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleGetWhitelabeledGuarantorPersona = async (applicationId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockApplicationInfo(applicationId) : await getBorrowerApplicationInfo(applicationId, proxyUser.id);
      if (response && response.ok) {
        const applicationInfo = await response.json();
        if (applicationInfo && applicationInfo.isWhiteLabeled) {
          setPersona(Personas.WL_GUARANTOR);
        }
        else if (applicationInfo && applicationInfo.isWhiteLabeled === false) {
          setPersona(Personas.NWL_GUARANTOR);
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }
  };

  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  const handleRouteToApplications = useCallback(() => {
    history.push("/applications");
  }, [history]);

  const handleRouteToHome = useCallback(() => {
    history.push("/home");
  }, [history]);

  const handleRouteToApplicationInteriorCard = useCallback((applicationId) => {
    history.push(`/application/pricing/${applicationId}`);
  }, [history]);

  const handleRouteToPayments = () => {
    history.push(`/application/payments/${applicationId}`);
  };

  useEffect(() => {
    const convertToStartAppObj = async (obj, isCopy = false) => {
      if (proxyUser && proxyUser.id) {
        user = proxyUser;
      }
      
      if (!getIsWhiteLabeled() && !isApplicationGuarantor(permissions, "GuarantorWhiteLabeledApplication", "read", obj.guarantors, organizationContactId) && obj.statusLookupName === "Submitted" && !isCopy) {
        handleRouteToApplicationInteriorCard(applicationId);
      }
      
      const convertedPlans = [] as any[];
      if (obj.borrowerApplicationPlans && obj.borrowerApplicationPlans.length > 0) {
        obj.borrowerApplicationPlans.forEach(plan => {
          const convertedPlan = {
            id: plan.id,
            name: plan.name && plan.name,
            numberOfBedroom: plan.numberOfBedroom && plan.numberOfBedroom,
            numberOfBathroom: plan.numberOfBathroom && plan.numberOfBathroom,
            numberOfCarGarage: plan.numberOfCarGarage && plan.numberOfCarGarage,
            squareFootage: plan.squareFootage && plan.squareFootage
          };
          convertedPlans.push(convertedPlan);
        });
      }
  
      const convertedProperties = [] as any[];
      if (obj.borrowerApplicationProperties && obj.borrowerApplicationProperties.length > 0) {
        const nonCollateralProperties = obj.borrowerApplicationProperties.filter(x => x.collateralProperty === false);
        nonCollateralProperties.forEach(property => {
          const convertedUnits = [] as any[];
          if (property.borrowerApplicationPropertyUnits && property.borrowerApplicationPropertyUnits.length > 0) {
            property.borrowerApplicationPropertyUnits.forEach(unit => {
              let foundPlan = undefined as any;
              if (convertedPlans.length > 0) {
                foundPlan = convertedPlans.find(x => x.id === unit.borrowerApplicationPlanId);
              }
              const convertedUnit = {
                id: unit.id,
                unitNumber: unit.unitNumber,
                plan: foundPlan && foundPlan.name,
                borrowerApplicationPlanId : unit.borrowerApplicationPlanId,
                monthOfFirstDraw: unit.monthOfFirstDraw,
                buildTimeInMonths: unit.buildTimeInMonths,
                timeFrameToSellOrRefinanceInMonths: unit.timeFrameToSellOrRefinanceInMonths,
                currentValue: unit.asIsValue,
                completedValue: unit.afterRepairValue,
                numberOfBedroom: unit.numberOfBedroom,
                numberOfBathroom: unit.numberOfBathroom,
                numberOfCarGarage: unit.numberOfCarGarage,
                squareFootage: unit.squareFootage
              };
  
              convertedUnits.push(convertedUnit);
            });
          }
          const convertedProperty = {
            id: property.id,
            address: property.street,
            city: property.cityName,
            county: property.countyName,
            workStageId: property.workStageId,
            monthOfFirstDraw: property.monthOfFirstDraw,
            buildTimeInMonths: property.buildTimeInMonths,
            timeFrameToSellOrRefinanceInMonths: property.timeFrameToSellOrRefinanceInMonths,
            existingStructurePropertyTypeId: property.existingStructurePropertyTypeId,
            lotNumber: property.lotNumber,
            newStructurePropertyTypeId: property.newStructurePropertyTypeId,
            numberOfUnits: convertedUnits.length > 0 ? convertedUnits.length : undefined,
            parcelNumber: property.parcelNumber,
            state: property.stateName,
            units: convertedUnits.length > 0 ? convertedUnits : undefined,
            zip: property.zip,
            zoning: property.zoning,
            currentValue: property.asIsValue
          };
          
          convertedProperties.push(convertedProperty);
        });
      }

      handleCalculateGreatestLoanTerm(convertedProperties);
      const convertedCollateralProperties = [] as any[];
      if (obj.borrowerApplicationProperties && obj.borrowerApplicationProperties.length > 0) {
        const collateralProperties = obj.borrowerApplicationProperties.filter(x => x.collateralProperty === true); 
        collateralProperties.forEach(collateralProperty => {
          const convertedCollateralProperty = {
            id: collateralProperty.id,
            address: parseAddressLine1(collateralProperty.street),
            addressLine2: parseAddressLine2(collateralProperty.street),
            zip: collateralProperty.zip,
            city: collateralProperty.cityName,
            state: collateralProperty.stateName,
            county: collateralProperty.countyName,
            parcelNumber: collateralProperty.parcelNumber,
            lotNumber: collateralProperty.lotNumber,
            zoning: collateralProperty.zoning,
            currentValue: collateralProperty.asIsValue,
            numberOfUnits: collateralProperty.numberOfUnits
          };
  
          convertedCollateralProperties.push(convertedCollateralProperty);
        });
      }
  
      const isGuarantorCreated = obj.createdByOrganizationContactId === user.organizationContactId;
      const applicationMetadata = await getApplicationMetadataAsync(isGuarantorCreated, obj.submittedOn, obj.guarantors, isCopy);
      if (obj.borrowerOrganizationId) {
        await handleGetBorrowerEntityAsync(obj.id, obj.borrowerOrganizationId, applicationMetadata);
        if (persona === Personas.WL_GUARANTOR) {
          await handleGetGuarantorGuarantorsAsync(obj.borrowerOrganizationId);
        }
        else {
          await handleGetBrokerGuarantorsAsync(obj.borrowerOrganizationId, obj.id);
        }
      }

      if (obj.builderOrganizationId) {
        await handleGetBuilderAsync(obj.builderOrganizationId);
      }

      let isSelfGuarantor = undefined as boolean | undefined;
      if (obj.guarantors && obj.guarantors.length > 0) {
        if (isGuarantorPersona) {
          const foundSelfGuarantor = obj.guarantors.find(x => x.id === user.organizationContactId);
          isSelfGuarantor = foundSelfGuarantor && foundSelfGuarantor.status !== "Declined" ? true : false;
        }

        const selectedGuarantors = [] as any[];
        if (obj.guarantors) {
          obj.guarantors.forEach((guarantor) => {
            selectedGuarantors.push({
              id: guarantor.id,
              firstName: guarantor.firstName,
              lastName: guarantor.lastName,
              email: guarantor.email,
              accessLevelId: guarantor.accessLevelId,
              status: guarantor.status,
              borrowerApplicationEntityId: guarantor.borrowerApplicationEntityId
            });
          });
        }

        setSelectedBrokerGuarantors(selectedGuarantors);
        await handleGetGuarantorsAsync(obj.submittedOn);
      }
      
      const convertedGmrCostPaids = [] as any[];
      if (obj.borrowerApplicationCostPaids) {
        obj.borrowerApplicationCostPaids.forEach(gmrCostPaid => {
          const convertedGmrCostPaid = {
            id: gmrCostPaid.id,
            amount: gmrCostPaid.amount,
            costPaidId: gmrCostPaid.gmrprojectCostId,
            description: gmrCostPaid.description
          };
  
          convertedGmrCostPaids.push(convertedGmrCostPaid);
        });
      }

      if (obj.screenStatus) {
        const screenStatusObject = JSON.parse(obj.screenStatus);
        setApplicationScreenStatus(screenStatusObject.maxScreens);
        if (isApplicationGuarantor(permissions, "GuarantorWhiteLabeledApplication", "read", obj.guarantors, organizationContactId)) {
          setBrokerScreenStatus(screenStatusObject.screenNo);
          if (screenStatusObject.wlScreenNo && screenStatusObject.wlScreenNo === GuarantorSteps.Disclosure.id) {
            setCurrentStepId(GuarantorSteps.Disclosure.id);
          }
          else {
            setCurrentStepId(ProjectSteps.WhiteLabeledWelcome.id);
          }
        }
        else {
          if (!screenStatusObject || !screenStatusObject.screenNo) {
            setCurrentStepId(ProjectSteps.BrokerWelcome.id);
          }
          else {
            setCurrentStepId(screenStatusObject.screenNo);
          }
        }
      }

      let brokerFeeRate = obj.brokerFeeRate ? Number(obj.brokerFeeRate) : undefined;
      let wlbrokerFeeRate = obj.wlbrokerFeeRate ? Number(obj.wlbrokerFeeRate) - minMandatoryBrokerFee : undefined;
      let isCombineOriginationFee = undefined as any;
      if (!FeatureFlags.IS_BROKER_FEE_ALLIANCE) {
        if (obj?.wlbrokerFeeRate > 0) {
          let displayBrokerFeeRate = obj.wlbrokerFeeRate;
          if (obj?.brokerFeeRate > 0) {
            displayBrokerFeeRate = displayBrokerFeeRate + obj.brokerFeeRate;
          }

          brokerFeeRate = displayBrokerFeeRate;
          isCombineOriginationFee = true;
        } 
        else if (wlbrokerFeeRate || brokerFeeRate) {
          wlbrokerFeeRate = 0;
          isCombineOriginationFee = false;
        }
      }
      
      if (isAdminBrmNwlOrLo && obj.brokerOrganizationContactId) {
        setBrokerSearch(obj.brokerEmail);
      }
      else if (isAdminBrmNwlOrLo && user.organizationContactId === obj.brokerOrganizationContactId) {
        brokerFeeRate = undefined;
        wlbrokerFeeRate = undefined;
      }

      if ([GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL, GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_INTERNAL].indexOf(obj.purchaseRefinanceOptionLookupId) > -1) {
        setIsRefinanceSelected(true);
      }

      const applicationObj = {
        afterRepairValue: obj.afterRepairValue,
        id: obj.id,name: obj.name && obj.name,
        originatingGmrId: obj.originatingGmrId,
        applicationGmrId: obj.applicationGmrId,
        loanProgramId: obj.loanProgramId && obj.loanProgramId,
        city: (obj.cityName && obj.cityName === "Unknown") ? undefined : obj.cityName,
        state: obj.stateName,
        county: obj.countyName,
        zip: obj.zip,
        isBrokerInvolved: (isAdminBrmNwlOrLo && obj.brokerOrganizationContactId) ? true : false,
        brokerSearchEmail: (isAdminBrmNwlOrLo && obj.brokerOrganizationContactId) ? obj.brokerEmail : undefined,
        brokerOrganizationContactId: obj.brokerOrganizationContactId,
        brokerFeeRate: brokerFeeRate,
        wlbrokerFeeRate: wlbrokerFeeRate,
        isCombineOriginationFee: isCombineOriginationFee,
        regularBrokerFeeRate: obj.regularBrokerFeeRate ? obj.regularBrokerFeeRate * 100 : undefined,
        loanOfficerOrganizationContactId: obj.loanOfficerOrganizationContactId,
        existingStructurePropertyTypeId: obj.existingStructurePropertyTypeId,
        newStructurePropertyTypeId: obj.newStructurePropertyTypeId,
        zoning: obj.zoning,
        durationOwnedId: obj.howLongOwnedBorrowerApplicationInputId,
        originalPurchasePrice: obj.originalPurchasePrice && obj.originalPurchasePrice,
        estimatePropertyValue: obj.estimatePropertyValue,
        amountOwed: obj.amountOwed && obj.amountOwed,
        preferredLoanTerm: obj.requestedLoanTermInMonths,
        isSubordinatedDebt: obj.subordinatedDebtAmount ? true : false,
        subordinatedDebtAmount: obj.subordinatedDebtAmount && obj.subordinatedDebtAmount,
        noOfProposedLots: obj.noOfProposedLots && obj.noOfProposedLots,
        developmentBeginsAfterClosingInMonths: obj.developmentBeginsAfterClosingInMonths && obj.developmentBeginsAfterClosingInMonths,
        timeFrameToDevelopInMonths: obj.timeFrameToDevelopInMonths && obj.timeFrameToDevelopInMonths,
        horizontalDevelopmentBudget: obj.horizontalDevelopmentBudget && obj.horizontalDevelopmentBudget,
        sizeOfCurrentProperty: obj.sizeOfCurrentProperty,
        sizeOfProposedLot: obj.sizeOfProposedLot,
        sizeOfCurrentPropertyUnitOfMeasurementBorrowerApplicationInputId: UserFeatureFlags.IS_RETAIL_PHASE_2 ? obj.sizeOfCurrentPropertyUnitOfMeasurementBorrowerApplicationInputId ? obj.sizeOfCurrentPropertyUnitOfMeasurementBorrowerApplicationInputId : GlobalConstants.UnitMeasurements.ACRE : GlobalConstants.UnitMeasurements.ACRE,
        sizeOfProposedLotUnitOfMeasurementBorrowerApplicationInputId: UserFeatureFlags.IS_RETAIL_PHASE_2 ? obj.sizeOfProposedLotUnitOfMeasurementBorrowerApplicationInputId ? obj.sizeOfProposedLotUnitOfMeasurementBorrowerApplicationInputId : GlobalConstants.UnitMeasurements.SQFT : GlobalConstants.UnitMeasurements.SQFT,
        districtReimbursementsAvailableBorrowerApplicationInputId: obj.districtReimbursementsAvailableBorrowerApplicationInputId && obj.districtReimbursementsAvailableBorrowerApplicationInputId,
        districtReimbursementsAvailableDescription: obj.districtReimbursementsAvailableDescription && obj.districtReimbursementsAvailableDescription,
        bondingRequirementsBorrowerApplicationInputId: obj.bondingRequirementsBorrowerApplicationInputId && obj.bondingRequirementsBorrowerApplicationInputId,
        bondingRequirementsDescription: obj.bondingRequirementsDescription && obj.bondingRequirementsDescription,
        seasonalityConcernsBorrowerApplicationInputId: obj.seasonalityConcernsBorrowerApplicationInputId && obj.seasonalityConcernsBorrowerApplicationInputId,
        seasonalityConcernsDescription: obj.seasonailtyConcernsDescription && obj.seasonailtyConcernsDescription,
        permitStatusId: obj.permitStatusId && obj.permitStatusId,
        workStageId: obj.workStageId,
        developmentOrVerticalPermitTimingInMonths: obj.developmentOrVerticalPermitTimingInMonths,
        numberOfProperties: (convertedProperties && convertedProperties.length > 0) ? convertedProperties.length : 1,
        uploadOptionLookupId: obj.uploadOptionLookupId ? obj.uploadOptionLookupId : undefined,
        properties: convertedProperties,
        unitPlans: convertedPlans,
        isAdditionalCollateral: convertedCollateralProperties.length > 0 ? true : false,
        additionalCollateral: convertedCollateralProperties.length > 0 ? convertedCollateralProperties : undefined,
        budget: obj.budget,
        useInterestReserveId: obj.useInterestReserveBorrowerApplicationInputId,
        paidCosts: obj.borrowerApplicationCostPaids && obj.borrowerApplicationCostPaids.length > 0 ? true : false,
        gmrCostPaids: obj.borrowerApplicationCostPaids && obj.borrowerApplicationCostPaids.length ? convertedGmrCostPaids : undefined,
        cashDown: obj.cashDown,
        purchaseRefinanceOptionLookupId: !FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? obj.purchaseRefinanceOptionLookupId : 
          obj.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_INTERNAL ? 
          GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL : obj.purchaseRefinanceOptionLookupId,
        refinanceOptionLookupId: [GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL, GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_INTERNAL].indexOf(obj.purchaseRefinanceOptionLookupId) > -1 ? 
          obj.purchaseRefinanceOptionLookupId : undefined,
        cashOutAmountRequested: obj.cashOutAmountRequested,
        whoWillDoConstructionBorrowerApplicationInputId: obj.whoWillDoConstructionBorrowerApplicationInputId,
        generalContractorId: obj.builderOrganizationId,
        payoffStrategyId: obj.payoffStrategyId,
        requestedClosingDate: obj.requestedClosingDate ? new Date(obj.requestedClosingDate).toISOString().substr(0, 10) : undefined,
        projectComment: obj.projectComment,
        loanOfficerId: obj.loanOfficerOrganizationContactId,
        isExistingBorrower: obj.borrowerOrganizationId ? true : undefined,
        borrowerOrganizationId: obj.borrowerOrganizationId,
        guarantors: obj.guarantors,
        borrowerContactOrganizationContactId : obj.borrowerContactOrganizationContactId,
        cumulativeProjectExperience: obj.cumulativeProjectExperience,
        submittedOn: obj.submittedOn,
        payoffStrategyDescription: obj.payoffStrategyDescription,
        hasUnpaidInvoices: obj.hasUnpaidInvoices,
        createdByOrganizationContactId: obj.createdByOrganizationContactId,
        isSelfGuarantor: isSelfGuarantor,
        permitStatusExplanation: obj.permitStatusExplanation,
      };

      return applicationObj;
    };

    const handleConvertALandReoToView = async (obj, applicationMetadata) => {
      const editAssetsAndLiabilities = [] as any[];
      const assetsAndLiabilitiesViews = [] as any[];
      if (obj.alschedules && obj.alschedules.length > 0) {
        obj.alschedules.forEach(al => {
          const editAssetAndLiability = {
            id: al.id,
            alOption: al.alclassName,
            alType: al.altypeId,
            institutionName: al.institution,
            currentBalance: al.value,
            monthlyLiability: al.monthlyLiability,
            status: al.alstatusId,
            isEditHide: al.pulledByApi === true,
            isDeleteHide: al.pulledByApi === true
          };
  
          const assetAndLiabilityView = {
            id: al.id,
            "Class": al.alclassName,
            "Type": al.alclassName === "Asset" ? handleGetValueFromId(applicationMetadata.assetTypes, al.altypeId) : handleGetValueFromId(applicationMetadata.liabilityTypes, al.altypeId),
            "Name of Institution": al.institution,
            "Current Balance": al.value,
            "Monthly Liability": al.monthlyLiability,
            "Status": handleGetValueFromId(applicationMetadata.alStatuses, al.alstatusId),
            isEditHide: al.pulledByApi === true,
            isDeleteHide: al.pulledByApi === true
          };
  
          assetsAndLiabilitiesViews.push(assetAndLiabilityView);
          editAssetsAndLiabilities.push(editAssetAndLiability);
        });
      }
  
      const editReoSchedules = [] as any[];
      const reoSchedulesViews = [] as any[];
      if (obj.reoschedules && obj.reoschedules.length > 0) {
        obj.reoschedules.forEach(reoSchedule => {
          const editReoSchedule = {
            id: reoSchedule.id,
            reoType: reoSchedule.reotypeId,
            reoStatus: reoSchedule.reostatusId,
            amountOwed: reoSchedule.amountOwed,
            isMortgageFree: reoSchedule.mortgageFree,
            street: reoSchedule.street,
            zip: reoSchedule.zipCode,
            state: reoSchedule.stateName,
            city: reoSchedule.cityName,
            marketValue: reoSchedule.marketValue,
            parcelNumber: reoSchedule.parcelNumber,
            maintenance: reoSchedule.monthlyTaxInsuranceAndMaintenance,
            alSchedule1: reoSchedule.mortgage1AlscheduleName,
            alSchedule2: reoSchedule.mortgage2AlscheduleName,
            alSchedule3: reoSchedule.mortgage3AlscheduleName,
            mortgageAmount1: reoSchedule.mortgageAmount1,
            mortgageAmount2: reoSchedule.mortgageAmount2,
            mortgageAmount3: reoSchedule.mortgageAmount3,
            mortgagePayment1: reoSchedule.mortgagePayment1,
            mortgagePayment2: reoSchedule.mortgagePayment2,
            mortgagePayment3: reoSchedule.mortgagePayment3,
            holder1: reoSchedule.mortgageHolder1,
            holder2: reoSchedule.mortgageHolder2,
            holder3: reoSchedule.mortgageHolder3,
            reoScheduleDescription: reoSchedule.description,
            additionalCollateral: reoSchedule.additionalCollateral ? true : false
          };
  
          const reoScheduleView = {
            id: reoSchedule.id,
            "Address": `${reoSchedule.street}, ${reoSchedule.cityName}, ${reoSchedule.stateName}`,
            "Market Value": reoSchedule.marketValue,
            "Parcel Number": reoSchedule.parcelNumber,
            "Total Mortgage Amount": (reoSchedule.mortgageAmount1 ? reoSchedule.mortgageAmount1 : 0) + 
              (reoSchedule.mortgageAmount2 ? reoSchedule.mortgageAmount2 : 0) + (reoSchedule.mortgageAmount3 ? reoSchedule.mortgageAmount3 : 0),
            "Total Mortgage Payment": (reoSchedule.mortgagePayment1 ? reoSchedule.mortgagePayment1 : 0) + 
              (reoSchedule.mortgagePayment2 ? reoSchedule.mortgagePayment2 : 0) + (reoSchedule.mortgagePayment3 ? reoSchedule.mortgagePayment3 : 0),
            "REO Type": handleGetValueFromId(applicationMetadata.reoTypes, reoSchedule.reotypeId),
            "Reo Status": handleGetValueFromId(applicationMetadata.reoStatuses, reoSchedule.reostatusId)
          }; 
  
          reoSchedulesViews.push(reoScheduleView);
          editReoSchedules.push(editReoSchedule);
        });
      }
  
      return {
        assetsAndLiabilitiesViews: assetsAndLiabilitiesViews,
        editAssetsAndLiabilities: editAssetsAndLiabilities,
        reoSchedulesViews: reoSchedulesViews,
        editReoSchedules: editReoSchedules
      };
    };

    const handleGetBorrowerEntityAsync = async (applicationId, entityId, metadata) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockBorrowerEntity(applicationId, entityId) : await getBorrowerEntity(applicationId, entityId, proxyUser.id) as any;
        if (response && response.ok) {
          const apiBorrower = await response.json();
          const alAndReoObj = await handleConvertALandReoToView(apiBorrower, metadata) as any;
          const newEditBorrowerEntity = {
            id: apiBorrower.id,
            name: apiBorrower.name,
            physicalStreet: parseAddressLine1(apiBorrower.physicalStreet),
            addressLine2: parseAddressLine2(apiBorrower.physicalStreet),
            physicalZipCode: apiBorrower.physicalZipCode,
            physicalCityName: apiBorrower.physicalCityName,
            physicalStateName: apiBorrower.physicalStateName,
            physicalCountyName: apiBorrower.physicalCountyName,
            entitySubTypeId: apiBorrower.entitySubTypeId,
            eintin: apiBorrower.employerIdentificationNumber,
            website: apiBorrower.website,
            yearsInBusiness: apiBorrower.yearsInIndustry,
            grossRevenue: apiBorrower.monthlyRevenue,
            netIncome: apiBorrower.monthlyIncome,
            assetsAndLiabilities: alAndReoObj && alAndReoObj.editAssetsAndLiabilities,
            reoSchedules: alAndReoObj && alAndReoObj.editReoSchedules
          };
    
          setNewBorrowerEntity({...newEditBorrowerEntity});
          setEntityAssetAndLiabilities(alAndReoObj && alAndReoObj.assetsAndLiabilitiesViews);

          if (newEditBorrowerEntity.reoSchedules && newEditBorrowerEntity.reoSchedules.length > 0) {
            const entityAdditionalCollateral = [] as any;
            newEditBorrowerEntity.reoSchedules.forEach(reoschedule => {
              if (reoschedule.additionalCollateral) {
                const additonalCollateralView = {
                  id: reoschedule.id,
                  "Address": handleAddressValue({
                    address: reoschedule.street,
                    city: reoschedule.city,
                    state: reoschedule.state,
                    zip: reoschedule.zip
                  }),
                  "Market Value": reoschedule.marketValue,
                  "Owner": newEditBorrowerEntity.name
                };

                entityAdditionalCollateral.push(additonalCollateralView);
              }
            });

            setEntityAdditionalCollateral(entityAdditionalCollateral);
          }
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        setIsMessage(false);
      }
    };

    const getApplicationInfoListAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockApplicationInfolist() : await getApplicationInfoList(proxyUser.id);
        if (response && response.ok) {
          return await response.json();
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        handleError();
      }
    };

    const handleAcceptGuarantorInvitation = async (guarantor) => {
      if (proxyUser && proxyUser.organizationContactId) {
        return true;
      }

      const acceptObj = {
        borrowerApplicationId: applicationId,
        guarantorEmail: guarantor.email,
        guarantorOrganizationContactId: guarantor.id
      };

      try {
        const response = FeatureFlags.IS_MOCK ? await acceptMockGuarantorInvitation(acceptObj) : await acceptGuarantorInvitation(acceptObj, proxyUser.id);
        if (response && response.ok) {
          return true;
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        setIsMessage(false);
      }

      return false;
    };

    const handleGetGuarantorAsync = async (guarantorId, submittedOn, metadata, isCopy = false, isGuarantorCreated = false) => {
      try {
        const getGuarantorObj = {
          "BorrowerApplicationId": applicationId,
          "OrganizationContactId": guarantorId
        };
        const response = FeatureFlags.IS_MOCK ? await getMockGuarantor(getGuarantorObj) : await getGuarantor(getGuarantorObj, proxyUser.id) as any;
        if (response && response.ok) {
          const apiGuarantor = await response.json();
          if (!getIsWhiteLabeled() && submittedOn && apiGuarantor.submittedOn && !isCopy) {
            handleRouteToApplicationInteriorCard(applicationId);
          }

          let alAndReoObj = undefined as any;
          if (metadata) {
            alAndReoObj = await handleConvertALandReoToView(apiGuarantor, metadata);
          }

          const newEditGuarantor = {
            id: apiGuarantor.id,
            firstName: apiGuarantor.firstName,
            lastName: apiGuarantor.lastName,
            email: apiGuarantor.email,
            mobilePhone: apiGuarantor.mobilePhone,
            physicalAddress: parseAddressLine1(apiGuarantor.physicalStreet),
            physicalAddressLine2: parseAddressLine2(apiGuarantor.physicalStreet),
            physicalZip: apiGuarantor.physicalZipCode,
            physicalCity: apiGuarantor.physicalCityName,
            physicalState: apiGuarantor.physicalStateName,
            physicalCounty: apiGuarantor.physicalCountyName,
            isMailingSameAsPhysical: apiGuarantor.physicalAddress === apiGuarantor.mailingAddress,
            mailingAddress: parseAddressLine1(apiGuarantor.mailingStreet),
            mailingAddressLine2: parseAddressLine2(apiGuarantor.mailingStreet),
            mailingZip: apiGuarantor.mailingZipCode,
            mailingCity: apiGuarantor.mailingCityName,
            mailingState: apiGuarantor.mailingStateName,
            mailingCounty: apiGuarantor.mailingCountyName,
            organizationRole: apiGuarantor.employerPosition,
            homePhone: apiGuarantor.homePhone,
            businessPhone: apiGuarantor.officePhone,
            extension: apiGuarantor.officePhoneExtension,
            socialSecurityNumber: apiGuarantor.socialSecurityNumber,
            creditScore: apiGuarantor.creditScore,
            estimatedCreditScore: apiGuarantor.estimatedCreditScore,
            isCreditScorePulled: apiGuarantor.isCreditScorePulled,
            dateOfBirth: apiGuarantor.dateOfBirth ? new Date(apiGuarantor.dateOfBirth).toISOString().substr(0, 10) : undefined,
            maritalStatus: apiGuarantor.maritalStatusId,
            spouseName: apiGuarantor.spouseName,
            isSelfEmployed: apiGuarantor.selfEmployed,
            employerName: apiGuarantor.employerName,
            position: apiGuarantor.employerPosition,
            netIncome: apiGuarantor.monthlyIncome,
            grossRevenue: apiGuarantor.monthlyRevenue,
            yearsInIndustry: apiGuarantor.yearsInIndustry,
            yearsInBusiness: apiGuarantor.yearsInBusiness,
            yearsInJob: apiGuarantor.yearsInJob,
            isUSCitizen: apiGuarantor.uscitizen,
            citizenStatus: apiGuarantor.citizenshipStatus,
            isPendingLegalAction: apiGuarantor.pendingLegalAction,
            legalActionDescription: apiGuarantor.legalActionDescription,
            isForeclosureInitiated: apiGuarantor.isForeclosureInitiated,
            forclosureDescription: apiGuarantor.foreclosureDescription,
            otherCreditNames: apiGuarantor.otherCreditName,
            assetsAndLiabilities: alAndReoObj && alAndReoObj.editAssetsAndLiabilities,
            reoSchedules: alAndReoObj && alAndReoObj.editReoSchedules,
            isDisclosureCompleted: apiGuarantor.isDisclosureCompleted
          };
          
          if (!apiGuarantor.socialSecurityNumber) {
            setIsSSNReveal(true);
          }

          if (!apiGuarantor.dateOfBirth) {
            setIsDOBReveal(true);
          }

          setNewGuarantor(newEditGuarantor);
          setGuarantorAssetAndLiabilities(alAndReoObj && alAndReoObj.assetsAndLiabilitiesViews);
          setGuarantorReoSchedules(alAndReoObj && alAndReoObj.reoSchedulesViews);
          if (!isGuarantorCreated) {
            handleAcceptGuarantorInvitation(apiGuarantor);
          }
          
          return apiGuarantor;
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        setIsMessage(false);
      }
    };

    const handleGetGuarantorsAsync = async (submittedOn) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockGuarantors(applicationId) : await getGuarantors(applicationId, proxyUser.id) as any;
        if (response && response.ok) {
          const apiGuarantors = await response.json();
          // TODO: Remove after refactor
          if (getIsWhiteLabeled() && apiGuarantors && apiGuarantors.length > 0) {
            const foundUserIsGuarantor = apiGuarantors.find(x => x.id === user.organizationContactId);
            if (foundUserIsGuarantor && foundUserIsGuarantor.disclosureCompletedOn && submittedOn) {
              handleRouteToApplicationInteriorCard(applicationId);
            }
          }
          
          const additonalCollateralViews = [] as any[];
          const additonalCollateralReos = [] as any[];
          apiGuarantors.forEach(apiGuarantor => {
            if (apiGuarantor.reoschedules && apiGuarantor.reoschedules.length > 0) {
              apiGuarantor.reoschedules.forEach(reoschedule => {
                if (reoschedule.additionalCollateral) {
                  const additonalCollateralView = {
                    "Address": handleAddressValue({
                      address: reoschedule.street,
                      city: reoschedule.cityName,
                      state: reoschedule.stateName,
                      zip: reoschedule.zipCode
                    }),
                    "Market Value": reoschedule.marketValue,
                    "Owner": `${apiGuarantor.firstName} ${apiGuarantor.lastName}`
                  };

                  additonalCollateralViews.push(additonalCollateralView);
                  reoschedule.owner = `${apiGuarantor.firstName} ${apiGuarantor.lastName}`;
                  additonalCollateralReos.push(reoschedule);
                }
              });
            }
          });

          setGuarantorAdditionalCollateral([...additonalCollateralViews]);
          setGuarantorAdditionalCollateralFull([...additonalCollateralReos]);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        setIsMessage(false);
      }
    };

    const getApplicationMetadataAsync = async (isGuarantorCreated = false, submittedOn = undefined, applicationGuarantors = [] as any[], isCopy = false) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockApplicationMetadata() : await getApplicationMetadata(proxyUser.id);
        if (response && response.ok) {
          const applicationMetadata = await response.json();
          setMetaGuarantors(applicationMetadata.guarantors);
          let allBrokers = [];
          if (isAdminPersona) { 
            allBrokers = await getAllBrokersAsync();
            applicationMetadata.associatedBrokers = allBrokers;
          } 

          setApplicationMetadata(applicationMetadata);
          let metadataExcludedIds = [SummarySteps.Calculation.id] as string[];
          if (isGuarantorPersona) {
            if (isGuarantorCreated) {
              metadataExcludedIds = metadataExcludedIds.concat([ProjectSteps.WhiteLabeledWelcome.id]);
            }
            else if (persona === Personas.WL_GUARANTOR && isApplicationGuarantor(permissions, "GuarantorWhiteLabeledApplication", "read", applicationGuarantors, organizationContactId)) {
              metadataExcludedIds = metadataExcludedIds.concat([ProjectSteps.BrokerWelcome.id, GuarantorSteps.SelfGuarantor.id]);
              const foundSelfGuarantor = applicationGuarantors.find(x => x.id === organizationContactId);
              if (!FeatureFlags.IS_BETA || (FeatureFlags.IS_BETA && foundSelfGuarantor && [GlobalConstants.AccessLevelIds.LIMITED, GlobalConstants.AccessLevelIds.LIMITED].indexOf(foundSelfGuarantor.accessLevelId) > -1)) {
                metadataExcludedIds = metadataExcludedIds.concat([GuarantorSteps.DoubleFilterGuarantor.id]);
              }
            }
            
            metadataExcludedIds = metadataExcludedIds.concat([GuarantorSteps.BorrowerGuarantor.id]);
            if (organizationContactId) {
              const apiGuarantor = await handleGetGuarantorAsync(organizationContactId, submittedOn, applicationMetadata, isCopy, isGuarantorCreated);
              if (apiGuarantor && apiGuarantor.isCreditScorePulled && apiGuarantor.creditScore) {
                metadataExcludedIds = metadataExcludedIds.concat([GuarantorSteps.CreditScore.id]);
              }
              
              if (apiGuarantor && apiGuarantor.isDisclosureCompleted) {
                applicationMetadata.isGuarantorDisclosure = apiGuarantor.isDisclosureCompleted;
              }
            }
          }
          else if (persona === Personas.UNKNOWN) {
            handleError();
          }
          else if (isValidPermission(permissions, "BrokerBorrowerApplication", "read")) {
            metadataExcludedIds = metadataExcludedIds.concat([ProjectSteps.WhiteLabeledWelcome.id, GuarantorSteps.BorrowerGuarantor.id, GuarantorSteps.CreditScore.id, 
              GuarantorSteps.AdditionalInformation.id, GuarantorSteps.Assets.id, GuarantorSteps.Liabilities.id, 
              GuarantorSteps.RealEstateOwned.id, GuarantorSteps.Disclosure.id, "80706312-52b1-484e-b491-666129d2348e", 
              "d2fe7caf-7d1d-4f8d-8732-36f2c6a52a6f", GuarantorSteps.SelfGuarantor.id]);
          }
          
          setMetadataExcludedIds([...metadataExcludedIds]);
          return applicationMetadata;
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        handleError();
      }
    };

    const handleExcludedIds = (infoObj, startAppObject, isGmrInfo = false) => {
      let excludedIds = [] as string[];
      if (infoObj["loanProgramId"] === GlobalConstants.LoanProgramIds.ALL_IN_ONE) {
        excludedIds = excludedIds.concat(AllInOneExcludeIds);
        if (isGmrInfo) {
          startAppObject.existingStructurePropertyTypeId = GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
        }
      }
      else if (infoObj["loanProgramId"] === GlobalConstants.LoanProgramIds.BRIDGE) {
        excludedIds = excludedIds.concat(FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? [...BridgeExcludeIds, PropertySteps.Plans.id] : BridgeExcludeIds);
      }
      else if (infoObj["loanProgramId"] === GlobalConstants.LoanProgramIds.DEVELOPMENT) {
        excludedIds = excludedIds.concat(FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? [...DevelopmentExcludeIds, PropertySteps.Plans.id] : DevelopmentExcludeIds);
        if (isGmrInfo) {
          startAppObject.newStructurePropertyTypeId = GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
          startAppObject.existingStructurePropertyTypeId = FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? GlobalConstants.PropertyTypeIds.LAND_UNDEVELOPED : GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
        }
      }
      else if (infoObj["loanProgramId"] === GlobalConstants.LoanProgramIds.FIX_AND_FLIP) {
        excludedIds = excludedIds.concat(FixAndFlipExcludeIds);
      }
      else if (infoObj["loanProgramId"] === GlobalConstants.LoanProgramIds.NEW_CONSTRUCTION) {
        excludedIds = excludedIds.concat(NewConstructionExcludeIds);
        if (isGmrInfo) {
          startAppObject.existingStructurePropertyTypeId = GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
        }
      }
      else if (infoObj["loanProgramId"] === GlobalConstants.LoanProgramIds.BRIDGE_TO_BUILD) {
        excludedIds = excludedIds.concat(BridgeToBuildExcludeIds);
        if (isGmrInfo) {
          startAppObject.existingStructurePropertyTypeId = GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
        }
      }

      if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
        if ((isGmrInfo && infoObj["propertyTypeId"] === GlobalConstants.PropertyTypeIds.APARTMENT) || (!isGmrInfo && infoObj["newStructurePropertyTypeId"] === GlobalConstants.PropertyTypeIds.APARTMENT)) {
          excludedIds = excludedIds.concat([...excludedStepIds, PropertySteps.Plans.id]);
        }
      }

      if (startAppObject?.isSelfGuarantor === false) {
        const selfGuarantorExcludedStepIds = [GuarantorSteps.AdditionalInformation.id, GuarantorSteps.Assets.id, GuarantorSteps.Liabilities.id, GuarantorSteps.RealEstateOwned.id, GuarantorSteps.CreditScore.id, GuarantorSteps.Disclosure.id];
        excludedIds = excludedIds.concat(selfGuarantorExcludedStepIds); 
      }

      setExcludedStepIds(excludedIds);
      return startAppObject;
    };

    const getApplicationInfoAsync = async (applicationId, newApplicationId = undefined) => {
      try {
        let response = undefined as any;
        if (newApplicationId) {
          const copyObject = {
            originalBorrowerApplicationId: applicationId,
            newBorrowerApplicationId: newApplicationId
          };

          response = FeatureFlags.IS_MOCK ? await getMockApplicationCopy(copyObject) : await getApplicationCopy(copyObject, proxyUser.id);
        }
        else {
          response = FeatureFlags.IS_MOCK ? await getMockApplicationInfo(applicationId) : await getBorrowerApplicationInfo(applicationId, proxyUser.id);
        }
        
        if (response && response.ok) {
          const applicationInfo = await response.json();
          let convertedAppObj = await convertToStartAppObj(applicationInfo, newApplicationId ? true : false);
          await handleAssociatedBorrowers(
            isAllBorrowersPersona, 
            handleAssociatedOrganizationContactId(convertedAppObj, persona === Personas.BROKER && user.organizationContactId),
            setAssociatedBorrowers,
            proxyUser,
            setIsMessage,
            setErrorResponse
          );

          if (convertedAppObj.uploadOptionLookupId === GlobalConstants.UploadOptions.UPLOAD) {
            setIsPropertyUnitMixUploaded(true);
          }
          
          convertedAppObj = handleExcludedIds(applicationInfo, convertedAppObj);
          if (newApplicationId) {
            setCurrentStepId(ProjectSteps.ProjectOverview.id);
          }

          if (isGuarantorPersona) {
            if (applicationInfo && applicationInfo.isWhiteLabeled) {
              setPersona(Personas.WL_GUARANTOR);
            }
            else if (applicationInfo && applicationInfo.isWhiteLabeled === false) {
              setPersona(Personas.NWL_GUARANTOR);
            }
          }

          setStartAppObject(convertedAppObj);
          setInitialStartAppObject(deepCopy(convertedAppObj));
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        handleError();
      }
    };

    const getAllDataAsync = async (applicationId) => {
      try {
        const applicationInfoList = await getApplicationInfoListAsync();  
        if (applicationInfoList) {
          const foundApplicationInfo = applicationInfoList.find(x => x.id === applicationId);
          if (foundApplicationInfo) {
            setIsApplicationNew(false);
            await getApplicationInfoAsync(applicationId);
          }
          else if (copiedApplicationId !== undefined) {
            setIsApplicationNew(false);
            await getApplicationInfoAsync(copiedApplicationId, applicationId);
          }
          else {
            const applicationMetadata = await getApplicationMetadataAsync(isGuarantorPersona);
            const initialStartAppObject = {
              id: applicationId,
              isBrokerInvolved: persona === Personas.BROKER_ADMIN ? true : isAdminBrmNwlOrLo ? false : undefined,
              loanOfficerOrganizationContactId: (proxyUser.id
                ? proxyUser.preferredLoanOfficerOrganizationContactId
                : user.preferredLoanOfficerOrganizationContactId) || ""
            } as any;

            if (FeatureFlags.IS_BETA && isGuarantorPersona && applicationMetadata.associatedBrokers && applicationMetadata.associatedBrokers.length === 1) {
              initialStartAppObject.brokerOrganizationContactId = applicationMetadata.associatedBrokers[0].id;
            }  

            setStartAppObject(initialStartAppObject);
            await handleAssociatedBorrowers(
              isAllBorrowersPersona, 
              handleAssociatedOrganizationContactId(initialStartAppObject, persona === Personas.BROKER && user.organizationContactId),
              setAssociatedBorrowers,
              proxyUser,
              setIsMessage,
              setErrorResponse
            );
          }
        }
        
        setIsLoading(false);
      }
      catch (error) {
        setIsLoading(false);
      }
    };

    const getGmrSummaryAsync = async (gmrId) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockGMRSummary(gmrId) : await getGMRSummary(gmrId, proxyUser.id);
        if (response && response.ok) {
          const gmrSummaryObject = await response.json();
          gmrSummaryObject.id = applicationId;
          const publishProperties = [] as any[];
          for (let i = 0; i < gmrSummaryObject.numberOfPropertiesOrUnits; i++) {
            let numberOfUnits = undefined as number | undefined;
            if (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT || gmrSummaryObject.propertyTypeId === GlobalConstants.PropertyTypeIds.SINGLE_FAMILY ||
              (startAppObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE && startAppObject.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND)) {
                numberOfUnits = 1;
            }

            const publishProperty = {
              id: guid(),
              zip: gmrSummaryObject.projectZipCode,
              city: gmrSummaryObject.cityName,
              county: gmrSummaryObject.countyName,
              state: gmrSummaryObject.stateName,
              newStructurePropertyTypeId: gmrSummaryObject.propertyTypeId,
              existingStructurePropertyTypeId: !FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? gmrSummaryObject.propertyTypeId : null,
              collateralProperty: false,
              numberOfUnits: numberOfUnits,
              monthOfFirstDraw: gmrSummaryObject?.gmrUnitDrawMonths[i]?.monthOfFirstDraw,
              buildTimeInMonths: gmrSummaryObject.totalBuildTimeInMonths
            } as any;

            if (gmrSummaryObject.loanProgramId === GlobalConstants.LoanProgramIds.BRIDGE) {
              publishProperty.numberOfUnits = 1;
            }

            if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && gmrSummaryObject.loanProgramId === GlobalConstants.LoanProgramIds.DEVELOPMENT) {
              publishProperty.existingStructurePropertyTypeId = GlobalConstants.PropertyTypeIds.LAND_UNDEVELOPED;
              publishProperty.numberOfUnits = 1;
            }

            publishProperties.push(publishProperty);
          }
          
          const costPaids = [] as any[];
          if (gmrSummaryObject.gmrCostPaids) {
            gmrSummaryObject.gmrCostPaids.forEach(gmrCostPaid => {
              const convertedGmrCostPaid = {
                id: gmrCostPaid.id,
                amount: gmrCostPaid.amount,
                costPaidId: gmrCostPaid.gmrprojectCostId,
                description: gmrCostPaid.description
              };
    
              costPaids.push(convertedGmrCostPaid);
            });
          }

          if (FeatureFlags.IS_BETA) {
            if (isAdminBrmNwlOrLo && gmrSummaryObject.brokerOrganizationContactId && gmrSummaryObject.brokerEmail) {
              gmrSummaryObject.isBrokerInvolved = true;
              setBrokerSearch(gmrSummaryObject.brokerEmail);
            }
            else if (isAdminBrmNwlOrLo && !gmrSummaryObject.brokerOrganizationContactId) {
              gmrSummaryObject.isBrokerInvolved = false;
            }
          }
          
          let brokerFeeRate = gmrSummaryObject.brokerFeeRate ? Number(gmrSummaryObject.brokerFeeRate) : undefined;
          let wlbrokerFeeRate = gmrSummaryObject.wlbrokerFeeRate ? Number(gmrSummaryObject.wlbrokerFeeRate) - minMandatoryBrokerFee : undefined;
          let isCombineOriginationFee = undefined as any;
          if (!FeatureFlags.IS_BROKER_FEE_ALLIANCE) {
            if (gmrSummaryObject?.wlbrokerFeeRate > 0) {
              let displayBrokerFeeRate = gmrSummaryObject.wlbrokerFeeRate;
              if (gmrSummaryObject?.brokerFeeRate > 0) {
                displayBrokerFeeRate = displayBrokerFeeRate + gmrSummaryObject.brokerFeeRate;
              }

              brokerFeeRate = displayBrokerFeeRate;
              isCombineOriginationFee = true;
            } 
            else if (wlbrokerFeeRate || brokerFeeRate) {
              wlbrokerFeeRate = 0;
              isCombineOriginationFee = false;
            }
          }

          const newEditBorrowerEntity = {};
          setNewBorrowerEntity(newEditBorrowerEntity);
          let startObjData = {
            id: applicationId,
            originatingGmrId: gmrId,
            name: gmrSummaryObject.name, 
            isBrokerInvolved: persona === Personas.BROKER_ADMIN ? true : gmrSummaryObject.isBrokerInvolved,
            brokerSearchEmail: gmrSummaryObject.brokerEmail,
            brokerOrganizationContactId: gmrSummaryObject.brokerOrganizationContactId,
            brokerFeeRate: brokerFeeRate,
            wlbrokerFeeRate: wlbrokerFeeRate,
            isCombineOriginationFee: isCombineOriginationFee,
            loanOfficerOrganizationContactId: gmrSummaryObject.loanOfficerOrganizationContactId,
            loanProgramId: gmrSummaryObject.loanProgramId, 
            existingStructurePropertyTypeId: gmrSummaryObject.propertyTypeId,
            newStructurePropertyTypeId: gmrSummaryObject.propertyTypeId, 
            purchaseRefinanceOptionLookupId: !FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? gmrSummaryObject.purchaseRefinanceOptionLookupId :
              gmrSummaryObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_INTERNAL ? 
              GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL : gmrSummaryObject.purchaseRefinanceOptionLookupId,
            refinanceOptionLookupId: [GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL, GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_INTERNAL].indexOf(gmrSummaryObject.purchaseRefinanceOptionLookupId) > -1 ? 
              gmrSummaryObject.purchaseRefinanceOptionLookupId : undefined,
            originalPurchasePrice: (gmrSummaryObject.refinancePayoff && gmrSummaryObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE) ?
              gmrSummaryObject.refinancePayoff : undefined,
            amountOwed: (gmrSummaryObject.refinancePayoff && gmrSummaryObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL) ?
              gmrSummaryObject.refinancePayoff : undefined,
            cashOutAmountRequested: (gmrSummaryObject.refinancePayoff && gmrSummaryObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.OWN) ?
              gmrSummaryObject.refinancePayoff : undefined,
            timeFrameToDevelopInMonths: gmrSummaryObject.totalBuildTimeInMonths, 
            cashDown: gmrSummaryObject.cashDown, 
            budget: gmrSummaryObject.budget,
            useInterestReserveId: gmrSummaryObject.useInterestReserve ? GlobalConstants.InterestCalculationMethodIds.INTEREST_RESERVE : GlobalConstants.InterestCalculationMethodIds.MONTHLY_PAYMENTS,
            paidCosts: gmrSummaryObject.gmrCostPaids && gmrSummaryObject.gmrCostPaids.length === 0 ? false : true,
            gmrCostPaids: costPaids,
            hasCostPaidsChanged: costPaids.length > 0 ? true : false,
            zip : gmrSummaryObject.projectZipCode,
            city: gmrSummaryObject.cityName,
            county: gmrSummaryObject.countyName,
            state: gmrSummaryObject.stateName,
            numberOfProperties: [GlobalConstants.LoanProgramIds.DEVELOPMENT, GlobalConstants.LoanProgramIds.FIX_AND_FLIP].indexOf(gmrSummaryObject.loanProgramId) > -1 ? 1 : gmrSummaryObject.numberOfPropertiesOrUnits,
            properties: publishProperties,
            requestedClosingDate: gmrSummaryObject.estimatedClosingDate ? convertToDateString(gmrSummaryObject.estimatedClosingDate, "calendar") : null,
            cumulativeProjectExperience: gmrSummaryObject.projectExperience,
            preferredLoanTerm: gmrSummaryObject.requestedLoanTermInMonths,
            borrowerOrganizationName: gmrSummaryObject?.borrowerInfo?.companyName
          } as any;

          startObjData = handleExcludedIds(gmrSummaryObject, startObjData, true);
          await getApplicationMetadataAsync();
          await handleAssociatedBorrowers(
            isAllBorrowersPersona, 
            handleAssociatedOrganizationContactId(startObjData, persona === Personas.BROKER && user.organizationContactId),
            setAssociatedBorrowers,
            proxyUser,
            setIsMessage,
            setErrorResponse
          );

          if (gmrSummaryObject.name && gmrSummaryObject.loanProgramId && gmrSummaryObject.brokerFeeRate && gmrSummaryObject.wlbrokerFeeRate) {
            prefilledFromGmr.projectBasicInfo = true;
          }

          if (gmrSummaryObject.borrowerOrganizationId) {
            await handleGetBorrowerEntityAsync(applicationId, gmrSummaryObject.borrowerOrganizationId, applicationMetadata);
            startObjData.isExistingBorrower = true;
            startObjData.borrowerOrganizationId = gmrSummaryObject.borrowerOrganizationId;
            prefilledFromGmr.borrowerInfo = true;
          }

          setStartAppObject(startObjData);
          setStartAppObjectFromGmr(startObjData);
          setIsPatchedFromGmr(true);
          setPrefilledFromGmr({...prefilledFromGmr});
          setIsLoading(false);
        }
        else {
          setIsMessage(true);
        }
      }
      catch (error) {
        handleError();
      }
    }; 

    if (isFirstLoad) {
      if (applicationRef.current) {
        applicationRef.current.focus();
      }

      if (gmrEditData && gmrEditData.id) {
        getGmrSummaryAsync(gmrEditData.id);
        setGmrEditData({});
      }
      else {
        getAllDataAsync(applicationId);
      }
    }
  }, [
    setIsMessage, 
    setErrorResponse,
    handleError, 
    handleRouteToApplicationInteriorCard,
    proxyUser, 
    isFirstLoad, 
    applicationId, 
    startAppObject,
    ApplicationSteps,
    copiedApplicationId,
    ProjectSteps.ProjectOverview.id,
    ProjectSteps.WhiteLabeledWelcome.id,
    GuarantorSteps.AdditionalInformation.id,
    SummarySteps.Calculation.id,
    AllInOneExcludeIds,
    BridgeExcludeIds,
    DevelopmentExcludeIds,
    FixAndFlipExcludeIds,
    NewConstructionExcludeIds,
    BridgeToBuildExcludeIds,
    GuarantorSteps,
    organizationContactId,
    permissions,
    gmrEditData,
    setGmrEditData,
    generalContractors
  ]);

  useEffect(() => {
    setIsFirstLoad(false);
  }, []);

  return (
    <div 
      className={`wizard-container ${(isGreaterThanTablet && isSidebar) ? "hide-sidebar" : "sidebar"}`} 
      tabIndex={0}
      onKeyDown={(e) => handleEnterKeyNext(e, currentStepId)}
      ref={applicationRef as any}
    >
      <BCModal
        isModalOpen={primeGuarantorModal}
        onClose={() => clearInviteGuarantorFormInputs()}
        size="large"
        closeIcon
        header="Inviting a Guarantor"
        subHeader="Complete these fields to quickly invite your primary Guarantor."
        content={<BPAddGuarantorForm 
          applicationMetadata={applicationMetadata} 
          handleBrokerGuarantorInviteAsync={handleBrokerGuarantorInviteAsync} 
          handleApplicationFormChange={handleApplicationFormChange} 
          handleSaveApplication={handleSaveApplication}
          startAppObject={startAppObject} 
          setStartAppObject={setStartAppObject}
          setPrimeGuarantorModal={setPrimeGuarantorModal}
          setIsApplicationNew={setIsApplicationNew}
          clearInviteGuarantorFormInputs={clearInviteGuarantorFormInputs} 
          handleGetBorrowerEntityAsync={handleGetBorrowerEntityAsync}
          newBorrowerEntity={newBorrowerEntity}
          setNewBorrowerEntity={setNewBorrowerEntity}
          handleEntityFormChange={(value, field, type, charLimit) => handleApplicationFormChange(value, field, newBorrowerEntity, setNewBorrowerEntity, type, undefined, charLimit)}
          handleGuarantorSearchChange={handleGuarantorSearchChange}
          guarantorSearch={guarantorSearch}
          handleDoubleFilterGuarantorSuggestions={handleDoubleFilterGuarantorSuggestions}
          handleGuarantorSelect={handleGuarantorSelect}
          isBrokerGuarantorSelected={isBrokerGuarantorSelected}
          handleGuarantorFocus={handleGuarantorFocus}
          setIsBrokerGuarantorInvited={setIsBrokerGuarantorInvited}
          setBrokerGuarantorInvitedName={setBrokerGuarantorInvitedName}
          handleCreateOrPatchBorrowerEntity={handleCreateOrPatchBorrowerEntity}
          handleCreateOrPatchGuarantor={handleCreateOrPatchGuarantor}
        />}
      />
      <BCMessage
        animation={"fly down"}
        duration={750}
        visible={isMessage}
        transitionOnMount
        styles="full-width"
        onDismiss={() => setIsMessage(false)}
        errorResponse={errorResponse}
      />
      {(currentStepId === EntitySteps.AdditionalInformation.id && isNotifyLoanOfficerPersona &&
        startAppObject.loanOfficerOrganizationContactId &&
        applicationScreenStatus.Projects === ProjectSteps.PermitStatus.id &&
        applicationScreenStatus.Property === PropertySteps.LoanTerm.id &&
        applicationScreenStatus.Budget === BudgetSteps.ProjectDetails.id) ? <BCMessage 
          animation={"fly down"}
          duration={750}
          visible={isLoanOfficerMessage}
          transitionOnMount
          styles="full-width"
          color="green"
          onDismiss={() => setIsLoanOfficerMessage(false)}
          header="Success!"
          custom={<>
            <div>You have entered enough information to negotiate pricing with your loan officer.</div>
            <Button className="bp-button" icon onClick={handleNotifyLoanOfficer}>
              <div className="gmr-button-container">
                <div className="gmr-button-text">Notify the Loan Officer</div> 
              </div>
            </Button>
          </>}
        /> : (currentStepId === EntitySteps.AdditionalInformation.id && isNotifyLoanOfficerPersona && 
        startAppObject.loanOfficerOrganizationContactId) ? <BCMessage
          animation={"fly down"}
          duration={750}
          visible={isLoanOfficerWarning}
          transitionOnMount
          styles="full-width"
          color="yellow"
          onDismiss={() => setIsLoanOfficerWarning(false)}
          header={"Warning!"}
          text={handleLoanOfficerWarningText()}
        /> : null
      }
      <BCMessage
        animation={"fly down"}
        duration={750}
        visible={isBrokerGuarantorInvited}
        transitionOnMount
        styles="full-width"
        color="green"
        onDismiss={() => setIsBrokerGuarantorInvited(false)}
        header={"Success!"}
        text={`${brokerGuarantorInvitedName} has been sent an invitation.`}
      />
      <BCMessage
        animation={"fly down"}
        duration={750}
        visible={isPropertyUnitUploadedMessage}
        transitionOnMount
        styles="full-width"
        color="green"
        onDismiss={() => setIsPropertyUnitUploadedMessage(false)}
        header={"Success!"}
        text={`Document has been uploaded as ${startAppObject.name}.propertyupload.${propertyUnitExcelDate}.xlsm.`}
      />
      <BCMessage
        animation={"fly down"}
        duration={750}
        visible={isAdditionalCollateralWarning}
        transitionOnMount
        styles="full-width"
        color="yellow"
        onDismiss={() => setIsAdditionalCollateralWarning(false)}
        header={"Warning!"}
        text={additionalCollateralWarning ? `${additionalCollateralWarning.name} has already added ${additionalCollateralWarning.property} to this application.` : ""}
      />
      <BCMessage
        animation="fly down"
        duration={750}
        visible={!!(FeatureFlags.IS_BETA && persona === Personas.WL_GUARANTOR && applicationMetadata.associatedBrokers && applicationMetadata.associatedBrokers.length === 0)}
        transitionOnMount
        styles="full-width"
        color="red"
        text="Please contact your Broker to start an application on your behalf."
      />
      <BPNewBrokerModals 
        newBroker={newBroker}
        setNewBroker={setNewBroker}
        newBrokerageName={newBrokerageName}
        setNewBrokerageName={setNewBrokerageName}
        brokerageInfo={brokerageInfo}
        isNewBrokerage={isNewBrokerage}
        setBrokerageInfo={setBrokerageInfo}
        isBrokerModalOpen={isBrokerModalOpen}
        setIsBrokerModalOpen={setIsBrokerModalOpen}
        isBrokerageNameModalOpen={isBrokerageNameModalOpen}
        setIsBrokerageNameModalOpen={setIsBrokerageNameModalOpen}
        isBrokerageInfoModalOpen={isBrokerageInfoModalOpen}
        setIsBrokerageInfoModalOpen={setIsBrokerageInfoModalOpen}
        isModalMessage={isModalMessage}
        setIsModalMessage={setIsModalMessage}
        errorResponse={errorResponse}
        metadata={applicationMetadata}
        handleOpenBrokerageListModal={handleOpenBrokerageListModal}
        isGreaterThanMobile={isGreaterThanMobile}
        isModalLoading={isModalLoading}
        similarBrokerageList={similarBrokerageList}
        newBrokerageId={newBrokerageId}
        handleSelectBrokerage={handleSelectBrokerage}
        handleOpenBrokerageInfoModal={handleOpenBrokerageInfoModal}
        handleBrokerModalSubmit={handleBrokerModalSubmit}
        brokerColor={brokerColor}
        invalidProps={invalidProps}
        isBrokerageDisabled={user?.organization}
      />
      <BCModal
        size="large"
        isModalOpen={isModalOpen} 
        onClose={() => modalType.includes("guarantor") ? void 0 : handleModalClose()}
        onOpen={() => setIsModalOpen(true)}
        header={handleBrokerModal(modalType).header && handleBrokerModal(modalType).header}
        content={handleBrokerModal(modalType).content && handleBrokerModal(modalType).content}
        actions={handleBrokerModal(modalType) && handleBrokerModal(modalType).actions}
        brokerColor={wlBrokerHex}
      />
      <BCModal
        size="tiny"
        isModalOpen={isCreditModalOpen} 
        onClose={() => creditModalStage !== "pulling" ? handleCreditModalClose() : void 0}
        onOpen={() => setIsCreditModalOpen(true)}
        content={handleCreditModal(creditModalStage).content && handleCreditModal(creditModalStage).content}
        actions={handleCreditModal(creditModalStage).actions && handleCreditModal(creditModalStage).actions}
        brokerColor={wlBrokerHex}
      />
      <BCModal
        size="small"
        isModalOpen={isSkipModalOpen} 
        onClose={() => setIsSkipModalOpen(false)}
        onOpen={() => setIsSkipModalOpen(true)}
        header={handleSkipModal().header && handleSkipModal().header}
        content={handleSkipModal().content && handleSkipModal().content}
        actions={handleSkipModal().actions && handleSkipModal().actions}
        brokerColor={wlBrokerHex}
      />
      <BCModal
        size="tiny"
        isModalOpen={isPaymentModalOpen} 
        onClose={() => setIsPaymentModalOpen(false)}
        onOpen={() => setIsPaymentModalOpen(true)}
        content={handlePaymentModal(paymentModalStage).content && handlePaymentModal(paymentModalStage).content}
        actions={handlePaymentModal(paymentModalStage).actions && handlePaymentModal(paymentModalStage).actions}
        brokerColor={wlBrokerHex}
      />
      <BCModal
        size="large"
        isModalOpen={isPropertyUploadModalOpen} 
        onClose={() => setIsPropertyUploadModalOpen(false)}
        onOpen={() => setIsPropertyUploadModalOpen(true)}
        header="Warning, you will lose your data!"
        content={propertyUploadModalMessage}
        actions={<Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Button icon fluid onClick={() => setIsPropertyUploadModalOpen(false)}>
                <div className="gmr-button-container">
                  <div className="gmr-button-text">Cancel</div>
                </div>
              </Button>
            </Grid.Column>
            <Grid.Column>
              <Button 
                className="bp-button" 
                style={backgroundColorStyle}
                fluid 
                onClick={() => importPropertyUnitExcelAsync(propertyUploadModalFile, true)}
                >
                <div className="gmr-button-container">
                  <div className="gmr-button-text">Override</div>
                </div>
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>}
        brokerColor="#EED202"
      />
      <input className="gmr-unfocus-input" ref={unfocusRef as any} />
      <React.Fragment>
        <BCSteps 
          isGreaterThanMobile={isGreaterThanMobile}
          currentProgress={currentProgress}
          handleStep={(step) => handleNavigateToStep(step)}
          steps={ApplicationMainSteps}
          isDisableOnClick
        />
        <div className={"application-screen-container"}>
          <Card fluid>
            <Card.Content>
              <Card.Description className="gmr-card">
                {isLoading ? <Loader active inline="centered" size={"big"} /> : <Form className="primary-form" autoComplete="off">
                  <Grid>   
                    {ApplicationSteps.map((step, i) => {
                      return (
                        <React.Fragment key={`application-step-${i}`}>
                          {currentStepId === step.id && <React.Fragment>
                            {step.questions.map((question, j) => {
                              return (
                                <React.Fragment key={`application-question-${i}-${j}`}>
                                  {question && question.content && question.content}
                                </React.Fragment>
                              );
                            })}
                            <Grid.Row className="application-row">
                              {Object.values(ApplicationWarnings).map((warning, i) => {
                                return (
                                  <Grid.Column key={`application-warning-${i}`} width={16}>
                                    <BCValidationMessage 
                                      invalidProps={warningIds} 
                                      prop={warning.id} 
                                      propText={warning.message}
                                      color="yellow"
                                      onDismiss={() => setWarningIds([])}
                                    />
                                  </Grid.Column>
                                );
                              })}
                            </Grid.Row>
                          </React.Fragment>}
                        </React.Fragment>
                      );
                    })}
                  </Grid>
                </Form>}
              </Card.Description>
              <Card.Content extra className="application-extra">
                <Grid>
                  <Grid.Row columns={isGreaterThanMobile ? 3 : 1}>
                    <Grid.Column>
                      <Button icon fluid onClick={() => currentStepId === SummarySteps.Confirmation.id ? handleRouteToHome() : handlePrev()}>
                        <div className="primary-wizard-button-container">
                          <Icon name='arrow alternate circle left' size="large" />
                          <div className="gmr-button-icon-text">
                            {currentStepId === SummarySteps.Confirmation.id ? "Go Home" : handlePreviousButtonText(currentStepId)}
                          </div>
                        </div>
                      </Button>
                    </Grid.Column>
                    <Grid.Column className={isGreaterThanMobile ? "" : "primary-mobile-button-spacing"}>
                      {handleSubmitText() === "Submit" && <Button icon fluid onClick={handleSaveAndClose}>
                        <div className="primary-wizard-button-container">
                          <Icon name='save' size="large" />
                          <div className="gmr-button-icon-text">Save and Close</div>
                        </div>
                      </Button>}
                    </Grid.Column>
                    <Grid.Column className={isGreaterThanMobile ? "" : "primary-mobile-button-spacing"}>
                      {(isSubmitButtonPersona && currentStepId === SummarySteps.Summary.id || currentStepId !== SummarySteps.Summary.id) && <Button 
                        className="bp-button"
                        icon 
                        fluid 
                        onClick={() => (currentStepId === ProjectSteps.ProjectOverview.id && applicationChoice === ApplicationChoices.Send.type) ? handleSendApplication() :
                          currentStepId === SummarySteps.Confirmation.id ? handleRouteToHome() : 
                          currentStepId === SummarySteps.Summary.id ? handleSubmitNoCalculate() : 
                          currentStepId === SummarySteps.Calculation.id ? handleCalculate() : 
                          handleTryNext()}
                      >
                        <div className="primary-wizard-button-container">
                          <div className="gmr-button-icon-text">{(currentStepId === ProjectSteps.ProjectOverview.id && applicationChoice === ApplicationChoices.Send.type) ? "Submit" :
                            currentStepId === SummarySteps.Confirmation.id ? "Go Home" :
                            currentStepId === SummarySteps.Summary.id ? handleSubmitText() :
                            currentStepId === SummarySteps.Calculation.id ? "Calculate" : 
                            currentStepId === ProjectSteps.BrokerWelcome.id ? "Start the Application" :
                            "Save and Next"}</div>
                          <Icon name='arrow alternate circle right' size="large" />
                        </div>
                      </Button>}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Card.Content>
            </Card.Content>
          </Card>
        </div>
      </React.Fragment>
      {FeatureFlags.IS_DEBUG && <React.Fragment>
        <div>Application Step Id: {currentStepId}</div>
        <div>Application Step Index: {ApplicationSteps.findIndex(x => x.id === currentStepId)}</div>
        <div>Application Progress: {currentProgress}</div>
        <input onChange={(e) => (ApplicationSteps[parseInt(e.target.value)] && ApplicationSteps[parseInt(e.target.value)].id) ? 
          setCurrentStepId(ApplicationSteps[parseInt(e.target.value)].id) : void 0} />
        <button onClick={() => console.log(startAppObject)}>startAppObject</button>
        <button onClick={() => console.log(initialStartAppObject)}>initialStartAppObject</button>
        <button onClick={() => console.log(isScreenFormChanged)}>isScreenFormChanged</button>
        <button onClick={() => console.log(applicationScreenStatus)}>applicationScreenStatus</button>
        <button onClick={() => console.log(currentStepId)}>currentStepId</button>
        <button onClick={() => console.log(applicationMetadata)}>applicationMetadata</button>
        <button onClick={() => console.log(excludedStepIds)}>excludedStepIds</button>
        <button onClick={() => console.log(metadataExcludedIds)}>metadataExcludedIds</button>
        <button onClick={() => console.log(invalidProps)}>invalidProps</button>
        <button onClick={() => console.log(newBorrowerEntity)}>newBorrowerEntity</button>
        <button onClick={() => console.log(newGuarantor)}>newGuarantor</button>
        <button onClick={() => console.log(warningIds)}>warningIds</button>
        <button onClick={() => console.log(generalContractors)}>generalContractors</button>
        <button onClick={() => console.log(selectedBrokerGuarantors)}>selectedBrokerGuarantors</button>
        <button onClick={() => console.log(guarantorAdditionalCollateral)}>guarantorAdditionalCollateral</button>
        <button onClick={() => console.log(guarantorAdditionalCollateralFull)}>guarantorAdditionalCollateralFull</button>
        <button onClick={() => console.log(guarantorAssetsAndLiabilities)}>guarantorAssetsAndLiabilities</button>
        <button onClick={() => console.log(persona)}>persona</button>
        <button onClick={() => console.log(user)}>user</button>
        <button onClick={() => console.log(proxyUser)}>proxyUser</button>
      </React.Fragment>}
    </div>
  );
};

export default BPBorrowerApplication;
